// Auto-generated file - do not edit manually
// Generated on 2025-06-14T07:43:28.686Z
// FontAwesome icons data
import type { FontAwesome } from '../types';

export const FONTAWESOME_ICONS: FontAwesome[] = [
  {
    name: '0',
    label: '0',
    unicode: '30',
    styles: ['solid'],
    searchTerms: ['Digit Zero', 'nada', 'none', 'zero', 'zilch'],
    categories: ['numbers'],
  },
  {
    name: '1',
    label: '1',
    unicode: '31',
    styles: ['solid'],
    searchTerms: ['Digit One', 'one'],
    categories: ['numbers'],
  },
  {
    name: '2',
    label: '2',
    unicode: '32',
    styles: ['solid'],
    searchTerms: ['Digit Two', 'two'],
    categories: ['numbers'],
  },
  {
    name: '3',
    label: '3',
    unicode: '33',
    styles: ['solid'],
    searchTerms: ['Digit Three', 'three'],
    categories: ['numbers'],
  },
  {
    name: '4',
    label: '4',
    unicode: '34',
    styles: ['solid'],
    searchTerms: ['Digit Four', 'four'],
    categories: ['numbers'],
  },
  {
    name: '5',
    label: '5',
    unicode: '35',
    styles: ['solid'],
    searchTerms: ['Digit Five', 'five'],
    categories: ['numbers'],
  },
  {
    name: '6',
    label: '6',
    unicode: '36',
    styles: ['solid'],
    searchTerms: ['Digit Six', 'six'],
    categories: ['numbers'],
  },
  {
    name: '7',
    label: '7',
    unicode: '37',
    styles: ['solid'],
    searchTerms: ['Digit Seven', 'seven'],
    categories: ['numbers'],
  },
  {
    name: '8',
    label: '8',
    unicode: '38',
    styles: ['solid'],
    searchTerms: ['Digit Eight', 'eight'],
    categories: ['numbers'],
  },
  {
    name: '9',
    label: '9',
    unicode: '39',
    styles: ['solid'],
    searchTerms: ['Digit Nine', 'nine'],
    categories: ['numbers'],
  },
  {
    name: '42-group',
    label: '42.group',
    unicode: 'e080',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['innosoft'],
  },
  {
    name: '500px',
    label: '500px',
    unicode: 'f26e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'a',
    label: 'A',
    unicode: '41',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter A', 'Latin Small Letter A', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'accessible-icon',
    label: 'Accessible Icon',
    unicode: 'f368',
    styles: ['brands'],
    searchTerms: [
      'accessibility',
      'disabled',
      'handicap',
      'person',
      'uer',
      'wheelchair',
      'wheelchair-alt',
    ],
    categories: [
      'accessibility',
      'medical-health',
      'transportation',
      'users-people',
    ],
  },
  {
    name: 'accusoft',
    label: 'Accusoft',
    unicode: 'f369',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'address-book',
    label: 'Address Book',
    unicode: 'f2b9',
    styles: ['regular', 'solid'],
    searchTerms: [
      'contact',
      'directory',
      'employee',
      'index',
      'little black book',
      'portfolio',
      'rolodex',
      'uer',
      'username',
    ],
    categories: ['business', 'communication', 'users-people'],
    aliases: ['contact-book'],
  },
  {
    name: 'address-card',
    label: 'Address Card',
    unicode: 'f2bb',
    styles: ['regular', 'solid'],
    searchTerms: [
      'about',
      'contact',
      'employee',
      'id',
      'identification',
      'portfolio',
      'postcard',
      'profile',
      'registration',
      'uer',
      'username',
    ],
    categories: [
      'accessibility',
      'alphabet',
      'business',
      'communication',
      'users-people',
    ],
    aliases: ['contact-card', 'vcard'],
  },
  {
    name: 'adn',
    label: 'App.net',
    unicode: 'f170',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'adversal',
    label: 'Adversal',
    unicode: 'f36a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'affiliatetheme',
    label: 'affiliatetheme',
    unicode: 'f36b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'airbnb',
    label: 'Airbnb',
    unicode: 'f834',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'algolia',
    label: 'Algolia',
    unicode: 'f36c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'align-center',
    label: 'Align Center',
    unicode: 'f037',
    styles: ['solid'],
    searchTerms: ['format', 'middle', 'paragraph', 'text'],
    categories: ['text-formatting'],
  },
  {
    name: 'align-justify',
    label: 'Align Justify',
    unicode: 'f039',
    styles: ['solid'],
    searchTerms: ['format', 'paragraph', 'text'],
    categories: ['text-formatting'],
  },
  {
    name: 'align-left',
    label: 'Align Left',
    unicode: 'f036',
    styles: ['solid'],
    searchTerms: ['format', 'paragraph', 'text'],
    categories: ['text-formatting'],
  },
  {
    name: 'align-right',
    label: 'Align Right',
    unicode: 'f038',
    styles: ['solid'],
    searchTerms: ['format', 'paragraph', 'text'],
    categories: ['text-formatting'],
  },
  {
    name: 'alipay',
    label: 'Alipay',
    unicode: 'f642',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'amazon',
    label: 'Amazon',
    unicode: 'f270',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'amazon-pay',
    label: 'Amazon Pay',
    unicode: 'f42c',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'amilia',
    label: 'Amilia',
    unicode: 'f36d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'anchor',
    label: 'Anchor',
    unicode: 'f13d',
    styles: ['solid'],
    searchTerms: [
      'anchor',
      'berth',
      'boat',
      'dock',
      'embed',
      'link',
      'maritime',
      'moor',
      'port',
      'secure',
      'ship',
      'tool',
    ],
    categories: ['humanitarian', 'logistics', 'maps', 'maritime'],
  },
  {
    name: 'anchor-circle-check',
    label: 'Anchor Circle Check',
    unicode: 'e4aa',
    styles: ['solid'],
    searchTerms: [
      'enable',
      'marina',
      'not affected',
      'ok',
      'okay',
      'port',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'logistics', 'maritime'],
  },
  {
    name: 'anchor-circle-exclamation',
    label: 'Anchor Circle Exclamation',
    unicode: 'e4ab',
    styles: ['solid'],
    searchTerms: ['affected', 'failed', 'marina', 'port'],
    categories: ['humanitarian', 'logistics', 'maritime'],
  },
  {
    name: 'anchor-circle-xmark',
    label: 'Anchor Circle Xmark',
    unicode: 'e4ac',
    styles: ['solid'],
    searchTerms: ['destroy', 'marina', 'port', 'uncheck'],
    categories: ['humanitarian', 'logistics', 'maritime'],
  },
  {
    name: 'anchor-lock',
    label: 'Anchor Lock',
    unicode: 'e4ad',
    styles: ['solid'],
    searchTerms: [
      'closed',
      'lockdown',
      'marina',
      'padlock',
      'port',
      'privacy',
      'quarantine',
    ],
    categories: ['humanitarian', 'logistics', 'maritime'],
  },
  {
    name: 'android',
    label: 'Android',
    unicode: 'f17b',
    styles: ['brands'],
    searchTerms: ['robot'],
    categories: [],
  },
  {
    name: 'angellist',
    label: 'AngelList',
    unicode: 'f209',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'angle-down',
    label: 'Angle Down',
    unicode: 'f107',
    styles: ['solid'],
    searchTerms: [
      'Down Arrowhead',
      'arrow',
      'caret',
      'download',
      'expand',
      'insert',
    ],
    categories: ['arrows'],
  },
  {
    name: 'angle-left',
    label: 'Angle Left',
    unicode: 'f104',
    styles: ['solid'],
    searchTerms: [
      'Single Left-Pointing Angle Quotation Mark',
      'arrow',
      'back',
      'caret',
      'less',
      'previous',
    ],
    categories: ['arrows'],
  },
  {
    name: 'angle-right',
    label: 'Angle Right',
    unicode: 'f105',
    styles: ['solid'],
    searchTerms: [
      'Single Right-Pointing Angle Quotation Mark',
      'arrow',
      'care',
      'forward',
      'more',
      'next',
    ],
    categories: ['arrows'],
  },
  {
    name: 'angle-up',
    label: 'Angle Up',
    unicode: 'f106',
    styles: ['solid'],
    searchTerms: [
      'Up Arrowhead',
      'arrow',
      'caret',
      'collapse',
      'upgrade',
      'upload',
    ],
    categories: ['arrows'],
  },
  {
    name: 'angles-down',
    label: 'Angles Down',
    unicode: 'f103',
    styles: ['solid'],
    searchTerms: ['arrows', 'caret', 'download', 'expand'],
    categories: ['arrows'],
    aliases: ['angle-double-down'],
  },
  {
    name: 'angles-left',
    label: 'Angles Left',
    unicode: 'f100',
    styles: ['solid'],
    searchTerms: [
      'Left-Pointing Double Angle Quotation Mark',
      'arrows',
      'back',
      'caret',
      'laquo',
      'previous',
      'quote',
    ],
    categories: ['arrows'],
    aliases: ['angle-double-left'],
  },
  {
    name: 'angles-right',
    label: 'Angles Right',
    unicode: 'f101',
    styles: ['solid'],
    searchTerms: [
      'Right-Pointing Double Angle Quotation Mark',
      'arrows',
      'caret',
      'forward',
      'more',
      'next',
      'quote',
      'raquo',
    ],
    categories: ['arrows'],
    aliases: ['angle-double-right'],
  },
  {
    name: 'angles-up',
    label: 'Angles Up',
    unicode: 'f102',
    styles: ['solid'],
    searchTerms: ['arrows', 'caret', 'collapse', 'upload'],
    categories: ['arrows'],
    aliases: ['angle-double-up'],
  },
  {
    name: 'angrycreative',
    label: 'Angry Creative',
    unicode: 'f36e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'angular',
    label: 'Angular',
    unicode: 'f420',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ankh',
    label: 'Ankh',
    unicode: 'f644',
    styles: ['solid'],
    searchTerms: [
      'Ankh',
      'amulet',
      'copper',
      'coptic christianity',
      'copts',
      'crux ansata',
      'egypt',
      'venus',
    ],
    categories: ['religion'],
  },
  {
    name: 'app-store',
    label: 'App Store',
    unicode: 'f36f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'app-store-ios',
    label: 'iOS App Store',
    unicode: 'f370',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'apper',
    label: 'Apper Systems AB',
    unicode: 'f371',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'apple',
    label: 'Apple',
    unicode: 'f179',
    styles: ['brands'],
    searchTerms: ['fruit', 'ios', 'mac', 'operating system', 'os', 'osx'],
    categories: [],
  },
  {
    name: 'apple-pay',
    label: 'Apple Pay',
    unicode: 'f415',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'apple-whole',
    label: 'Apple Whole',
    unicode: 'f5d1',
    styles: ['solid'],
    searchTerms: [
      'apple',
      'fall',
      'fruit',
      'fuji',
      'green',
      'green apple',
      'macintosh',
      'orchard',
      'red',
      'red apple',
      'seasonal',
      'vegan',
    ],
    categories: [
      'childhood',
      'education',
      'food-beverage',
      'fruits-vegetables',
    ],
    aliases: ['apple-alt'],
  },
  {
    name: 'archway',
    label: 'Archway',
    unicode: 'f557',
    styles: ['solid'],
    searchTerms: ['arc', 'monument', 'road', 'street', 'tunnel'],
    categories: ['buildings', 'travel-hotel'],
  },
  {
    name: 'arrow-down',
    label: 'Arrow Down',
    unicode: 'f063',
    styles: ['solid'],
    searchTerms: ['Downwards Arrow', 'download'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-down-1-9',
    label: 'Arrow Down 1 9',
    unicode: 'f162',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'numbers', 'order', 'sort-numeric-asc'],
    categories: ['arrows'],
    aliases: ['sort-numeric-asc', 'sort-numeric-down'],
  },
  {
    name: 'arrow-down-9-1',
    label: 'Arrow Down 9 1',
    unicode: 'f886',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'numbers', 'order', 'sort-numeric-asc'],
    categories: ['arrows'],
    aliases: ['sort-numeric-desc', 'sort-numeric-down-alt'],
  },
  {
    name: 'arrow-down-a-z',
    label: 'Arrow Down A Z',
    unicode: 'f15d',
    styles: ['solid'],
    searchTerms: [
      'alphabetical',
      'arrange',
      'filter',
      'order',
      'sort-alpha-asc',
    ],
    categories: ['arrows'],
    aliases: ['sort-alpha-asc', 'sort-alpha-down'],
  },
  {
    name: 'arrow-down-long',
    label: 'Arrow Down Long',
    unicode: 'f175',
    styles: ['solid'],
    searchTerms: ['download', 'long-arrow-down'],
    categories: ['arrows'],
    aliases: ['long-arrow-down'],
  },
  {
    name: 'arrow-down-short-wide',
    label: 'Arrow Down Short Wide',
    unicode: 'f884',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'order', 'sort-amount-asc'],
    categories: ['arrows'],
    aliases: ['sort-amount-desc', 'sort-amount-down-alt'],
  },
  {
    name: 'arrow-down-up-across-line',
    label: 'Arrow Down Up Across Line',
    unicode: 'e4af',
    styles: ['solid'],
    searchTerms: ['border', 'crossing', 'transfer'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrow-down-up-lock',
    label: 'Arrow Down Up Lock',
    unicode: 'e4b0',
    styles: ['solid'],
    searchTerms: [
      'border',
      'closed',
      'crossing',
      'lockdown',
      'padlock',
      'privacy',
      'quarantine',
      'transfer',
    ],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrow-down-wide-short',
    label: 'Arrow Down Wide Short',
    unicode: 'f160',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'number', 'order', 'sort-amount-asc'],
    categories: ['arrows'],
    aliases: ['sort-amount-asc', 'sort-amount-down'],
  },
  {
    name: 'arrow-down-z-a',
    label: 'Arrow Down Z A',
    unicode: 'f881',
    styles: ['solid'],
    searchTerms: [
      'alphabetical',
      'arrange',
      'filter',
      'order',
      'sort-alpha-asc',
    ],
    categories: ['arrows'],
    aliases: ['sort-alpha-desc', 'sort-alpha-down-alt'],
  },
  {
    name: 'arrow-left',
    label: 'Arrow Left',
    unicode: 'f060',
    styles: ['solid'],
    searchTerms: ['Leftwards Arrow', 'back', 'previous'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-left-long',
    label: 'Arrow Left Long',
    unicode: 'f177',
    styles: ['solid'],
    searchTerms: ['back', 'long-arrow-left', 'previous'],
    categories: ['arrows'],
    aliases: ['long-arrow-left'],
  },
  {
    name: 'arrow-pointer',
    label: 'Arrow Pointer',
    unicode: 'f245',
    styles: ['solid'],
    searchTerms: ['arrow', 'cursor', 'select'],
    categories: ['arrows'],
    aliases: ['mouse-pointer'],
  },
  {
    name: 'arrow-right',
    label: 'Arrow Right',
    unicode: 'f061',
    styles: ['solid'],
    searchTerms: ['Rightwards Arrow', 'forward', 'next'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-right-arrow-left',
    label: 'Arrow Right Arrow Left',
    unicode: 'f0ec',
    styles: ['solid'],
    searchTerms: [
      'Rightwards Arrow Over Leftwards Arrow',
      'arrow',
      'arrows',
      'reciprocate',
      'return',
      'swap',
      'transfer',
    ],
    categories: ['arrows'],
    aliases: ['exchange'],
  },
  {
    name: 'arrow-right-from-bracket',
    label: 'Arrow Right From Bracket',
    unicode: 'f08b',
    styles: ['solid'],
    searchTerms: ['arrow', 'exit', 'leave', 'log out', 'logout'],
    categories: ['arrows'],
    aliases: ['sign-out'],
  },
  {
    name: 'arrow-right-long',
    label: 'Arrow Right Long',
    unicode: 'f178',
    styles: ['solid'],
    searchTerms: ['forward', 'long-arrow-right', 'next'],
    categories: ['arrows'],
    aliases: ['long-arrow-right'],
  },
  {
    name: 'arrow-right-to-bracket',
    label: 'Arrow Right To Bracket',
    unicode: 'f090',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'enter',
      'insert',
      'join',
      'log in',
      'login',
      'sign in',
      'sign up',
      'sign-in',
      'signin',
      'signup',
    ],
    categories: ['arrows'],
    aliases: ['sign-in'],
  },
  {
    name: 'arrow-right-to-city',
    label: 'Arrow Right To City',
    unicode: 'e4b3',
    styles: ['solid'],
    searchTerms: ['building', 'city', 'exodus', 'insert', 'rural', 'urban'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'arrow-rotate-left',
    label: 'Arrow Rotate Left',
    unicode: 'f0e2',
    styles: ['solid'],
    searchTerms: [
      'Anticlockwise Open Circle Arrow',
      'back',
      'control z',
      'exchange',
      'oops',
      'return',
      'rotate',
      'swap',
    ],
    categories: ['arrows', 'media-playback', 'spinners'],
    aliases: [
      'arrow-left-rotate',
      'arrow-rotate-back',
      'arrow-rotate-backward',
      'undo',
    ],
  },
  {
    name: 'arrow-rotate-right',
    label: 'Arrow Rotate Right',
    unicode: 'f01e',
    styles: ['solid'],
    searchTerms: [
      'Clockwise Open Circle Arrow',
      'forward',
      'refresh',
      'reload',
      'renew',
      'repeat',
      'retry',
    ],
    categories: ['arrows', 'media-playback', 'spinners'],
    aliases: ['arrow-right-rotate', 'arrow-rotate-forward', 'redo'],
  },
  {
    name: 'arrow-trend-down',
    label: 'Arrow Trend Down',
    unicode: 'e097',
    styles: ['solid'],
    searchTerms: ['line', 'stocks', 'trend'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-trend-up',
    label: 'Arrow Trend Up',
    unicode: 'e098',
    styles: ['solid'],
    searchTerms: ['line', 'stocks', 'trend'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-turn-down',
    label: 'Arrow Turn Down',
    unicode: 'f149',
    styles: ['solid'],
    searchTerms: ['arrow'],
    categories: ['arrows'],
    aliases: ['level-down'],
  },
  {
    name: 'arrow-turn-up',
    label: 'Arrow Turn Up',
    unicode: 'f148',
    styles: ['solid'],
    searchTerms: ['arrow'],
    categories: ['arrows'],
    aliases: ['level-up'],
  },
  {
    name: 'arrow-up',
    label: 'Arrow Up',
    unicode: 'f062',
    styles: ['solid'],
    searchTerms: ['Upwards Arrow', 'forward', 'upgrade', 'upload'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-up-1-9',
    label: 'Arrow Up 1 9',
    unicode: 'f163',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'numbers', 'order', 'sort-numeric-desc'],
    categories: ['arrows'],
    aliases: ['sort-numeric-up'],
  },
  {
    name: 'arrow-up-9-1',
    label: 'Arrow Up 9 1',
    unicode: 'f887',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'numbers', 'order', 'sort-numeric-desc'],
    categories: ['arrows'],
    aliases: ['sort-numeric-up-alt'],
  },
  {
    name: 'arrow-up-a-z',
    label: 'Arrow Up A Z',
    unicode: 'f15e',
    styles: ['solid'],
    searchTerms: [
      'alphabetical',
      'arrange',
      'filter',
      'order',
      'sort-alpha-desc',
    ],
    categories: ['arrows'],
    aliases: ['sort-alpha-up'],
  },
  {
    name: 'arrow-up-from-bracket',
    label: 'Arrow Up From Bracket',
    unicode: 'e09a',
    styles: ['solid'],
    searchTerms: ['share', 'transfer', 'upgrade', 'upload'],
    categories: ['arrows'],
  },
  {
    name: 'arrow-up-from-ground-water',
    label: 'Arrow Up From Ground Water',
    unicode: 'e4b5',
    styles: ['solid'],
    searchTerms: [
      'groundwater',
      'spring',
      'upgrade',
      'water supply',
      'water table',
    ],
    categories: ['construction', 'energy', 'humanitarian'],
  },
  {
    name: 'arrow-up-from-water-pump',
    label: 'Arrow Up From Water Pump',
    unicode: 'e4b6',
    styles: ['solid'],
    searchTerms: [
      'flood',
      'groundwater',
      'pump',
      'submersible',
      'sump pump',
      'upgrade',
    ],
    categories: ['household', 'humanitarian'],
  },
  {
    name: 'arrow-up-long',
    label: 'Arrow Up Long',
    unicode: 'f176',
    styles: ['solid'],
    searchTerms: ['long-arrow-up', 'upload'],
    categories: ['arrows'],
    aliases: ['long-arrow-up'],
  },
  {
    name: 'arrow-up-right-dots',
    label: 'Arrow Up Right Dots',
    unicode: 'e4b7',
    styles: ['solid'],
    searchTerms: ['growth', 'increase', 'population', 'upgrade'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrow-up-right-from-square',
    label: 'Arrow Up Right From Square',
    unicode: 'f08e',
    styles: ['solid'],
    searchTerms: ['new', 'open', 'send', 'share', 'upgrade'],
    categories: ['arrows', 'humanitarian'],
    aliases: ['external-link'],
  },
  {
    name: 'arrow-up-short-wide',
    label: 'Arrow Up Short Wide',
    unicode: 'f885',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'order', 'sort-amount-desc'],
    categories: ['arrows'],
    aliases: ['sort-amount-up-alt'],
  },
  {
    name: 'arrow-up-wide-short',
    label: 'Arrow Up Wide Short',
    unicode: 'f161',
    styles: ['solid'],
    searchTerms: ['arrange', 'filter', 'order', 'sort-amount-desc', 'upgrade'],
    categories: ['arrows'],
    aliases: ['sort-amount-up'],
  },
  {
    name: 'arrow-up-z-a',
    label: 'Arrow Up Z A',
    unicode: 'f882',
    styles: ['solid'],
    searchTerms: [
      'alphabetical',
      'arrange',
      'filter',
      'order',
      'sort-alpha-desc',
    ],
    categories: ['arrows'],
    aliases: ['sort-alpha-up-alt'],
  },
  {
    name: 'arrows-down-to-line',
    label: 'Arrows Down To Line',
    unicode: 'e4b8',
    styles: ['solid'],
    searchTerms: ['insert', 'scale down', 'sink'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrows-down-to-people',
    label: 'Arrows Down To People',
    unicode: 'e4b9',
    styles: ['solid'],
    searchTerms: ['affected', 'focus', 'insert', 'targeted', 'together', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'arrows-left-right',
    label: 'Arrows Left Right',
    unicode: 'f07e',
    styles: ['solid'],
    searchTerms: ['expand', 'horizontal', 'landscape', 'resize', 'wide'],
    categories: ['arrows'],
    aliases: ['arrows-h'],
  },
  {
    name: 'arrows-left-right-to-line',
    label: 'Arrows Left Right To Line',
    unicode: 'e4ba',
    styles: ['solid'],
    searchTerms: ['analysis', 'expand', 'gap'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrows-rotate',
    label: 'Arrows Rotate',
    unicode: 'f021',
    styles: ['solid'],
    searchTerms: [
      'Clockwise Right and Left Semicircle Arrows',
      'clockwise',
      'exchange',
      'modify',
      'refresh',
      'reload',
      'renew',
      'retry',
      'rotate',
      'swap',
    ],
    categories: ['arrows', 'editing', 'media-playback', 'spinners'],
    aliases: ['refresh', 'sync'],
  },
  {
    name: 'arrows-spin',
    label: 'Arrows Spin',
    unicode: 'e4bb',
    styles: ['solid'],
    searchTerms: ['cycle', 'rotate', 'spin', 'whirl'],
    categories: ['arrows', 'business', 'humanitarian', 'marketing', 'spinners'],
  },
  {
    name: 'arrows-split-up-and-left',
    label: 'Arrows Split Up And Left',
    unicode: 'e4bc',
    styles: ['solid'],
    searchTerms: ['agile', 'split'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrows-to-circle',
    label: 'Arrows To Circle',
    unicode: 'e4bd',
    styles: ['solid'],
    searchTerms: [
      'center',
      'concentrate',
      'coordinate',
      'coordination',
      'focal point',
      'focus',
      'insert',
    ],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrows-to-dot',
    label: 'Arrows To Dot',
    unicode: 'e4be',
    styles: ['solid'],
    searchTerms: [
      'assembly point',
      'center',
      'condense',
      'focus',
      'insert',
      'minimize',
    ],
    categories: ['arrows', 'business', 'humanitarian', 'marketing'],
  },
  {
    name: 'arrows-to-eye',
    label: 'Arrows To Eye',
    unicode: 'e4bf',
    styles: ['solid'],
    searchTerms: ['center', 'coordinated assessment', 'focus'],
    categories: ['arrows', 'business', 'humanitarian', 'marketing'],
  },
  {
    name: 'arrows-turn-right',
    label: 'Arrows Turn Right',
    unicode: 'e4c0',
    styles: ['solid'],
    searchTerms: ['arrows'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrows-turn-to-dots',
    label: 'Arrows Turn To Dots',
    unicode: 'e4c1',
    styles: ['solid'],
    searchTerms: ['destination', 'insert', 'nexus'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'arrows-up-down',
    label: 'Arrows Up Down',
    unicode: 'f07d',
    styles: ['solid'],
    searchTerms: ['expand', 'portrait', 'resize', 'tall', 'vertical'],
    categories: ['arrows'],
    aliases: ['arrows-v'],
  },
  {
    name: 'arrows-up-down-left-right',
    label: 'Arrows Up Down Left Right',
    unicode: 'f047',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'arrows',
      'bigger',
      'enlarge',
      'expand',
      'fullscreen',
      'move',
      'position',
      'reorder',
      'resize',
    ],
    categories: ['arrows'],
    aliases: ['arrows'],
  },
  {
    name: 'arrows-up-to-line',
    label: 'Arrows Up To Line',
    unicode: 'e4c2',
    styles: ['solid'],
    searchTerms: ['rise', 'scale up', 'upgrade'],
    categories: ['arrows', 'humanitarian'],
  },
  {
    name: 'artstation',
    label: 'Artstation',
    unicode: 'f77a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'asterisk',
    label: 'Asterisk',
    unicode: '2a',
    styles: ['solid'],
    searchTerms: [
      'Asterisk',
      'Heavy Asterisk',
      'annotation',
      'details',
      'reference',
      'required',
      'star',
    ],
    categories: ['punctuation-symbols', 'spinners'],
  },
  {
    name: 'asymmetrik',
    label: 'Asymmetrik, Ltd.',
    unicode: 'f372',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'at',
    label: 'At',
    unicode: '40',
    styles: ['solid'],
    searchTerms: [
      'Commercial At',
      'address',
      'author',
      'e-mail',
      'email',
      'fluctuate',
      'handle',
    ],
    categories: ['communication', 'punctuation-symbols'],
  },
  {
    name: 'atlassian',
    label: 'Atlassian',
    unicode: 'f77b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'atom',
    label: 'Atom',
    unicode: 'f5d2',
    styles: ['solid'],
    searchTerms: [
      'atheism',
      'atheist',
      'atom',
      'atom symbol',
      'chemistry',
      'electron',
      'ion',
      'isotope',
      'knowledge',
      'neutron',
      'nuclear',
      'proton',
      'science',
    ],
    categories: [
      'education',
      'energy',
      'religion',
      'science',
      'science-fiction',
      'spinners',
    ],
  },
  {
    name: 'audible',
    label: 'Audible',
    unicode: 'f373',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'audio-description',
    label: 'Audio Description',
    unicode: 'f29e',
    styles: ['solid'],
    searchTerms: ['blind', 'narration', 'video', 'visual'],
    categories: ['accessibility', 'film-video'],
  },
  {
    name: 'austral-sign',
    label: 'Austral Sign',
    unicode: 'e0a9',
    styles: ['solid'],
    searchTerms: ['Austral Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'autoprefixer',
    label: 'Autoprefixer',
    unicode: 'f41c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'avianex',
    label: 'avianex',
    unicode: 'f374',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'aviato',
    label: 'Aviato',
    unicode: 'f421',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'award',
    label: 'Award',
    unicode: 'f559',
    styles: ['solid'],
    searchTerms: [
      'guarantee',
      'honor',
      'praise',
      'prize',
      'recognition',
      'ribbon',
      'trophy',
      'warranty',
    ],
    categories: ['education', 'political'],
  },
  {
    name: 'aws',
    label: 'Amazon Web Services (AWS)',
    unicode: 'f375',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'b',
    label: 'B',
    unicode: '42',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter B', 'Latin Small Letter B', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'baby',
    label: 'Baby',
    unicode: 'f77c',
    styles: ['solid'],
    searchTerms: ['uer', 'users-people'],
    categories: ['childhood', 'humanitarian', 'users-people'],
  },
  {
    name: 'baby-carriage',
    label: 'Baby Carriage',
    unicode: 'f77d',
    styles: ['solid'],
    searchTerms: [
      'buggy',
      'carrier',
      'infant',
      'push',
      'stroller',
      'transportation',
      'walk',
      'wheels',
    ],
    categories: ['childhood', 'transportation', 'travel-hotel'],
    aliases: ['carriage-baby'],
  },
  {
    name: 'backward',
    label: 'Backward',
    unicode: 'f04a',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'double',
      'fast reverse button',
      'previous',
      'rewind',
    ],
    categories: ['media-playback'],
  },
  {
    name: 'backward-fast',
    label: 'Backward Fast',
    unicode: 'f049',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'beginning',
      'first',
      'last track button',
      'previous',
      'previous scene',
      'previous track',
      'quick',
      'rewind',
      'start',
      'triangle',
    ],
    categories: ['media-playback'],
    aliases: ['fast-backward'],
  },
  {
    name: 'backward-step',
    label: 'Backward Step',
    unicode: 'f048',
    styles: ['solid'],
    searchTerms: ['beginning', 'first', 'previous', 'rewind', 'start'],
    categories: ['media-playback'],
    aliases: ['step-backward'],
  },
  {
    name: 'bacon',
    label: 'Bacon',
    unicode: 'f7e5',
    styles: ['solid'],
    searchTerms: [
      'bacon',
      'blt',
      'breakfast',
      'food',
      'ham',
      'lard',
      'meat',
      'pancetta',
      'pork',
      'rasher',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'bacteria',
    label: 'Bacteria',
    unicode: 'e059',
    styles: ['solid'],
    searchTerms: [
      'antibiotic',
      'antibody',
      'covid-19',
      'health',
      'organism',
      'sick',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'bacterium',
    label: 'Bacterium',
    unicode: 'e05a',
    styles: ['solid'],
    searchTerms: [
      'antibiotic',
      'antibody',
      'covid-19',
      'germ',
      'health',
      'organism',
      'sick',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'bag-shopping',
    label: 'Bag Shopping',
    unicode: 'f290',
    styles: ['solid'],
    searchTerms: ['buy', 'checkout', 'grocery', 'payment', 'purchase'],
    categories: ['maps', 'shopping'],
    aliases: ['shopping-bag'],
  },
  {
    name: 'bahai',
    label: 'Bahai',
    unicode: 'f666',
    styles: ['solid'],
    searchTerms: ['bahai', "bahá'í", 'star'],
    categories: ['religion', 'spinners'],
    aliases: ['haykal'],
  },
  {
    name: 'baht-sign',
    label: 'Baht Sign',
    unicode: 'e0ac',
    styles: ['solid'],
    searchTerms: ['currency'],
    categories: ['money'],
  },
  {
    name: 'ban',
    label: 'Ban',
    unicode: 'f05e',
    styles: ['solid'],
    searchTerms: [
      '404',
      'abort',
      'ban',
      'block',
      'cancel',
      'delete',
      'deny',
      'disabled',
      'entry',
      'failed',
      'forbidden',
      'hide',
      'no',
      'not',
      'not found',
      'prohibit',
      'prohibited',
      'remove',
      'stop',
      'trash',
    ],
    categories: ['humanitarian', 'security'],
    aliases: ['cancel'],
  },
  {
    name: 'ban-smoking',
    label: 'Ban Smoking',
    unicode: 'f54d',
    styles: ['solid'],
    searchTerms: [
      'ban',
      'cancel',
      'deny',
      'disabled',
      'forbidden',
      'no',
      'no smoking',
      'non-smoking',
      'not',
      'prohibited',
      'smoking',
    ],
    categories: ['medical-health', 'travel-hotel'],
    aliases: ['smoking-ban'],
  },
  {
    name: 'bandage',
    label: 'Bandage',
    unicode: 'f462',
    styles: ['solid'],
    searchTerms: [
      'adhesive bandage',
      'bandage',
      'boo boo',
      'first aid',
      'modify',
      'ouch',
    ],
    categories: ['editing', 'medical-health'],
    aliases: ['band-aid'],
  },
  {
    name: 'bandcamp',
    label: 'Bandcamp',
    unicode: 'f2d5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bangladeshi-taka-sign',
    label: 'Bangladeshi Taka Sign',
    unicode: 'e2e6',
    styles: ['solid'],
    searchTerms: ['bdt', 'currency', 'tk'],
    categories: ['money'],
  },
  {
    name: 'barcode',
    label: 'Barcode',
    unicode: 'f02a',
    styles: ['solid'],
    searchTerms: ['info', 'laser', 'price', 'scan', 'upc'],
    categories: ['coding', 'shopping'],
  },
  {
    name: 'bars',
    label: 'Bars',
    unicode: 'f0c9',
    styles: ['solid'],
    searchTerms: [
      'checklist',
      'drag',
      'hamburger',
      'list',
      'menu',
      'nav',
      'navigation',
      'ol',
      'reorder',
      'settings',
      'todo',
      'ul',
    ],
    categories: ['coding', 'editing'],
    aliases: ['navicon'],
  },
  {
    name: 'bars-progress',
    label: 'Bars Progress',
    unicode: 'f828',
    styles: ['solid'],
    searchTerms: [
      'checklist',
      'downloading',
      'downloads',
      'loading',
      'poll',
      'progress',
      'project management',
      'settings',
      'to do',
    ],
    categories: ['business', 'charts-diagrams'],
    aliases: ['tasks-alt'],
  },
  {
    name: 'bars-staggered',
    label: 'Bars Staggered',
    unicode: 'f550',
    styles: ['solid'],
    searchTerms: ['flow', 'list', 'timeline'],
    categories: ['business', 'coding'],
    aliases: ['reorder', 'stream'],
  },
  {
    name: 'baseball',
    label: 'Baseball',
    unicode: 'f433',
    styles: ['solid'],
    searchTerms: [
      'ball',
      'baseball',
      'foul',
      'glove',
      'hardball',
      'league',
      'leather',
      'mlb',
      'softball',
      'sport',
      'underarm',
    ],
    categories: ['sports-fitness'],
    aliases: ['baseball-ball'],
  },
  {
    name: 'baseball-bat-ball',
    label: 'Baseball Bat Ball',
    unicode: 'f432',
    styles: ['solid'],
    searchTerms: ['bat', 'league', 'mlb', 'slugger', 'softball', 'sport'],
    categories: ['childhood', 'sports-fitness'],
  },
  {
    name: 'basket-shopping',
    label: 'Basket Shopping',
    unicode: 'f291',
    styles: ['solid'],
    searchTerms: ['buy', 'checkout', 'grocery', 'payment', 'purchase'],
    categories: ['maps', 'shopping'],
    aliases: ['shopping-basket'],
  },
  {
    name: 'basketball',
    label: 'Basketball',
    unicode: 'f434',
    styles: ['solid'],
    searchTerms: ['ball', 'basketball', 'dribble', 'dunk', 'hoop', 'nba'],
    categories: ['sports-fitness'],
    aliases: ['basketball-ball'],
  },
  {
    name: 'bath',
    label: 'Bath',
    unicode: 'f2cd',
    styles: ['solid'],
    searchTerms: ['bath', 'bathtub', 'clean', 'shower', 'tub', 'wash'],
    categories: ['childhood', 'coding', 'household', 'maps', 'travel-hotel'],
    aliases: ['bathtub'],
  },
  {
    name: 'battery-empty',
    label: 'Battery Empty',
    unicode: 'f244',
    styles: ['solid'],
    searchTerms: ['charge', 'dead', 'power', 'status'],
    categories: ['energy'],
    aliases: ['battery-0'],
  },
  {
    name: 'battery-full',
    label: 'Battery Full',
    unicode: 'f240',
    styles: ['solid'],
    searchTerms: ['batter', 'battery', 'charge', 'power', 'status'],
    categories: ['energy'],
    aliases: ['battery', 'battery-5'],
  },
  {
    name: 'battery-half',
    label: 'Battery Half',
    unicode: 'f242',
    styles: ['solid'],
    searchTerms: ['charge', 'power', 'status'],
    categories: ['energy'],
    aliases: ['battery-3'],
  },
  {
    name: 'battery-quarter',
    label: 'Battery Quarter',
    unicode: 'f243',
    styles: ['solid'],
    searchTerms: ['charge', 'low', 'power', 'status'],
    categories: ['energy'],
    aliases: ['battery-2'],
  },
  {
    name: 'battery-three-quarters',
    label: 'Battery Three Quarters',
    unicode: 'f241',
    styles: ['solid'],
    searchTerms: ['charge', 'power', 'status'],
    categories: ['energy'],
    aliases: ['battery-4'],
  },
  {
    name: 'battle-net',
    label: 'Battle.net',
    unicode: 'f835',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bed',
    label: 'Bed',
    unicode: 'f236',
    styles: ['solid'],
    searchTerms: [
      'hospital',
      'hotel',
      'lodging',
      'mattress',
      'patient',
      'person in bed',
      'rest',
      'sleep',
      'travel',
      'uer',
    ],
    categories: [
      'household',
      'humanitarian',
      'maps',
      'travel-hotel',
      'users-people',
    ],
  },
  {
    name: 'bed-pulse',
    label: 'Bed Pulse',
    unicode: 'f487',
    styles: ['solid'],
    searchTerms: [
      'EKG',
      'bed',
      'electrocardiogram',
      'health',
      'hospital',
      'life',
      'patient',
      'vital',
    ],
    categories: ['medical-health'],
    aliases: ['procedures'],
  },
  {
    name: 'beer-mug-empty',
    label: 'Beer Mug Empty',
    unicode: 'f0fc',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'ale',
      'bar',
      'beverage',
      'brew',
      'brewery',
      'drink',
      'foam',
      'lager',
      'liquor',
      'mug',
      'stein',
    ],
    categories: ['food-beverage', 'maps'],
    aliases: ['beer'],
  },
  {
    name: 'behance',
    label: 'Behance',
    unicode: 'f1b4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bell',
    label: 'Bell',
    unicode: 'f0f3',
    styles: ['regular', 'solid'],
    searchTerms: [
      'alarm',
      'alert',
      'bel',
      'bell',
      'chime',
      'notification',
      'reminder',
      'request',
    ],
    categories: [
      'alert',
      'education',
      'household',
      'maps',
      'shopping',
      'social',
      'time',
    ],
  },
  {
    name: 'bell-concierge',
    label: 'Bell Concierge',
    unicode: 'f562',
    styles: ['solid'],
    searchTerms: [
      'attention',
      'bell',
      'bellhop',
      'bellhop bell',
      'hotel',
      'receptionist',
      'request',
      'service',
      'support',
    ],
    categories: ['travel-hotel'],
    aliases: ['concierge-bell'],
  },
  {
    name: 'bell-slash',
    label: 'Bell Slash',
    unicode: 'f1f6',
    styles: ['regular', 'solid'],
    searchTerms: [
      'alert',
      'bell',
      'bell with slash',
      'cancel',
      'disabled',
      'forbidden',
      'mute',
      'notification',
      'off',
      'quiet',
      'reminder',
      'silent',
    ],
    categories: ['alert', 'education', 'maps', 'time'],
  },
  {
    name: 'bezier-curve',
    label: 'Bezier Curve',
    unicode: 'f55b',
    styles: ['solid'],
    searchTerms: ['curves', 'illustrator', 'lines', 'path', 'vector'],
    categories: ['design'],
  },
  {
    name: 'bicycle',
    label: 'Bicycle',
    unicode: 'f206',
    styles: ['solid'],
    searchTerms: [
      'bicycle',
      'bike',
      'gears',
      'pedal',
      'transportation',
      'vehicle',
    ],
    categories: ['maps', 'sports-fitness', 'transportation'],
  },
  {
    name: 'bilibili',
    label: 'Bilibili',
    unicode: 'e3d9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bimobject',
    label: 'BIMobject',
    unicode: 'f378',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'binoculars',
    label: 'Binoculars',
    unicode: 'f1e5',
    styles: ['solid'],
    searchTerms: [
      'glasses',
      'inspection',
      'magnifier',
      'magnify',
      'scenic',
      'spyglass',
      'view',
    ],
    categories: ['astronomy', 'camping', 'maps', 'nature'],
  },
  {
    name: 'biohazard',
    label: 'Biohazard',
    unicode: 'f780',
    styles: ['solid'],
    searchTerms: [
      'biohazard',
      'covid-19',
      'danger',
      'dangerous',
      'epidemic',
      'hazmat',
      'medical',
      'pandemic',
      'radioactive',
      'sign',
      'toxic',
      'waste',
      'zombie',
    ],
    categories: ['disaster', 'humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'bitbucket',
    label: 'Bitbucket',
    unicode: 'f171',
    styles: ['brands'],
    searchTerms: ['atlassian', 'bitbucket-square', 'git'],
    categories: [],
  },
  {
    name: 'bitcoin',
    label: 'Bitcoin',
    unicode: 'f379',
    styles: ['brands'],
    searchTerms: [],
    categories: ['money', 'shopping'],
  },
  {
    name: 'bitcoin-sign',
    label: 'Bitcoin Sign',
    unicode: 'e0b4',
    styles: ['solid'],
    searchTerms: ['Bitcoin Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'bity',
    label: 'Bity',
    unicode: 'f37a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'black-tie',
    label: 'Font Awesome Black Tie',
    unicode: 'f27e',
    styles: ['brands'],
    searchTerms: ['administrator'],
    categories: [],
  },
  {
    name: 'blackberry',
    label: 'BlackBerry',
    unicode: 'f37b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'blender',
    label: 'Blender',
    unicode: 'f517',
    styles: ['solid'],
    searchTerms: ['cocktail', 'milkshake', 'mixer', 'puree', 'smoothie'],
    categories: ['food-beverage', 'household'],
  },
  {
    name: 'blender-phone',
    label: 'Blender Phone',
    unicode: 'f6b6',
    styles: ['solid'],
    searchTerms: [
      'appliance',
      'cocktail',
      'fantasy',
      'milkshake',
      'mixer',
      'puree',
      'silly',
      'smoothie',
    ],
    categories: ['communication', 'devices-hardware'],
  },
  {
    name: 'blog',
    label: 'Blog',
    unicode: 'f781',
    styles: ['solid'],
    searchTerms: [
      'journal',
      'log',
      'online',
      'personal',
      'post',
      'web 2.0',
      'wordpress',
      'writing',
    ],
    categories: ['writing'],
  },
  {
    name: 'blogger',
    label: 'Blogger',
    unicode: 'f37c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'blogger-b',
    label: 'Blogger B',
    unicode: 'f37d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bluesky',
    label: 'Bluesky',
    unicode: 'e671',
    styles: ['brands'],
    searchTerms: ['social network'],
    categories: ['social'],
  },
  {
    name: 'bluetooth',
    label: 'Bluetooth',
    unicode: 'f293',
    styles: ['brands'],
    searchTerms: ['signal'],
    categories: ['connectivity'],
  },
  {
    name: 'bluetooth-b',
    label: 'Bluetooth',
    unicode: 'f294',
    styles: ['brands'],
    searchTerms: [],
    categories: ['communication'],
  },
  {
    name: 'bold',
    label: 'Bold',
    unicode: 'f032',
    styles: ['solid'],
    searchTerms: ['emphasis', 'format', 'text'],
    categories: ['text-formatting'],
  },
  {
    name: 'bolt',
    label: 'Bolt',
    unicode: 'f0e7',
    styles: ['solid'],
    searchTerms: [
      'charge',
      'danger',
      'electric',
      'electricity',
      'flash',
      'high voltage',
      'lightning',
      'voltage',
      'weather',
      'zap',
    ],
    categories: ['energy', 'photos-images', 'weather'],
    aliases: ['zap'],
  },
  {
    name: 'bolt-lightning',
    label: 'Bolt Lightning',
    unicode: 'e0b7',
    styles: ['solid'],
    searchTerms: ['electricity', 'flash', 'lightning', 'weather', 'zap'],
    categories: ['photos-images', 'weather'],
  },
  {
    name: 'bomb',
    label: 'Bomb',
    unicode: 'f1e2',
    styles: ['solid'],
    searchTerms: [
      'bomb',
      'comic',
      'error',
      'explode',
      'fuse',
      'grenade',
      'warning',
    ],
    categories: ['maps'],
  },
  {
    name: 'bone',
    label: 'Bone',
    unicode: 'f5d7',
    styles: ['solid'],
    searchTerms: ['bone', 'calcium', 'dog', 'skeletal', 'skeleton', 'tibia'],
    categories: ['food-beverage', 'medical-health'],
  },
  {
    name: 'bong',
    label: 'Bong',
    unicode: 'f55c',
    styles: ['solid'],
    searchTerms: [
      'aparatus',
      'cannabis',
      'marijuana',
      'pipe',
      'smoke',
      'smoking',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'book',
    label: 'Book',
    unicode: 'f02d',
    styles: ['solid'],
    searchTerms: [
      'book',
      'cover',
      'decorated',
      'diary',
      'documentation',
      'journal',
      'knowledge',
      'library',
      'notebook',
      'notebook with decorative cover',
      'read',
      'research',
      'scholar',
    ],
    categories: ['business', 'maps', 'writing'],
  },
  {
    name: 'book-atlas',
    label: 'Book Atlas',
    unicode: 'f558',
    styles: ['solid'],
    searchTerms: [
      'book',
      'directions',
      'geography',
      'globe',
      'knowledge',
      'library',
      'map',
      'research',
      'travel',
      'wayfinding',
    ],
    categories: ['maps', 'travel-hotel'],
    aliases: ['atlas'],
  },
  {
    name: 'book-bible',
    label: 'Book Bible',
    unicode: 'f647',
    styles: ['solid'],
    searchTerms: ['book', 'catholicism', 'christianity', 'god', 'holy'],
    categories: ['religion'],
    aliases: ['bible'],
  },
  {
    name: 'book-bookmark',
    label: 'Book Bookmark',
    unicode: 'e0bb',
    styles: ['solid'],
    searchTerms: ['knowledge', 'library', 'research'],
    categories: ['humanitarian', 'writing'],
  },
  {
    name: 'book-journal-whills',
    label: 'Book Journal Whills',
    unicode: 'f66a',
    styles: ['solid'],
    searchTerms: ['book', 'force', 'jedi', 'sith', 'star wars', 'yoda'],
    categories: ['religion', 'science-fiction'],
    aliases: ['journal-whills'],
  },
  {
    name: 'book-medical',
    label: 'Book Medical',
    unicode: 'f7e6',
    styles: ['solid'],
    searchTerms: [
      'diary',
      'documentation',
      'health',
      'history',
      'journal',
      'library',
      'read',
      'record',
      'research',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'book-open',
    label: 'Book Open',
    unicode: 'f518',
    styles: ['solid'],
    searchTerms: [
      'Book',
      'book',
      'flyer',
      'knowledge',
      'library',
      'notebook',
      'open',
      'open book',
      'pamphlet',
      'reading',
      'research',
    ],
    categories: ['education'],
  },
  {
    name: 'book-open-reader',
    label: 'Book Open Reader',
    unicode: 'f5da',
    styles: ['solid'],
    searchTerms: [
      'flyer',
      'library',
      'notebook',
      'open book',
      'pamphlet',
      'reading',
      'research',
    ],
    categories: ['education'],
    aliases: ['book-reader'],
  },
  {
    name: 'book-quran',
    label: 'Book Quran',
    unicode: 'f687',
    styles: ['solid'],
    searchTerms: ['book', 'islam', 'muslim', 'religion'],
    categories: ['religion'],
    aliases: ['quran'],
  },
  {
    name: 'book-skull',
    label: 'Book Skull',
    unicode: 'f6b7',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'crossbones',
      'd&d',
      'dark arts',
      'death',
      'dnd',
      'documentation',
      'evil',
      'fantasy',
      'halloween',
      'holiday',
      'library',
      'necronomicon',
      'read',
      'research',
      'skull',
      'spell',
    ],
    categories: ['gaming', 'halloween'],
    aliases: ['book-dead'],
  },
  {
    name: 'book-tanakh',
    label: 'Book Tanakh',
    unicode: 'f827',
    styles: ['solid'],
    searchTerms: ['book', 'jewish', 'judaism', 'religion'],
    categories: ['religion'],
    aliases: ['tanakh'],
  },
  {
    name: 'bookmark',
    label: 'Bookmark',
    unicode: 'f02e',
    styles: ['regular', 'solid'],
    searchTerms: [
      'bookmark',
      'favorite',
      'library',
      'mark',
      'marker',
      'read',
      'remember',
      'research',
      'save',
    ],
    categories: ['maps', 'shapes', 'shopping', 'writing'],
  },
  {
    name: 'bootstrap',
    label: 'Bootstrap',
    unicode: 'f836',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'border-all',
    label: 'Border All',
    unicode: 'f84c',
    styles: ['solid'],
    searchTerms: ['cell', 'grid', 'outline', 'stroke', 'table'],
    categories: ['text-formatting'],
  },
  {
    name: 'border-none',
    label: 'Border None',
    unicode: 'f850',
    styles: ['solid'],
    searchTerms: ['cell', 'grid', 'outline', 'stroke', 'table'],
    categories: ['text-formatting'],
  },
  {
    name: 'border-top-left',
    label: 'Border Top Left',
    unicode: 'f853',
    styles: ['solid'],
    searchTerms: ['cell', 'outline', 'stroke', 'table'],
    categories: ['text-formatting'],
    aliases: ['border-style'],
  },
  {
    name: 'bore-hole',
    label: 'Bore Hole',
    unicode: 'e4c3',
    styles: ['solid'],
    searchTerms: ['bore', 'bury', 'drill', 'hole'],
    categories: ['construction', 'humanitarian'],
  },
  {
    name: 'bots',
    label: 'Bots',
    unicode: 'e340',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bottle-droplet',
    label: 'Bottle Droplet',
    unicode: 'e4c4',
    styles: ['solid'],
    searchTerms: ['alcohol', 'drink', 'oil', 'olive oil', 'wine'],
    categories: ['food-beverage', 'humanitarian'],
  },
  {
    name: 'bottle-water',
    label: 'Bottle Water',
    unicode: 'e4c5',
    styles: ['solid'],
    searchTerms: ['h2o', 'plastic', 'water'],
    categories: ['camping', 'food-beverage', 'humanitarian'],
  },
  {
    name: 'bowl-food',
    label: 'Bowl Food',
    unicode: 'e4c6',
    styles: ['solid'],
    searchTerms: ['catfood', 'dogfood', 'food', 'rice'],
    categories: ['food-beverage', 'humanitarian'],
  },
  {
    name: 'bowl-rice',
    label: 'Bowl Rice',
    unicode: 'e2eb',
    styles: ['solid'],
    searchTerms: ['boiled', 'cooked', 'cooked rice', 'rice', 'steamed'],
    categories: ['food-beverage', 'humanitarian'],
  },
  {
    name: 'bowling-ball',
    label: 'Bowling Ball',
    unicode: 'f436',
    styles: ['solid'],
    searchTerms: ['alley', 'candlepin', 'gutter', 'lane', 'strike', 'tenpin'],
    categories: ['sports-fitness'],
  },
  {
    name: 'box',
    label: 'Box',
    unicode: 'f466',
    styles: ['solid'],
    searchTerms: [
      'archive',
      'box',
      'container',
      'package',
      'parcel',
      'storage',
    ],
    categories: ['logistics'],
  },
  {
    name: 'box-archive',
    label: 'Box Archive',
    unicode: 'f187',
    styles: ['solid'],
    searchTerms: ['box', 'package', 'save', 'storage'],
    categories: ['business', 'coding', 'files', 'moving', 'writing'],
    aliases: ['archive'],
  },
  {
    name: 'box-open',
    label: 'Box Open',
    unicode: 'f49e',
    styles: ['solid'],
    searchTerms: ['archive', 'container', 'package', 'storage', 'unpack'],
    categories: ['moving'],
  },
  {
    name: 'box-tissue',
    label: 'Box Tissue',
    unicode: 'e05b',
    styles: ['solid'],
    searchTerms: [
      'cough',
      'covid-19',
      'kleenex',
      'mucus',
      'nose',
      'sneeze',
      'snot',
    ],
    categories: ['household'],
  },
  {
    name: 'boxes-packing',
    label: 'Boxes Packing',
    unicode: 'e4c7',
    styles: ['solid'],
    searchTerms: ['archive', 'box', 'package', 'storage', 'supplies'],
    categories: ['business', 'humanitarian', 'logistics', 'moving'],
  },
  {
    name: 'boxes-stacked',
    label: 'Boxes Stacked',
    unicode: 'f468',
    styles: ['solid'],
    searchTerms: ['archives', 'inventory', 'storage', 'warehouse'],
    categories: ['logistics'],
    aliases: ['boxes', 'boxes-alt'],
  },
  {
    name: 'braille',
    label: 'Braille',
    unicode: 'f2a1',
    styles: ['solid'],
    searchTerms: ['alphabet', 'blind', 'dots', 'raised', 'vision'],
    categories: ['accessibility'],
  },
  {
    name: 'brain',
    label: 'Brain',
    unicode: 'f5dc',
    styles: ['solid'],
    searchTerms: [
      'brain',
      'cerebellum',
      'gray matter',
      'intellect',
      'intelligent',
      'knowledge',
      'medulla oblongata',
      'mind',
      'noodle',
      'scholar',
      'wit',
    ],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'brave',
    label: 'Brave',
    unicode: 'e63c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'brave-reverse',
    label: 'Brave Reverse',
    unicode: 'e63d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'brazilian-real-sign',
    label: 'Brazilian Real Sign',
    unicode: 'e46c',
    styles: ['solid'],
    searchTerms: ['brazilian real sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'bread-slice',
    label: 'Bread Slice',
    unicode: 'f7ec',
    styles: ['solid'],
    searchTerms: [
      'bake',
      'bakery',
      'baking',
      'dough',
      'flour',
      'gluten',
      'grain',
      'sandwich',
      'sourdough',
      'toast',
      'wheat',
      'yeast',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'bridge',
    label: 'Bridge',
    unicode: 'e4c8',
    styles: ['solid'],
    searchTerms: ['bridge', 'road'],
    categories: ['humanitarian', 'logistics', 'maps'],
  },
  {
    name: 'bridge-circle-check',
    label: 'Bridge Circle Check',
    unicode: 'e4c9',
    styles: ['solid'],
    searchTerms: [
      'bridge',
      'enable',
      'not affected',
      'ok',
      'okay',
      'road',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'bridge-circle-exclamation',
    label: 'Bridge Circle Exclamation',
    unicode: 'e4ca',
    styles: ['solid'],
    searchTerms: ['affected', 'bridge', 'failed', 'road'],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'bridge-circle-xmark',
    label: 'Bridge Circle Xmark',
    unicode: 'e4cb',
    styles: ['solid'],
    searchTerms: ['bridge', 'destroy', 'road', 'uncheck'],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'bridge-lock',
    label: 'Bridge Lock',
    unicode: 'e4cc',
    styles: ['solid'],
    searchTerms: [
      'bridge',
      'closed',
      'lockdown',
      'padlock',
      'privacy',
      'quarantine',
      'road',
    ],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'bridge-water',
    label: 'Bridge Water',
    unicode: 'e4ce',
    styles: ['solid'],
    searchTerms: ['bridge', 'road'],
    categories: ['humanitarian', 'logistics', 'maps'],
  },
  {
    name: 'briefcase',
    label: 'Briefcase',
    unicode: 'f0b1',
    styles: ['solid'],
    searchTerms: [
      'bag',
      'briefcas',
      'briefcase',
      'business',
      'luggage',
      'offer',
      'office',
      'portfolio',
      'work',
    ],
    categories: ['business', 'maps', 'travel-hotel'],
  },
  {
    name: 'briefcase-medical',
    label: 'Briefcase Medical',
    unicode: 'f469',
    styles: ['solid'],
    searchTerms: ['doctor', 'emt', 'first aid', 'health'],
    categories: ['medical-health'],
  },
  {
    name: 'broom',
    label: 'Broom',
    unicode: 'f51a',
    styles: ['solid'],
    searchTerms: [
      'broom',
      'clean',
      'cleaning',
      'firebolt',
      'fly',
      'halloween',
      'nimbus 2000',
      'quidditch',
      'sweep',
      'sweeping',
      'witch',
    ],
    categories: ['halloween'],
  },
  {
    name: 'broom-ball',
    label: 'Broom Ball',
    unicode: 'f458',
    styles: ['solid'],
    searchTerms: [
      'ball',
      'bludger',
      'broom',
      'golden snitch',
      'harry potter',
      'hogwarts',
      'quaffle',
      'sport',
      'wizard',
    ],
    categories: ['sports-fitness'],
    aliases: ['quidditch', 'quidditch-broom-ball'],
  },
  {
    name: 'brush',
    label: 'Brush',
    unicode: 'f55d',
    styles: ['solid'],
    searchTerms: [
      'art',
      'bristles',
      'color',
      'handle',
      'maintenance',
      'modify',
      'paint',
    ],
    categories: ['construction', 'design', 'editing'],
  },
  {
    name: 'btc',
    label: 'BTC',
    unicode: 'f15a',
    styles: ['brands'],
    searchTerms: [],
    categories: ['money', 'shopping'],
  },
  {
    name: 'bucket',
    label: 'Bucket',
    unicode: 'e4cf',
    styles: ['solid'],
    searchTerms: ['bucket', 'pail', 'sandcastle'],
    categories: ['camping', 'childhood', 'construction', 'humanitarian'],
  },
  {
    name: 'buffer',
    label: 'Buffer',
    unicode: 'f837',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'bug',
    label: 'Bug',
    unicode: 'f188',
    styles: ['solid'],
    searchTerms: ['beetle', 'error', 'glitch', 'insect', 'repair', 'report'],
    categories: ['coding', 'nature', 'security'],
  },
  {
    name: 'bug-slash',
    label: 'Bug Slash',
    unicode: 'e490',
    styles: ['solid'],
    searchTerms: [
      'beetle',
      'disabled',
      'fix',
      'glitch',
      'insect',
      'optimize',
      'repair',
      'report',
      'warning',
    ],
    categories: ['coding', 'security'],
  },
  {
    name: 'bugs',
    label: 'Bugs',
    unicode: 'e4d0',
    styles: ['solid'],
    searchTerms: ['bedbug', 'infestation', 'lice', 'plague', 'ticks'],
    categories: ['animals', 'disaster', 'humanitarian', 'nature'],
  },
  {
    name: 'building',
    label: 'Building',
    unicode: 'f1ad',
    styles: ['regular', 'solid'],
    searchTerms: [
      'apartment',
      'building',
      'business',
      'city',
      'company',
      'office',
      'office building',
      'urban',
      'work',
    ],
    categories: ['buildings', 'business', 'humanitarian', 'maps'],
  },
  {
    name: 'building-circle-arrow-right',
    label: 'Building Circle Arrow Right',
    unicode: 'e4d1',
    styles: ['solid'],
    searchTerms: ['building', 'city', 'distribution center', 'office'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-circle-check',
    label: 'Building Circle Check',
    unicode: 'e4d2',
    styles: ['solid'],
    searchTerms: [
      'building',
      'city',
      'enable',
      'not affected',
      'office',
      'ok',
      'okay',
      'validate',
      'working',
    ],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-circle-exclamation',
    label: 'Building Circle Exclamation',
    unicode: 'e4d3',
    styles: ['solid'],
    searchTerms: ['affected', 'building', 'city', 'failed', 'office'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-circle-xmark',
    label: 'Building Circle Xmark',
    unicode: 'e4d4',
    styles: ['solid'],
    searchTerms: ['building', 'city', 'destroy', 'office', 'uncheck'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-columns',
    label: 'Building Columns',
    unicode: 'f19c',
    styles: ['solid'],
    searchTerms: [
      'bank',
      'building',
      'college',
      'education',
      'institution',
      'museum',
      'students',
    ],
    categories: ['buildings', 'humanitarian', 'maps'],
    aliases: ['bank', 'institution', 'museum', 'university'],
  },
  {
    name: 'building-flag',
    label: 'Building Flag',
    unicode: 'e4d5',
    styles: ['solid'],
    searchTerms: [
      'building',
      'city',
      'diplomat',
      'embassy',
      'flag',
      'headquarters',
      'united nations',
    ],
    categories: ['buildings', 'humanitarian', 'political'],
  },
  {
    name: 'building-lock',
    label: 'Building Lock',
    unicode: 'e4d6',
    styles: ['solid'],
    searchTerms: [
      'building',
      'city',
      'closed',
      'lock',
      'lockdown',
      'padlock',
      'privacy',
      'quarantine',
      'secure',
    ],
    categories: ['buildings', 'humanitarian', 'security'],
  },
  {
    name: 'building-ngo',
    label: 'Building Ngo',
    unicode: 'e4d7',
    styles: ['solid'],
    searchTerms: [
      'building',
      'city',
      'non governmental organization',
      'office',
    ],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-shield',
    label: 'Building Shield',
    unicode: 'e4d8',
    styles: ['solid'],
    searchTerms: ['building', 'city', 'police', 'protect', 'safety'],
    categories: ['buildings', 'humanitarian', 'security'],
  },
  {
    name: 'building-un',
    label: 'Building Un',
    unicode: 'e4d9',
    styles: ['solid'],
    searchTerms: ['building', 'city', 'office', 'united nations'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-user',
    label: 'Building User',
    unicode: 'e4da',
    styles: ['solid'],
    searchTerms: ['apartment', 'building', 'city', 'employee', 'uer'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'building-wheat',
    label: 'Building Wheat',
    unicode: 'e4db',
    styles: ['solid'],
    searchTerms: ['agriculture', 'building', 'city', 'usda'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'bullhorn',
    label: 'Bullhorn',
    unicode: 'f0a1',
    styles: ['solid'],
    searchTerms: [
      'Bullhorn',
      'announcement',
      'broadcast',
      'loud',
      'louder',
      'loudspeaker',
      'megaphone',
      'public address',
      'request',
      'share',
    ],
    categories: [
      'business',
      'communication',
      'marketing',
      'political',
      'shopping',
    ],
  },
  {
    name: 'bullseye',
    label: 'Bullseye',
    unicode: 'f140',
    styles: ['solid'],
    searchTerms: ['archery', 'goal', 'objective', 'strategy', 'target'],
    categories: ['business', 'marketing', 'toggle'],
  },
  {
    name: 'burger',
    label: 'Burger',
    unicode: 'f805',
    styles: ['solid'],
    searchTerms: [
      'bacon',
      'beef',
      'burger',
      'burger king',
      'cheeseburger',
      'fast food',
      'grill',
      'ground beef',
      'mcdonalds',
      'sandwich',
    ],
    categories: ['food-beverage'],
    aliases: ['hamburger'],
  },
  {
    name: 'buromobelexperte',
    label: 'Büromöbel-Experte GmbH & Co. KG.',
    unicode: 'f37f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'burst',
    label: 'Burst',
    unicode: 'e4dc',
    styles: ['solid'],
    searchTerms: ['boom', 'crash', 'explosion'],
    categories: ['disaster', 'humanitarian', 'security', 'shapes'],
  },
  {
    name: 'bus',
    label: 'Bus',
    unicode: 'f207',
    styles: ['solid'],
    searchTerms: [
      'bus',
      'oncoming',
      'oncoming bus',
      'public transportation',
      'transportation',
      'travel',
      'vehicle',
    ],
    categories: [
      'automotive',
      'humanitarian',
      'logistics',
      'transportation',
      'travel-hotel',
    ],
  },
  {
    name: 'bus-simple',
    label: 'Bus Simple',
    unicode: 'f55e',
    styles: ['solid'],
    searchTerms: [
      'mta',
      'public transportation',
      'transportation',
      'travel',
      'vehicle',
    ],
    categories: ['automotive', 'logistics', 'transportation', 'travel-hotel'],
    aliases: ['bus-alt'],
  },
  {
    name: 'business-time',
    label: 'Business Time',
    unicode: 'f64a',
    styles: ['solid'],
    searchTerms: [
      'alarm',
      'briefcase',
      'business socks',
      'clock',
      'flight of the conchords',
      'portfolio',
      'reminder',
      'wednesday',
    ],
    categories: ['business'],
    aliases: ['briefcase-clock'],
  },
  {
    name: 'buy-n-large',
    label: 'Buy n Large',
    unicode: 'f8a6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'buysellads',
    label: 'BuySellAds',
    unicode: 'f20d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'c',
    label: 'C',
    unicode: '43',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter C', 'Latin Small Letter C', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'cable-car',
    label: 'Cable Car',
    unicode: 'f7da',
    styles: ['solid'],
    searchTerms: [
      'aerial tramway',
      'cable',
      'gondola',
      'lift',
      'mountain',
      'mountain cableway',
      'tram',
      'tramway',
      'trolley',
    ],
    categories: ['transportation', 'travel-hotel'],
    aliases: ['tram'],
  },
  {
    name: 'cake-candles',
    label: 'Cake Candles',
    unicode: 'f1fd',
    styles: ['solid'],
    searchTerms: [
      'anniversary',
      'bakery',
      'birthday',
      'birthday cake',
      'cake',
      'candles',
      'celebration',
      'dessert',
      'frosting',
      'holiday',
      'party',
      'pastry',
      'sweet',
    ],
    categories: ['business', 'childhood', 'food-beverage', 'maps', 'social'],
    aliases: ['birthday-cake', 'cake'],
  },
  {
    name: 'calculator',
    label: 'Calculator',
    unicode: 'f1ec',
    styles: ['solid'],
    searchTerms: [
      'Pocket Calculator',
      'abacus',
      'addition',
      'arithmetic',
      'counting',
      'math',
      'multiplication',
      'subtraction',
    ],
    categories: ['business', 'mathematics'],
  },
  {
    name: 'calendar',
    label: 'Calendar',
    unicode: 'f133',
    styles: ['regular', 'solid'],
    searchTerms: [
      'calendar',
      'calendar-o',
      'date',
      'day',
      'event',
      'month',
      'schedule',
      'tear-off calendar',
      'time',
      'when',
      'year',
    ],
    categories: ['business', 'shapes', 'time'],
  },
  {
    name: 'calendar-check',
    label: 'Calendar Check',
    unicode: 'f274',
    styles: ['regular', 'solid'],
    searchTerms: [
      'accept',
      'agree',
      'appointment',
      'confirm',
      'correct',
      'date',
      'day',
      'done',
      'enable',
      'event',
      'month',
      'ok',
      'schedule',
      'select',
      'success',
      'tick',
      'time',
      'todo',
      'validate',
      'warranty',
      'when',
      'working',
      'year',
    ],
    categories: ['time'],
  },
  {
    name: 'calendar-day',
    label: 'Calendar Day',
    unicode: 'f783',
    styles: ['solid'],
    searchTerms: [
      'date',
      'day',
      'detail',
      'event',
      'focus',
      'month',
      'schedule',
      'single day',
      'time',
      'today',
      'when',
      'year',
    ],
    categories: ['time'],
  },
  {
    name: 'calendar-days',
    label: 'Calendar Days',
    unicode: 'f073',
    styles: ['regular', 'solid'],
    searchTerms: [
      'calendar',
      'date',
      'day',
      'event',
      'month',
      'schedule',
      'time',
      'when',
      'year',
    ],
    categories: ['business', 'time'],
    aliases: ['calendar-alt'],
  },
  {
    name: 'calendar-minus',
    label: 'Calendar Minus',
    unicode: 'f272',
    styles: ['regular', 'solid'],
    searchTerms: [
      'calendar',
      'date',
      'day',
      'delete',
      'event',
      'month',
      'negative',
      'remove',
      'schedule',
      'time',
      'when',
      'year',
    ],
    categories: ['time'],
  },
  {
    name: 'calendar-plus',
    label: 'Calendar Plus',
    unicode: 'f271',
    styles: ['regular', 'solid'],
    searchTerms: [
      'add',
      'calendar',
      'create',
      'date',
      'day',
      'event',
      'month',
      'new',
      'positive',
      'schedule',
      'time',
      'when',
      'year',
    ],
    categories: ['time'],
  },
  {
    name: 'calendar-week',
    label: 'Calendar Week',
    unicode: 'f784',
    styles: ['solid'],
    searchTerms: [
      'date',
      'day',
      'detail',
      'event',
      'focus',
      'month',
      'schedule',
      'single week',
      'time',
      'today',
      'when',
      'year',
    ],
    categories: ['time'],
  },
  {
    name: 'calendar-xmark',
    label: 'Calendar Xmark',
    unicode: 'f273',
    styles: ['regular', 'solid'],
    searchTerms: [
      'archive',
      'calendar',
      'date',
      'day',
      'delete',
      'event',
      'month',
      'remove',
      'schedule',
      'time',
      'uncheck',
      'when',
      'x',
      'year',
    ],
    categories: ['time'],
    aliases: ['calendar-times'],
  },
  {
    name: 'camera',
    label: 'Camera',
    unicode: 'f030',
    styles: ['solid'],
    searchTerms: [
      'image',
      'img',
      'lens',
      'photo',
      'picture',
      'record',
      'shutter',
      'video',
    ],
    categories: ['devices-hardware', 'photos-images', 'shopping', 'social'],
    aliases: ['camera-alt'],
  },
  {
    name: 'camera-retro',
    label: 'Camera Retro',
    unicode: 'f083',
    styles: ['solid'],
    searchTerms: [
      'camera',
      'image',
      'img',
      'lens',
      'photo',
      'picture',
      'record',
      'shutter',
      'video',
    ],
    categories: ['devices-hardware', 'photos-images', 'shopping'],
  },
  {
    name: 'camera-rotate',
    label: 'Camera Rotate',
    unicode: 'e0d8',
    styles: ['solid'],
    searchTerms: ['flip', 'front-facing', 'img', 'photo', 'selfie'],
    categories: ['photos-images'],
  },
  {
    name: 'campground',
    label: 'Campground',
    unicode: 'f6bb',
    styles: ['solid'],
    searchTerms: ['camping', 'fall', 'outdoors', 'teepee', 'tent', 'tipi'],
    categories: ['buildings', 'camping'],
  },
  {
    name: 'canadian-maple-leaf',
    label: 'Canadian Maple Leaf',
    unicode: 'f785',
    styles: ['brands'],
    searchTerms: ['canada', 'flag', 'flora', 'nature', 'plant'],
    categories: [],
  },
  {
    name: 'candy-cane',
    label: 'Candy Cane',
    unicode: 'f786',
    styles: ['solid'],
    searchTerms: [
      'candy',
      'christmas',
      'holiday',
      'mint',
      'peppermint',
      'striped',
      'xmas',
    ],
    categories: ['food-beverage', 'holidays'],
  },
  {
    name: 'cannabis',
    label: 'Cannabis',
    unicode: 'f55f',
    styles: ['solid'],
    searchTerms: [
      'bud',
      'chronic',
      'drugs',
      'endica',
      'endo',
      'ganja',
      'marijuana',
      'mary jane',
      'pot',
      'reefer',
      'sativa',
      'spliff',
      'weed',
      'whacky-tabacky',
    ],
    categories: ['medical-health', 'nature'],
  },
  {
    name: 'capsules',
    label: 'Capsules',
    unicode: 'f46b',
    styles: ['solid'],
    searchTerms: ['drugs', 'medicine', 'pills', 'prescription'],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'car',
    label: 'Car',
    unicode: 'f1b9',
    styles: ['solid'],
    searchTerms: [
      'auto',
      'automobile',
      'car',
      'oncoming',
      'oncoming automobile',
      'sedan',
      'transportation',
      'travel',
      'vehicle',
    ],
    categories: [
      'automotive',
      'humanitarian',
      'logistics',
      'maps',
      'transportation',
      'travel-hotel',
    ],
    aliases: ['automobile'],
  },
  {
    name: 'car-battery',
    label: 'Car Battery',
    unicode: 'f5df',
    styles: ['solid'],
    searchTerms: ['auto', 'electric', 'mechanic', 'power'],
    categories: ['automotive', 'devices-hardware', 'energy'],
    aliases: ['battery-car'],
  },
  {
    name: 'car-burst',
    label: 'Car Burst',
    unicode: 'f5e1',
    styles: ['solid'],
    searchTerms: [
      'accident',
      'auto',
      'automobile',
      'insurance',
      'sedan',
      'transportation',
      'vehicle',
      'wreck',
    ],
    categories: ['automotive', 'transportation'],
    aliases: ['car-crash'],
  },
  {
    name: 'car-on',
    label: 'Car On',
    unicode: 'e4dd',
    styles: ['solid'],
    searchTerms: ['alarm', 'car', 'carjack', 'warning'],
    categories: ['automotive', 'humanitarian', 'security'],
  },
  {
    name: 'car-rear',
    label: 'Car Rear',
    unicode: 'f5de',
    styles: ['solid'],
    searchTerms: [
      'auto',
      'automobile',
      'sedan',
      'transportation',
      'travel',
      'vehicle',
    ],
    categories: ['automotive', 'transportation'],
    aliases: ['car-alt'],
  },
  {
    name: 'car-side',
    label: 'Car Side',
    unicode: 'f5e4',
    styles: ['solid'],
    searchTerms: [
      'auto',
      'automobile',
      'car',
      'sedan',
      'transportation',
      'travel',
      'vehicle',
    ],
    categories: ['automotive', 'transportation'],
  },
  {
    name: 'car-tunnel',
    label: 'Car Tunnel',
    unicode: 'e4de',
    styles: ['solid'],
    searchTerms: ['road', 'tunnel'],
    categories: ['automotive', 'humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'caravan',
    label: 'Caravan',
    unicode: 'f8ff',
    styles: ['solid'],
    searchTerms: ['camper', 'motor home', 'rv', 'trailer', 'travel'],
    categories: ['automotive', 'camping', 'moving', 'travel-hotel'],
  },
  {
    name: 'caret-down',
    label: 'Caret Down',
    unicode: 'f0d7',
    styles: ['solid'],
    searchTerms: ['arrow', 'dropdown', 'expand', 'menu', 'more', 'triangle'],
    categories: ['arrows'],
  },
  {
    name: 'caret-left',
    label: 'Caret Left',
    unicode: 'f0d9',
    styles: ['solid'],
    searchTerms: ['arrow', 'back', 'previous', 'triangle'],
    categories: ['arrows'],
  },
  {
    name: 'caret-right',
    label: 'Caret Right',
    unicode: 'f0da',
    styles: ['solid'],
    searchTerms: ['arrow', 'forward', 'next', 'triangle'],
    categories: ['arrows'],
  },
  {
    name: 'caret-up',
    label: 'Caret Up',
    unicode: 'f0d8',
    styles: ['solid'],
    searchTerms: ['arrow', 'collapse', 'triangle', 'upgrade'],
    categories: ['arrows'],
  },
  {
    name: 'carrot',
    label: 'Carrot',
    unicode: 'f787',
    styles: ['solid'],
    searchTerms: [
      'bugs bunny',
      'carrot',
      'food',
      'orange',
      'vegan',
      'vegetable',
    ],
    categories: ['food-beverage', 'fruits-vegetables', 'holidays'],
  },
  {
    name: 'cart-arrow-down',
    label: 'Cart Arrow Down',
    unicode: 'f218',
    styles: ['solid'],
    searchTerms: ['download', 'insert', 'save', 'shopping'],
    categories: ['shopping'],
  },
  {
    name: 'cart-flatbed',
    label: 'Cart Flatbed',
    unicode: 'f474',
    styles: ['solid'],
    searchTerms: ['carry', 'inventory', 'shipping', 'transport'],
    categories: ['logistics'],
    aliases: ['dolly-flatbed'],
  },
  {
    name: 'cart-flatbed-suitcase',
    label: 'Cart Flatbed Suitcase',
    unicode: 'f59d',
    styles: ['solid'],
    searchTerms: ['airport', 'bag', 'baggage', 'suitcase', 'travel'],
    categories: ['travel-hotel'],
    aliases: ['luggage-cart'],
  },
  {
    name: 'cart-plus',
    label: 'Cart Plus',
    unicode: 'f217',
    styles: ['solid'],
    searchTerms: ['add', 'create', 'new', 'positive', 'shopping'],
    categories: ['shopping'],
  },
  {
    name: 'cart-shopping',
    label: 'Cart Shopping',
    unicode: 'f07a',
    styles: ['solid'],
    searchTerms: [
      'buy',
      'cart',
      'checkout',
      'grocery',
      'payment',
      'purchase',
      'shopping',
      'shopping cart',
      'trolley',
    ],
    categories: ['maps', 'shopping', 'transportation'],
    aliases: ['shopping-cart'],
  },
  {
    name: 'cash-register',
    label: 'Cash Register',
    unicode: 'f788',
    styles: ['solid'],
    searchTerms: [
      'buy',
      'cha-ching',
      'change',
      'checkout',
      'commerce',
      'leaerboard',
      'machine',
      'pay',
      'payment',
      'purchase',
      'store',
    ],
    categories: ['money', 'shopping'],
  },
  {
    name: 'cat',
    label: 'Cat',
    unicode: 'f6be',
    styles: ['solid'],
    searchTerms: [
      'cat',
      'feline',
      'halloween',
      'holiday',
      'kitten',
      'kitty',
      'meow',
      'pet',
    ],
    categories: ['animals', 'halloween'],
  },
  {
    name: 'cc-amazon-pay',
    label: 'Amazon Pay Credit Card',
    unicode: 'f42d',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-amex',
    label: 'Cc Amex',
    unicode: 'f1f3',
    styles: ['brands'],
    searchTerms: ['amex'],
    categories: ['shopping'],
  },
  {
    name: 'cc-apple-pay',
    label: 'Apple Pay Credit Card',
    unicode: 'f416',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-diners-club',
    label: "Diner's Club Credit Card",
    unicode: 'f24c',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-discover',
    label: 'Discover Credit Card',
    unicode: 'f1f2',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-jcb',
    label: 'JCB Credit Card',
    unicode: 'f24b',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-mastercard',
    label: 'MasterCard Credit Card',
    unicode: 'f1f1',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-paypal',
    label: 'Paypal Credit Card',
    unicode: 'f1f4',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-stripe',
    label: 'Stripe Credit Card',
    unicode: 'f1f5',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cc-visa',
    label: 'Visa Credit Card',
    unicode: 'f1f0',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'cedi-sign',
    label: 'Cedi Sign',
    unicode: 'e0df',
    styles: ['solid'],
    searchTerms: ['Cedi Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'cent-sign',
    label: 'Cent Sign',
    unicode: 'e3f5',
    styles: ['solid'],
    searchTerms: ['Cent Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'centercode',
    label: 'Centercode',
    unicode: 'f380',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'centos',
    label: 'Centos',
    unicode: 'f789',
    styles: ['brands'],
    searchTerms: ['linux', 'operating system', 'os'],
    categories: [],
  },
  {
    name: 'certificate',
    label: 'Certificate',
    unicode: 'f0a3',
    styles: ['solid'],
    searchTerms: ['badge', 'guarantee', 'star', 'verified'],
    categories: ['business', 'shapes', 'shopping', 'spinners'],
  },
  {
    name: 'chair',
    label: 'Chair',
    unicode: 'f6c0',
    styles: ['solid'],
    searchTerms: ['chair', 'furniture', 'seat', 'sit'],
    categories: ['household'],
  },
  {
    name: 'chalkboard',
    label: 'Chalkboard',
    unicode: 'f51b',
    styles: ['solid'],
    searchTerms: [
      'blackboard',
      'learning',
      'school',
      'teaching',
      'whiteboard',
      'writing',
    ],
    categories: ['education', 'photos-images'],
    aliases: ['blackboard'],
  },
  {
    name: 'chalkboard-user',
    label: 'Chalkboard User',
    unicode: 'f51c',
    styles: ['solid'],
    searchTerms: [
      'blackboard',
      'instructor',
      'learning',
      'professor',
      'school',
      'uer',
      'whiteboard',
      'writing',
    ],
    categories: ['education', 'users-people'],
    aliases: ['chalkboard-teacher'],
  },
  {
    name: 'champagne-glasses',
    label: 'Champagne Glasses',
    unicode: 'f79f',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'bar',
      'beverage',
      'celebrate',
      'celebration',
      'champagne',
      'clink',
      'clinking glasses',
      'drink',
      'glass',
      'holiday',
      "new year's eve",
      'party',
      'toast',
    ],
    categories: ['food-beverage', 'holidays'],
    aliases: ['glass-cheers'],
  },
  {
    name: 'charging-station',
    label: 'Charging Station',
    unicode: 'f5e7',
    styles: ['solid'],
    searchTerms: ['electric', 'ev', 'tesla', 'vehicle'],
    categories: ['automotive', 'energy'],
  },
  {
    name: 'chart-area',
    label: 'Chart Area',
    unicode: 'f1fe',
    styles: ['solid'],
    searchTerms: [
      'analytics',
      'area',
      'chart',
      'graph',
      'performance',
      'revenue',
      'statistics',
    ],
    categories: ['charts-diagrams'],
    aliases: ['area-chart'],
  },
  {
    name: 'chart-bar',
    label: 'Chart Bar',
    unicode: 'f080',
    styles: ['regular', 'solid'],
    searchTerms: [
      'analytics',
      'bar',
      'chart',
      'graph',
      'performance',
      'statistics',
    ],
    categories: ['charts-diagrams'],
    aliases: ['bar-chart'],
  },
  {
    name: 'chart-column',
    label: 'Chart Column',
    unicode: 'e0e3',
    styles: ['solid'],
    searchTerms: [
      'bar',
      'bar chart',
      'chart',
      'graph',
      'performance',
      'revenue',
      'statistics',
      'track',
      'trend',
    ],
    categories: ['charts-diagrams'],
  },
  {
    name: 'chart-diagram',
    label: 'Chart Diagram',
    unicode: 'e695',
    styles: ['solid'],
    searchTerms: ['algorithm', 'analytics', 'flow', 'graph'],
    categories: ['charts-diagrams', 'coding'],
  },
  {
    name: 'chart-gantt',
    label: 'Chart Gantt',
    unicode: 'e0e4',
    styles: ['solid'],
    searchTerms: [
      'chart',
      'graph',
      'performance',
      'statistics',
      'track',
      'trend',
    ],
    categories: ['charts-diagrams'],
  },
  {
    name: 'chart-line',
    label: 'Chart Line',
    unicode: 'f201',
    styles: ['solid'],
    searchTerms: [
      'activity',
      'analytics',
      'chart',
      'dashboard',
      'gain',
      'graph',
      'increase',
      'line',
      'performance',
      'revenue',
      'statistics',
    ],
    categories: ['business', 'charts-diagrams', 'money'],
    aliases: ['line-chart'],
  },
  {
    name: 'chart-pie',
    label: 'Chart Pie',
    unicode: 'f200',
    styles: ['solid'],
    searchTerms: [
      'analytics',
      'chart',
      'diagram',
      'graph',
      'performance',
      'pie',
      'revenue',
      'statistics',
    ],
    categories: ['business', 'charts-diagrams', 'money'],
    aliases: ['pie-chart'],
  },
  {
    name: 'chart-simple',
    label: 'Chart Simple',
    unicode: 'e473',
    styles: ['solid'],
    searchTerms: [
      'analytics',
      'bar',
      'chart',
      'column',
      'graph',
      'performance',
      'revenue',
      'row',
      'statistics',
      'trend',
    ],
    categories: [
      'business',
      'charts-diagrams',
      'editing',
      'logistics',
      'marketing',
    ],
  },
  {
    name: 'check',
    label: 'Check',
    unicode: 'f00c',
    styles: ['solid'],
    searchTerms: [
      'Check Mark',
      'accept',
      'agree',
      'check',
      'check mark',
      'checkmark',
      'confirm',
      'correct',
      'coupon',
      'done',
      'enable',
      'mark',
      'notice',
      'notification',
      'notify',
      'ok',
      'select',
      'success',
      'tick',
      'todo',
      'true',
      'validate',
      'working',
      'yes',
      '✓',
    ],
    categories: ['editing', 'punctuation-symbols', 'text-formatting'],
  },
  {
    name: 'check-double',
    label: 'Check Double',
    unicode: 'f560',
    styles: ['solid'],
    searchTerms: [
      'accept',
      'agree',
      'checkmark',
      'confirm',
      'correct',
      'coupon',
      'done',
      'enable',
      'notice',
      'notification',
      'notify',
      'ok',
      'select',
      'select all',
      'success',
      'tick',
      'todo',
      'validate',
      'working',
    ],
    categories: [
      'editing',
      'political',
      'punctuation-symbols',
      'text-formatting',
    ],
  },
  {
    name: 'check-to-slot',
    label: 'Check To Slot',
    unicode: 'f772',
    styles: ['solid'],
    searchTerms: [
      'accept',
      'cast',
      'election',
      'enable',
      'politics',
      'positive',
      'validate',
      'voting',
      'working',
      'yes',
    ],
    categories: ['political'],
    aliases: ['vote-yea'],
  },
  {
    name: 'cheese',
    label: 'Cheese',
    unicode: 'f7ef',
    styles: ['solid'],
    searchTerms: [
      'cheddar',
      'curd',
      'gouda',
      'melt',
      'parmesan',
      'sandwich',
      'swiss',
      'wedge',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'chess',
    label: 'Chess',
    unicode: 'f439',
    styles: ['solid'],
    searchTerms: [
      'board',
      'castle',
      'checkmate',
      'game',
      'king',
      'rook',
      'strategy',
      'tournament',
    ],
    categories: ['gaming'],
  },
  {
    name: 'chess-bishop',
    label: 'Chess Bishop',
    unicode: 'f43a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Chess Bishop',
      'board',
      'checkmate',
      'game',
      'strategy',
    ],
    categories: ['gaming'],
  },
  {
    name: 'chess-board',
    label: 'Chess Board',
    unicode: 'f43c',
    styles: ['solid'],
    searchTerms: ['board', 'checkmate', 'game', 'strategy'],
    categories: ['gaming'],
  },
  {
    name: 'chess-king',
    label: 'Chess King',
    unicode: 'f43f',
    styles: ['regular', 'solid'],
    searchTerms: ['Black Chess King', 'board', 'checkmate', 'game', 'strategy'],
    categories: ['gaming'],
  },
  {
    name: 'chess-knight',
    label: 'Chess Knight',
    unicode: 'f441',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Chess Knight',
      'board',
      'checkmate',
      'game',
      'horse',
      'strategy',
    ],
    categories: ['gaming'],
  },
  {
    name: 'chess-pawn',
    label: 'Chess Pawn',
    unicode: 'f443',
    styles: ['regular', 'solid'],
    searchTerms: [
      'board',
      'checkmate',
      'chess',
      'chess pawn',
      'dupe',
      'expendable',
      'game',
      'strategy',
    ],
    categories: ['gaming'],
  },
  {
    name: 'chess-queen',
    label: 'Chess Queen',
    unicode: 'f445',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Chess Queen',
      'board',
      'checkmate',
      'game',
      'strategy',
    ],
    categories: ['gaming'],
  },
  {
    name: 'chess-rook',
    label: 'Chess Rook',
    unicode: 'f447',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Chess Rook',
      'board',
      'castle',
      'checkmate',
      'game',
      'strategy',
    ],
    categories: ['gaming'],
  },
  {
    name: 'chevron-down',
    label: 'Chevron Down',
    unicode: 'f078',
    styles: ['solid'],
    searchTerms: ['arrow', 'download', 'expand', 'insert'],
    categories: ['arrows'],
  },
  {
    name: 'chevron-left',
    label: 'Chevron Left',
    unicode: 'f053',
    styles: ['solid'],
    searchTerms: [
      'Left-Pointing Angle Bracket',
      'arrow',
      'back',
      'bracket',
      'previous',
    ],
    categories: ['arrows'],
  },
  {
    name: 'chevron-right',
    label: 'Chevron Right',
    unicode: 'f054',
    styles: ['solid'],
    searchTerms: [
      'Right-Pointing Angle Bracket',
      'arrow',
      'bracket',
      'forward',
      'next',
    ],
    categories: ['arrows'],
  },
  {
    name: 'chevron-up',
    label: 'Chevron Up',
    unicode: 'f077',
    styles: ['solid'],
    searchTerms: ['arrow', 'collapse', 'upgrade', 'upload'],
    categories: ['arrows'],
  },
  {
    name: 'child',
    label: 'Child',
    unicode: 'f1ae',
    styles: ['solid'],
    searchTerms: ['boy', 'girl', 'kid', 'toddler', 'uer', 'young', 'youth'],
    categories: ['childhood', 'users-people'],
  },
  {
    name: 'child-combatant',
    label: 'Child Combatant',
    unicode: 'e4e0',
    styles: ['solid'],
    searchTerms: ['combatant'],
    categories: ['disaster', 'humanitarian'],
    aliases: ['child-rifle'],
  },
  {
    name: 'child-dress',
    label: 'Child Dress',
    unicode: 'e59c',
    styles: ['solid'],
    searchTerms: ['boy', 'girl', 'kid', 'toddler', 'uer', 'young', 'youth'],
    categories: ['childhood', 'users-people'],
  },
  {
    name: 'child-reaching',
    label: 'Child Reaching',
    unicode: 'e59d',
    styles: ['solid'],
    searchTerms: ['boy', 'girl', 'kid', 'toddler', 'uer', 'young', 'youth'],
    categories: ['childhood', 'users-people'],
  },
  {
    name: 'children',
    label: 'Children',
    unicode: 'e4e1',
    styles: ['solid'],
    searchTerms: [
      'boy',
      'child',
      'girl',
      'kid',
      'kids',
      'together',
      'uer',
      'young',
      'youth',
    ],
    categories: ['childhood', 'humanitarian', 'users-people'],
  },
  {
    name: 'chrome',
    label: 'Chrome',
    unicode: 'f268',
    styles: ['brands'],
    searchTerms: ['browser'],
    categories: [],
  },
  {
    name: 'chromecast',
    label: 'Chromecast',
    unicode: 'f838',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'church',
    label: 'Church',
    unicode: 'f51d',
    styles: ['solid'],
    searchTerms: [
      'Christian',
      'building',
      'cathedral',
      'chapel',
      'church',
      'community',
      'cross',
      'religion',
    ],
    categories: ['buildings', 'humanitarian', 'religion'],
  },
  {
    name: 'circle',
    label: 'Circle',
    unicode: 'f111',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Circle',
      'Black Large Circle',
      'black circle',
      'blue',
      'blue circle',
      'brown',
      'brown circle',
      'chart',
      'circle',
      'circle-thin',
      'diameter',
      'dot',
      'ellipse',
      'fill',
      'geometric',
      'green',
      'green circle',
      'notification',
      'orange',
      'orange circle',
      'progress',
      'purple',
      'purple circle',
      'red',
      'red circle',
      'round',
      'white circle',
      'yellow',
      'yellow circle',
    ],
    categories: ['film-video', 'shapes', 'toggle'],
  },
  {
    name: 'circle-arrow-down',
    label: 'Circle Arrow Down',
    unicode: 'f0ab',
    styles: ['solid'],
    searchTerms: ['download'],
    categories: ['arrows'],
    aliases: ['arrow-circle-down'],
  },
  {
    name: 'circle-arrow-left',
    label: 'Circle Arrow Left',
    unicode: 'f0a8',
    styles: ['solid'],
    searchTerms: ['back', 'previous'],
    categories: ['arrows'],
    aliases: ['arrow-circle-left'],
  },
  {
    name: 'circle-arrow-right',
    label: 'Circle Arrow Right',
    unicode: 'f0a9',
    styles: ['solid'],
    searchTerms: ['forward', 'next'],
    categories: ['arrows'],
    aliases: ['arrow-circle-right'],
  },
  {
    name: 'circle-arrow-up',
    label: 'Circle Arrow Up',
    unicode: 'f0aa',
    styles: ['solid'],
    searchTerms: ['upgrade', 'upload'],
    categories: ['arrows'],
    aliases: ['arrow-circle-up'],
  },
  {
    name: 'circle-check',
    label: 'Circle Check',
    unicode: 'f058',
    styles: ['regular', 'solid'],
    searchTerms: [
      'accept',
      'affected',
      'agree',
      'clear',
      'confirm',
      'correct',
      'coupon',
      'done',
      'enable',
      'ok',
      'select',
      'success',
      'tick',
      'todo',
      'validate',
      'working',
      'yes',
    ],
    categories: ['editing', 'text-formatting', 'toggle'],
    aliases: ['check-circle'],
  },
  {
    name: 'circle-chevron-down',
    label: 'Circle Chevron Down',
    unicode: 'f13a',
    styles: ['solid'],
    searchTerms: ['arrow', 'download', 'dropdown', 'menu', 'more'],
    categories: ['arrows'],
    aliases: ['chevron-circle-down'],
  },
  {
    name: 'circle-chevron-left',
    label: 'Circle Chevron Left',
    unicode: 'f137',
    styles: ['solid'],
    searchTerms: ['arrow', 'back', 'previous'],
    categories: ['arrows'],
    aliases: ['chevron-circle-left'],
  },
  {
    name: 'circle-chevron-right',
    label: 'Circle Chevron Right',
    unicode: 'f138',
    styles: ['solid'],
    searchTerms: ['arrow', 'forward', 'next'],
    categories: ['arrows'],
    aliases: ['chevron-circle-right'],
  },
  {
    name: 'circle-chevron-up',
    label: 'Circle Chevron Up',
    unicode: 'f139',
    styles: ['solid'],
    searchTerms: ['arrow', 'collapse', 'upgrade', 'upload'],
    categories: ['arrows'],
    aliases: ['chevron-circle-up'],
  },
  {
    name: 'circle-dollar-to-slot',
    label: 'Circle Dollar To Slot',
    unicode: 'f4b9',
    styles: ['solid'],
    searchTerms: ['contribute', 'generosity', 'gift', 'give', 'premium'],
    categories: ['charity', 'money', 'political'],
    aliases: ['donate'],
  },
  {
    name: 'circle-dot',
    label: 'Circle Dot',
    unicode: 'f192',
    styles: ['regular', 'solid'],
    searchTerms: [
      'bullseye',
      'button',
      'geometric',
      'notification',
      'radio',
      'radio button',
      'target',
    ],
    categories: ['toggle'],
    aliases: ['dot-circle'],
  },
  {
    name: 'circle-down',
    label: 'Circle Down',
    unicode: 'f358',
    styles: ['regular', 'solid'],
    searchTerms: ['arrow-circle-o-down', 'download'],
    categories: ['arrows'],
    aliases: ['arrow-alt-circle-down'],
  },
  {
    name: 'circle-exclamation',
    label: 'Circle Exclamation',
    unicode: 'f06a',
    styles: ['solid'],
    searchTerms: [
      'affect',
      'alert',
      'attention',
      'damage',
      'danger',
      'error',
      'failed',
      'important',
      'notice',
      'notification',
      'notify',
      'problem',
      'required',
      'warning',
    ],
    categories: ['alert', 'punctuation-symbols'],
    aliases: ['exclamation-circle'],
  },
  {
    name: 'circle-h',
    label: 'Circle H',
    unicode: 'f47e',
    styles: ['solid'],
    searchTerms: [
      'Circled Latin Capital Letter H',
      'clinic',
      'covid-19',
      'emergency',
      'letter',
      'map',
    ],
    categories: ['alphabet', 'humanitarian', 'medical-health'],
    aliases: ['hospital-symbol'],
  },
  {
    name: 'circle-half-stroke',
    label: 'Circle Half Stroke',
    unicode: 'f042',
    styles: ['solid'],
    searchTerms: [
      'Circle with Left Half Black',
      'adjust',
      'chart',
      'contrast',
      'dark',
      'fill',
      'light',
      'pie',
      'progress',
      'saturation',
    ],
    categories: [
      'charts-diagrams',
      'design',
      'editing',
      'photos-images',
      'shapes',
    ],
    aliases: ['adjust'],
  },
  {
    name: 'circle-info',
    label: 'Circle Info',
    unicode: 'f05a',
    styles: ['solid'],
    searchTerms: ['details', 'help', 'information', 'more', 'support'],
    categories: ['accessibility', 'maps'],
    aliases: ['info-circle'],
  },
  {
    name: 'circle-left',
    label: 'Circle Left',
    unicode: 'f359',
    styles: ['regular', 'solid'],
    searchTerms: ['arrow-circle-o-left', 'back', 'previous'],
    categories: ['arrows'],
    aliases: ['arrow-alt-circle-left'],
  },
  {
    name: 'circle-minus',
    label: 'Circle Minus',
    unicode: 'f056',
    styles: ['solid'],
    searchTerms: ['delete', 'hide', 'negative', 'remove', 'shape', 'trash'],
    categories: ['mathematics'],
    aliases: ['minus-circle'],
  },
  {
    name: 'circle-nodes',
    label: 'Circle Nodes',
    unicode: 'e4e2',
    styles: ['solid'],
    searchTerms: ['cluster', 'connect', 'network'],
    categories: ['coding', 'connectivity', 'design', 'humanitarian'],
  },
  {
    name: 'circle-notch',
    label: 'Circle Notch',
    unicode: 'f1ce',
    styles: ['solid'],
    searchTerms: [
      'circle-o-notch',
      'diameter',
      'dot',
      'ellipse',
      'round',
      'spinner',
    ],
    categories: ['spinners'],
  },
  {
    name: 'circle-pause',
    label: 'Circle Pause',
    unicode: 'f28b',
    styles: ['regular', 'solid'],
    searchTerms: ['hold', 'wait'],
    categories: ['media-playback'],
    aliases: ['pause-circle'],
  },
  {
    name: 'circle-play',
    label: 'Circle Play',
    unicode: 'f144',
    styles: ['regular', 'solid'],
    searchTerms: ['audio', 'music', 'playing', 'sound', 'start', 'video'],
    categories: ['media-playback'],
    aliases: ['play-circle'],
  },
  {
    name: 'circle-plus',
    label: 'Circle Plus',
    unicode: 'f055',
    styles: ['solid'],
    searchTerms: ['add', 'create', 'expand', 'new', 'positive', 'shape'],
    categories: ['mathematics'],
    aliases: ['plus-circle'],
  },
  {
    name: 'circle-question',
    label: 'Circle Question',
    unicode: 'f059',
    styles: ['regular', 'solid'],
    searchTerms: ['faq', 'help', 'information', 'support', 'unknown'],
    categories: ['accessibility', 'punctuation-symbols'],
    aliases: ['question-circle'],
  },
  {
    name: 'circle-radiation',
    label: 'Circle Radiation',
    unicode: 'f7ba',
    styles: ['solid'],
    searchTerms: [
      'danger',
      'dangerous',
      'deadly',
      'hazard',
      'nuclear',
      'radioactive',
      'sign',
      'warning',
    ],
    categories: ['alert', 'disaster', 'energy', 'medical-health', 'science'],
    aliases: ['radiation-alt'],
  },
  {
    name: 'circle-right',
    label: 'Circle Right',
    unicode: 'f35a',
    styles: ['regular', 'solid'],
    searchTerms: ['arrow-circle-o-right', 'forward', 'next'],
    categories: ['arrows'],
    aliases: ['arrow-alt-circle-right'],
  },
  {
    name: 'circle-stop',
    label: 'Circle Stop',
    unicode: 'f28d',
    styles: ['regular', 'solid'],
    searchTerms: ['block', 'box', 'circle', 'square'],
    categories: ['media-playback'],
    aliases: ['stop-circle'],
  },
  {
    name: 'circle-up',
    label: 'Circle Up',
    unicode: 'f35b',
    styles: ['regular', 'solid'],
    searchTerms: ['arrow-circle-o-up', 'upgrade'],
    categories: ['arrows'],
    aliases: ['arrow-alt-circle-up'],
  },
  {
    name: 'circle-user',
    label: 'Circle User',
    unicode: 'f2bd',
    styles: ['regular', 'solid'],
    searchTerms: ['employee', 'uer', 'username', 'users-people'],
    categories: ['social', 'users-people'],
    aliases: ['user-circle'],
  },
  {
    name: 'circle-xmark',
    label: 'Circle Xmark',
    unicode: 'f057',
    styles: ['regular', 'solid'],
    searchTerms: [
      'close',
      'cross',
      'destroy',
      'exit',
      'incorrect',
      'notice',
      'notification',
      'notify',
      'problem',
      'uncheck',
      'wrong',
      'x',
    ],
    categories: ['mathematics'],
    aliases: ['times-circle', 'xmark-circle'],
  },
  {
    name: 'city',
    label: 'City',
    unicode: 'f64f',
    styles: ['solid'],
    searchTerms: [
      'buildings',
      'busy',
      'city',
      'cityscape',
      'skyscrapers',
      'urban',
      'windows',
    ],
    categories: ['buildings', 'business'],
  },
  {
    name: 'clapperboard',
    label: 'Clapperboard',
    unicode: 'e131',
    styles: ['solid'],
    searchTerms: [
      'camera',
      'clapper',
      'clapper board',
      'director',
      'film',
      'movie',
      'record',
    ],
    categories: ['film-video'],
  },
  {
    name: 'clipboard',
    label: 'Clipboard',
    unicode: 'f328',
    styles: ['regular', 'solid'],
    searchTerms: [
      'clipboar',
      'clipboard',
      'copy',
      'notepad',
      'notes',
      'paste',
      'record',
    ],
    categories: ['business'],
  },
  {
    name: 'clipboard-check',
    label: 'Clipboard Check',
    unicode: 'f46c',
    styles: ['solid'],
    searchTerms: [
      'accept',
      'agree',
      'confirm',
      'coupon',
      'done',
      'enable',
      'ok',
      'select',
      'success',
      'tick',
      'todo',
      'validate',
      'working',
      'yes',
    ],
    categories: ['logistics', 'science'],
  },
  {
    name: 'clipboard-list',
    label: 'Clipboard List',
    unicode: 'f46d',
    styles: ['solid'],
    searchTerms: [
      'cheatsheet',
      'checklist',
      'completed',
      'done',
      'finished',
      'intinerary',
      'ol',
      'schedule',
      'summary',
      'survey',
      'tick',
      'todo',
      'ul',
      'wishlist',
    ],
    categories: ['logistics'],
  },
  {
    name: 'clipboard-question',
    label: 'Clipboard Question',
    unicode: 'e4e3',
    styles: ['solid'],
    searchTerms: ['assistance', 'faq', 'interview', 'query', 'question'],
    categories: ['business', 'humanitarian', 'logistics'],
  },
  {
    name: 'clipboard-user',
    label: 'Clipboard User',
    unicode: 'f7f3',
    styles: ['solid'],
    searchTerms: ['attendance', 'employee', 'record', 'roster', 'staff', 'uer'],
    categories: ['humanitarian', 'medical-health', 'users-people'],
  },
  {
    name: 'clock',
    label: 'Clock',
    unicode: 'f017',
    styles: ['regular', 'solid'],
    searchTerms: [
      '00',
      '4',
      '4:00',
      'clock',
      'date',
      'four',
      'four o’clock',
      'hour',
      'late',
      'minute',
      "o'clock",
      'o’clock',
      'pending',
      'schedule',
      'ticking',
      'time',
      'timer',
      'timestamp',
      'watch',
    ],
    categories: ['time'],
    aliases: ['clock-four'],
  },
  {
    name: 'clock-rotate-left',
    label: 'Clock Rotate Left',
    unicode: 'f1da',
    styles: ['solid'],
    searchTerms: [
      'Rewind',
      'clock',
      'pending',
      'reverse',
      'time',
      'time machine',
      'time travel',
      'waiting',
    ],
    categories: ['arrows', 'medical-health'],
    aliases: ['history'],
  },
  {
    name: 'clone',
    label: 'Clone',
    unicode: 'f24d',
    styles: ['regular', 'solid'],
    searchTerms: ['arrange', 'copy', 'duplicate', 'paste'],
    categories: ['design', 'files', 'photos-images'],
  },
  {
    name: 'closed-captioning',
    label: 'Closed Captioning',
    unicode: 'f20a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'cc',
      'deaf',
      'hearing',
      'subtitle',
      'subtitling',
      'text',
      'video',
    ],
    categories: ['accessibility', 'film-video'],
  },
  {
    name: 'cloud',
    label: 'Cloud',
    unicode: 'f0c2',
    styles: ['solid'],
    searchTerms: [
      'atmosphere',
      'cloud',
      'fog',
      'overcast',
      'save',
      'upload',
      'weather',
    ],
    categories: ['connectivity', 'shapes', 'weather'],
  },
  {
    name: 'cloud-arrow-down',
    label: 'Cloud Arrow Down',
    unicode: 'f0ed',
    styles: ['solid'],
    searchTerms: ['download', 'export', 'save'],
    categories: ['arrows', 'connectivity'],
    aliases: ['cloud-download', 'cloud-download-alt'],
  },
  {
    name: 'cloud-arrow-up',
    label: 'Cloud Arrow Up',
    unicode: 'f0ee',
    styles: ['solid'],
    searchTerms: ['import', 'save', 'upgrade', 'upload'],
    categories: ['arrows', 'connectivity'],
    aliases: ['cloud-upload', 'cloud-upload-alt'],
  },
  {
    name: 'cloud-bolt',
    label: 'Cloud Bolt',
    unicode: 'f76c',
    styles: ['solid'],
    searchTerms: [
      'bolt',
      'cloud',
      'cloud with lightning',
      'lightning',
      'precipitation',
      'rain',
      'storm',
      'weather',
    ],
    categories: ['disaster', 'humanitarian', 'weather'],
    aliases: ['thunderstorm'],
  },
  {
    name: 'cloud-meatball',
    label: 'Cloud Meatball',
    unicode: 'f73b',
    styles: ['solid'],
    searchTerms: ['FLDSMDFR', 'food', 'spaghetti', 'storm'],
    categories: ['food-beverage', 'weather'],
  },
  {
    name: 'cloud-moon',
    label: 'Cloud Moon',
    unicode: 'f6c3',
    styles: ['solid'],
    searchTerms: [
      'crescent',
      'evening',
      'lunar',
      'night',
      'partly cloudy',
      'sky',
    ],
    categories: ['halloween', 'weather'],
  },
  {
    name: 'cloud-moon-rain',
    label: 'Cloud Moon Rain',
    unicode: 'f73c',
    styles: ['solid'],
    searchTerms: [
      'crescent',
      'evening',
      'lunar',
      'night',
      'partly cloudy',
      'precipitation',
      'rain',
      'sky',
      'storm',
    ],
    categories: ['weather'],
  },
  {
    name: 'cloud-rain',
    label: 'Cloud Rain',
    unicode: 'f73d',
    styles: ['solid'],
    searchTerms: [
      'Rain',
      'cloud',
      'cloud with rain',
      'precipitation',
      'rain',
      'sky',
      'storm',
    ],
    categories: ['weather'],
  },
  {
    name: 'cloud-showers-heavy',
    label: 'Cloud Showers Heavy',
    unicode: 'f740',
    styles: ['solid'],
    searchTerms: ['precipitation', 'rain', 'sky', 'storm'],
    categories: ['disaster', 'humanitarian', 'weather'],
  },
  {
    name: 'cloud-showers-water',
    label: 'Cloud Showers Water',
    unicode: 'e4e4',
    styles: ['solid'],
    searchTerms: ['cloud', 'deluge', 'flood', 'rain', 'storm', 'surge'],
    categories: ['disaster', 'humanitarian', 'weather'],
  },
  {
    name: 'cloud-sun',
    label: 'Cloud Sun',
    unicode: 'f6c4',
    styles: ['solid'],
    searchTerms: [
      'clear',
      'cloud',
      'day',
      'daytime',
      'fall',
      'outdoors',
      'overcast',
      'partly cloudy',
      'sun',
      'sun behind cloud',
    ],
    categories: ['nature', 'weather'],
  },
  {
    name: 'cloud-sun-rain',
    label: 'Cloud Sun Rain',
    unicode: 'f743',
    styles: ['solid'],
    searchTerms: [
      'cloud',
      'day',
      'overcast',
      'precipitation',
      'rain',
      'storm',
      'summer',
      'sun',
      'sun behind rain cloud',
      'sunshower',
    ],
    categories: ['weather'],
  },
  {
    name: 'cloudflare',
    label: 'Cloudflare',
    unicode: 'e07d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'cloudscale',
    label: 'cloudscale.ch',
    unicode: 'f383',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'cloudsmith',
    label: 'Cloudsmith',
    unicode: 'f384',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'cloudversify',
    label: 'cloudversify',
    unicode: 'f385',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'clover',
    label: 'Clover',
    unicode: 'e139',
    styles: ['solid'],
    searchTerms: [
      '4',
      'charm',
      'clover',
      'four',
      'four leaf clover',
      'four-leaf clover',
      'leaf',
      'leprechaun',
      'luck',
      'lucky',
    ],
    categories: ['nature', 'shapes'],
  },
  {
    name: 'cmplid',
    label: 'Cmplid',
    unicode: 'e360',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'code',
    label: 'Code',
    unicode: 'f121',
    styles: ['solid'],
    searchTerms: ['brackets', 'code', 'development', 'html', 'mysql', 'sql'],
    categories: ['coding'],
  },
  {
    name: 'code-branch',
    label: 'Code Branch',
    unicode: 'f126',
    styles: ['solid'],
    searchTerms: [
      'branch',
      'git',
      'github',
      'mysql',
      'rebase',
      'sql',
      'svn',
      'vcs',
      'version',
    ],
    categories: ['coding'],
  },
  {
    name: 'code-commit',
    label: 'Code Commit',
    unicode: 'f386',
    styles: ['solid'],
    searchTerms: [
      'commit',
      'git',
      'github',
      'hash',
      'rebase',
      'svn',
      'vcs',
      'version',
    ],
    categories: ['coding'],
  },
  {
    name: 'code-compare',
    label: 'Code Compare',
    unicode: 'e13a',
    styles: ['solid'],
    searchTerms: ['compare', 'git', 'github', 'svn', 'version'],
    categories: ['coding'],
  },
  {
    name: 'code-fork',
    label: 'Code Fork',
    unicode: 'e13b',
    styles: ['solid'],
    searchTerms: ['fork', 'git', 'github', 'svn', 'version'],
    categories: ['coding'],
  },
  {
    name: 'code-merge',
    label: 'Code Merge',
    unicode: 'f387',
    styles: ['solid'],
    searchTerms: [
      'git',
      'github',
      'merge',
      'pr',
      'rebase',
      'svn',
      'vcs',
      'version',
    ],
    categories: ['coding'],
  },
  {
    name: 'code-pull-request',
    label: 'Code Pull Request',
    unicode: 'e13c',
    styles: ['solid'],
    searchTerms: ['git', 'github', 'pr', 'svn', 'version'],
    categories: ['coding'],
  },
  {
    name: 'codepen',
    label: 'Codepen',
    unicode: 'f1cb',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'codiepie',
    label: 'Codie Pie',
    unicode: 'f284',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'coins',
    label: 'Coins',
    unicode: 'f51e',
    styles: ['solid'],
    searchTerms: [
      'currency',
      'dime',
      'financial',
      'gold',
      'money',
      'penny',
      'premium',
    ],
    categories: ['money'],
  },
  {
    name: 'colon-sign',
    label: 'Colon Sign',
    unicode: 'e140',
    styles: ['solid'],
    searchTerms: ['Colon Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'comment',
    label: 'Comment',
    unicode: 'f075',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Right Speech Bubble',
      'answer',
      'bubble',
      'chat',
      'commenting',
      'conversation',
      'conversation',
      'discussion',
      'feedback',
      'message',
      'note',
      'notification',
      'sms',
      'speech',
      'talk',
      'talking',
      'texting',
    ],
    categories: ['communication', 'shapes', 'social'],
  },
  {
    name: 'comment-dollar',
    label: 'Comment Dollar',
    unicode: 'f651',
    styles: ['solid'],
    searchTerms: [
      'answer',
      'bubble',
      'chat',
      'commenting',
      'conversation',
      'feedback',
      'message',
      'money',
      'note',
      'notification',
      'pay',
      'salary',
      'sms',
      'speech',
      'spend',
      'texting',
      'transfer',
    ],
    categories: ['marketing', 'money'],
  },
  {
    name: 'comment-dots',
    label: 'Comment Dots',
    unicode: 'f4ad',
    styles: ['regular', 'solid'],
    searchTerms: [
      'answer',
      'balloon',
      'bubble',
      'chat',
      'comic',
      'commenting',
      'conversation',
      'dialog',
      'feedback',
      'message',
      'more',
      'note',
      'notification',
      'reply',
      'request',
      'sms',
      'speech',
      'speech balloon',
      'texting',
    ],
    categories: ['communication'],
    aliases: ['commenting'],
  },
  {
    name: 'comment-medical',
    label: 'Comment Medical',
    unicode: 'f7f5',
    styles: ['solid'],
    searchTerms: [
      'advice',
      'answer',
      'bubble',
      'chat',
      'commenting',
      'conversation',
      'diagnose',
      'feedback',
      'message',
      'note',
      'notification',
      'prescription',
      'sms',
      'speech',
      'texting',
    ],
    categories: ['communication', 'medical-health'],
  },
  {
    name: 'comment-nodes',
    label: 'Comment Nodes',
    unicode: 'e696',
    styles: ['solid'],
    searchTerms: [
      'ai',
      'artificial intelligence',
      'cluster',
      'language',
      'model',
      'network',
      'neuronal',
    ],
    categories: ['coding', 'communication'],
  },
  {
    name: 'comment-slash',
    label: 'Comment Slash',
    unicode: 'f4b3',
    styles: ['solid'],
    searchTerms: [
      'answer',
      'bubble',
      'cancel',
      'chat',
      'commenting',
      'conversation',
      'disabled',
      'feedback',
      'message',
      'mute',
      'note',
      'notification',
      'quiet',
      'sms',
      'speech',
      'texting',
    ],
    categories: ['communication'],
  },
  {
    name: 'comment-sms',
    label: 'Comment Sms',
    unicode: 'f7cd',
    styles: ['solid'],
    searchTerms: [
      'answer',
      'chat',
      'conversation',
      'message',
      'mobile',
      'notification',
      'phone',
      'sms',
      'texting',
    ],
    categories: ['communication'],
    aliases: ['sms'],
  },
  {
    name: 'comments',
    label: 'Comments',
    unicode: 'f086',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Two Speech Bubbles',
      'answer',
      'bubble',
      'chat',
      'commenting',
      'conversation',
      'conversation',
      'discussion',
      'feedback',
      'message',
      'note',
      'notification',
      'sms',
      'speech',
      'talk',
      'talking',
      'texting',
    ],
    categories: ['communication'],
  },
  {
    name: 'comments-dollar',
    label: 'Comments Dollar',
    unicode: 'f653',
    styles: ['solid'],
    searchTerms: [
      'answer',
      'bubble',
      'chat',
      'commenting',
      'conversation',
      'feedback',
      'message',
      'money',
      'note',
      'notification',
      'pay',
      'salary',
      'sms',
      'speech',
      'spend',
      'texting',
      'transfer',
    ],
    categories: ['marketing', 'money'],
  },
  {
    name: 'compact-disc',
    label: 'Compact Disc',
    unicode: 'f51f',
    styles: ['solid'],
    searchTerms: [
      'Optical Disc Icon',
      'album',
      'blu-ray',
      'bluray',
      'cd',
      'computer',
      'disc',
      'disk',
      'dvd',
      'media',
      'movie',
      'music',
      'optical',
      'optical disk',
      'record',
      'video',
      'vinyl',
    ],
    categories: ['devices-hardware', 'film-video', 'music-audio', 'spinners'],
  },
  {
    name: 'compass',
    label: 'Compass',
    unicode: 'f14e',
    styles: ['regular', 'solid'],
    searchTerms: [
      'compass',
      'directions',
      'directory',
      'location',
      'magnetic',
      'menu',
      'navigation',
      'orienteering',
      'safari',
      'travel',
    ],
    categories: ['business', 'camping', 'spinners'],
  },
  {
    name: 'compass-drafting',
    label: 'Compass Drafting',
    unicode: 'f568',
    styles: ['solid'],
    searchTerms: ['design', 'map', 'mechanical drawing', 'plot', 'plotting'],
    categories: ['construction', 'design'],
    aliases: ['drafting-compass'],
  },
  {
    name: 'compress',
    label: 'Compress',
    unicode: 'f066',
    styles: ['solid'],
    searchTerms: [
      'collapse',
      'fullscreen',
      'minimize',
      'move',
      'resize',
      'shrink',
      'smaller',
    ],
    categories: ['media-playback'],
  },
  {
    name: 'computer',
    label: 'Computer',
    unicode: 'e4e5',
    styles: ['solid'],
    searchTerms: ['computer', 'desktop', 'display', 'monitor', 'tower'],
    categories: ['devices-hardware', 'household', 'humanitarian'],
  },
  {
    name: 'computer-mouse',
    label: 'Computer Mouse',
    unicode: 'f8cc',
    styles: ['solid'],
    searchTerms: [
      'click',
      'computer',
      'computer mouse',
      'cursor',
      'input',
      'peripheral',
    ],
    categories: ['devices-hardware'],
    aliases: ['mouse'],
  },
  {
    name: 'confluence',
    label: 'Confluence',
    unicode: 'f78d',
    styles: ['brands'],
    searchTerms: ['atlassian'],
    categories: [],
  },
  {
    name: 'connectdevelop',
    label: 'Connect Develop',
    unicode: 'f20e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'contao',
    label: 'Contao',
    unicode: 'f26d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'cookie',
    label: 'Cookie',
    unicode: 'f563',
    styles: ['solid'],
    searchTerms: [
      'baked good',
      'chips',
      'chocolate',
      'cookie',
      'dessert',
      'eat',
      'snack',
      'sweet',
      'treat',
    ],
    categories: ['childhood', 'food-beverage'],
  },
  {
    name: 'cookie-bite',
    label: 'Cookie Bite',
    unicode: 'f564',
    styles: ['solid'],
    searchTerms: [
      'baked good',
      'bitten',
      'chips',
      'chocolate',
      'eat',
      'snack',
      'sweet',
      'treat',
    ],
    categories: ['childhood', 'holidays'],
  },
  {
    name: 'copy',
    label: 'Copy',
    unicode: 'f0c5',
    styles: ['regular', 'solid'],
    searchTerms: ['clone', 'duplicate', 'file', 'files-o', 'paper', 'paste'],
    categories: ['business', 'design', 'files'],
  },
  {
    name: 'copyright',
    label: 'Copyright',
    unicode: 'f1f9',
    styles: ['regular', 'solid'],
    searchTerms: ['brand', 'c', 'copyright', 'mark', 'register', 'trademark'],
    categories: ['business'],
  },
  {
    name: 'cotton-bureau',
    label: 'Cotton Bureau',
    unicode: 'f89e',
    styles: ['brands'],
    searchTerms: ['clothing', 't-shirts', 'tshirts'],
    categories: [],
  },
  {
    name: 'couch',
    label: 'Couch',
    unicode: 'f4b8',
    styles: ['solid'],
    searchTerms: ['chair', 'cushion', 'furniture', 'relax', 'sofa'],
    categories: ['household', 'moving'],
  },
  {
    name: 'cow',
    label: 'Cow',
    unicode: 'f6c8',
    styles: ['solid'],
    searchTerms: [
      'agriculture',
      'animal',
      'beef',
      'bovine',
      'co',
      'cow',
      'farm',
      'fauna',
      'livestock',
      'mammal',
      'milk',
      'moo',
    ],
    categories: ['animals', 'humanitarian'],
  },
  {
    name: 'cpanel',
    label: 'cPanel',
    unicode: 'f388',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons',
    label: 'Creative Commons',
    unicode: 'f25e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-by',
    label: 'Creative Commons Attribution',
    unicode: 'f4e7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-nc',
    label: 'Creative Commons Noncommercial',
    unicode: 'f4e8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-nc-eu',
    label: 'Creative Commons Noncommercial (Euro Sign)',
    unicode: 'f4e9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-nc-jp',
    label: 'Creative Commons Noncommercial (Yen Sign)',
    unicode: 'f4ea',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-nd',
    label: 'Creative Commons No Derivative Works',
    unicode: 'f4eb',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-pd',
    label: 'Creative Commons Public Domain',
    unicode: 'f4ec',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-pd-alt',
    label: 'Alternate Creative Commons Public Domain',
    unicode: 'f4ed',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-remix',
    label: 'Creative Commons Remix',
    unicode: 'f4ee',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-sa',
    label: 'Creative Commons Share Alike',
    unicode: 'f4ef',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-sampling',
    label: 'Creative Commons Sampling',
    unicode: 'f4f0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-sampling-plus',
    label: 'Creative Commons Sampling +',
    unicode: 'f4f1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-share',
    label: 'Creative Commons Share',
    unicode: 'f4f2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'creative-commons-zero',
    label: 'Creative Commons CC0',
    unicode: 'f4f3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'credit-card',
    label: 'Credit Card',
    unicode: 'f09d',
    styles: ['regular', 'solid'],
    searchTerms: [
      'buy',
      'card',
      'checkout',
      'credit',
      'credit card',
      'credit-card-alt',
      'debit',
      'money',
      'payment',
      'purchase',
    ],
    categories: ['money', 'shopping'],
    aliases: ['credit-card-alt'],
  },
  {
    name: 'critical-role',
    label: 'Critical Role',
    unicode: 'f6c9',
    styles: ['brands'],
    searchTerms: [
      'Dungeons & Dragons',
      'd&d',
      'dnd',
      'fantasy',
      'game',
      'gaming',
      'tabletop',
    ],
    categories: ['gaming'],
  },
  {
    name: 'crop',
    label: 'Crop',
    unicode: 'f125',
    styles: ['solid'],
    searchTerms: ['design', 'frame', 'mask', 'modify', 'resize', 'shrink'],
    categories: ['design', 'editing'],
  },
  {
    name: 'crop-simple',
    label: 'Crop Simple',
    unicode: 'f565',
    styles: ['solid'],
    searchTerms: ['design', 'frame', 'mask', 'modify', 'resize', 'shrink'],
    categories: ['design', 'editing'],
    aliases: ['crop-alt'],
  },
  {
    name: 'cross',
    label: 'Cross',
    unicode: 'f654',
    styles: ['solid'],
    searchTerms: [
      'Christian',
      'Heavy Latin Cross',
      'catholicism',
      'christianity',
      'church',
      'cross',
      'jesus',
      'latin cross',
      'religion',
    ],
    categories: ['religion'],
  },
  {
    name: 'crosshairs',
    label: 'Crosshairs',
    unicode: 'f05b',
    styles: ['solid'],
    searchTerms: ['aim', 'bullseye', 'gpd', 'picker', 'position'],
    categories: ['design', 'maps', 'spinners'],
  },
  {
    name: 'crow',
    label: 'Crow',
    unicode: 'f520',
    styles: ['solid'],
    searchTerms: ['bird', 'bullfrog', 'fauna', 'halloween', 'holiday', 'toad'],
    categories: ['animals', 'halloween'],
  },
  {
    name: 'crown',
    label: 'Crown',
    unicode: 'f521',
    styles: ['solid'],
    searchTerms: [
      'award',
      'clothing',
      'crown',
      'favorite',
      'king',
      'queen',
      'royal',
      'tiara',
      'vip',
    ],
    categories: ['shapes'],
  },
  {
    name: 'crutch',
    label: 'Crutch',
    unicode: 'f7f7',
    styles: ['solid'],
    searchTerms: ['cane', 'injury', 'mobility', 'wheelchair'],
    categories: ['medical-health'],
  },
  {
    name: 'cruzeiro-sign',
    label: 'Cruzeiro Sign',
    unicode: 'e152',
    styles: ['solid'],
    searchTerms: ['Cruzeiro Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'css',
    label: 'Css',
    unicode: 'e6a2',
    styles: ['brands'],
    searchTerms: ['rebecca purple'],
    categories: ['coding'],
  },
  {
    name: 'css3',
    label: 'CSS 3 Logo',
    unicode: 'f13c',
    styles: ['brands'],
    searchTerms: ['code'],
    categories: [],
  },
  {
    name: 'css3-alt',
    label: 'Alternate CSS3 Logo',
    unicode: 'f38b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'cube',
    label: 'Cube',
    unicode: 'f1b2',
    styles: ['solid'],
    searchTerms: ['3d', 'block', 'dice', 'package', 'square', 'tesseract'],
    categories: ['coding', 'design', 'editing'],
  },
  {
    name: 'cubes',
    label: 'Cubes',
    unicode: 'f1b3',
    styles: ['solid'],
    searchTerms: [
      '3d',
      'block',
      'dice',
      'package',
      'pyramid',
      'square',
      'stack',
      'tesseract',
    ],
    categories: ['coding', 'design'],
  },
  {
    name: 'cubes-stacked',
    label: 'Cubes Stacked',
    unicode: 'e4e6',
    styles: ['solid'],
    searchTerms: ['blocks', 'cubes', 'sugar'],
    categories: ['childhood', 'food-beverage', 'humanitarian', 'shapes'],
  },
  {
    name: 'cuttlefish',
    label: 'Cuttlefish',
    unicode: 'f38c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'd',
    label: 'D',
    unicode: '44',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter D', 'Latin Small Letter D', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'd-and-d',
    label: 'Dungeons & Dragons',
    unicode: 'f38d',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
  },
  {
    name: 'd-and-d-beyond',
    label: 'D&D Beyond',
    unicode: 'f6ca',
    styles: ['brands'],
    searchTerms: [
      'Dungeons & Dragons',
      'd&d',
      'dnd',
      'fantasy',
      'gaming',
      'tabletop',
    ],
    categories: ['gaming'],
  },
  {
    name: 'dailymotion',
    label: 'dailymotion',
    unicode: 'e052',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dart-lang',
    label: 'Dart Lang',
    unicode: 'e693',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dashcube',
    label: 'DashCube',
    unicode: 'f210',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'database',
    label: 'Database',
    unicode: 'f1c0',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'development',
      'directory',
      'memory',
      'mysql',
      'sql',
      'storage',
    ],
    categories: ['devices-hardware'],
  },
  {
    name: 'debian',
    label: 'Debian',
    unicode: 'e60b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'deezer',
    label: 'Deezer',
    unicode: 'e077',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'delete-left',
    label: 'Delete Left',
    unicode: 'f55a',
    styles: ['solid'],
    searchTerms: [
      'Erase to the Left',
      'command',
      'delete',
      'erase',
      'keyboard',
      'undo',
    ],
    categories: ['editing'],
    aliases: ['backspace'],
  },
  {
    name: 'delicious',
    label: 'Delicious',
    unicode: 'f1a5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'democrat',
    label: 'Democrat',
    unicode: 'f747',
    styles: ['solid'],
    searchTerms: [
      'american',
      'democratic party',
      'donkey',
      'election',
      'left',
      'left-wing',
      'liberal',
      'politics',
      'usa',
    ],
    categories: ['political'],
  },
  {
    name: 'deploydog',
    label: 'deploy.dog',
    unicode: 'f38e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'deskpro',
    label: 'Deskpro',
    unicode: 'f38f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'desktop',
    label: 'Desktop',
    unicode: 'f390',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'cpu',
      'demo',
      'desktop',
      'desktop computer',
      'device',
      'imac',
      'machine',
      'monitor',
      'pc',
      'screen',
    ],
    categories: ['devices-hardware'],
    aliases: ['desktop-alt'],
  },
  {
    name: 'dev',
    label: 'DEV',
    unicode: 'f6cc',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'deviantart',
    label: 'deviantART',
    unicode: 'f1bd',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dharmachakra',
    label: 'Dharmachakra',
    unicode: 'f655',
    styles: ['solid'],
    searchTerms: [
      'Buddhist',
      'buddhism',
      'buddhist',
      'dharma',
      'religion',
      'wheel',
      'wheel of dharma',
    ],
    categories: ['religion', 'spinners'],
  },
  {
    name: 'dhl',
    label: 'DHL',
    unicode: 'f790',
    styles: ['brands'],
    searchTerms: [
      'Dalsey',
      'Hillblom and Lynn',
      'german',
      'package',
      'shipping',
    ],
    categories: [],
  },
  {
    name: 'diagram-next',
    label: 'Diagram Next',
    unicode: 'e476',
    styles: ['solid'],
    searchTerms: [
      'cells',
      'chart',
      'gantt',
      'row',
      'subtask',
      'successor',
      'table',
    ],
    categories: ['charts-diagrams'],
  },
  {
    name: 'diagram-predecessor',
    label: 'Diagram Predecessor',
    unicode: 'e477',
    styles: ['solid'],
    searchTerms: [
      'cells',
      'chart',
      'gantt',
      'predecessor',
      'previous',
      'row',
      'subtask',
      'table',
    ],
    categories: ['charts-diagrams'],
  },
  {
    name: 'diagram-project',
    label: 'Diagram Project',
    unicode: 'f542',
    styles: ['solid'],
    searchTerms: ['chart', 'graph', 'network', 'pert', 'statistics'],
    categories: ['charts-diagrams', 'coding'],
    aliases: ['project-diagram'],
  },
  {
    name: 'diagram-successor',
    label: 'Diagram Successor',
    unicode: 'e47a',
    styles: ['solid'],
    searchTerms: [
      'cells',
      'chart',
      'gantt',
      'next',
      'row',
      'subtask',
      'successor',
      'table',
    ],
    categories: ['charts-diagrams'],
  },
  {
    name: 'diamond',
    label: 'Diamond',
    unicode: 'f219',
    styles: ['solid'],
    searchTerms: [
      'ace',
      'card',
      'cards',
      'diamond suit',
      'game',
      'gem',
      'gemstone',
      'poker',
      'suit',
    ],
    categories: ['gaming', 'shapes'],
  },
  {
    name: 'diamond-turn-right',
    label: 'Diamond Turn Right',
    unicode: 'f5eb',
    styles: ['solid'],
    searchTerms: ['map', 'navigation', 'sign', 'turn'],
    categories: ['maps'],
    aliases: ['directions'],
  },
  {
    name: 'diaspora',
    label: 'Diaspora',
    unicode: 'f791',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dice',
    label: 'Dice',
    unicode: 'f522',
    styles: ['solid'],
    searchTerms: [
      'chance',
      'dice',
      'die',
      'gambling',
      'game',
      'game die',
      'roll',
    ],
    categories: ['gaming', 'travel-hotel'],
  },
  {
    name: 'dice-d20',
    label: 'Dice D20',
    unicode: 'f6cf',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'chance',
      'd&d',
      'dnd',
      'fantasy',
      'gambling',
      'game',
      'roll',
    ],
    categories: ['gaming'],
  },
  {
    name: 'dice-d6',
    label: 'Dice D6',
    unicode: 'f6d1',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'chance',
      'd&d',
      'dnd',
      'fantasy',
      'gambling',
      'game',
      'roll',
    ],
    categories: ['gaming'],
  },
  {
    name: 'dice-five',
    label: 'Dice Five',
    unicode: 'f523',
    styles: ['solid'],
    searchTerms: ['Die Face-5', 'chance', 'gambling', 'game', 'roll'],
    categories: ['gaming', 'travel-hotel'],
  },
  {
    name: 'dice-four',
    label: 'Dice Four',
    unicode: 'f524',
    styles: ['solid'],
    searchTerms: ['Die Face-4', 'chance', 'gambling', 'game', 'roll'],
    categories: ['gaming'],
  },
  {
    name: 'dice-one',
    label: 'Dice One',
    unicode: 'f525',
    styles: ['solid'],
    searchTerms: ['Die Face-1', 'chance', 'gambling', 'game', 'roll'],
    categories: ['gaming'],
  },
  {
    name: 'dice-six',
    label: 'Dice Six',
    unicode: 'f526',
    styles: ['solid'],
    searchTerms: ['Die Face-6', 'chance', 'gambling', 'game', 'roll'],
    categories: ['gaming'],
  },
  {
    name: 'dice-three',
    label: 'Dice Three',
    unicode: 'f527',
    styles: ['solid'],
    searchTerms: ['Die Face-3', 'chance', 'gambling', 'game', 'roll'],
    categories: ['gaming'],
  },
  {
    name: 'dice-two',
    label: 'Dice Two',
    unicode: 'f528',
    styles: ['solid'],
    searchTerms: ['Die Face-2', 'chance', 'gambling', 'game', 'roll'],
    categories: ['gaming'],
  },
  {
    name: 'digg',
    label: 'Digg Logo',
    unicode: 'f1a6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'digital-ocean',
    label: 'Digital Ocean',
    unicode: 'f391',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'discord',
    label: 'Discord',
    unicode: 'f392',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'discourse',
    label: 'Discourse',
    unicode: 'f393',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'disease',
    label: 'Disease',
    unicode: 'f7fa',
    styles: ['solid'],
    searchTerms: [
      'bacteria',
      'cancer',
      'coronavirus',
      'covid-19',
      'flu',
      'illness',
      'infection',
      'pandemic',
      'sickness',
      'virus',
    ],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'display',
    label: 'Display',
    unicode: 'e163',
    styles: ['solid'],
    searchTerms: ['Screen', 'computer', 'desktop', 'imac'],
    categories: ['devices-hardware', 'humanitarian'],
  },
  {
    name: 'divide',
    label: 'Divide',
    unicode: 'f529',
    styles: ['solid'],
    searchTerms: [
      'Division Sign',
      'arithmetic',
      'calculus',
      'divide',
      'division',
      'math',
      'sign',
      '÷',
    ],
    categories: ['mathematics'],
  },
  {
    name: 'dna',
    label: 'Dna',
    unicode: 'f471',
    styles: ['solid'],
    searchTerms: [
      'biologist',
      'dna',
      'double helix',
      'evolution',
      'gene',
      'genetic',
      'genetics',
      'helix',
      'life',
      'molecule',
      'protein',
    ],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'dochub',
    label: 'DocHub',
    unicode: 'f394',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'docker',
    label: 'Docker',
    unicode: 'f395',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dog',
    label: 'Dog',
    unicode: 'f6d3',
    styles: ['solid'],
    searchTerms: [
      'animal',
      'canine',
      'dog',
      'fauna',
      'mammal',
      'pet',
      'pooch',
      'puppy',
      'woof',
    ],
    categories: ['animals'],
  },
  {
    name: 'dollar-sign',
    label: 'Dollar Sign',
    unicode: '24',
    styles: ['solid'],
    searchTerms: [
      'Dollar Sign',
      'coupon',
      'currency',
      'dollar',
      'heavy dollar sign',
      'investment',
      'money',
      'premium',
      'revenue',
      'salary',
    ],
    categories: ['charity', 'maps', 'money'],
    aliases: ['dollar', 'usd'],
  },
  {
    name: 'dolly',
    label: 'Dolly',
    unicode: 'f472',
    styles: ['solid'],
    searchTerms: ['carry', 'shipping', 'transport'],
    categories: ['logistics', 'moving'],
    aliases: ['dolly-box'],
  },
  {
    name: 'dong-sign',
    label: 'Dong Sign',
    unicode: 'e169',
    styles: ['solid'],
    searchTerms: ['Dong Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'door-closed',
    label: 'Door Closed',
    unicode: 'f52a',
    styles: ['solid'],
    searchTerms: ['doo', 'door', 'enter', 'exit', 'locked', 'privacy'],
    categories: ['household', 'security', 'travel-hotel'],
  },
  {
    name: 'door-open',
    label: 'Door Open',
    unicode: 'f52b',
    styles: ['solid'],
    searchTerms: ['enter', 'exit', 'welcome'],
    categories: ['household', 'security', 'travel-hotel'],
  },
  {
    name: 'dove',
    label: 'Dove',
    unicode: 'f4ba',
    styles: ['solid'],
    searchTerms: ['bird', 'dove', 'fauna', 'fly', 'flying', 'peace', 'war'],
    categories: ['animals', 'charity', 'political', 'religion'],
  },
  {
    name: 'down-left-and-up-right-to-center',
    label: 'Down Left And Up Right To Center',
    unicode: 'f422',
    styles: ['solid'],
    searchTerms: [
      'collapse',
      'fullscreen',
      'minimize',
      'move',
      'resize',
      'scale',
      'shrink',
      'size',
      'smaller',
    ],
    categories: ['arrows', 'media-playback'],
    aliases: ['compress-alt'],
  },
  {
    name: 'down-long',
    label: 'Down Long',
    unicode: 'f309',
    styles: ['solid'],
    searchTerms: ['download', 'long-arrow-down'],
    categories: ['arrows'],
    aliases: ['long-arrow-alt-down'],
  },
  {
    name: 'download',
    label: 'Download',
    unicode: 'f019',
    styles: ['solid'],
    searchTerms: ['export', 'hard drive', 'insert', 'save', 'transfer'],
    categories: ['arrows', 'devices-hardware'],
  },
  {
    name: 'draft2digital',
    label: 'Draft2digital',
    unicode: 'f396',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dragon',
    label: 'Dragon',
    unicode: 'f6d5',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'd&d',
      'dnd',
      'dragon',
      'fairy tale',
      'fantasy',
      'fire',
      'lizard',
      'serpent',
    ],
    categories: ['animals', 'gaming'],
  },
  {
    name: 'draw-polygon',
    label: 'Draw Polygon',
    unicode: 'f5ee',
    styles: ['solid'],
    searchTerms: ['anchors', 'lines', 'object', 'render', 'shape'],
    categories: ['design', 'maps'],
  },
  {
    name: 'dribbble',
    label: 'Dribbble',
    unicode: 'f17d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dropbox',
    label: 'Dropbox',
    unicode: 'f16b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'droplet',
    label: 'Droplet',
    unicode: 'f043',
    styles: ['solid'],
    searchTerms: [
      'blood',
      'cold',
      'color',
      'comic',
      'drop',
      'droplet',
      'raindrop',
      'sweat',
      'waterdrop',
    ],
    categories: [
      'design',
      'humanitarian',
      'maps',
      'medical-health',
      'photos-images',
    ],
    aliases: ['tint'],
  },
  {
    name: 'droplet-slash',
    label: 'Droplet Slash',
    unicode: 'f5c7',
    styles: ['solid'],
    searchTerms: [
      'blood',
      'color',
      'disabled',
      'drop',
      'droplet',
      'raindrop',
      'waterdrop',
    ],
    categories: ['design', 'medical-health'],
    aliases: ['tint-slash'],
  },
  {
    name: 'drum',
    label: 'Drum',
    unicode: 'f569',
    styles: ['solid'],
    searchTerms: [
      'drum',
      'drumsticks',
      'instrument',
      'music',
      'percussion',
      'snare',
      'sound',
    ],
    categories: ['music-audio'],
  },
  {
    name: 'drum-steelpan',
    label: 'Drum Steelpan',
    unicode: 'f56a',
    styles: ['solid'],
    searchTerms: [
      'calypso',
      'instrument',
      'music',
      'percussion',
      'reggae',
      'snare',
      'sound',
      'steel',
      'tropical',
    ],
    categories: ['music-audio'],
  },
  {
    name: 'drumstick-bite',
    label: 'Drumstick Bite',
    unicode: 'f6d7',
    styles: ['solid'],
    searchTerms: ['bone', 'chicken', 'leg', 'meat', 'poultry', 'turkey'],
    categories: ['food-beverage'],
  },
  {
    name: 'drupal',
    label: 'Drupal Logo',
    unicode: 'f1a9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'dumbbell',
    label: 'Dumbbell',
    unicode: 'f44b',
    styles: ['solid'],
    searchTerms: [
      'exercise',
      'gym',
      'strength',
      'weight',
      'weight-lifting',
      'workout',
    ],
    categories: ['sports-fitness', 'travel-hotel'],
  },
  {
    name: 'dumpster',
    label: 'Dumpster',
    unicode: 'f793',
    styles: ['solid'],
    searchTerms: ['alley', 'bin', 'commercial', 'trash', 'waste'],
    categories: ['construction'],
  },
  {
    name: 'dumpster-fire',
    label: 'Dumpster Fire',
    unicode: 'f794',
    styles: ['solid'],
    searchTerms: [
      'alley',
      'bin',
      'commercial',
      'danger',
      'dangerous',
      'euphemism',
      'flame',
      'heat',
      'hot',
      'trash',
      'waste',
    ],
    categories: ['construction', 'political'],
  },
  {
    name: 'dungeon',
    label: 'Dungeon',
    unicode: 'f6d9',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'building',
      'd&d',
      'dnd',
      'door',
      'entrance',
      'fantasy',
      'gate',
    ],
    categories: ['buildings', 'gaming', 'household', 'security'],
  },
  {
    name: 'dyalog',
    label: 'Dyalog',
    unicode: 'f399',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'e',
    label: 'E',
    unicode: '45',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter E', 'Latin Small Letter E', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'ear-deaf',
    label: 'Ear Deaf',
    unicode: 'f2a4',
    styles: ['solid'],
    searchTerms: ['ear', 'hearing', 'sign language'],
    categories: ['accessibility'],
    aliases: ['deaf', 'deafness', 'hard-of-hearing'],
  },
  {
    name: 'ear-listen',
    label: 'Ear Listen',
    unicode: 'f2a2',
    styles: ['solid'],
    searchTerms: [
      'amplify',
      'audio',
      'deaf',
      'ear',
      'headset',
      'hearing',
      'sound',
    ],
    categories: ['accessibility', 'communication'],
    aliases: ['assistive-listening-systems'],
  },
  {
    name: 'earlybirds',
    label: 'Earlybirds',
    unicode: 'f39a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'earth-africa',
    label: 'Earth Africa',
    unicode: 'f57c',
    styles: ['solid'],
    searchTerms: [
      'africa',
      'all',
      'country',
      'earth',
      'europe',
      'global',
      'globe',
      'gps',
      'language',
      'localize',
      'location',
      'map',
      'online',
      'place',
      'planet',
      'translate',
      'travel',
      'world',
    ],
    categories: ['travel-hotel'],
    aliases: ['globe-africa'],
  },
  {
    name: 'earth-americas',
    label: 'Earth Americas',
    unicode: 'f57d',
    styles: ['solid'],
    searchTerms: [
      'all',
      'america',
      'country',
      'earth',
      'global',
      'globe',
      'gps',
      'language',
      'localize',
      'location',
      'map',
      'online',
      'place',
      'planet',
      'translate',
      'travel',
      'world',
    ],
    categories: ['travel-hotel'],
    aliases: ['earth', 'earth-america', 'globe-americas'],
  },
  {
    name: 'earth-asia',
    label: 'Earth Asia',
    unicode: 'f57e',
    styles: ['solid'],
    searchTerms: [
      'all',
      'asia',
      'australia',
      'country',
      'earth',
      'global',
      'globe',
      'gps',
      'language',
      'localize',
      'location',
      'map',
      'online',
      'place',
      'planet',
      'translate',
      'travel',
      'world',
    ],
    categories: ['travel-hotel'],
    aliases: ['globe-asia'],
  },
  {
    name: 'earth-europe',
    label: 'Earth Europe',
    unicode: 'f7a2',
    styles: ['solid'],
    searchTerms: [
      'all',
      'country',
      'earth',
      'europe',
      'global',
      'globe',
      'gps',
      'language',
      'localize',
      'location',
      'map',
      'online',
      'place',
      'planet',
      'translate',
      'travel',
      'world',
    ],
    categories: ['travel-hotel'],
    aliases: ['globe-europe'],
  },
  {
    name: 'earth-oceania',
    label: 'Earth Oceania',
    unicode: 'e47b',
    styles: ['solid'],
    searchTerms: [
      'all',
      'australia',
      'country',
      'earth',
      'global',
      'globe',
      'gps',
      'language',
      'localize',
      'location',
      'map',
      'melanesia',
      'micronesia',
      'new zealand',
      'online',
      'place',
      'planet',
      'polynesia',
      'translate',
      'travel',
      'world',
    ],
    categories: ['travel-hotel'],
    aliases: ['globe-oceania'],
  },
  {
    name: 'ebay',
    label: 'eBay',
    unicode: 'f4f4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'edge',
    label: 'Edge Browser',
    unicode: 'f282',
    styles: ['brands'],
    searchTerms: ['browser', 'ie'],
    categories: [],
  },
  {
    name: 'edge-legacy',
    label: 'Edge Legacy Browser',
    unicode: 'e078',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'egg',
    label: 'Egg',
    unicode: 'f7fb',
    styles: ['solid'],
    searchTerms: [
      'breakfast',
      'chicken',
      'easter',
      'egg',
      'food',
      'shell',
      'yolk',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'eject',
    label: 'Eject',
    unicode: 'f052',
    styles: ['solid'],
    searchTerms: [
      'abort',
      'cancel',
      'cd',
      'discharge',
      'eject',
      'eject button',
    ],
    categories: ['media-playback'],
  },
  {
    name: 'elementor',
    label: 'Elementor',
    unicode: 'f430',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'elevator',
    label: 'Elevator',
    unicode: 'e16d',
    styles: ['solid'],
    searchTerms: [
      'accessibility',
      'elevator',
      'hoist',
      'lift',
      'uer',
      'users-people',
    ],
    categories: ['travel-hotel', 'users-people'],
  },
  {
    name: 'ellipsis',
    label: 'Ellipsis',
    unicode: 'f141',
    styles: ['solid'],
    searchTerms: [
      'dots',
      'drag',
      'kebab',
      'list',
      'menu',
      'nav',
      'navigation',
      'ol',
      'pacman',
      'reorder',
      'settings',
      'three dots',
      'ul',
    ],
    categories: ['editing'],
    aliases: ['ellipsis-h'],
  },
  {
    name: 'ellipsis-vertical',
    label: 'Ellipsis Vertical',
    unicode: 'f142',
    styles: ['solid'],
    searchTerms: [
      'bullet',
      'dots',
      'drag',
      'kebab',
      'list',
      'menu',
      'nav',
      'navigation',
      'ol',
      'reorder',
      'settings',
      'three dots',
      'ul',
    ],
    categories: ['editing'],
    aliases: ['ellipsis-v'],
  },
  {
    name: 'ello',
    label: 'Ello',
    unicode: 'f5f1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ember',
    label: 'Ember',
    unicode: 'f423',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'empire',
    label: 'Galactic Empire',
    unicode: 'f1d1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'envelope',
    label: 'Envelope',
    unicode: 'f0e0',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Back of Envelope',
      'e-mail',
      'email',
      'envelope',
      'letter',
      'mail',
      'message',
      'newsletter',
      'notification',
      'offer',
      'support',
    ],
    categories: [
      'business',
      'communication',
      'humanitarian',
      'social',
      'writing',
    ],
  },
  {
    name: 'envelope-circle-check',
    label: 'Envelope Circle Check',
    unicode: 'e4e8',
    styles: ['solid'],
    searchTerms: [
      'check',
      'email',
      'enable',
      'envelope',
      'mail',
      'not affected',
      'ok',
      'okay',
      'read',
      'sent',
      'validate',
      'working',
    ],
    categories: ['business', 'communication', 'humanitarian'],
  },
  {
    name: 'envelope-open',
    label: 'Envelope Open',
    unicode: 'f2b6',
    styles: ['regular', 'solid'],
    searchTerms: [
      'e-mail',
      'email',
      'letter',
      'mail',
      'message',
      'newsletter',
      'notification',
      'offer',
      'support',
    ],
    categories: ['business', 'communication', 'writing'],
  },
  {
    name: 'envelope-open-text',
    label: 'Envelope Open Text',
    unicode: 'f658',
    styles: ['solid'],
    searchTerms: [
      'e-mail',
      'email',
      'letter',
      'mail',
      'message',
      'newsletter',
      'notification',
      'offer',
      'support',
    ],
    categories: ['marketing'],
  },
  {
    name: 'envelopes-bulk',
    label: 'Envelopes Bulk',
    unicode: 'f674',
    styles: ['solid'],
    searchTerms: [
      'archive',
      'envelope',
      'letter',
      'newsletter',
      'offer',
      'post office',
      'postal',
      'postcard',
      'send',
      'stamp',
      'usps',
    ],
    categories: ['marketing'],
    aliases: ['mail-bulk'],
  },
  {
    name: 'envira',
    label: 'Envira Gallery',
    unicode: 'f299',
    styles: ['brands'],
    searchTerms: ['leaf'],
    categories: [],
  },
  {
    name: 'equals',
    label: 'Equals',
    unicode: '3d',
    styles: ['solid'],
    searchTerms: ['Equals Sign', 'arithmetic', 'even', 'match', 'math'],
    categories: ['mathematics', 'punctuation-symbols'],
  },
  {
    name: 'eraser',
    label: 'Eraser',
    unicode: 'f12d',
    styles: ['solid'],
    searchTerms: ['art', 'delete', 'remove', 'rubber'],
    categories: ['business', 'design', 'writing'],
  },
  {
    name: 'erlang',
    label: 'Erlang',
    unicode: 'f39d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ethereum',
    label: 'Ethereum',
    unicode: 'f42e',
    styles: ['brands'],
    searchTerms: [],
    categories: ['money', 'shopping'],
  },
  {
    name: 'ethernet',
    label: 'Ethernet',
    unicode: 'f796',
    styles: ['solid'],
    searchTerms: [
      'cable',
      'cat 5',
      'cat 6',
      'connection',
      'hardware',
      'internet',
      'network',
      'wired',
    ],
    categories: ['connectivity', 'devices-hardware'],
  },
  {
    name: 'etsy',
    label: 'Etsy',
    unicode: 'f2d7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'euro-sign',
    label: 'Euro Sign',
    unicode: 'f153',
    styles: ['solid'],
    searchTerms: ['Euro Sign', 'currency'],
    categories: ['money'],
    aliases: ['eur', 'euro'],
  },
  {
    name: 'evernote',
    label: 'Evernote',
    unicode: 'f839',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'exclamation',
    label: 'Exclamation',
    unicode: '21',
    styles: ['solid'],
    searchTerms: [
      '!',
      'Exclamation Mark',
      'alert',
      'attention',
      'danger',
      'error',
      'exclamation',
      'failed',
      'important',
      'mark',
      'notice',
      'notification',
      'notify',
      'outlined',
      'problem',
      'punctuation',
      'red exclamation mark',
      'required',
      'warning',
      'white exclamation mark',
    ],
    categories: ['alert', 'punctuation-symbols'],
  },
  {
    name: 'expand',
    label: 'Expand',
    unicode: 'f065',
    styles: ['solid'],
    searchTerms: [
      'arrows',
      'bigger',
      'enlarge',
      'expand',
      'fullscreen',
      'maximize',
      'resize',
      'resize',
      'scale',
      'size',
      'viewfinder',
    ],
    categories: ['media-playback'],
  },
  {
    name: 'expeditedssl',
    label: 'ExpeditedSSL',
    unicode: 'f23e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'explosion',
    label: 'Explosion',
    unicode: 'e4e9',
    styles: ['solid'],
    searchTerms: [
      'blast',
      'blowup',
      'boom',
      'crash',
      'detonation',
      'explosion',
    ],
    categories: ['energy', 'humanitarian', 'science-fiction', 'security'],
  },
  {
    name: 'eye',
    label: 'Eye',
    unicode: 'f06e',
    styles: ['regular', 'solid'],
    searchTerms: [
      'body',
      'eye',
      'look',
      'optic',
      'see',
      'seen',
      'show',
      'sight',
      'views',
      'visible',
    ],
    categories: [
      'accessibility',
      'design',
      'maps',
      'medical-health',
      'photos-images',
      'security',
    ],
  },
  {
    name: 'eye-dropper',
    label: 'Eye Dropper',
    unicode: 'f1fb',
    styles: ['solid'],
    searchTerms: ['beaker', 'clone', 'color', 'copy', 'eyedropper', 'pipette'],
    categories: [
      'design',
      'editing',
      'medical-health',
      'photos-images',
      'science',
    ],
    aliases: ['eye-dropper-empty', 'eyedropper'],
  },
  {
    name: 'eye-low-vision',
    label: 'Eye Low Vision',
    unicode: 'f2a8',
    styles: ['solid'],
    searchTerms: ['blind', 'eye', 'sight'],
    categories: ['accessibility', 'maps'],
    aliases: ['low-vision'],
  },
  {
    name: 'eye-slash',
    label: 'Eye Slash',
    unicode: 'f070',
    styles: ['regular', 'solid'],
    searchTerms: [
      'blind',
      'disabled',
      'hide',
      'show',
      'toggle',
      'unseen',
      'views',
      'visible',
      'visiblity',
    ],
    categories: ['design', 'editing', 'maps', 'photos-images', 'security'],
  },
  {
    name: 'f',
    label: 'F',
    unicode: '46',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter F', 'Latin Small Letter F', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'face-angry',
    label: 'Face Angry',
    unicode: 'f556',
    styles: ['regular', 'solid'],
    searchTerms: [
      'angry',
      'angry face',
      'disapprove',
      'emoticon',
      'face',
      'mad',
      'upset',
    ],
    categories: ['emoji'],
    aliases: ['angry'],
  },
  {
    name: 'face-dizzy',
    label: 'Face Dizzy',
    unicode: 'f567',
    styles: ['regular', 'solid'],
    searchTerms: ['dazed', 'dead', 'disapprove', 'emoticon', 'face'],
    categories: ['emoji'],
    aliases: ['dizzy'],
  },
  {
    name: 'face-flushed',
    label: 'Face Flushed',
    unicode: 'f579',
    styles: ['regular', 'solid'],
    searchTerms: [
      'dazed',
      'embarrassed',
      'emoticon',
      'face',
      'flushed',
      'flushed face',
    ],
    categories: ['emoji'],
    aliases: ['flushed'],
  },
  {
    name: 'face-frown',
    label: 'Face Frown',
    unicode: 'f119',
    styles: ['regular', 'solid'],
    searchTerms: [
      'disapprove',
      'emoticon',
      'face',
      'frown',
      'frowning face',
      'rating',
      'sad',
      'uer',
    ],
    categories: ['communication', 'emoji', 'users-people'],
    aliases: ['frown'],
  },
  {
    name: 'face-frown-open',
    label: 'Face Frown Open',
    unicode: 'f57a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'disapprove',
      'emoticon',
      'face',
      'frown',
      'frowning face with open mouth',
      'mouth',
      'open',
      'rating',
      'sad',
    ],
    categories: ['emoji'],
    aliases: ['frown-open'],
  },
  {
    name: 'face-grimace',
    label: 'Face Grimace',
    unicode: 'f57f',
    styles: ['regular', 'solid'],
    searchTerms: [
      'cringe',
      'emoticon',
      'face',
      'grimace',
      'grimacing face',
      'teeth',
    ],
    categories: ['emoji'],
    aliases: ['grimace'],
  },
  {
    name: 'face-grin',
    label: 'Face Grin',
    unicode: 'f580',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'grin',
      'grinning face',
      'laugh',
      'smile',
    ],
    categories: ['emoji'],
    aliases: ['grin'],
  },
  {
    name: 'face-grin-beam',
    label: 'Face Grin Beam',
    unicode: 'f582',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'eye',
      'face',
      'grinning face with smiling eyes',
      'laugh',
      'mouth',
      'open',
      'smile',
    ],
    categories: ['emoji'],
    aliases: ['grin-beam'],
  },
  {
    name: 'face-grin-beam-sweat',
    label: 'Face Grin Beam Sweat',
    unicode: 'f583',
    styles: ['regular', 'solid'],
    searchTerms: [
      'cold',
      'embarass',
      'emoticon',
      'face',
      'grinning face with sweat',
      'open',
      'smile',
      'sweat',
    ],
    categories: ['emoji'],
    aliases: ['grin-beam-sweat'],
  },
  {
    name: 'face-grin-hearts',
    label: 'Face Grin Hearts',
    unicode: 'f584',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'eye',
      'face',
      'love',
      'smile',
      'smiling face with heart-eyes',
    ],
    categories: ['emoji', 'holidays'],
    aliases: ['grin-hearts'],
  },
  {
    name: 'face-grin-squint',
    label: 'Face Grin Squint',
    unicode: 'f585',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'grinning squinting face',
      'laugh',
      'mouth',
      'satisfied',
      'smile',
    ],
    categories: ['emoji'],
    aliases: ['grin-squint'],
  },
  {
    name: 'face-grin-squint-tears',
    label: 'Face Grin Squint Tears',
    unicode: 'f586',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'floor',
      'happy',
      'laugh',
      'rolling',
      'rolling on the floor laughing',
      'smile',
    ],
    categories: ['emoji'],
    aliases: ['grin-squint-tears'],
  },
  {
    name: 'face-grin-stars',
    label: 'Face Grin Stars',
    unicode: 'f587',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'eyes',
      'face',
      'grinning',
      'quality',
      'star',
      'star-struck',
      'starry-eyed',
      'vip',
    ],
    categories: ['emoji'],
    aliases: ['grin-stars'],
  },
  {
    name: 'face-grin-tears',
    label: 'Face Grin Tears',
    unicode: 'f588',
    styles: ['regular', 'solid'],
    searchTerms: [
      'LOL',
      'emoticon',
      'face',
      'face with tears of joy',
      'joy',
      'laugh',
      'tear',
    ],
    categories: ['emoji'],
    aliases: ['grin-tears'],
  },
  {
    name: 'face-grin-tongue',
    label: 'Face Grin Tongue',
    unicode: 'f589',
    styles: ['regular', 'solid'],
    searchTerms: ['LOL', 'emoticon', 'face', 'face with tongue', 'tongue'],
    categories: ['emoji'],
    aliases: ['grin-tongue'],
  },
  {
    name: 'face-grin-tongue-squint',
    label: 'Face Grin Tongue Squint',
    unicode: 'f58a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'LOL',
      'emoticon',
      'eye',
      'face',
      'horrible',
      'squinting face with tongue',
      'taste',
      'tongue',
    ],
    categories: ['emoji'],
    aliases: ['grin-tongue-squint'],
  },
  {
    name: 'face-grin-tongue-wink',
    label: 'Face Grin Tongue Wink',
    unicode: 'f58b',
    styles: ['regular', 'solid'],
    searchTerms: [
      'LOL',
      'emoticon',
      'eye',
      'face',
      'joke',
      'tongue',
      'wink',
      'winking face with tongue',
    ],
    categories: ['emoji'],
    aliases: ['grin-tongue-wink'],
  },
  {
    name: 'face-grin-wide',
    label: 'Face Grin Wide',
    unicode: 'f581',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'grinning face with big eyes',
      'laugh',
      'mouth',
      'open',
      'smile',
    ],
    categories: ['emoji'],
    aliases: ['grin-alt'],
  },
  {
    name: 'face-grin-wink',
    label: 'Face Grin Wink',
    unicode: 'f58c',
    styles: ['regular', 'solid'],
    searchTerms: ['emoticon', 'face', 'flirt', 'laugh', 'smile'],
    categories: ['emoji'],
    aliases: ['grin-wink'],
  },
  {
    name: 'face-kiss',
    label: 'Face Kiss',
    unicode: 'f596',
    styles: ['regular', 'solid'],
    searchTerms: [
      'beso',
      'emoticon',
      'face',
      'kiss',
      'kissing face',
      'love',
      'smooch',
    ],
    categories: ['emoji'],
    aliases: ['kiss'],
  },
  {
    name: 'face-kiss-beam',
    label: 'Face Kiss Beam',
    unicode: 'f597',
    styles: ['regular', 'solid'],
    searchTerms: [
      'beso',
      'emoticon',
      'eye',
      'face',
      'kiss',
      'kissing face with smiling eyes',
      'love',
      'smile',
      'smooch',
    ],
    categories: ['emoji'],
    aliases: ['kiss-beam'],
  },
  {
    name: 'face-kiss-wink-heart',
    label: 'Face Kiss Wink Heart',
    unicode: 'f598',
    styles: ['regular', 'solid'],
    searchTerms: [
      'beso',
      'emoticon',
      'face',
      'face blowing a kiss',
      'kiss',
      'love',
      'smooch',
    ],
    categories: ['emoji', 'holidays'],
    aliases: ['kiss-wink-heart'],
  },
  {
    name: 'face-laugh',
    label: 'Face Laugh',
    unicode: 'f599',
    styles: ['regular', 'solid'],
    searchTerms: ['LOL', 'emoticon', 'face', 'laugh', 'smile'],
    categories: ['emoji'],
    aliases: ['laugh'],
  },
  {
    name: 'face-laugh-beam',
    label: 'Face Laugh Beam',
    unicode: 'f59a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'LOL',
      'beaming face with smiling eyes',
      'emoticon',
      'eye',
      'face',
      'grin',
      'happy',
      'smile',
    ],
    categories: ['emoji'],
    aliases: ['laugh-beam'],
  },
  {
    name: 'face-laugh-squint',
    label: 'Face Laugh Squint',
    unicode: 'f59b',
    styles: ['regular', 'solid'],
    searchTerms: ['LOL', 'emoticon', 'face', 'happy', 'smile'],
    categories: ['emoji'],
    aliases: ['laugh-squint'],
  },
  {
    name: 'face-laugh-wink',
    label: 'Face Laugh Wink',
    unicode: 'f59c',
    styles: ['regular', 'solid'],
    searchTerms: ['LOL', 'emoticon', 'face', 'happy', 'smile'],
    categories: ['emoji'],
    aliases: ['laugh-wink'],
  },
  {
    name: 'face-meh',
    label: 'Face Meh',
    unicode: 'f11a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'deadpan',
      'default',
      'emoticon',
      'face',
      'meh',
      'neutral',
      'neutral face',
      'rating',
      'uer',
    ],
    categories: ['communication', 'emoji', 'users-people'],
    aliases: ['meh'],
  },
  {
    name: 'face-meh-blank',
    label: 'Face Meh Blank',
    unicode: 'f5a4',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'face without mouth',
      'mouth',
      'neutral',
      'quiet',
      'rating',
      'silent',
    ],
    categories: ['emoji'],
    aliases: ['meh-blank'],
  },
  {
    name: 'face-rolling-eyes',
    label: 'Face Rolling Eyes',
    unicode: 'f5a5',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'eyeroll',
      'eyes',
      'face',
      'face with rolling eyes',
      'neutral',
      'rating',
      'rolling',
    ],
    categories: ['emoji'],
    aliases: ['meh-rolling-eyes'],
  },
  {
    name: 'face-sad-cry',
    label: 'Face Sad Cry',
    unicode: 'f5b3',
    styles: ['regular', 'solid'],
    searchTerms: [
      'cry',
      'emoticon',
      'face',
      'loudly crying face',
      'sad',
      'sob',
      'tear',
      'tears',
    ],
    categories: ['emoji'],
    aliases: ['sad-cry'],
  },
  {
    name: 'face-sad-tear',
    label: 'Face Sad Tear',
    unicode: 'f5b4',
    styles: ['regular', 'solid'],
    searchTerms: [
      'cry',
      'crying face',
      'emoticon',
      'face',
      'sad',
      'tear',
      'tears',
    ],
    categories: ['emoji'],
    aliases: ['sad-tear'],
  },
  {
    name: 'face-smile',
    label: 'Face Smile',
    unicode: 'f118',
    styles: ['regular', 'solid'],
    searchTerms: [
      'approve',
      'default',
      'emoticon',
      'face',
      'happy',
      'rating',
      'satisfied',
      'slightly smiling face',
      'smile',
      'uer',
    ],
    categories: ['communication', 'emoji', 'users-people'],
    aliases: ['smile'],
  },
  {
    name: 'face-smile-beam',
    label: 'Face Smile Beam',
    unicode: 'f5b8',
    styles: ['regular', 'solid'],
    searchTerms: [
      'blush',
      'emoticon',
      'eye',
      'face',
      'happy',
      'positive',
      'smile',
      'smiling face with smiling eyes',
    ],
    categories: ['emoji'],
    aliases: ['smile-beam'],
  },
  {
    name: 'face-smile-wink',
    label: 'Face Smile Wink',
    unicode: 'f4da',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'happy',
      'hint',
      'joke',
      'wink',
      'winking face',
    ],
    categories: ['emoji'],
    aliases: ['smile-wink'],
  },
  {
    name: 'face-surprise',
    label: 'Face Surprise',
    unicode: 'f5c2',
    styles: ['regular', 'solid'],
    searchTerms: [
      'emoticon',
      'face',
      'face with open mouth',
      'mouth',
      'open',
      'shocked',
      'sympathy',
    ],
    categories: ['emoji'],
    aliases: ['surprise'],
  },
  {
    name: 'face-tired',
    label: 'Face Tired',
    unicode: 'f5c8',
    styles: ['regular', 'solid'],
    searchTerms: [
      'angry',
      'emoticon',
      'face',
      'grumpy',
      'tired',
      'tired face',
      'upset',
    ],
    categories: ['emoji'],
    aliases: ['tired'],
  },
  {
    name: 'facebook',
    label: 'Facebook',
    unicode: 'f09a',
    styles: ['brands'],
    searchTerms: ['fabook', 'facebook-official', 'fb', 'social network'],
    categories: ['social'],
  },
  {
    name: 'facebook-f',
    label: 'Facebook F',
    unicode: 'f39e',
    styles: ['brands'],
    searchTerms: ['fabook', 'facebook', 'fb'],
    categories: [],
  },
  {
    name: 'facebook-messenger',
    label: 'Facebook Messenger',
    unicode: 'f39f',
    styles: ['brands'],
    searchTerms: ['fabook', 'fb'],
    categories: [],
  },
  {
    name: 'fan',
    label: 'Fan',
    unicode: 'f863',
    styles: ['solid'],
    searchTerms: ['ac', 'air conditioning', 'blade', 'blower', 'cool', 'hot'],
    categories: ['energy', 'household', 'spinners'],
  },
  {
    name: 'fantasy-flight-games',
    label: 'Fantasy Flight-games',
    unicode: 'f6dc',
    styles: ['brands'],
    searchTerms: [
      'Dungeons & Dragons',
      'd&d',
      'dnd',
      'fantasy',
      'game',
      'gaming',
      'tabletop',
    ],
    categories: ['gaming'],
  },
  {
    name: 'faucet',
    label: 'Faucet',
    unicode: 'e005',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'drinking',
      'drip',
      'house',
      'hygiene',
      'kitchen',
      'potable',
      'potable water',
      'sanitation',
      'sink',
      'water',
    ],
    categories: ['camping', 'household'],
  },
  {
    name: 'faucet-drip',
    label: 'Faucet Drip',
    unicode: 'e006',
    styles: ['solid'],
    searchTerms: [
      'drinking',
      'drip',
      'house',
      'hygiene',
      'kitchen',
      'potable',
      'potable water',
      'sanitation',
      'sink',
      'water',
    ],
    categories: ['camping', 'household', 'humanitarian'],
  },
  {
    name: 'fax',
    label: 'Fax',
    unicode: 'f1ac',
    styles: ['solid'],
    searchTerms: [
      'Fax Icon',
      'business',
      'communicate',
      'copy',
      'facsimile',
      'fax',
      'fax machine',
      'send',
    ],
    categories: [
      'business',
      'communication',
      'devices-hardware',
      'humanitarian',
    ],
  },
  {
    name: 'feather',
    label: 'Feather',
    unicode: 'f52d',
    styles: ['solid'],
    searchTerms: [
      'bird',
      'feather',
      'flight',
      'light',
      'plucked',
      'plumage',
      'quill',
      'write',
    ],
    categories: ['animals', 'nature'],
  },
  {
    name: 'feather-pointed',
    label: 'Feather Pointed',
    unicode: 'f56b',
    styles: ['solid'],
    searchTerms: ['bird', 'light', 'plucked', 'quill', 'write'],
    categories: ['animals', 'nature'],
    aliases: ['feather-alt'],
  },
  {
    name: 'fedex',
    label: 'FedEx',
    unicode: 'f797',
    styles: ['brands'],
    searchTerms: ['Federal Express', 'package', 'shipping'],
    categories: [],
  },
  {
    name: 'fedora',
    label: 'Fedora',
    unicode: 'f798',
    styles: ['brands'],
    searchTerms: ['linux', 'operating system', 'os'],
    categories: [],
  },
  {
    name: 'ferry',
    label: 'Ferry',
    unicode: 'e4ea',
    styles: ['solid'],
    searchTerms: ['barge', 'boat', 'carry', 'ferryboat', 'ship'],
    categories: ['humanitarian', 'logistics', 'maritime', 'transportation'],
  },
  {
    name: 'figma',
    label: 'Figma',
    unicode: 'f799',
    styles: ['brands'],
    searchTerms: ['app', 'design', 'interface'],
    categories: [],
  },
  {
    name: 'file',
    label: 'File',
    unicode: 'f15b',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Empty Document',
      'cv',
      'document',
      'new',
      'page',
      'page facing up',
      'pdf',
      'resume',
    ],
    categories: [
      'business',
      'coding',
      'files',
      'humanitarian',
      'shapes',
      'writing',
    ],
  },
  {
    name: 'file-arrow-down',
    label: 'File Arrow Down',
    unicode: 'f56d',
    styles: ['solid'],
    searchTerms: ['archive', 'document', 'export', 'insert', 'save'],
    categories: ['files'],
    aliases: ['file-download'],
  },
  {
    name: 'file-arrow-up',
    label: 'File Arrow Up',
    unicode: 'f574',
    styles: ['solid'],
    searchTerms: ['document', 'import', 'page', 'save', 'upgrade'],
    categories: ['files'],
    aliases: ['file-upload'],
  },
  {
    name: 'file-audio',
    label: 'File Audio',
    unicode: 'f1c7',
    styles: ['regular', 'solid'],
    searchTerms: ['document', 'mp3', 'music', 'page', 'play', 'sound'],
    categories: ['files', 'film-video', 'music-audio'],
  },
  {
    name: 'file-circle-check',
    label: 'File Circle Check',
    unicode: 'e5a0',
    styles: ['solid'],
    searchTerms: [
      'document',
      'enable',
      'file',
      'not affected',
      'ok',
      'okay',
      'paper',
      'validate',
      'working',
    ],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-circle-exclamation',
    label: 'File Circle Exclamation',
    unicode: 'e4eb',
    styles: ['solid'],
    searchTerms: ['document', 'failed', 'file', 'paper'],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-circle-minus',
    label: 'File Circle Minus',
    unicode: 'e4ed',
    styles: ['solid'],
    searchTerms: ['document', 'file', 'paper'],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-circle-plus',
    label: 'File Circle Plus',
    unicode: 'e494',
    styles: ['solid'],
    searchTerms: ['add', 'document', 'file', 'new', 'page', 'paper', 'pdf'],
    categories: ['business', 'files', 'humanitarian'],
  },
  {
    name: 'file-circle-question',
    label: 'File Circle Question',
    unicode: 'e4ef',
    styles: ['solid'],
    searchTerms: ['document', 'file', 'paper'],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-circle-xmark',
    label: 'File Circle Xmark',
    unicode: 'e5a1',
    styles: ['solid'],
    searchTerms: ['document', 'file', 'paper', 'uncheck'],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-code',
    label: 'File Code',
    unicode: 'f1c9',
    styles: ['regular', 'solid'],
    searchTerms: ['css', 'development', 'document', 'html', 'mysql', 'sql'],
    categories: ['coding', 'files'],
  },
  {
    name: 'file-contract',
    label: 'File Contract',
    unicode: 'f56c',
    styles: ['solid'],
    searchTerms: [
      'agreement',
      'binding',
      'document',
      'legal',
      'signature',
      'username',
    ],
    categories: ['security'],
  },
  {
    name: 'file-csv',
    label: 'File Csv',
    unicode: 'f6dd',
    styles: ['solid'],
    searchTerms: ['document', 'excel', 'numbers', 'spreadsheets', 'table'],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-excel',
    label: 'File Excel',
    unicode: 'f1c3',
    styles: ['regular', 'solid'],
    searchTerms: ['csv', 'document', 'numbers', 'spreadsheets', 'table'],
    categories: ['files'],
  },
  {
    name: 'file-export',
    label: 'File Export',
    unicode: 'f56e',
    styles: ['solid'],
    searchTerms: ['download', 'save'],
    categories: ['files'],
    aliases: ['arrow-right-from-file'],
  },
  {
    name: 'file-fragment',
    label: 'File Fragment',
    unicode: 'e697',
    styles: ['solid'],
    searchTerms: ['block', 'data', 'partial', 'piece'],
    categories: ['files'],
  },
  {
    name: 'file-half-dashed',
    label: 'File Half Dashed',
    unicode: 'e698',
    styles: ['solid'],
    searchTerms: ['data', 'fragment', 'partial', 'piece'],
    categories: ['files'],
  },
  {
    name: 'file-image',
    label: 'File Image',
    unicode: 'f1c5',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Document with Picture',
      'document',
      'image',
      'img',
      'jpg',
      'photo',
      'png',
    ],
    categories: ['files', 'photos-images'],
  },
  {
    name: 'file-import',
    label: 'File Import',
    unicode: 'f56f',
    styles: ['solid'],
    searchTerms: ['copy', 'document', 'insert', 'send', 'upload'],
    categories: ['files'],
    aliases: ['arrow-right-to-file'],
  },
  {
    name: 'file-invoice',
    label: 'File Invoice',
    unicode: 'f570',
    styles: ['solid'],
    searchTerms: [
      'account',
      'bill',
      'charge',
      'document',
      'payment',
      'receipt',
    ],
    categories: ['money'],
  },
  {
    name: 'file-invoice-dollar',
    label: 'File Invoice Dollar',
    unicode: 'f571',
    styles: ['solid'],
    searchTerms: [
      '$',
      'account',
      'bill',
      'charge',
      'document',
      'dollar-sign',
      'money',
      'payment',
      'receipt',
      'revenue',
      'salary',
      'usd',
    ],
    categories: ['money'],
  },
  {
    name: 'file-lines',
    label: 'File Lines',
    unicode: 'f15c',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Document',
      'Document with Text',
      'document',
      'file-text',
      'invoice',
      'new',
      'page',
      'pdf',
    ],
    categories: ['business', 'coding', 'files', 'writing'],
    aliases: ['file-alt', 'file-text'],
  },
  {
    name: 'file-medical',
    label: 'File Medical',
    unicode: 'f477',
    styles: ['solid'],
    searchTerms: ['document', 'health', 'history', 'prescription', 'record'],
    categories: ['medical-health'],
  },
  {
    name: 'file-pdf',
    label: 'File Pdf',
    unicode: 'f1c1',
    styles: ['regular', 'solid'],
    searchTerms: ['acrobat', 'document', 'preview', 'save'],
    categories: ['files', 'humanitarian'],
  },
  {
    name: 'file-pen',
    label: 'File Pen',
    unicode: 'f31c',
    styles: ['solid'],
    searchTerms: ['edit', 'memo', 'modify', 'pen', 'pencil', 'update', 'write'],
    categories: ['files', 'humanitarian'],
    aliases: ['file-edit'],
  },
  {
    name: 'file-powerpoint',
    label: 'File Powerpoint',
    unicode: 'f1c4',
    styles: ['regular', 'solid'],
    searchTerms: ['display', 'document', 'keynote', 'presentation'],
    categories: ['files'],
  },
  {
    name: 'file-prescription',
    label: 'File Prescription',
    unicode: 'f572',
    styles: ['solid'],
    searchTerms: ['document', 'drugs', 'medical', 'medicine', 'rx'],
    categories: ['medical-health'],
  },
  {
    name: 'file-shield',
    label: 'File Shield',
    unicode: 'e4f0',
    styles: ['solid'],
    searchTerms: [
      'antivirus',
      'data',
      'document',
      'protect',
      'safe',
      'safety',
      'secure',
    ],
    categories: ['files', 'humanitarian', 'security'],
  },
  {
    name: 'file-signature',
    label: 'File Signature',
    unicode: 'f573',
    styles: ['solid'],
    searchTerms: ['John Hancock', 'contract', 'document', 'name', 'username'],
    categories: ['security'],
  },
  {
    name: 'file-video',
    label: 'File Video',
    unicode: 'f1c8',
    styles: ['regular', 'solid'],
    searchTerms: ['document', 'm4v', 'movie', 'mp4', 'play'],
    categories: ['files', 'film-video'],
  },
  {
    name: 'file-waveform',
    label: 'File Waveform',
    unicode: 'f478',
    styles: ['solid'],
    searchTerms: ['document', 'health', 'history', 'prescription', 'record'],
    categories: ['medical-health'],
    aliases: ['file-medical-alt'],
  },
  {
    name: 'file-word',
    label: 'File Word',
    unicode: 'f1c2',
    styles: ['regular', 'solid'],
    searchTerms: ['document', 'edit', 'page', 'text', 'writing'],
    categories: ['files'],
  },
  {
    name: 'file-zipper',
    label: 'File Zipper',
    unicode: 'f1c6',
    styles: ['regular', 'solid'],
    searchTerms: [
      '.zip',
      'bundle',
      'compress',
      'compression',
      'download',
      'zip',
    ],
    categories: ['files'],
    aliases: ['file-archive'],
  },
  {
    name: 'files-pinwheel',
    label: 'Files Pinwheel',
    unicode: 'e69f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'fill',
    label: 'Fill',
    unicode: 'f575',
    styles: ['solid'],
    searchTerms: ['bucket', 'color', 'paint', 'paint bucket'],
    categories: ['design'],
  },
  {
    name: 'fill-drip',
    label: 'Fill Drip',
    unicode: 'f576',
    styles: ['solid'],
    searchTerms: ['bucket', 'color', 'drop', 'paint', 'paint bucket', 'spill'],
    categories: ['design'],
  },
  {
    name: 'film',
    label: 'Film',
    unicode: 'f008',
    styles: ['solid'],
    searchTerms: [
      'cinema',
      'film',
      'film frames',
      'frames',
      'movie',
      'strip',
      'video',
    ],
    categories: ['film-video', 'photos-images'],
  },
  {
    name: 'filter',
    label: 'Filter',
    unicode: 'f0b0',
    styles: ['solid'],
    searchTerms: ['funnel', 'options', 'separate', 'sort'],
    categories: ['coding', 'science'],
  },
  {
    name: 'filter-circle-dollar',
    label: 'Filter Circle Dollar',
    unicode: 'f662',
    styles: ['solid'],
    searchTerms: ['filter', 'money', 'options', 'premium', 'separate', 'sort'],
    categories: ['marketing'],
    aliases: ['funnel-dollar'],
  },
  {
    name: 'filter-circle-xmark',
    label: 'Filter Circle Xmark',
    unicode: 'e17b',
    styles: ['solid'],
    searchTerms: [
      'cancel',
      'funnel',
      'options',
      'remove',
      'separate',
      'sort',
      'uncheck',
    ],
    categories: ['text-formatting'],
  },
  {
    name: 'fingerprint',
    label: 'Fingerprint',
    unicode: 'f577',
    styles: ['solid'],
    searchTerms: [
      'human',
      'id',
      'identification',
      'lock',
      'privacy',
      'smudge',
      'touch',
      'unique',
      'unlock',
    ],
    categories: ['accessibility', 'security'],
  },
  {
    name: 'fire',
    label: 'Fire',
    unicode: 'f06d',
    styles: ['solid'],
    searchTerms: [
      'burn',
      'caliente',
      'fire',
      'flame',
      'heat',
      'hot',
      'popular',
      'tool',
    ],
    categories: ['camping', 'energy', 'maps', 'nature', 'science'],
  },
  {
    name: 'fire-burner',
    label: 'Fire Burner',
    unicode: 'e4f1',
    styles: ['solid'],
    searchTerms: ['cook', 'fire', 'flame', 'kitchen', 'stove'],
    categories: ['camping', 'household', 'humanitarian'],
  },
  {
    name: 'fire-extinguisher',
    label: 'Fire Extinguisher',
    unicode: 'f134',
    styles: ['solid'],
    searchTerms: [
      'burn',
      'caliente',
      'extinguish',
      'fire',
      'fire extinguisher',
      'fire fighter',
      'flame',
      'heat',
      'hot',
      'quench',
      'rescue',
    ],
    categories: ['coding', 'maps'],
  },
  {
    name: 'fire-flame-curved',
    label: 'Fire Flame Curved',
    unicode: 'f7e4',
    styles: ['solid'],
    searchTerms: ['burn', 'caliente', 'flame', 'heat', 'hot', 'popular'],
    categories: ['camping', 'energy', 'maps', 'science', 'sports-fitness'],
    aliases: ['fire-alt'],
  },
  {
    name: 'fire-flame-simple',
    label: 'Fire Flame Simple',
    unicode: 'f46a',
    styles: ['solid'],
    searchTerms: ['caliente', 'energy', 'fire', 'flame', 'gas', 'heat', 'hot'],
    categories: [
      'energy',
      'humanitarian',
      'medical-health',
      'science',
      'sports-fitness',
    ],
    aliases: ['burn'],
  },
  {
    name: 'firefox',
    label: 'Firefox',
    unicode: 'f269',
    styles: ['brands'],
    searchTerms: ['browser'],
    categories: [],
  },
  {
    name: 'firefox-browser',
    label: 'Firefox Browser',
    unicode: 'e007',
    styles: ['brands'],
    searchTerms: ['browser'],
    categories: [],
  },
  {
    name: 'first-order',
    label: 'First Order',
    unicode: 'f2b0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'first-order-alt',
    label: 'Alternate First Order',
    unicode: 'f50a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'firstdraft',
    label: 'firstdraft',
    unicode: 'f3a1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'fish',
    label: 'Fish',
    unicode: 'f578',
    styles: ['solid'],
    searchTerms: [
      'Pisces',
      'fauna',
      'fish',
      'gold',
      'seafood',
      'swimming',
      'zodiac',
    ],
    categories: ['animals', 'food-beverage', 'maritime'],
  },
  {
    name: 'fish-fins',
    label: 'Fish Fins',
    unicode: 'e4f2',
    styles: ['solid'],
    searchTerms: ['fish', 'fishery', 'pisces', 'seafood'],
    categories: ['animals', 'food-beverage', 'humanitarian', 'maritime'],
  },
  {
    name: 'flag',
    label: 'Flag',
    unicode: 'f024',
    styles: ['regular', 'solid'],
    searchTerms: [
      'black flag',
      'country',
      'notice',
      'notification',
      'notify',
      'pole',
      'report',
      'symbol',
      'waving',
    ],
    categories: ['humanitarian', 'maps'],
  },
  {
    name: 'flag-checkered',
    label: 'Flag Checkered',
    unicode: 'f11e',
    styles: ['solid'],
    searchTerms: [
      'checkered',
      'chequered',
      'chequered flag',
      'finish',
      'notice',
      'notification',
      'notify',
      'pole',
      'racing',
      'report',
      'start',
      'symbol',
      'win',
    ],
    categories: ['maps'],
  },
  {
    name: 'flag-usa',
    label: 'Flag Usa',
    unicode: 'f74d',
    styles: ['solid'],
    searchTerms: [
      'betsy ross',
      'country',
      'fla',
      'flag: United States',
      'old glory',
      'stars',
      'stripes',
      'symbol',
    ],
    categories: ['political'],
  },
  {
    name: 'flask',
    label: 'Flask',
    unicode: 'f0c3',
    styles: ['solid'],
    searchTerms: [
      'beaker',
      'chemicals',
      'experiment',
      'experimental',
      'knowledge',
      'labs',
      'liquid',
      'potion',
      'science',
      'vial',
    ],
    categories: ['food-beverage', 'maps', 'medical-health', 'science'],
  },
  {
    name: 'flask-vial',
    label: 'Flask Vial',
    unicode: 'e4f3',
    styles: ['solid'],
    searchTerms: [
      'ampule',
      'beaker',
      'chemicals',
      'chemistry',
      'experiment',
      'experimental',
      'lab',
      'laboratory',
      'labs',
      'liquid',
      'potion',
      'science',
      'test',
      'test tube',
      'vial',
    ],
    categories: ['humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'flickr',
    label: 'Flickr',
    unicode: 'f16e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'flipboard',
    label: 'Flipboard',
    unicode: 'f44d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'floppy-disk',
    label: 'Floppy Disk',
    unicode: 'f0c7',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Hard Shell Floppy Disk',
      'computer',
      'disk',
      'download',
      'floppy',
      'floppy disk',
      'floppy-o',
    ],
    categories: ['business', 'design', 'devices-hardware', 'files'],
    aliases: ['save'],
  },
  {
    name: 'florin-sign',
    label: 'Florin Sign',
    unicode: 'e184',
    styles: ['solid'],
    searchTerms: ['currency'],
    categories: ['money'],
  },
  {
    name: 'flutter',
    label: 'Flutter',
    unicode: 'e694',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'fly',
    label: 'Fly',
    unicode: 'f417',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'folder',
    label: 'Folder',
    unicode: 'f07b',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Folder',
      'archive',
      'directory',
      'document',
      'file',
      'file folder',
      'folder',
    ],
    categories: ['business', 'coding', 'files', 'shapes', 'writing'],
    aliases: ['folder-blank'],
  },
  {
    name: 'folder-closed',
    label: 'Folder Closed',
    unicode: 'e185',
    styles: ['regular', 'solid'],
    searchTerms: ['file'],
    categories: ['files'],
  },
  {
    name: 'folder-minus',
    label: 'Folder Minus',
    unicode: 'f65d',
    styles: ['solid'],
    searchTerms: [
      'archive',
      'delete',
      'directory',
      'document',
      'file',
      'negative',
      'remove',
    ],
    categories: ['business'],
  },
  {
    name: 'folder-open',
    label: 'Folder Open',
    unicode: 'f07c',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Open Folder',
      'archive',
      'directory',
      'document',
      'empty',
      'file',
      'folder',
      'new',
      'open',
      'open file folder',
    ],
    categories: ['business', 'coding', 'files', 'writing'],
  },
  {
    name: 'folder-plus',
    label: 'Folder Plus',
    unicode: 'f65e',
    styles: ['solid'],
    searchTerms: [
      'add',
      'archive',
      'create',
      'directory',
      'document',
      'file',
      'new',
      'positive',
    ],
    categories: ['business'],
  },
  {
    name: 'folder-tree',
    label: 'Folder Tree',
    unicode: 'f802',
    styles: ['solid'],
    searchTerms: [
      'archive',
      'directory',
      'document',
      'file',
      'search',
      'structure',
    ],
    categories: ['business'],
  },
  {
    name: 'font',
    label: 'Font',
    unicode: 'f031',
    styles: ['solid'],
    searchTerms: ['alphabet', 'glyph', 'text', 'type', 'typeface'],
    categories: ['text-formatting'],
  },
  {
    name: 'font-awesome',
    label: 'Font Awesome',
    unicode: 'f2b4',
    styles: ['brands', 'regular', 'solid'],
    searchTerms: ['awesome', 'flag', 'font', 'icons', 'typeface'],
    categories: ['coding', 'design'],
    aliases: ['font-awesome-flag', 'font-awesome-logo-full'],
  },
  {
    name: 'fonticons',
    label: 'Fonticons',
    unicode: 'f280',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'fonticons-fi',
    label: 'Fonticons Fi',
    unicode: 'f3a2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'football',
    label: 'Football',
    unicode: 'f44e',
    styles: ['solid'],
    searchTerms: [
      'american',
      'american football',
      'ball',
      'fall',
      'football',
      'nfl',
      'pigskin',
      'seasonal',
    ],
    categories: ['sports-fitness'],
    aliases: ['football-ball'],
  },
  {
    name: 'fort-awesome',
    label: 'Fort Awesome',
    unicode: 'f286',
    styles: ['brands'],
    searchTerms: ['castle'],
    categories: [],
  },
  {
    name: 'fort-awesome-alt',
    label: 'Alternate Fort Awesome',
    unicode: 'f3a3',
    styles: ['brands'],
    searchTerms: ['castle'],
    categories: [],
  },
  {
    name: 'forumbee',
    label: 'Forumbee',
    unicode: 'f211',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'forward',
    label: 'Forward',
    unicode: 'f04e',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'double',
      'fast',
      'fast-forward button',
      'forward',
      'next',
      'skip',
    ],
    categories: ['media-playback'],
  },
  {
    name: 'forward-fast',
    label: 'Forward Fast',
    unicode: 'f050',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'end',
      'last',
      'next',
      'next scene',
      'next track',
      'next track button',
      'quick',
      'triangle',
    ],
    categories: ['media-playback'],
    aliases: ['fast-forward'],
  },
  {
    name: 'forward-step',
    label: 'Forward Step',
    unicode: 'f051',
    styles: ['solid'],
    searchTerms: ['end', 'last', 'next'],
    categories: ['media-playback'],
    aliases: ['step-forward'],
  },
  {
    name: 'foursquare',
    label: 'Foursquare',
    unicode: 'f180',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'franc-sign',
    label: 'Franc Sign',
    unicode: 'e18f',
    styles: ['solid'],
    searchTerms: ['French Franc Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'free-code-camp',
    label: 'freeCodeCamp',
    unicode: 'f2c5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'freebsd',
    label: 'FreeBSD',
    unicode: 'f3a4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'frog',
    label: 'Frog',
    unicode: 'f52e',
    styles: ['solid'],
    searchTerms: [
      'amphibian',
      'bullfrog',
      'fauna',
      'hop',
      'kermit',
      'kiss',
      'prince',
      'ribbit',
      'toad',
      'wart',
    ],
    categories: ['animals', 'camping', 'nature', 'science'],
  },
  {
    name: 'fulcrum',
    label: 'Fulcrum',
    unicode: 'f50b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'futbol',
    label: 'Futbol',
    unicode: 'f1e3',
    styles: ['regular', 'solid'],
    searchTerms: ['ball', 'football', 'mls', 'soccer', 'soccer ball'],
    categories: ['sports-fitness'],
    aliases: ['futbol-ball', 'soccer-ball'],
  },
  {
    name: 'g',
    label: 'G',
    unicode: '47',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter G', 'Latin Small Letter G', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'galactic-republic',
    label: 'Galactic Republic',
    unicode: 'f50c',
    styles: ['brands'],
    searchTerms: ['politics', 'star wars'],
    categories: ['science-fiction'],
  },
  {
    name: 'galactic-senate',
    label: 'Galactic Senate',
    unicode: 'f50d',
    styles: ['brands'],
    searchTerms: ['star wars'],
    categories: ['science-fiction'],
  },
  {
    name: 'gamepad',
    label: 'Gamepad',
    unicode: 'f11b',
    styles: ['solid'],
    searchTerms: [
      'arcade',
      'controller',
      'd-pad',
      'joystick',
      'playstore',
      'video',
      'video game',
    ],
    categories: ['childhood', 'devices-hardware', 'gaming', 'maps'],
  },
  {
    name: 'gas-pump',
    label: 'Gas Pump',
    unicode: 'f52f',
    styles: ['solid'],
    searchTerms: [
      'car',
      'diesel',
      'fuel',
      'fuel pump',
      'fuelpump',
      'gas',
      'gasoline',
      'petrol',
      'pump',
      'station',
    ],
    categories: ['automotive', 'energy', 'humanitarian', 'logistics'],
  },
  {
    name: 'gauge',
    label: 'Gauge',
    unicode: 'f624',
    styles: ['solid'],
    searchTerms: ['dashboard', 'fast', 'odometer', 'speed', 'speedometer'],
    categories: ['automotive'],
    aliases: ['dashboard', 'gauge-med', 'tachometer-alt-average'],
  },
  {
    name: 'gauge-high',
    label: 'Gauge High',
    unicode: 'f625',
    styles: ['solid'],
    searchTerms: [
      'dashboard',
      'fast',
      'odometer',
      'quick',
      'speed',
      'speedometer',
    ],
    categories: ['automotive'],
    aliases: ['tachometer-alt', 'tachometer-alt-fast'],
  },
  {
    name: 'gauge-simple',
    label: 'Gauge Simple',
    unicode: 'f629',
    styles: ['solid'],
    searchTerms: ['dashboard', 'fast', 'odometer', 'speed', 'speedometer'],
    categories: ['automotive'],
    aliases: ['gauge-simple-med', 'tachometer-average'],
  },
  {
    name: 'gauge-simple-high',
    label: 'Gauge Simple High',
    unicode: 'f62a',
    styles: ['solid'],
    searchTerms: [
      'dashboard',
      'fast',
      'odometer',
      'quick',
      'speed',
      'speedometer',
    ],
    categories: ['automotive'],
    aliases: ['tachometer', 'tachometer-fast'],
  },
  {
    name: 'gavel',
    label: 'Gavel',
    unicode: 'f0e3',
    styles: ['solid'],
    searchTerms: ['hammer', 'judge', 'law', 'lawyer', 'opinion'],
    categories: ['maps'],
    aliases: ['legal'],
  },
  {
    name: 'gear',
    label: 'Gear',
    unicode: 'f013',
    styles: ['solid'],
    searchTerms: [
      'cog',
      'cogwheel',
      'configuration',
      'gear',
      'mechanical',
      'modify',
      'settings',
      'sprocket',
      'tool',
      'wheel',
    ],
    categories: ['coding', 'editing', 'spinners'],
    aliases: ['cog'],
  },
  {
    name: 'gears',
    label: 'Gears',
    unicode: 'f085',
    styles: ['solid'],
    searchTerms: [
      'configuration',
      'gears',
      'mechanical',
      'modify',
      'settings',
      'sprocket',
      'wheel',
    ],
    categories: ['coding', 'logistics'],
    aliases: ['cogs'],
  },
  {
    name: 'gem',
    label: 'Gem',
    unicode: 'f3a5',
    styles: ['regular', 'solid'],
    searchTerms: [
      'diamond',
      'gem',
      'gem stone',
      'jewel',
      'jewelry',
      'sapphire',
      'stone',
      'treasure',
    ],
    categories: ['shopping'],
  },
  {
    name: 'genderless',
    label: 'Genderless',
    unicode: 'f22d',
    styles: ['solid'],
    searchTerms: ['androgynous', 'asexual', 'gender', 'sexless'],
    categories: ['gender'],
  },
  {
    name: 'get-pocket',
    label: 'Get Pocket',
    unicode: 'f265',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'gg',
    label: 'GG Currency',
    unicode: 'f260',
    styles: ['brands'],
    searchTerms: [],
    categories: ['money'],
  },
  {
    name: 'gg-circle',
    label: 'GG Currency Circle',
    unicode: 'f261',
    styles: ['brands'],
    searchTerms: [],
    categories: ['money'],
  },
  {
    name: 'ghost',
    label: 'Ghost',
    unicode: 'f6e2',
    styles: ['solid'],
    searchTerms: [
      'apparition',
      'blinky',
      'clyde',
      'creature',
      'face',
      'fairy tale',
      'fantasy',
      'floating',
      'ghost',
      'halloween',
      'holiday',
      'inky',
      'monster',
      'pacman',
      'pinky',
      'spirit',
    ],
    categories: ['gaming', 'halloween'],
  },
  {
    name: 'gift',
    label: 'Gift',
    unicode: 'f06b',
    styles: ['solid'],
    searchTerms: [
      'box',
      'celebration',
      'christmas',
      'generosity',
      'gift',
      'giving',
      'holiday',
      'party',
      'present',
      'wrapped',
      'wrapped gift',
      'xmas',
    ],
    categories: ['charity', 'holidays', 'maps', 'shopping'],
  },
  {
    name: 'gifts',
    label: 'Gifts',
    unicode: 'f79c',
    styles: ['solid'],
    searchTerms: [
      'christmas',
      'generosity',
      'giving',
      'holiday',
      'party',
      'present',
      'wrapped',
      'xmas',
    ],
    categories: ['holidays', 'shopping'],
  },
  {
    name: 'git',
    label: 'Git',
    unicode: 'f1d3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'git-alt',
    label: 'Git Alt',
    unicode: 'f841',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'github',
    label: 'GitHub',
    unicode: 'f09b',
    styles: ['brands'],
    searchTerms: ['octocat'],
    categories: [],
  },
  {
    name: 'github-alt',
    label: 'Alternate GitHub',
    unicode: 'f113',
    styles: ['brands'],
    searchTerms: ['octocat'],
    categories: [],
  },
  {
    name: 'gitkraken',
    label: 'GitKraken',
    unicode: 'f3a6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'gitlab',
    label: 'GitLab',
    unicode: 'f296',
    styles: ['brands'],
    searchTerms: ['Axosoft'],
    categories: [],
  },
  {
    name: 'gitter',
    label: 'Gitter',
    unicode: 'f426',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'glass-water',
    label: 'Glass Water',
    unicode: 'e4f4',
    styles: ['solid'],
    searchTerms: ['potable', 'water'],
    categories: ['food-beverage', 'humanitarian'],
  },
  {
    name: 'glass-water-droplet',
    label: 'Glass Water Droplet',
    unicode: 'e4f5',
    styles: ['solid'],
    searchTerms: ['potable', 'water'],
    categories: ['food-beverage', 'humanitarian'],
  },
  {
    name: 'glasses',
    label: 'Glasses',
    unicode: 'f530',
    styles: ['solid'],
    searchTerms: [
      'hipster',
      'nerd',
      'reading',
      'sight',
      'spectacles',
      'vision',
    ],
    categories: ['business', 'clothing-fashion'],
  },
  {
    name: 'glide',
    label: 'Glide',
    unicode: 'f2a5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'glide-g',
    label: 'Glide G',
    unicode: 'f2a6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'globe',
    label: 'Globe',
    unicode: 'f0ac',
    styles: ['solid'],
    searchTerms: [
      'all',
      'coordinates',
      'country',
      'earth',
      'global',
      'globe',
      'globe with meridians',
      'gps',
      'internet',
      'language',
      'localize',
      'location',
      'map',
      'meridians',
      'network',
      'online',
      'place',
      'planet',
      'translate',
      'travel',
      'world',
      'www',
    ],
    categories: ['astronomy', 'business', 'charity', 'connectivity', 'maps'],
  },
  {
    name: 'gofore',
    label: 'Gofore',
    unicode: 'f3a7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'golang',
    label: 'Go',
    unicode: 'e40f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'golf-ball-tee',
    label: 'Golf Ball Tee',
    unicode: 'f450',
    styles: ['solid'],
    searchTerms: ['caddy', 'eagle', 'putt', 'tee'],
    categories: ['sports-fitness'],
    aliases: ['golf-ball'],
  },
  {
    name: 'goodreads',
    label: 'Goodreads',
    unicode: 'f3a8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'goodreads-g',
    label: 'Goodreads G',
    unicode: 'f3a9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'google',
    label: 'Google Logo',
    unicode: 'f1a0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'google-drive',
    label: 'Google Drive',
    unicode: 'f3aa',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'google-pay',
    label: 'Google Pay',
    unicode: 'e079',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'google-play',
    label: 'Google Play',
    unicode: 'f3ab',
    styles: ['brands'],
    searchTerms: ['playstore'],
    categories: [],
  },
  {
    name: 'google-plus',
    label: 'Google Plus',
    unicode: 'f2b3',
    styles: ['brands'],
    searchTerms: ['google-plus-circle', 'google-plus-official'],
    categories: [],
  },
  {
    name: 'google-plus-g',
    label: 'Google Plus G',
    unicode: 'f0d5',
    styles: ['brands'],
    searchTerms: ['google-plus', 'social network'],
    categories: [],
  },
  {
    name: 'google-scholar',
    label: 'Google Scholar',
    unicode: 'e63b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'google-wallet',
    label: 'Google Wallet',
    unicode: 'f1ee',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'gopuram',
    label: 'Gopuram',
    unicode: 'f664',
    styles: ['solid'],
    searchTerms: ['building', 'entrance', 'hinduism', 'temple', 'tower'],
    categories: ['buildings', 'humanitarian', 'religion'],
  },
  {
    name: 'graduation-cap',
    label: 'Graduation Cap',
    unicode: 'f19d',
    styles: ['solid'],
    searchTerms: [
      'cap',
      'celebration',
      'ceremony',
      'clothing',
      'college',
      'graduate',
      'graduation',
      'graduation cap',
      'hat',
      'learning',
      'school',
      'student',
    ],
    categories: ['clothing-fashion', 'education', 'maps'],
    aliases: ['mortar-board'],
  },
  {
    name: 'gratipay',
    label: 'Gratipay (Gittip)',
    unicode: 'f184',
    styles: ['brands'],
    searchTerms: ['favorite', 'heart', 'like', 'love'],
    categories: [],
  },
  {
    name: 'grav',
    label: 'Grav',
    unicode: 'f2d6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'greater-than',
    label: 'Greater Than',
    unicode: '3e',
    styles: ['solid'],
    searchTerms: ['Greater-Than Sign', 'arithmetic', 'compare', 'math'],
    categories: ['mathematics', 'punctuation-symbols'],
  },
  {
    name: 'greater-than-equal',
    label: 'Greater Than Equal',
    unicode: 'f532',
    styles: ['solid'],
    searchTerms: ['arithmetic', 'compare', 'math'],
    categories: ['mathematics'],
  },
  {
    name: 'grip',
    label: 'Grip',
    unicode: 'f58d',
    styles: ['solid'],
    searchTerms: ['affordance', 'drag', 'drop', 'grab', 'handle'],
    categories: ['editing'],
    aliases: ['grip-horizontal'],
  },
  {
    name: 'grip-lines',
    label: 'Grip Lines',
    unicode: 'f7a4',
    styles: ['solid'],
    searchTerms: ['affordance', 'drag', 'drop', 'grab', 'handle'],
    categories: ['editing'],
  },
  {
    name: 'grip-lines-vertical',
    label: 'Grip Lines Vertical',
    unicode: 'f7a5',
    styles: ['solid'],
    searchTerms: ['affordance', 'drag', 'drop', 'grab', 'handle'],
    categories: ['editing'],
  },
  {
    name: 'grip-vertical',
    label: 'Grip Vertical',
    unicode: 'f58e',
    styles: ['solid'],
    searchTerms: ['affordance', 'drag', 'drop', 'grab', 'handle'],
    categories: ['editing'],
  },
  {
    name: 'gripfire',
    label: 'Gripfire, Inc.',
    unicode: 'f3ac',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'group-arrows-rotate',
    label: 'Group Arrows Rotate',
    unicode: 'e4f6',
    styles: ['solid'],
    searchTerms: ['community', 'engagement', 'spin', 'sync'],
    categories: ['humanitarian', 'marketing'],
  },
  {
    name: 'grunt',
    label: 'Grunt',
    unicode: 'f3ad',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'guarani-sign',
    label: 'Guarani Sign',
    unicode: 'e19a',
    styles: ['solid'],
    searchTerms: ['Guarani Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'guilded',
    label: 'Guilded',
    unicode: 'e07e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'guitar',
    label: 'Guitar',
    unicode: 'f7a6',
    styles: ['solid'],
    searchTerms: [
      'acoustic',
      'instrument',
      'music',
      'rock',
      'rock and roll',
      'song',
      'strings',
    ],
    categories: ['music-audio'],
  },
  {
    name: 'gulp',
    label: 'Gulp',
    unicode: 'f3ae',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'gun',
    label: 'Gun',
    unicode: 'e19b',
    styles: ['solid'],
    searchTerms: ['firearm', 'pistol', 'weapon'],
    categories: ['security'],
  },
  {
    name: 'h',
    label: 'H',
    unicode: '48',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter H', 'Latin Small Letter H', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'hacker-news',
    label: 'Hacker News',
    unicode: 'f1d4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hackerrank',
    label: 'Hackerrank',
    unicode: 'f5f7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hammer',
    label: 'Hammer',
    unicode: 'f6e3',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'configuration',
      'equipment',
      'fix',
      'hammer',
      'maintenance',
      'modify',
      'recovery',
      'repair',
      'settings',
      'tool',
    ],
    categories: ['construction', 'humanitarian'],
  },
  {
    name: 'hamsa',
    label: 'Hamsa',
    unicode: 'f665',
    styles: ['solid'],
    searchTerms: [
      'amulet',
      'christianity',
      'islam',
      'jewish',
      'judaism',
      'muslim',
      'protection',
    ],
    categories: ['religion'],
  },
  {
    name: 'hand',
    label: 'Hand',
    unicode: 'f256',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Raised Hand',
      'backhand',
      'game',
      'halt',
      'palm',
      'raised',
      'raised back of hand',
      'request',
      'roshambo',
      'stop',
    ],
    categories: ['hands', 'media-playback'],
    aliases: ['hand-paper'],
  },
  {
    name: 'hand-back-fist',
    label: 'Hand Back Fist',
    unicode: 'f255',
    styles: ['regular', 'solid'],
    searchTerms: ['fist', 'game', 'roshambo'],
    categories: ['hands'],
    aliases: ['hand-rock'],
  },
  {
    name: 'hand-dots',
    label: 'Hand Dots',
    unicode: 'f461',
    styles: ['solid'],
    searchTerms: [
      'allergy',
      'freckles',
      'hand',
      'hives',
      'palm',
      'pox',
      'skin',
      'spots',
    ],
    categories: ['hands', 'medical-health'],
    aliases: ['allergies'],
  },
  {
    name: 'hand-fist',
    label: 'Hand Fist',
    unicode: 'f6de',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'clenched',
      'd&d',
      'dnd',
      'fantasy',
      'fist',
      'hand',
      'ki',
      'monk',
      'punch',
      'raised fist',
      'resist',
      'strength',
      'unarmed combat',
    ],
    categories: ['gaming', 'hands', 'political'],
    aliases: ['fist-raised'],
  },
  {
    name: 'hand-holding',
    label: 'Hand Holding',
    unicode: 'f4bd',
    styles: ['solid'],
    searchTerms: ['carry', 'lift'],
    categories: ['hands'],
  },
  {
    name: 'hand-holding-dollar',
    label: 'Hand Holding Dollar',
    unicode: 'f4c0',
    styles: ['solid'],
    searchTerms: [
      '$',
      'carry',
      'coupon',
      'dollar sign',
      'donate',
      'donation',
      'giving',
      'investment',
      'lift',
      'money',
      'premium',
      'price',
      'revenue',
      'salary',
    ],
    categories: ['charity', 'hands', 'money'],
    aliases: ['hand-holding-usd'],
  },
  {
    name: 'hand-holding-droplet',
    label: 'Hand Holding Droplet',
    unicode: 'f4c1',
    styles: ['solid'],
    searchTerms: [
      'blood',
      'carry',
      'covid-19',
      'drought',
      'grow',
      'lift',
      'sanitation',
    ],
    categories: ['charity', 'hands', 'medical-health'],
    aliases: ['hand-holding-water'],
  },
  {
    name: 'hand-holding-hand',
    label: 'Hand Holding Hand',
    unicode: 'e4f7',
    styles: ['solid'],
    searchTerms: ['care', 'give', 'help', 'hold', 'protect'],
    categories: ['charity', 'hands', 'humanitarian'],
  },
  {
    name: 'hand-holding-heart',
    label: 'Hand Holding Heart',
    unicode: 'f4be',
    styles: ['solid'],
    searchTerms: ['carry', 'charity', 'gift', 'lift', 'package', 'wishlist'],
    categories: ['charity', 'hands'],
  },
  {
    name: 'hand-holding-medical',
    label: 'Hand Holding Medical',
    unicode: 'e05c',
    styles: ['solid'],
    searchTerms: ['care', 'covid-19', 'donate', 'help'],
    categories: ['hands', 'medical-health'],
  },
  {
    name: 'hand-lizard',
    label: 'Hand Lizard',
    unicode: 'f258',
    styles: ['regular', 'solid'],
    searchTerms: ['game', 'roshambo'],
    categories: ['hands'],
  },
  {
    name: 'hand-middle-finger',
    label: 'Hand Middle Finger',
    unicode: 'f806',
    styles: ['solid'],
    searchTerms: [
      'finger',
      'flip the bird',
      'gesture',
      'hand',
      'hate',
      'middle finger',
      'rude',
    ],
    categories: ['hands'],
  },
  {
    name: 'hand-peace',
    label: 'Hand Peace',
    unicode: 'f25b',
    styles: ['regular', 'solid'],
    searchTerms: ['hand', 'rest', 'truce', 'v', 'victory', 'victory hand'],
    categories: ['hands'],
  },
  {
    name: 'hand-point-down',
    label: 'Hand Point Down',
    unicode: 'f0a7',
    styles: ['regular', 'solid'],
    searchTerms: ['finger', 'hand-o-down', 'point'],
    categories: ['hands'],
  },
  {
    name: 'hand-point-left',
    label: 'Hand Point Left',
    unicode: 'f0a5',
    styles: ['regular', 'solid'],
    searchTerms: ['back', 'finger', 'hand-o-left', 'left', 'point', 'previous'],
    categories: ['hands'],
  },
  {
    name: 'hand-point-right',
    label: 'Hand Point Right',
    unicode: 'f0a4',
    styles: ['regular', 'solid'],
    searchTerms: [
      'finger',
      'forward',
      'hand-o-right',
      'next',
      'point',
      'right',
    ],
    categories: ['hands'],
  },
  {
    name: 'hand-point-up',
    label: 'Hand Point Up',
    unicode: 'f0a6',
    styles: ['regular', 'solid'],
    searchTerms: [
      'finger',
      'hand',
      'hand-o-up',
      'index',
      'index pointing up',
      'point',
      'request',
      'up',
      'upgrade',
    ],
    categories: ['hands'],
  },
  {
    name: 'hand-pointer',
    label: 'Hand Pointer',
    unicode: 'f25a',
    styles: ['regular', 'solid'],
    searchTerms: ['arrow', 'cursor', 'select'],
    categories: ['hands'],
  },
  {
    name: 'hand-scissors',
    label: 'Hand Scissors',
    unicode: 'f257',
    styles: ['regular', 'solid'],
    searchTerms: ['cut', 'game', 'roshambo'],
    categories: ['hands'],
  },
  {
    name: 'hand-sparkles',
    label: 'Hand Sparkles',
    unicode: 'e05d',
    styles: ['solid'],
    searchTerms: [
      'clean',
      'covid-19',
      'hygiene',
      'magic',
      'palm',
      'soap',
      'wash',
    ],
    categories: ['hands'],
  },
  {
    name: 'hand-spock',
    label: 'Hand Spock',
    unicode: 'f259',
    styles: ['regular', 'solid'],
    searchTerms: [
      'finger',
      'hand',
      'live long',
      'palm',
      'prosper',
      'salute',
      'spock',
      'star trek',
      'vulcan',
      'vulcan salute',
    ],
    categories: ['hands', 'science-fiction'],
  },
  {
    name: 'handcuffs',
    label: 'Handcuffs',
    unicode: 'e4f8',
    styles: ['solid'],
    searchTerms: [
      'arrest',
      'criminal',
      'handcuffs',
      'jail',
      'lock',
      'police',
      'wrist',
    ],
    categories: ['humanitarian', 'security'],
  },
  {
    name: 'hands',
    label: 'Hands',
    unicode: 'f2a7',
    styles: ['solid'],
    searchTerms: ['Translate', 'asl', 'deaf', 'hands'],
    categories: ['accessibility'],
    aliases: ['sign-language', 'signing'],
  },
  {
    name: 'hands-asl-interpreting',
    label: 'Hands Asl Interpreting',
    unicode: 'f2a3',
    styles: ['solid'],
    searchTerms: ['asl', 'deaf', 'finger', 'hand', 'interpret', 'speak'],
    categories: ['accessibility', 'communication'],
    aliases: [
      'american-sign-language-interpreting',
      'asl-interpreting',
      'hands-american-sign-language-interpreting',
    ],
  },
  {
    name: 'hands-bound',
    label: 'Hands Bound',
    unicode: 'e4f9',
    styles: ['solid'],
    searchTerms: ['abduction', 'bound', 'handcuff', 'wrist'],
    categories: ['hands', 'humanitarian', 'security'],
  },
  {
    name: 'hands-bubbles',
    label: 'Hands Bubbles',
    unicode: 'e05e',
    styles: ['solid'],
    searchTerms: ['covid-19', 'hygiene', 'soap', 'wash'],
    categories: ['hands', 'humanitarian'],
    aliases: ['hands-wash'],
  },
  {
    name: 'hands-clapping',
    label: 'Hands Clapping',
    unicode: 'e1a8',
    styles: ['solid'],
    searchTerms: ['applause', 'clap', 'clapping hands', 'hand'],
    categories: ['hands'],
  },
  {
    name: 'hands-holding',
    label: 'Hands Holding',
    unicode: 'f4c2',
    styles: ['solid'],
    searchTerms: ['carry', 'hold', 'lift'],
    categories: ['hands'],
  },
  {
    name: 'hands-holding-child',
    label: 'Hands Holding Child',
    unicode: 'e4fa',
    styles: ['solid'],
    searchTerms: ['care', 'give', 'help', 'hold', 'parent', 'protect'],
    categories: ['charity', 'childhood', 'hands', 'humanitarian', 'security'],
  },
  {
    name: 'hands-holding-circle',
    label: 'Hands Holding Circle',
    unicode: 'e4fb',
    styles: ['solid'],
    searchTerms: ['circle', 'gift', 'protection'],
    categories: ['charity', 'hands', 'humanitarian', 'security'],
  },
  {
    name: 'hands-praying',
    label: 'Hands Praying',
    unicode: 'f684',
    styles: ['solid'],
    searchTerms: ['kneel', 'preach', 'religion', 'worship'],
    categories: ['hands', 'religion'],
    aliases: ['praying-hands'],
  },
  {
    name: 'handshake',
    label: 'Handshake',
    unicode: 'f2b5',
    styles: ['regular', 'solid'],
    searchTerms: ['agreement', 'greeting', 'meeting', 'partnership'],
    categories: ['charity', 'hands', 'political', 'shopping'],
  },
  {
    name: 'handshake-angle',
    label: 'Handshake Angle',
    unicode: 'f4c4',
    styles: ['solid'],
    searchTerms: [
      'aid',
      'assistance',
      'handshake',
      'partnership',
      'volunteering',
    ],
    categories: ['accessibility', 'charity', 'hands'],
    aliases: ['hands-helping'],
  },
  {
    name: 'handshake-simple',
    label: 'Handshake Simple',
    unicode: 'f4c6',
    styles: ['solid'],
    searchTerms: [
      'agreement',
      'greeting',
      'hand',
      'handshake',
      'meeting',
      'partnership',
      'shake',
    ],
    categories: ['charity', 'hands', 'humanitarian'],
    aliases: ['handshake-alt'],
  },
  {
    name: 'handshake-simple-slash',
    label: 'Handshake Simple Slash',
    unicode: 'e05f',
    styles: ['solid'],
    searchTerms: ['broken', 'covid-19', 'disabled', 'social distance'],
    categories: ['hands'],
    aliases: ['handshake-alt-slash'],
  },
  {
    name: 'handshake-slash',
    label: 'Handshake Slash',
    unicode: 'e060',
    styles: ['solid'],
    searchTerms: ['broken', 'covid-19', 'disabled', 'social distance'],
    categories: ['hands'],
  },
  {
    name: 'hanukiah',
    label: 'Hanukiah',
    unicode: 'f6e6',
    styles: ['solid'],
    searchTerms: [
      'candelabrum',
      'candle',
      'candlestick',
      'hanukkah',
      'jewish',
      'judaism',
      'light',
      'menorah',
      'religion',
    ],
    categories: ['religion'],
  },
  {
    name: 'hard-drive',
    label: 'Hard Drive',
    unicode: 'f0a0',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Hard Disk',
      'cpu',
      'hard drive',
      'harddrive',
      'machine',
      'save',
      'storage',
    ],
    categories: ['devices-hardware'],
    aliases: ['hdd'],
  },
  {
    name: 'hashnode',
    label: 'Hashnode',
    unicode: 'e499',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hashtag',
    label: 'Hashtag',
    unicode: '23',
    styles: ['solid'],
    searchTerms: [
      'Number Sign',
      'Twitter',
      'instagram',
      'pound',
      'social media',
      'tag',
    ],
    categories: ['punctuation-symbols', 'social'],
  },
  {
    name: 'hat-cowboy',
    label: 'Hat Cowboy',
    unicode: 'f8c0',
    styles: ['solid'],
    searchTerms: [
      'buckaroo',
      'horse',
      'jackeroo',
      'john b.',
      'old west',
      'pardner',
      'ranch',
      'rancher',
      'rodeo',
      'western',
      'wrangler',
    ],
    categories: ['clothing-fashion'],
  },
  {
    name: 'hat-cowboy-side',
    label: 'Hat Cowboy Side',
    unicode: 'f8c1',
    styles: ['solid'],
    searchTerms: [
      'buckaroo',
      'horse',
      'jackeroo',
      'john b.',
      'old west',
      'pardner',
      'ranch',
      'rancher',
      'rodeo',
      'western',
      'wrangler',
    ],
    categories: ['clothing-fashion'],
  },
  {
    name: 'hat-wizard',
    label: 'Hat Wizard',
    unicode: 'f6e8',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'accessory',
      'buckle',
      'clothing',
      'd&d',
      'dnd',
      'fantasy',
      'halloween',
      'head',
      'holiday',
      'mage',
      'magic',
      'pointy',
      'witch',
    ],
    categories: ['clothing-fashion', 'gaming', 'halloween'],
  },
  {
    name: 'head-side-cough',
    label: 'Head Side Cough',
    unicode: 'e061',
    styles: ['solid'],
    searchTerms: [
      'cough',
      'covid-19',
      'germs',
      'lungs',
      'respiratory',
      'sick',
      'uer',
    ],
    categories: ['medical-health', 'users-people'],
  },
  {
    name: 'head-side-cough-slash',
    label: 'Head Side Cough Slash',
    unicode: 'e062',
    styles: ['solid'],
    searchTerms: [
      'cough',
      'covid-19',
      'disabled',
      'germs',
      'lungs',
      'respiratory',
      'sick',
      'uer',
    ],
    categories: ['medical-health', 'users-people'],
  },
  {
    name: 'head-side-mask',
    label: 'Head Side Mask',
    unicode: 'e063',
    styles: ['solid'],
    searchTerms: [
      'breath',
      'coronavirus',
      'covid-19',
      'filter',
      'flu',
      'infection',
      'pandemic',
      'respirator',
      'uer',
      'virus',
    ],
    categories: ['medical-health', 'users-people'],
  },
  {
    name: 'head-side-virus',
    label: 'Head Side Virus',
    unicode: 'e064',
    styles: ['solid'],
    searchTerms: [
      'cold',
      'coronavirus',
      'covid-19',
      'flu',
      'infection',
      'pandemic',
      'sick',
      'uer',
    ],
    categories: ['medical-health', 'users-people'],
  },
  {
    name: 'heading',
    label: 'Heading',
    unicode: 'f1dc',
    styles: ['solid'],
    searchTerms: ['format', 'header', 'text', 'title'],
    categories: ['text-formatting'],
    aliases: ['header'],
  },
  {
    name: 'headphones',
    label: 'Headphones',
    unicode: 'f025',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'earbud',
      'headphone',
      'listen',
      'music',
      'sound',
      'speaker',
    ],
    categories: ['devices-hardware', 'film-video', 'music-audio'],
  },
  {
    name: 'headphones-simple',
    label: 'Headphones Simple',
    unicode: 'f58f',
    styles: ['solid'],
    searchTerms: ['audio', 'listen', 'music', 'sound', 'speaker'],
    categories: ['music-audio'],
    aliases: ['headphones-alt'],
  },
  {
    name: 'headset',
    label: 'Headset',
    unicode: 'f590',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'gamer',
      'gaming',
      'listen',
      'live chat',
      'microphone',
      'shot caller',
      'sound',
      'support',
      'telemarketer',
    ],
    categories: ['gaming', 'humanitarian'],
  },
  {
    name: 'heart',
    label: 'Heart',
    unicode: 'f004',
    styles: ['regular', 'solid'],
    searchTerms: [
      'ace',
      'black',
      'black heart',
      'blue',
      'blue heart',
      'brown',
      'brown heart',
      'card',
      'evil',
      'favorite',
      'game',
      'green',
      'green heart',
      'heart',
      'heart suit',
      'like',
      'love',
      'orange',
      'orange heart',
      'purple',
      'purple heart',
      'red heart',
      'relationship',
      'valentine',
      'white',
      'white heart',
      'wicked',
      'wishlist',
      'yellow',
      'yellow heart',
    ],
    categories: [
      'charity',
      'gaming',
      'holidays',
      'maps',
      'medical-health',
      'shapes',
      'shopping',
      'social',
      'sports-fitness',
    ],
  },
  {
    name: 'heart-circle-bolt',
    label: 'Heart Circle Bolt',
    unicode: 'e4fc',
    styles: ['solid'],
    searchTerms: [
      'cardiogram',
      'ekg',
      'electric',
      'heart',
      'love',
      'pacemaker',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'heart-circle-check',
    label: 'Heart Circle Check',
    unicode: 'e4fd',
    styles: ['solid'],
    searchTerms: [
      'enable',
      'favorite',
      'heart',
      'love',
      'not affected',
      'ok',
      'okay',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'heart-circle-exclamation',
    label: 'Heart Circle Exclamation',
    unicode: 'e4fe',
    styles: ['solid'],
    searchTerms: ['failed', 'favorite', 'heart', 'love'],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'heart-circle-minus',
    label: 'Heart Circle Minus',
    unicode: 'e4ff',
    styles: ['solid'],
    searchTerms: ['favorite', 'heart', 'love'],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'heart-circle-plus',
    label: 'Heart Circle Plus',
    unicode: 'e500',
    styles: ['solid'],
    searchTerms: ['favorite', 'heart', 'love'],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'heart-circle-xmark',
    label: 'Heart Circle Xmark',
    unicode: 'e501',
    styles: ['solid'],
    searchTerms: ['favorite', 'heart', 'love', 'uncheck'],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'heart-crack',
    label: 'Heart Crack',
    unicode: 'f7a9',
    styles: ['solid'],
    searchTerms: [
      'break',
      'breakup',
      'broken',
      'broken heart',
      'crushed',
      'dislike',
      'dumped',
      'grief',
      'love',
      'lovesick',
      'relationship',
      'sad',
    ],
    categories: ['shapes'],
    aliases: ['heart-broken'],
  },
  {
    name: 'heart-pulse',
    label: 'Heart Pulse',
    unicode: 'f21e',
    styles: ['solid'],
    searchTerms: [
      'ekg',
      'electrocardiogram',
      'health',
      'lifeline',
      'vital signs',
    ],
    categories: ['maps', 'medical-health', 'sports-fitness'],
    aliases: ['heartbeat'],
  },
  {
    name: 'helicopter',
    label: 'Helicopter',
    unicode: 'f533',
    styles: ['solid'],
    searchTerms: [
      'airwolf',
      'apache',
      'chopper',
      'flight',
      'fly',
      'helicopter',
      'travel',
      'vehicle',
    ],
    categories: ['humanitarian', 'logistics', 'maps', 'transportation'],
  },
  {
    name: 'helicopter-symbol',
    label: 'Helicopter Symbol',
    unicode: 'e502',
    styles: ['solid'],
    searchTerms: ['chopper', 'helicopter', 'landing pad', 'whirlybird'],
    categories: ['humanitarian', 'logistics', 'maps'],
  },
  {
    name: 'helmet-safety',
    label: 'Helmet Safety',
    unicode: 'f807',
    styles: ['solid'],
    searchTerms: ['construction', 'hardhat', 'helmet', 'maintenance', 'safety'],
    categories: ['construction', 'logistics'],
    aliases: ['hard-hat', 'hat-hard'],
  },
  {
    name: 'helmet-un',
    label: 'Helmet Un',
    unicode: 'e503',
    styles: ['solid'],
    searchTerms: ['helmet', 'united nations'],
    categories: ['disaster', 'humanitarian'],
  },
  {
    name: 'hexagon-nodes',
    label: 'Hexagon Nodes',
    unicode: 'e699',
    styles: ['solid'],
    searchTerms: [
      'action',
      'ai',
      'artificial intelligence',
      'cluster',
      'graph',
      'language',
      'llm',
      'model',
      'network',
      'neuronal',
    ],
    categories: ['charts-diagrams', 'coding'],
  },
  {
    name: 'hexagon-nodes-bolt',
    label: 'Hexagon Nodes Bolt',
    unicode: 'e69a',
    styles: ['solid'],
    searchTerms: [
      'LLM',
      'action',
      'ai',
      'artificial intelligence',
      'cluster',
      'graph',
      'language',
      'llm',
      'model',
      'network',
      'neuronal',
    ],
    categories: ['charts-diagrams', 'coding'],
  },
  {
    name: 'highlighter',
    label: 'Highlighter',
    unicode: 'f591',
    styles: ['solid'],
    searchTerms: ['edit', 'marker', 'modify', 'sharpie', 'update', 'write'],
    categories: ['business', 'design', 'text-formatting'],
  },
  {
    name: 'hill-avalanche',
    label: 'Hill Avalanche',
    unicode: 'e507',
    styles: ['solid'],
    searchTerms: ['mudslide', 'snow', 'winter'],
    categories: ['disaster', 'humanitarian'],
  },
  {
    name: 'hill-rockslide',
    label: 'Hill Rockslide',
    unicode: 'e508',
    styles: ['solid'],
    searchTerms: ['mudslide'],
    categories: ['disaster', 'humanitarian'],
  },
  {
    name: 'hippo',
    label: 'Hippo',
    unicode: 'f6ed',
    styles: ['solid'],
    searchTerms: [
      'animal',
      'fauna',
      'hippo',
      'hippopotamus',
      'hungry',
      'mammal',
    ],
    categories: ['animals'],
  },
  {
    name: 'hips',
    label: 'Hips',
    unicode: 'f452',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hire-a-helper',
    label: 'HireAHelper',
    unicode: 'f3b0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hive',
    label: 'Hive Blockchain Network',
    unicode: 'e07f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hockey-puck',
    label: 'Hockey Puck',
    unicode: 'f453',
    styles: ['solid'],
    searchTerms: ['ice', 'nhl', 'sport'],
    categories: ['sports-fitness'],
  },
  {
    name: 'holly-berry',
    label: 'Holly Berry',
    unicode: 'f7aa',
    styles: ['solid'],
    searchTerms: [
      'catwoman',
      'christmas',
      'decoration',
      'flora',
      'halle',
      'holiday',
      'ororo munroe',
      'plant',
      'storm',
      'xmas',
    ],
    categories: ['holidays'],
  },
  {
    name: 'hooli',
    label: 'Hooli',
    unicode: 'f427',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hornbill',
    label: 'Hornbill',
    unicode: 'f592',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'horse',
    label: 'Horse',
    unicode: 'f6f0',
    styles: ['solid'],
    searchTerms: [
      'equestrian',
      'equus',
      'fauna',
      'horse',
      'mammmal',
      'mare',
      'neigh',
      'pony',
      'racehorse',
      'racing',
    ],
    categories: ['animals', 'transportation'],
  },
  {
    name: 'horse-head',
    label: 'Horse Head',
    unicode: 'f7ab',
    styles: ['solid'],
    searchTerms: ['equus', 'fauna', 'mammmal', 'mare', 'neigh', 'pony'],
    categories: ['animals'],
  },
  {
    name: 'hospital',
    label: 'Hospital',
    unicode: 'f0f8',
    styles: ['regular', 'solid'],
    searchTerms: [
      'building',
      'covid-19',
      'doctor',
      'emergency room',
      'hospital',
      'medical center',
      'medicine',
    ],
    categories: ['buildings', 'humanitarian', 'maps', 'medical-health'],
    aliases: ['hospital-alt', 'hospital-wide'],
  },
  {
    name: 'hospital-user',
    label: 'Hospital User',
    unicode: 'f80d',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'doctor',
      'network',
      'patient',
      'primary care',
      'uer',
    ],
    categories: ['buildings', 'medical-health', 'users-people'],
  },
  {
    name: 'hot-tub-person',
    label: 'Hot Tub Person',
    unicode: 'f593',
    styles: ['solid'],
    searchTerms: ['jacuzzi', 'spa', 'uer'],
    categories: ['travel-hotel', 'users-people'],
    aliases: ['hot-tub'],
  },
  {
    name: 'hotdog',
    label: 'Hotdog',
    unicode: 'f80f',
    styles: ['solid'],
    searchTerms: [
      'bun',
      'chili',
      'frankfurt',
      'frankfurter',
      'hot dog',
      'hotdog',
      'kosher',
      'polish',
      'sandwich',
      'sausage',
      'vienna',
      'weiner',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'hotel',
    label: 'Hotel',
    unicode: 'f594',
    styles: ['solid'],
    searchTerms: [
      'building',
      'hotel',
      'inn',
      'lodging',
      'motel',
      'resort',
      'travel',
    ],
    categories: ['buildings', 'humanitarian', 'travel-hotel'],
  },
  {
    name: 'hotjar',
    label: 'Hotjar',
    unicode: 'f3b1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hourglass',
    label: 'Hourglass',
    unicode: 'f254',
    styles: ['regular', 'solid'],
    searchTerms: [
      'hour',
      'hourglass',
      'hourglass not done',
      'minute',
      'sand',
      'stopwatch',
      'time',
      'timer',
    ],
    categories: ['time'],
    aliases: ['hourglass-empty'],
  },
  {
    name: 'hourglass-end',
    label: 'Hourglass End',
    unicode: 'f253',
    styles: ['solid'],
    searchTerms: [
      'hour',
      'hourglass done',
      'minute',
      'pending',
      'sand',
      'stopwatch',
      'time',
      'timer',
      'waiting',
    ],
    categories: ['time'],
    aliases: ['hourglass-3'],
  },
  {
    name: 'hourglass-half',
    label: 'Hourglass Half',
    unicode: 'f252',
    styles: ['regular', 'solid'],
    searchTerms: [
      'hour',
      'minute',
      'pending',
      'sand',
      'stopwatch',
      'time',
      'waiting',
    ],
    categories: ['time'],
    aliases: ['hourglass-2'],
  },
  {
    name: 'hourglass-start',
    label: 'Hourglass Start',
    unicode: 'f251',
    styles: ['solid'],
    searchTerms: ['hour', 'minute', 'sand', 'stopwatch', 'time', 'waiting'],
    categories: ['time'],
    aliases: ['hourglass-1'],
  },
  {
    name: 'house',
    label: 'House',
    unicode: 'f015',
    styles: ['solid'],
    searchTerms: ['abode', 'building', 'home', 'house', 'main', 'residence'],
    categories: ['buildings', 'maps'],
    aliases: ['home', 'home-alt', 'home-lg-alt'],
  },
  {
    name: 'house-chimney',
    label: 'House Chimney',
    unicode: 'e3af',
    styles: ['solid'],
    searchTerms: [
      'abode',
      'building',
      'chimney',
      'house',
      'main',
      'residence',
      'smokestack',
    ],
    categories: ['buildings', 'humanitarian', 'moving'],
    aliases: ['home-lg'],
  },
  {
    name: 'house-chimney-crack',
    label: 'House Chimney Crack',
    unicode: 'f6f1',
    styles: ['solid'],
    searchTerms: [
      'building',
      'devastation',
      'disaster',
      'earthquake',
      'home',
      'insurance',
    ],
    categories: ['buildings', 'disaster', 'humanitarian'],
    aliases: ['house-damage'],
  },
  {
    name: 'house-chimney-medical',
    label: 'House Chimney Medical',
    unicode: 'f7f2',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'doctor',
      'general practitioner',
      'hospital',
      'infirmary',
      'medicine',
      'office',
      'outpatient',
    ],
    categories: ['buildings', 'medical-health'],
    aliases: ['clinic-medical'],
  },
  {
    name: 'house-chimney-user',
    label: 'House Chimney User',
    unicode: 'e065',
    styles: ['solid'],
    searchTerms: ['covid-19', 'home', 'isolation', 'quarantine', 'uer'],
    categories: ['household', 'users-people'],
  },
  {
    name: 'house-chimney-window',
    label: 'House Chimney Window',
    unicode: 'e00d',
    styles: ['solid'],
    searchTerms: ['abode', 'building', 'family', 'home', 'residence'],
    categories: ['buildings', 'household'],
  },
  {
    name: 'house-circle-check',
    label: 'House Circle Check',
    unicode: 'e509',
    styles: ['solid'],
    searchTerms: [
      'abode',
      'enable',
      'home',
      'house',
      'not affected',
      'ok',
      'okay',
      'validate',
      'working',
    ],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'house-circle-exclamation',
    label: 'House Circle Exclamation',
    unicode: 'e50a',
    styles: ['solid'],
    searchTerms: ['abode', 'affected', 'failed', 'home', 'house'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'house-circle-xmark',
    label: 'House Circle Xmark',
    unicode: 'e50b',
    styles: ['solid'],
    searchTerms: ['abode', 'destroy', 'home', 'house', 'uncheck'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'house-crack',
    label: 'House Crack',
    unicode: 'e3b1',
    styles: ['solid'],
    searchTerms: [
      'building',
      'devastation',
      'disaster',
      'earthquake',
      'home',
      'insurance',
    ],
    categories: ['buildings', 'disaster'],
  },
  {
    name: 'house-fire',
    label: 'House Fire',
    unicode: 'e50c',
    styles: ['solid'],
    searchTerms: ['burn', 'emergency', 'home'],
    categories: [
      'buildings',
      'disaster',
      'household',
      'humanitarian',
      'security',
    ],
  },
  {
    name: 'house-flag',
    label: 'House Flag',
    unicode: 'e50d',
    styles: ['solid'],
    searchTerms: ['camp', 'home'],
    categories: ['buildings', 'humanitarian'],
  },
  {
    name: 'house-flood-water',
    label: 'House Flood Water',
    unicode: 'e50e',
    styles: ['solid'],
    searchTerms: ['damage', 'flood', 'water'],
    categories: ['disaster', 'humanitarian'],
  },
  {
    name: 'house-flood-water-circle-arrow-right',
    label: 'House Flood Water Circle Arrow Right',
    unicode: 'e50f',
    styles: ['solid'],
    searchTerms: ['damage', 'flood', 'water'],
    categories: ['disaster', 'humanitarian'],
  },
  {
    name: 'house-laptop',
    label: 'House Laptop',
    unicode: 'e066',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'covid-19',
      'device',
      'office',
      'remote',
      'work from home',
    ],
    categories: ['business', 'devices-hardware', 'household'],
    aliases: ['laptop-house'],
  },
  {
    name: 'house-lock',
    label: 'House Lock',
    unicode: 'e510',
    styles: ['solid'],
    searchTerms: [
      'closed',
      'home',
      'house',
      'lockdown',
      'padlock',
      'privacy',
      'quarantine',
    ],
    categories: ['buildings', 'household', 'humanitarian', 'security'],
  },
  {
    name: 'house-medical',
    label: 'House Medical',
    unicode: 'e3b2',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'doctor',
      'facility',
      'general practitioner',
      'health',
      'hospital',
      'infirmary',
      'medicine',
      'office',
      'outpatient',
    ],
    categories: ['buildings', 'humanitarian', 'medical-health'],
  },
  {
    name: 'house-medical-circle-check',
    label: 'House Medical Circle Check',
    unicode: 'e511',
    styles: ['solid'],
    searchTerms: [
      'clinic',
      'enable',
      'hospital',
      'not affected',
      'ok',
      'okay',
      'validate',
      'working',
    ],
    categories: ['buildings', 'humanitarian', 'medical-health'],
  },
  {
    name: 'house-medical-circle-exclamation',
    label: 'House Medical Circle Exclamation',
    unicode: 'e512',
    styles: ['solid'],
    searchTerms: ['affected', 'clinic', 'failed', 'hospital'],
    categories: ['buildings', 'humanitarian', 'medical-health'],
  },
  {
    name: 'house-medical-circle-xmark',
    label: 'House Medical Circle Xmark',
    unicode: 'e513',
    styles: ['solid'],
    searchTerms: ['clinic', 'destroy', 'hospital', 'uncheck'],
    categories: ['buildings', 'humanitarian', 'medical-health'],
  },
  {
    name: 'house-medical-flag',
    label: 'House Medical Flag',
    unicode: 'e514',
    styles: ['solid'],
    searchTerms: ['clinic', 'hospital', 'mash'],
    categories: ['buildings', 'humanitarian', 'medical-health'],
  },
  {
    name: 'house-signal',
    label: 'House Signal',
    unicode: 'e012',
    styles: ['solid'],
    searchTerms: [
      'abode',
      'building',
      'connect',
      'family',
      'home',
      'residence',
      'smart home',
      'wifi',
      'www',
    ],
    categories: ['connectivity', 'household', 'humanitarian'],
  },
  {
    name: 'house-tsunami',
    label: 'House Tsunami',
    unicode: 'e515',
    styles: ['solid'],
    searchTerms: ['damage', 'flood', 'tidal wave', 'wave'],
    categories: ['disaster', 'humanitarian', 'weather'],
  },
  {
    name: 'house-user',
    label: 'House User',
    unicode: 'e1b0',
    styles: ['solid'],
    searchTerms: ['house', 'uer'],
    categories: ['household', 'users-people'],
    aliases: ['home-user'],
  },
  {
    name: 'houzz',
    label: 'Houzz',
    unicode: 'f27c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hryvnia-sign',
    label: 'Hryvnia Sign',
    unicode: 'f6f2',
    styles: ['solid'],
    searchTerms: ['Hryvnia Sign', 'currency'],
    categories: ['money'],
    aliases: ['hryvnia'],
  },
  {
    name: 'html5',
    label: 'HTML 5 Logo',
    unicode: 'f13b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hubspot',
    label: 'HubSpot',
    unicode: 'f3b2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'hurricane',
    label: 'Hurricane',
    unicode: 'f751',
    styles: ['solid'],
    searchTerms: [
      'coriolis effect',
      'eye',
      'storm',
      'tropical cyclone',
      'typhoon',
    ],
    categories: ['disaster', 'humanitarian', 'spinners', 'weather'],
  },
  {
    name: 'i',
    label: 'I',
    unicode: '49',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter I', 'Latin Small Letter I', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'i-cursor',
    label: 'I Cursor',
    unicode: 'f246',
    styles: ['solid'],
    searchTerms: ['editing', 'i-beam', 'type', 'writing'],
    categories: ['text-formatting'],
  },
  {
    name: 'ice-cream',
    label: 'Ice Cream',
    unicode: 'f810',
    styles: ['solid'],
    searchTerms: [
      'chocolate',
      'cone',
      'cream',
      'dessert',
      'frozen',
      'ice',
      'ice cream',
      'scoop',
      'sorbet',
      'sweet',
      'vanilla',
      'yogurt',
    ],
    categories: ['childhood', 'food-beverage'],
  },
  {
    name: 'icicles',
    label: 'Icicles',
    unicode: 'f7ad',
    styles: ['solid'],
    searchTerms: ['cold', 'frozen', 'hanging', 'ice', 'seasonal', 'sharp'],
    categories: ['nature', 'weather'],
  },
  {
    name: 'icons',
    label: 'Icons',
    unicode: 'f86d',
    styles: ['solid'],
    searchTerms: [
      'bolt',
      'category',
      'emoji',
      'heart',
      'image',
      'music',
      'photo',
      'symbols',
    ],
    categories: ['communication', 'design', 'social', 'text-formatting'],
    aliases: ['heart-music-camera-bolt'],
  },
  {
    name: 'id-badge',
    label: 'Id Badge',
    unicode: 'f2c1',
    styles: ['regular', 'solid'],
    searchTerms: [
      'address',
      'contact',
      'identification',
      'license',
      'profile',
      'uer',
      'username',
    ],
    categories: ['photos-images', 'security', 'users-people'],
  },
  {
    name: 'id-card',
    label: 'Id Card',
    unicode: 'f2c2',
    styles: ['regular', 'solid'],
    searchTerms: [
      'contact',
      'demographics',
      'document',
      'identification',
      'issued',
      'profile',
      'registration',
      'uer',
      'username',
    ],
    categories: ['humanitarian', 'photos-images', 'security', 'users-people'],
    aliases: ['drivers-license'],
  },
  {
    name: 'id-card-clip',
    label: 'Id Card Clip',
    unicode: 'f47f',
    styles: ['solid'],
    searchTerms: [
      'contact',
      'demographics',
      'document',
      'identification',
      'issued',
      'profile',
      'uer',
      'username',
    ],
    categories: ['medical-health', 'security', 'users-people'],
    aliases: ['id-card-alt'],
  },
  {
    name: 'ideal',
    label: 'iDeal',
    unicode: 'e013',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'igloo',
    label: 'Igloo',
    unicode: 'f7ae',
    styles: ['solid'],
    searchTerms: ['dome', 'dwelling', 'eskimo', 'home', 'house', 'ice', 'snow'],
    categories: ['buildings'],
  },
  {
    name: 'image',
    label: 'Image',
    unicode: 'f03e',
    styles: ['regular', 'solid'],
    searchTerms: ['album', 'img', 'landscape', 'photo', 'picture'],
    categories: ['maps', 'photos-images', 'social'],
  },
  {
    name: 'image-portrait',
    label: 'Image Portrait',
    unicode: 'f3e0',
    styles: ['solid'],
    searchTerms: [
      'id',
      'image',
      'img',
      'photo',
      'picture',
      'selfie',
      'uer',
      'username',
    ],
    categories: ['photos-images', 'users-people'],
    aliases: ['portrait'],
  },
  {
    name: 'images',
    label: 'Images',
    unicode: 'f302',
    styles: ['regular', 'solid'],
    searchTerms: ['album', 'img', 'landscape', 'photo', 'picture'],
    categories: ['maps', 'photos-images', 'social'],
  },
  {
    name: 'imdb',
    label: 'IMDB',
    unicode: 'f2d8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'inbox',
    label: 'Inbox',
    unicode: 'f01c',
    styles: ['solid'],
    searchTerms: ['archive', 'desk', 'email', 'mail', 'message'],
    categories: ['communication'],
  },
  {
    name: 'indent',
    label: 'Indent',
    unicode: 'f03c',
    styles: ['solid'],
    searchTerms: ['align', 'justify', 'paragraph', 'tab'],
    categories: ['text-formatting'],
  },
  {
    name: 'indian-rupee-sign',
    label: 'Indian Rupee Sign',
    unicode: 'e1bc',
    styles: ['solid'],
    searchTerms: ['Indian Rupee Sign', 'currency'],
    categories: ['money'],
    aliases: ['indian-rupee', 'inr'],
  },
  {
    name: 'industry',
    label: 'Industry',
    unicode: 'f275',
    styles: ['solid'],
    searchTerms: [
      'building',
      'factory',
      'industrial',
      'manufacturing',
      'mill',
      'warehouse',
    ],
    categories: ['buildings', 'business', 'energy', 'maps'],
  },
  {
    name: 'infinity',
    label: 'Infinity',
    unicode: 'f534',
    styles: ['solid'],
    searchTerms: [
      'Infinity',
      'eternity',
      'forever',
      'infinity',
      'math',
      'unbounded',
      'universal',
    ],
    categories: ['mathematics', 'travel-hotel'],
  },
  {
    name: 'info',
    label: 'Info',
    unicode: 'f129',
    styles: ['solid'],
    searchTerms: ['details', 'help', 'information', 'more', 'support'],
    categories: ['maps'],
  },
  {
    name: 'instagram',
    label: 'Instagram',
    unicode: 'f16d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'instalod',
    label: 'InstaLOD',
    unicode: 'e081',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'intercom',
    label: 'Intercom',
    unicode: 'f7af',
    styles: ['brands'],
    searchTerms: ['app', 'customer', 'messenger'],
    categories: [],
  },
  {
    name: 'internet-explorer',
    label: 'Internet-explorer',
    unicode: 'f26b',
    styles: ['brands'],
    searchTerms: ['browser', 'ie'],
    categories: [],
  },
  {
    name: 'invision',
    label: 'InVision',
    unicode: 'f7b0',
    styles: ['brands'],
    searchTerms: ['app', 'design', 'interface'],
    categories: [],
  },
  {
    name: 'ioxhost',
    label: 'ioxhost',
    unicode: 'f208',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'italic',
    label: 'Italic',
    unicode: 'f033',
    styles: ['solid'],
    searchTerms: ['edit', 'emphasis', 'font', 'format', 'text', 'type'],
    categories: ['text-formatting'],
  },
  {
    name: 'itch-io',
    label: 'itch.io',
    unicode: 'f83a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'itunes',
    label: 'iTunes',
    unicode: 'f3b4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'itunes-note',
    label: 'Itunes Note',
    unicode: 'f3b5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'j',
    label: 'J',
    unicode: '4a',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter J', 'Latin Small Letter J', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'jar',
    label: 'Jar',
    unicode: 'e516',
    styles: ['solid'],
    searchTerms: ['jam', 'jelly', 'storage'],
    categories: ['food-beverage', 'household', 'humanitarian'],
  },
  {
    name: 'jar-wheat',
    label: 'Jar Wheat',
    unicode: 'e517',
    styles: ['solid'],
    searchTerms: ['flour', 'storage'],
    categories: ['food-beverage', 'household', 'humanitarian'],
  },
  {
    name: 'java',
    label: 'Java',
    unicode: 'f4e4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'jedi',
    label: 'Jedi',
    unicode: 'f669',
    styles: ['solid'],
    searchTerms: ['crest', 'force', 'sith', 'skywalker', 'star wars', 'yoda'],
    categories: ['religion', 'science-fiction'],
  },
  {
    name: 'jedi-order',
    label: 'Jedi Order',
    unicode: 'f50e',
    styles: ['brands'],
    searchTerms: ['star wars'],
    categories: ['science-fiction'],
  },
  {
    name: 'jenkins',
    label: 'Jenkis',
    unicode: 'f3b6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'jet-fighter',
    label: 'Jet Fighter',
    unicode: 'f0fb',
    styles: ['solid'],
    searchTerms: [
      'airforce',
      'airplane',
      'airport',
      'fast',
      'fly',
      'goose',
      'marines',
      'maverick',
      'military',
      'plane',
      'quick',
      'top gun',
      'transportation',
      'travel',
    ],
    categories: ['maps', 'transportation'],
    aliases: ['fighter-jet'],
  },
  {
    name: 'jet-fighter-up',
    label: 'Jet Fighter Up',
    unicode: 'e518',
    styles: ['solid'],
    searchTerms: [
      'airforce',
      'airplane',
      'airport',
      'fast',
      'fly',
      'goose',
      'marines',
      'maverick',
      'military',
      'plane',
      'quick',
      'top gun',
      'transportation',
      'travel',
    ],
    categories: ['humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'jira',
    label: 'Jira',
    unicode: 'f7b1',
    styles: ['brands'],
    searchTerms: ['atlassian'],
    categories: [],
  },
  {
    name: 'joget',
    label: 'Joget',
    unicode: 'f3b7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'joint',
    label: 'Joint',
    unicode: 'f595',
    styles: ['solid'],
    searchTerms: [
      'blunt',
      'cannabis',
      'doobie',
      'drugs',
      'marijuana',
      'roach',
      'smoke',
      'smoking',
      'spliff',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'joomla',
    label: 'Joomla Logo',
    unicode: 'f1aa',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'js',
    label: 'JavaScript (JS)',
    unicode: 'f3b8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'jsfiddle',
    label: 'jsFiddle',
    unicode: 'f1cc',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'jug-detergent',
    label: 'Jug Detergent',
    unicode: 'e519',
    styles: ['solid'],
    searchTerms: ['detergent', 'laundry', 'soap', 'wash'],
    categories: ['household', 'humanitarian'],
  },
  {
    name: 'jxl',
    label: 'JXL',
    unicode: 'e67b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'k',
    label: 'K',
    unicode: '4b',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter K', 'Latin Small Letter K', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'kaaba',
    label: 'Kaaba',
    unicode: 'f66b',
    styles: ['solid'],
    searchTerms: [
      'Muslim',
      'building',
      'cube',
      'islam',
      'kaaba',
      'muslim',
      'religion',
    ],
    categories: ['buildings', 'religion'],
  },
  {
    name: 'kaggle',
    label: 'Kaggle',
    unicode: 'f5fa',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'key',
    label: 'Key',
    unicode: 'f084',
    styles: ['solid'],
    searchTerms: ['key', 'lock', 'password', 'private', 'secret', 'unlock'],
    categories: ['maps', 'security', 'shopping', 'travel-hotel'],
  },
  {
    name: 'keybase',
    label: 'Keybase',
    unicode: 'f4f5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'keyboard',
    label: 'Keyboard',
    unicode: 'f11c',
    styles: ['regular', 'solid'],
    searchTerms: [
      'accessory',
      'computer',
      'edit',
      'input',
      'keyboard',
      'text',
      'type',
      'write',
    ],
    categories: ['coding', 'devices-hardware', 'writing'],
  },
  {
    name: 'keycdn',
    label: 'KeyCDN',
    unicode: 'f3ba',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'khanda',
    label: 'Khanda',
    unicode: 'f66d',
    styles: ['solid'],
    searchTerms: ['Adi Shakti', 'chakkar', 'sikh', 'sikhism', 'sword'],
    categories: ['religion'],
  },
  {
    name: 'kickstarter',
    label: 'Kickstarter',
    unicode: 'f3bb',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['square-kickstarter'],
  },
  {
    name: 'kickstarter-k',
    label: 'Kickstarter K',
    unicode: 'f3bc',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'kip-sign',
    label: 'Kip Sign',
    unicode: 'e1c4',
    styles: ['solid'],
    searchTerms: ['Kip Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'kit-medical',
    label: 'Kit Medical',
    unicode: 'f479',
    styles: ['solid'],
    searchTerms: ['emergency', 'emt', 'health', 'medical', 'rescue'],
    categories: ['camping', 'medical-health'],
    aliases: ['first-aid'],
  },
  {
    name: 'kitchen-set',
    label: 'Kitchen Set',
    unicode: 'e51a',
    styles: ['solid'],
    searchTerms: ['chef', 'cook', 'cup', 'kitchen', 'pan', 'pot', 'skillet'],
    categories: ['household', 'humanitarian', 'travel-hotel'],
  },
  {
    name: 'kiwi-bird',
    label: 'Kiwi Bird',
    unicode: 'f535',
    styles: ['solid'],
    searchTerms: ['bird', 'fauna', 'new zealand'],
    categories: ['animals'],
  },
  {
    name: 'korvue',
    label: 'KORVUE',
    unicode: 'f42f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'l',
    label: 'L',
    unicode: '4c',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter L', 'Latin Small Letter L', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'land-mine-on',
    label: 'Land Mine On',
    unicode: 'e51b',
    styles: ['solid'],
    searchTerms: ['bomb', 'danger', 'explosion', 'war'],
    categories: ['humanitarian', 'security'],
  },
  {
    name: 'landmark',
    label: 'Landmark',
    unicode: 'f66f',
    styles: ['solid'],
    searchTerms: [
      'building',
      'classical',
      'historic',
      'memorable',
      'monument',
      'museum',
      'politics',
      'society',
    ],
    categories: ['buildings', 'business', 'humanitarian', 'maps', 'money'],
  },
  {
    name: 'landmark-dome',
    label: 'Landmark Dome',
    unicode: 'f752',
    styles: ['solid'],
    searchTerms: ['building', 'historic', 'memorable', 'monument', 'politics'],
    categories: ['buildings', 'humanitarian', 'political'],
    aliases: ['landmark-alt'],
  },
  {
    name: 'landmark-flag',
    label: 'Landmark Flag',
    unicode: 'e51c',
    styles: ['solid'],
    searchTerms: ['capitol', 'flag', 'landmark', 'memorial'],
    categories: ['buildings', 'humanitarian', 'maps', 'political'],
  },
  {
    name: 'language',
    label: 'Language',
    unicode: 'f1ab',
    styles: ['solid'],
    searchTerms: [
      'dialect',
      'idiom',
      'localize',
      'speech',
      'translate',
      'vernacular',
    ],
    categories: ['communication'],
  },
  {
    name: 'laptop',
    label: 'Laptop',
    unicode: 'f109',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'cpu',
      'dell',
      'demo',
      'device',
      'fabook',
      'fb',
      'laptop',
      'mac',
      'macbook',
      'machine',
      'pc',
      'personal',
    ],
    categories: ['devices-hardware', 'humanitarian'],
  },
  {
    name: 'laptop-code',
    label: 'Laptop Code',
    unicode: 'f5fc',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'cpu',
      'dell',
      'demo',
      'develop',
      'device',
      'fabook',
      'fb',
      'mac',
      'macbook',
      'machine',
      'mysql',
      'pc',
      'sql',
    ],
    categories: ['coding', 'education'],
  },
  {
    name: 'laptop-file',
    label: 'Laptop File',
    unicode: 'e51d',
    styles: ['solid'],
    searchTerms: ['computer', 'education', 'laptop', 'learning', 'remote work'],
    categories: ['business', 'devices-hardware', 'education', 'humanitarian'],
  },
  {
    name: 'laptop-medical',
    label: 'Laptop Medical',
    unicode: 'f812',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'device',
      'ehr',
      'electronic health records',
      'history',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'laravel',
    label: 'Laravel',
    unicode: 'f3bd',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'lari-sign',
    label: 'Lari Sign',
    unicode: 'e1c8',
    styles: ['solid'],
    searchTerms: ['Lari Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'lastfm',
    label: 'last.fm',
    unicode: 'f202',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'layer-group',
    label: 'Layer Group',
    unicode: 'f5fd',
    styles: ['solid'],
    searchTerms: [
      'arrange',
      'category',
      'develop',
      'layers',
      'map',
      'platform',
      'stack',
    ],
    categories: ['design', 'maps'],
  },
  {
    name: 'leaf',
    label: 'Leaf',
    unicode: 'f06c',
    styles: ['solid'],
    searchTerms: ['eco', 'flora', 'nature', 'plant', 'vegan'],
    categories: ['charity', 'energy', 'fruits-vegetables', 'maps', 'nature'],
  },
  {
    name: 'leanpub',
    label: 'Leanpub',
    unicode: 'f212',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'left-long',
    label: 'Left Long',
    unicode: 'f30a',
    styles: ['solid'],
    searchTerms: ['back', 'long-arrow-left', 'previous'],
    categories: ['arrows'],
    aliases: ['long-arrow-alt-left'],
  },
  {
    name: 'left-right',
    label: 'Left Right',
    unicode: 'f337',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'arrows-h',
      'expand',
      'horizontal',
      'landscape',
      'left-right arrow',
      'resize',
      'wide',
    ],
    categories: ['arrows'],
    aliases: ['arrows-alt-h'],
  },
  {
    name: 'lemon',
    label: 'Lemon',
    unicode: 'f094',
    styles: ['regular', 'solid'],
    searchTerms: ['citrus', 'fruit', 'lemon', 'lemonade', 'lime', 'tart'],
    categories: ['food-beverage', 'fruits-vegetables', 'maps'],
  },
  {
    name: 'less',
    label: 'Less',
    unicode: 'f41d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'less-than',
    label: 'Less Than',
    unicode: '3c',
    styles: ['solid'],
    searchTerms: ['Less-Than Sign', 'arithmetic', 'compare', 'math'],
    categories: ['mathematics', 'punctuation-symbols'],
  },
  {
    name: 'less-than-equal',
    label: 'Less Than Equal',
    unicode: 'f537',
    styles: ['solid'],
    searchTerms: ['arithmetic', 'compare', 'math'],
    categories: ['mathematics'],
  },
  {
    name: 'letterboxd',
    label: 'Letterboxd',
    unicode: 'e62d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'life-ring',
    label: 'Life Ring',
    unicode: 'f1cd',
    styles: ['regular', 'solid'],
    searchTerms: ['coast guard', 'help', 'overboard', 'save', 'support'],
    categories: ['humanitarian', 'maps', 'spinners'],
  },
  {
    name: 'lightbulb',
    label: 'Lightbulb',
    unicode: 'f0eb',
    styles: ['regular', 'solid'],
    searchTerms: [
      'bulb',
      'bulb',
      'comic',
      'comic',
      'electric',
      'electric',
      'energy',
      'idea',
      'idea',
      'innovation',
      'inspiration',
      'inspiration',
      'light',
      'light bulb',
      'mechanical',
    ],
    categories: ['energy', 'household', 'maps', 'marketing'],
  },
  {
    name: 'line',
    label: 'Line',
    unicode: 'f3c0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'lines-leaning',
    label: 'Lines Leaning',
    unicode: 'e51e',
    styles: ['solid'],
    searchTerms: [
      'canted',
      'domino',
      'falling',
      'resilience',
      'resilient',
      'tipped',
    ],
    categories: ['design', 'humanitarian', 'shapes'],
  },
  {
    name: 'link',
    label: 'Link',
    unicode: 'f0c1',
    styles: ['solid'],
    searchTerms: ['attach', 'attachment', 'chain', 'connect', 'lin', 'link'],
    categories: ['editing'],
    aliases: ['chain'],
  },
  {
    name: 'link-slash',
    label: 'Link Slash',
    unicode: 'f127',
    styles: ['solid'],
    searchTerms: [
      'attachment',
      'chain',
      'chain-broken',
      'disabled',
      'disconnect',
      'remove',
    ],
    categories: ['editing'],
    aliases: ['chain-broken', 'chain-slash', 'unlink'],
  },
  {
    name: 'linkedin',
    label: 'LinkedIn',
    unicode: 'f08c',
    styles: ['brands'],
    searchTerms: ['linkedin-square', 'linkin'],
    categories: [],
  },
  {
    name: 'linkedin-in',
    label: 'LinkedIn In',
    unicode: 'f0e1',
    styles: ['brands'],
    searchTerms: ['linkedin', 'linkin'],
    categories: [],
  },
  {
    name: 'linode',
    label: 'Linode',
    unicode: 'f2b8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'linux',
    label: 'Linux',
    unicode: 'f17c',
    styles: ['brands'],
    searchTerms: ['tux'],
    categories: [],
  },
  {
    name: 'lira-sign',
    label: 'Lira Sign',
    unicode: 'f195',
    styles: ['solid'],
    searchTerms: ['Lira Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'list',
    label: 'List',
    unicode: 'f03a',
    styles: ['solid'],
    searchTerms: [
      'bullet',
      'category',
      'cheatsheet',
      'checklist',
      'completed',
      'done',
      'finished',
      'ol',
      'summary',
      'todo',
      'ul',
    ],
    categories: ['text-formatting'],
    aliases: ['list-squares'],
  },
  {
    name: 'list-check',
    label: 'List Check',
    unicode: 'f0ae',
    styles: ['solid'],
    searchTerms: [
      'bullet',
      'cheatsheet',
      'checklist',
      'downloading',
      'downloads',
      'enable',
      'loading',
      'progress',
      'project management',
      'settings',
      'summary',
      'to do',
      'validate',
      'working',
    ],
    categories: ['business', 'text-formatting'],
    aliases: ['tasks'],
  },
  {
    name: 'list-ol',
    label: 'List Ol',
    unicode: 'f0cb',
    styles: ['solid'],
    searchTerms: [
      'cheatsheet',
      'checklist',
      'completed',
      'done',
      'finished',
      'numbers',
      'ol',
      'summary',
      'todo',
      'ul',
    ],
    categories: ['text-formatting'],
    aliases: ['list-1-2', 'list-numeric'],
  },
  {
    name: 'list-ul',
    label: 'List Ul',
    unicode: 'f0ca',
    styles: ['solid'],
    searchTerms: [
      'bullet',
      'cheatsheet',
      'checklist',
      'completed',
      'done',
      'finished',
      'ol',
      'summary',
      'survey',
      'todo',
      'ul',
    ],
    categories: ['text-formatting'],
    aliases: ['list-dots'],
  },
  {
    name: 'litecoin-sign',
    label: 'Litecoin Sign',
    unicode: 'e1d3',
    styles: ['solid'],
    searchTerms: ['currency'],
    categories: ['money'],
  },
  {
    name: 'location-arrow',
    label: 'Location Arrow',
    unicode: 'f124',
    styles: ['solid'],
    searchTerms: [
      'address',
      'compass',
      'coordinate',
      'direction',
      'gps',
      'map',
      'navigation',
      'place',
    ],
    categories: ['arrows', 'maps'],
  },
  {
    name: 'location-crosshairs',
    label: 'Location Crosshairs',
    unicode: 'f601',
    styles: ['solid'],
    searchTerms: [
      'address',
      'coordinate',
      'direction',
      'gps',
      'location',
      'map',
      'navigation',
      'place',
      'where',
    ],
    categories: ['maps', 'toggle'],
    aliases: ['location'],
  },
  {
    name: 'location-dot',
    label: 'Location Dot',
    unicode: 'f3c5',
    styles: ['solid'],
    searchTerms: [
      'address',
      'coordinates',
      'destination',
      'gps',
      'localize',
      'location',
      'map',
      'navigation',
      'paper',
      'pin',
      'place',
      'point of interest',
      'position',
      'route',
      'travel',
    ],
    categories: ['maps', 'social'],
    aliases: ['map-marker-alt'],
  },
  {
    name: 'location-pin',
    label: 'Location Pin',
    unicode: 'f041',
    styles: ['solid'],
    searchTerms: [
      'address',
      'coordinates',
      'destination',
      'gps',
      'localize',
      'location',
      'map',
      'navigation',
      'paper',
      'pin',
      'place',
      'point of interest',
      'position',
      'route',
      'travel',
    ],
    categories: ['maps', 'shapes', 'social'],
    aliases: ['map-marker'],
  },
  {
    name: 'location-pin-lock',
    label: 'Location Pin Lock',
    unicode: 'e51f',
    styles: ['solid'],
    searchTerms: [
      'closed',
      'lockdown',
      'map',
      'padlock',
      'privacy',
      'quarantine',
    ],
    categories: ['humanitarian', 'maps'],
  },
  {
    name: 'lock',
    label: 'Lock',
    unicode: 'f023',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'closed',
      'lock',
      'locked',
      'open',
      'padlock',
      'password',
      'privacy',
      'private',
      'protect',
      'security',
    ],
    categories: ['security'],
  },
  {
    name: 'lock-open',
    label: 'Lock Open',
    unicode: 'f3c1',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'lock',
      'open',
      'padlock',
      'password',
      'privacy',
      'private',
      'protect',
      'security',
      'unlock',
    ],
    categories: ['security'],
  },
  {
    name: 'locust',
    label: 'Locust',
    unicode: 'e520',
    styles: ['solid'],
    searchTerms: ['horde', 'infestation', 'locust', 'plague', 'swarm'],
    categories: ['animals', 'disaster', 'humanitarian', 'nature'],
  },
  {
    name: 'lungs',
    label: 'Lungs',
    unicode: 'f604',
    styles: ['solid'],
    searchTerms: [
      'air',
      'breath',
      'covid-19',
      'exhalation',
      'inhalation',
      'lungs',
      'organ',
      'respiration',
      'respiratory',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'lungs-virus',
    label: 'Lungs Virus',
    unicode: 'e067',
    styles: ['solid'],
    searchTerms: [
      'breath',
      'coronavirus',
      'covid-19',
      'flu',
      'infection',
      'pandemic',
      'respiratory',
      'sick',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'lyft',
    label: 'lyft',
    unicode: 'f3c3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'm',
    label: 'M',
    unicode: '4d',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter M', 'Latin Small Letter M', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'magento',
    label: 'Magento',
    unicode: 'f3c4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'magnet',
    label: 'Magnet',
    unicode: 'f076',
    styles: ['solid'],
    searchTerms: [
      'Attract',
      'attraction',
      'horseshoe',
      'lodestone',
      'magnet',
      'magnetic',
      'tool',
    ],
    categories: ['maps', 'science'],
  },
  {
    name: 'magnifying-glass',
    label: 'Magnifying Glass',
    unicode: 'f002',
    styles: ['solid'],
    searchTerms: [
      'bigger',
      'enlarge',
      'equipment',
      'find',
      'glass',
      'inspection',
      'magnifier',
      'magnify',
      'magnifying',
      'magnifying glass tilted left',
      'preview',
      'search',
      'tool',
      'zoom',
    ],
    categories: ['maps'],
    aliases: ['search'],
  },
  {
    name: 'magnifying-glass-arrow-right',
    label: 'Magnifying Glass Arrow Right',
    unicode: 'e521',
    styles: ['solid'],
    searchTerms: ['find', 'magnifier', 'next', 'search'],
    categories: ['business', 'humanitarian', 'marketing'],
  },
  {
    name: 'magnifying-glass-chart',
    label: 'Magnifying Glass Chart',
    unicode: 'e522',
    styles: ['solid'],
    searchTerms: [
      'analysis',
      'chart',
      'data',
      'graph',
      'intelligence',
      'magnifier',
      'market',
      'revenue',
    ],
    categories: ['business', 'humanitarian', 'marketing'],
  },
  {
    name: 'magnifying-glass-dollar',
    label: 'Magnifying Glass Dollar',
    unicode: 'f688',
    styles: ['solid'],
    searchTerms: [
      'bigger',
      'enlarge',
      'find',
      'magnifier',
      'magnify',
      'money',
      'preview',
      'zoom',
    ],
    categories: ['marketing'],
    aliases: ['search-dollar'],
  },
  {
    name: 'magnifying-glass-location',
    label: 'Magnifying Glass Location',
    unicode: 'f689',
    styles: ['solid'],
    searchTerms: [
      'bigger',
      'enlarge',
      'find',
      'magnifier',
      'magnify',
      'preview',
      'zoom',
    ],
    categories: ['maps', 'marketing'],
    aliases: ['search-location'],
  },
  {
    name: 'magnifying-glass-minus',
    label: 'Magnifying Glass Minus',
    unicode: 'f010',
    styles: ['solid'],
    searchTerms: [
      'magnifier',
      'minify',
      'negative',
      'smaller',
      'zoom',
      'zoom out',
    ],
    categories: ['maps'],
    aliases: ['search-minus'],
  },
  {
    name: 'magnifying-glass-plus',
    label: 'Magnifying Glass Plus',
    unicode: 'f00e',
    styles: ['solid'],
    searchTerms: [
      'bigger',
      'enlarge',
      'magnifier',
      'magnify',
      'positive',
      'zoom',
      'zoom in',
    ],
    categories: ['maps'],
    aliases: ['search-plus'],
  },
  {
    name: 'mailchimp',
    label: 'Mailchimp',
    unicode: 'f59e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'manat-sign',
    label: 'Manat Sign',
    unicode: 'e1d5',
    styles: ['solid'],
    searchTerms: ['Manat Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'mandalorian',
    label: 'Mandalorian',
    unicode: 'f50f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'map',
    label: 'Map',
    unicode: 'f279',
    styles: ['regular', 'solid'],
    searchTerms: [
      'address',
      'coordinates',
      'destination',
      'gps',
      'localize',
      'location',
      'map',
      'navigation',
      'paper',
      'pin',
      'place',
      'point of interest',
      'position',
      'route',
      'travel',
      'world',
      'world map',
    ],
    categories: ['camping', 'maps', 'travel-hotel'],
  },
  {
    name: 'map-location',
    label: 'Map Location',
    unicode: 'f59f',
    styles: ['solid'],
    searchTerms: [
      'address',
      'coordinates',
      'destination',
      'gps',
      'localize',
      'location',
      'map',
      'navigation',
      'paper',
      'pin',
      'place',
      'point of interest',
      'position',
      'route',
      'travel',
    ],
    categories: ['camping', 'travel-hotel'],
    aliases: ['map-marked'],
  },
  {
    name: 'map-location-dot',
    label: 'Map Location Dot',
    unicode: 'f5a0',
    styles: ['solid'],
    searchTerms: [
      'address',
      'coordinates',
      'destination',
      'gps',
      'localize',
      'location',
      'map',
      'navigation',
      'paper',
      'pin',
      'place',
      'point of interest',
      'position',
      'route',
      'travel',
    ],
    categories: ['camping', 'travel-hotel'],
    aliases: ['map-marked-alt'],
  },
  {
    name: 'map-pin',
    label: 'Map Pin',
    unicode: 'f276',
    styles: ['solid'],
    searchTerms: [
      'address',
      'agree',
      'coordinates',
      'destination',
      'gps',
      'localize',
      'location',
      'map',
      'marker',
      'navigation',
      'pin',
      'place',
      'position',
      'pushpin',
      'round pushpin',
      'travel',
    ],
    categories: ['maps'],
  },
  {
    name: 'markdown',
    label: 'Markdown',
    unicode: 'f60f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'marker',
    label: 'Marker',
    unicode: 'f5a1',
    styles: ['solid'],
    searchTerms: ['design', 'edit', 'modify', 'sharpie', 'update', 'write'],
    categories: ['business', 'design'],
  },
  {
    name: 'mars',
    label: 'Mars',
    unicode: 'f222',
    styles: ['solid'],
    searchTerms: ['gender', 'male', 'male sign', 'man'],
    categories: ['gender'],
  },
  {
    name: 'mars-and-venus',
    label: 'Mars And Venus',
    unicode: 'f224',
    styles: ['solid'],
    searchTerms: [
      'Male and Female Sign',
      'female',
      'gender',
      'intersex',
      'male',
      'transgender',
    ],
    categories: ['gender', 'humanitarian'],
  },
  {
    name: 'mars-and-venus-burst',
    label: 'Mars And Venus Burst',
    unicode: 'e523',
    styles: ['solid'],
    searchTerms: ['gender', 'uer', 'violence'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'mars-double',
    label: 'Mars Double',
    unicode: 'f227',
    styles: ['solid'],
    searchTerms: ['Doubled Male Sign', 'gay', 'gender', 'male', 'men'],
    categories: ['gender'],
  },
  {
    name: 'mars-stroke',
    label: 'Mars Stroke',
    unicode: 'f229',
    styles: ['solid'],
    searchTerms: ['Male with Stroke Sign', 'gender', 'transgender'],
    categories: ['gender'],
  },
  {
    name: 'mars-stroke-right',
    label: 'Mars Stroke Right',
    unicode: 'f22b',
    styles: ['solid'],
    searchTerms: ['Horizontal Male with Stroke Sign', 'gender'],
    categories: ['gender'],
    aliases: ['mars-stroke-h'],
  },
  {
    name: 'mars-stroke-up',
    label: 'Mars Stroke Up',
    unicode: 'f22a',
    styles: ['solid'],
    searchTerms: ['Vertical Male with Stroke Sign', 'gender'],
    categories: ['gender'],
    aliases: ['mars-stroke-v'],
  },
  {
    name: 'martini-glass',
    label: 'Martini Glass',
    unicode: 'f57b',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'bar',
      'beverage',
      'cocktail',
      'cocktail glass',
      'drink',
      'glass',
      'liquor',
    ],
    categories: ['food-beverage', 'travel-hotel'],
    aliases: ['glass-martini-alt'],
  },
  {
    name: 'martini-glass-citrus',
    label: 'Martini Glass Citrus',
    unicode: 'f561',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'beverage',
      'drink',
      'gin',
      'glass',
      'margarita',
      'martini',
      'vodka',
    ],
    categories: ['food-beverage', 'travel-hotel'],
    aliases: ['cocktail'],
  },
  {
    name: 'martini-glass-empty',
    label: 'Martini Glass Empty',
    unicode: 'f000',
    styles: ['solid'],
    searchTerms: ['alcohol', 'bar', 'beverage', 'drink', 'liquor'],
    categories: ['food-beverage', 'maps', 'travel-hotel'],
    aliases: ['glass-martini'],
  },
  {
    name: 'mask',
    label: 'Mask',
    unicode: 'f6fa',
    styles: ['solid'],
    searchTerms: [
      'carnivale',
      'costume',
      'disguise',
      'halloween',
      'secret',
      'super hero',
    ],
    categories: ['halloween', 'security'],
  },
  {
    name: 'mask-face',
    label: 'Mask Face',
    unicode: 'e1d7',
    styles: ['solid'],
    searchTerms: [
      'breath',
      'coronavirus',
      'covid-19',
      'filter',
      'flu',
      'infection',
      'pandemic',
      'respirator',
      'virus',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'mask-ventilator',
    label: 'Mask Ventilator',
    unicode: 'e524',
    styles: ['solid'],
    searchTerms: [
      'breath',
      'gas',
      'mask',
      'oxygen',
      'respirator',
      'ventilator',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'masks-theater',
    label: 'Masks Theater',
    unicode: 'f630',
    styles: ['solid'],
    searchTerms: [
      'art',
      'comedy',
      'mask',
      'perform',
      'performing',
      'performing arts',
      'theater',
      'theatre',
      'tragedy',
    ],
    categories: ['education'],
    aliases: ['theater-masks'],
  },
  {
    name: 'mastodon',
    label: 'Mastodon',
    unicode: 'f4f6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'mattress-pillow',
    label: 'Mattress Pillow',
    unicode: 'e525',
    styles: ['solid'],
    searchTerms: ['air mattress', 'mattress', 'pillow', 'rest', 'sleep'],
    categories: ['camping', 'household', 'humanitarian'],
  },
  {
    name: 'maxcdn',
    label: 'MaxCDN',
    unicode: 'f136',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'maximize',
    label: 'Maximize',
    unicode: 'f31e',
    styles: ['solid'],
    searchTerms: [
      'arrows',
      'bigger',
      'enlarge',
      'expand',
      'fullscreen',
      'maximize',
      'resize',
      'resize',
      'scale',
      'size',
    ],
    categories: ['arrows', 'media-playback'],
    aliases: ['expand-arrows-alt'],
  },
  {
    name: 'mdb',
    label: 'Material Design for Bootstrap',
    unicode: 'f8ca',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'medal',
    label: 'Medal',
    unicode: 'f5a2',
    styles: ['solid'],
    searchTerms: [
      'award',
      'guarantee',
      'medal',
      'quality',
      'ribbon',
      'sports medal',
      'star',
      'trophy',
      'warranty',
    ],
    categories: ['sports-fitness'],
  },
  {
    name: 'medapps',
    label: 'MedApps',
    unicode: 'f3c6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'medium',
    label: 'Medium',
    unicode: 'f23a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['medium-m'],
  },
  {
    name: 'medrt',
    label: 'MRT',
    unicode: 'f3c8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'meetup',
    label: 'Meetup',
    unicode: 'f2e0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'megaport',
    label: 'Megaport',
    unicode: 'f5a3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'memory',
    label: 'Memory',
    unicode: 'f538',
    styles: ['solid'],
    searchTerms: ['DIMM', 'RAM', 'hardware', 'storage', 'technology'],
    categories: ['devices-hardware'],
  },
  {
    name: 'mendeley',
    label: 'Mendeley',
    unicode: 'f7b3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'menorah',
    label: 'Menorah',
    unicode: 'f676',
    styles: ['solid'],
    searchTerms: ['candle', 'hanukkah', 'jewish', 'judaism', 'light'],
    categories: ['holidays', 'religion'],
  },
  {
    name: 'mercury',
    label: 'Mercury',
    unicode: 'f223',
    styles: ['solid'],
    searchTerms: ['Mercury', 'gender', 'hybrid', 'transgender'],
    categories: ['gender'],
  },
  {
    name: 'message',
    label: 'Message',
    unicode: 'f27a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'answer',
      'bubble',
      'chat',
      'commenting',
      'conversation',
      'conversation',
      'discussion',
      'feedback',
      'message',
      'note',
      'notification',
      'sms',
      'speech',
      'talk',
      'talking',
      'texting',
    ],
    categories: ['communication', 'social'],
    aliases: ['comment-alt'],
  },
  {
    name: 'meta',
    label: 'Meta',
    unicode: 'e49b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'meteor',
    label: 'Meteor',
    unicode: 'f753',
    styles: ['solid'],
    searchTerms: ['armageddon', 'asteroid', 'comet', 'shooting star', 'space'],
    categories: ['astronomy', 'weather'],
  },
  {
    name: 'microblog',
    label: 'Micro.blog',
    unicode: 'e01a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'microchip',
    label: 'Microchip',
    unicode: 'f2db',
    styles: ['solid'],
    searchTerms: ['cpu', 'hardware', 'processor', 'technology'],
    categories: ['coding', 'devices-hardware'],
  },
  {
    name: 'microphone',
    label: 'Microphone',
    unicode: 'f130',
    styles: ['solid'],
    searchTerms: [
      'address',
      'audio',
      'information',
      'podcast',
      'public',
      'record',
      'sing',
      'sound',
      'talking',
      'voice',
    ],
    categories: ['communication', 'film-video', 'music-audio', 'toggle'],
  },
  {
    name: 'microphone-lines',
    label: 'Microphone Lines',
    unicode: 'f3c9',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'mic',
      'microphone',
      'music',
      'podcast',
      'record',
      'sing',
      'sound',
      'studio',
      'studio microphone',
      'talking',
      'voice',
    ],
    categories: ['communication', 'film-video', 'music-audio'],
    aliases: ['microphone-alt'],
  },
  {
    name: 'microphone-lines-slash',
    label: 'Microphone Lines Slash',
    unicode: 'f539',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'disable',
      'disabled',
      'disconnect',
      'disconnect',
      'mute',
      'podcast',
      'record',
      'sing',
      'sound',
      'voice',
    ],
    categories: ['communication', 'film-video', 'music-audio'],
    aliases: ['microphone-alt-slash'],
  },
  {
    name: 'microphone-slash',
    label: 'Microphone Slash',
    unicode: 'f131',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'disable',
      'disabled',
      'mute',
      'podcast',
      'record',
      'sing',
      'sound',
      'voice',
    ],
    categories: ['communication', 'film-video', 'music-audio', 'toggle'],
  },
  {
    name: 'microscope',
    label: 'Microscope',
    unicode: 'f610',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'electron',
      'knowledge',
      'lens',
      'microscope',
      'optics',
      'science',
      'shrink',
      'testing',
      'tool',
    ],
    categories: ['education', 'humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'microsoft',
    label: 'Microsoft',
    unicode: 'f3ca',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'mill-sign',
    label: 'Mill Sign',
    unicode: 'e1ed',
    styles: ['solid'],
    searchTerms: ['Mill Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'minimize',
    label: 'Minimize',
    unicode: 'f78c',
    styles: ['solid'],
    searchTerms: [
      'collapse',
      'fullscreen',
      'minimize',
      'move',
      'resize',
      'shrink',
      'smaller',
    ],
    categories: ['media-playback', 'photos-images'],
    aliases: ['compress-arrows-alt'],
  },
  {
    name: 'mintbit',
    label: 'Mintbit',
    unicode: 'e62f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'minus',
    label: 'Minus',
    unicode: 'f068',
    styles: ['solid'],
    searchTerms: [
      'En Dash',
      'Minus Sign',
      'collapse',
      'delete',
      'hide',
      'math',
      'minify',
      'minus',
      'negative',
      'remove',
      'sign',
      'trash',
      '−',
    ],
    categories: ['editing', 'mathematics', 'punctuation-symbols'],
    aliases: ['subtract'],
  },
  {
    name: 'mitten',
    label: 'Mitten',
    unicode: 'f7b5',
    styles: ['solid'],
    searchTerms: [
      'clothing',
      'cold',
      'glove',
      'hands',
      'knitted',
      'seasonal',
      'warmth',
    ],
    categories: ['childhood', 'clothing-fashion'],
  },
  {
    name: 'mix',
    label: 'Mix',
    unicode: 'f3cb',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'mixcloud',
    label: 'Mixcloud',
    unicode: 'f289',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'mixer',
    label: 'Mixer',
    unicode: 'e056',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'mizuni',
    label: 'Mizuni',
    unicode: 'f3cc',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'mobile',
    label: 'Mobile',
    unicode: 'f3ce',
    styles: ['solid'],
    searchTerms: [
      'android',
      'call',
      'cell',
      'cell phone',
      'device',
      'mobile',
      'mobile phone',
      'number',
      'phone',
      'screen',
      'telephone',
      'text',
    ],
    categories: ['communication', 'devices-hardware'],
    aliases: ['mobile-android', 'mobile-phone'],
  },
  {
    name: 'mobile-button',
    label: 'Mobile Button',
    unicode: 'f10b',
    styles: ['solid'],
    searchTerms: [
      'apple',
      'call',
      'cell phone',
      'device',
      'iphone',
      'number',
      'screen',
      'telephone',
    ],
    categories: ['communication', 'devices-hardware'],
  },
  {
    name: 'mobile-retro',
    label: 'Mobile Retro',
    unicode: 'e527',
    styles: ['solid'],
    searchTerms: ['cellphone', 'cellular', 'phone'],
    categories: ['communication', 'devices-hardware', 'humanitarian'],
  },
  {
    name: 'mobile-screen',
    label: 'Mobile Screen',
    unicode: 'f3cf',
    styles: ['solid'],
    searchTerms: [
      'android',
      'call',
      'cell phone',
      'device',
      'number',
      'screen',
      'telephone',
      'text',
    ],
    categories: ['communication', 'devices-hardware', 'humanitarian'],
    aliases: ['mobile-android-alt'],
  },
  {
    name: 'mobile-screen-button',
    label: 'Mobile Screen Button',
    unicode: 'f3cd',
    styles: ['solid'],
    searchTerms: [
      'apple',
      'call',
      'cell phone',
      'device',
      'iphone',
      'number',
      'screen',
      'telephone',
    ],
    categories: ['communication', 'devices-hardware'],
    aliases: ['mobile-alt'],
  },
  {
    name: 'modx',
    label: 'MODX',
    unicode: 'f285',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'monero',
    label: 'Monero',
    unicode: 'f3d0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'money-bill',
    label: 'Money Bill',
    unicode: 'f0d6',
    styles: ['solid'],
    searchTerms: [
      'buy',
      'cash',
      'checkout',
      'coupon',
      'investment',
      'money',
      'payment',
      'premium',
      'price',
      'purchase',
      'revenue',
      'salary',
    ],
    categories: ['maps', 'money'],
  },
  {
    name: 'money-bill-1',
    label: 'Money Bill 1',
    unicode: 'f3d1',
    styles: ['regular', 'solid'],
    searchTerms: [
      'buy',
      'cash',
      'checkout',
      'money',
      'payment',
      'premium',
      'price',
      'purchase',
      'salary',
    ],
    categories: ['maps', 'money'],
    aliases: ['money-bill-alt'],
  },
  {
    name: 'money-bill-1-wave',
    label: 'Money Bill 1 Wave',
    unicode: 'f53b',
    styles: ['solid'],
    searchTerms: [
      'buy',
      'cash',
      'checkout',
      'money',
      'payment',
      'premium',
      'price',
      'purchase',
      'salary',
    ],
    categories: ['money'],
    aliases: ['money-bill-wave-alt'],
  },
  {
    name: 'money-bill-transfer',
    label: 'Money Bill Transfer',
    unicode: 'e528',
    styles: ['solid'],
    searchTerms: [
      'bank',
      'conversion',
      'deposit',
      'investment',
      'money',
      'salary',
      'transfer',
      'withdrawal',
    ],
    categories: ['humanitarian', 'money'],
  },
  {
    name: 'money-bill-trend-up',
    label: 'Money Bill Trend Up',
    unicode: 'e529',
    styles: ['solid'],
    searchTerms: [
      'bank',
      'bonds',
      'inflation',
      'investment',
      'market',
      'revenue',
      'salary',
      'stocks',
      'trade',
    ],
    categories: ['humanitarian', 'money'],
  },
  {
    name: 'money-bill-wave',
    label: 'Money Bill Wave',
    unicode: 'f53a',
    styles: ['solid'],
    searchTerms: [
      'buy',
      'cash',
      'checkout',
      'money',
      'payment',
      'premium',
      'price',
      'purchase',
      'salary',
    ],
    categories: ['money'],
  },
  {
    name: 'money-bill-wheat',
    label: 'Money Bill Wheat',
    unicode: 'e52a',
    styles: ['solid'],
    searchTerms: [
      'agribusiness',
      'agriculture',
      'farming',
      'food',
      'investment',
      'livelihood',
      'subsidy',
    ],
    categories: ['humanitarian', 'money'],
  },
  {
    name: 'money-bills',
    label: 'Money Bills',
    unicode: 'e1f3',
    styles: ['solid'],
    searchTerms: [
      'atm',
      'cash',
      'investment',
      'money',
      'moolah',
      'premium',
      'revenue',
      'salary',
    ],
    categories: ['humanitarian', 'money'],
  },
  {
    name: 'money-check',
    label: 'Money Check',
    unicode: 'f53c',
    styles: ['solid'],
    searchTerms: [
      'bank check',
      'buy',
      'checkout',
      'cheque',
      'money',
      'payment',
      'price',
      'purchase',
      'salary',
    ],
    categories: ['money', 'shopping'],
  },
  {
    name: 'money-check-dollar',
    label: 'Money Check Dollar',
    unicode: 'f53d',
    styles: ['solid'],
    searchTerms: [
      'bank check',
      'buy',
      'checkout',
      'cheque',
      'money',
      'payment',
      'price',
      'purchase',
      'salary',
    ],
    categories: ['money', 'shopping'],
    aliases: ['money-check-alt'],
  },
  {
    name: 'monument',
    label: 'Monument',
    unicode: 'f5a6',
    styles: ['solid'],
    searchTerms: ['building', 'historic', 'landmark', 'memorable'],
    categories: ['buildings', 'maps', 'travel-hotel'],
  },
  {
    name: 'moon',
    label: 'Moon',
    unicode: 'f186',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Power Sleep Symbol',
      'contrast',
      'crescent',
      'crescent moon',
      'dark',
      'lunar',
      'moon',
      'night',
    ],
    categories: ['astronomy', 'weather'],
  },
  {
    name: 'mortar-pestle',
    label: 'Mortar Pestle',
    unicode: 'f5a7',
    styles: ['solid'],
    searchTerms: [
      'crush',
      'culinary',
      'grind',
      'medical',
      'mix',
      'pharmacy',
      'prescription',
      'spices',
    ],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'mosque',
    label: 'Mosque',
    unicode: 'f678',
    styles: ['solid'],
    searchTerms: [
      'Muslim',
      'building',
      'islam',
      'landmark',
      'mosque',
      'muslim',
      'religion',
    ],
    categories: ['buildings', 'humanitarian', 'religion'],
  },
  {
    name: 'mosquito',
    label: 'Mosquito',
    unicode: 'e52b',
    styles: ['solid'],
    searchTerms: ['bite', 'bug', 'mosquito', 'west nile'],
    categories: ['animals', 'camping', 'disaster', 'humanitarian', 'nature'],
  },
  {
    name: 'mosquito-net',
    label: 'Mosquito Net',
    unicode: 'e52c',
    styles: ['solid'],
    searchTerms: ['bite', 'malaria', 'mosquito', 'net'],
    categories: ['camping', 'humanitarian'],
  },
  {
    name: 'motorcycle',
    label: 'Motorcycle',
    unicode: 'f21c',
    styles: ['solid'],
    searchTerms: [
      'bike',
      'machine',
      'motorcycle',
      'racing',
      'transportation',
      'vehicle',
    ],
    categories: ['automotive', 'maps', 'transportation'],
  },
  {
    name: 'mound',
    label: 'Mound',
    unicode: 'e52d',
    styles: ['solid'],
    searchTerms: ['barrier', 'hill', 'pitcher', 'speedbump'],
    categories: [
      'construction',
      'humanitarian',
      'nature',
      'sports-fitness',
      'transportation',
    ],
  },
  {
    name: 'mountain',
    label: 'Mountain',
    unicode: 'f6fc',
    styles: ['solid'],
    searchTerms: [
      'cold',
      'glacier',
      'hiking',
      'hill',
      'landscape',
      'mountain',
      'snow',
      'snow-capped mountain',
      'travel',
      'view',
    ],
    categories: ['camping', 'nature'],
  },
  {
    name: 'mountain-city',
    label: 'Mountain City',
    unicode: 'e52e',
    styles: ['solid'],
    searchTerms: ['location', 'rural', 'urban'],
    categories: ['buildings', 'humanitarian', 'nature', 'travel-hotel'],
  },
  {
    name: 'mountain-sun',
    label: 'Mountain Sun',
    unicode: 'e52f',
    styles: ['solid'],
    searchTerms: ['country', 'hiking', 'landscape', 'rural', 'travel', 'view'],
    categories: ['camping', 'humanitarian', 'maps', 'nature'],
  },
  {
    name: 'mug-hot',
    label: 'Mug Hot',
    unicode: 'f7b6',
    styles: ['solid'],
    searchTerms: [
      'beverage',
      'caliente',
      'cocoa',
      'coffee',
      'cup',
      'drink',
      'holiday',
      'hot',
      'hot beverage',
      'hot chocolate',
      'steam',
      'steaming',
      'tea',
      'warmth',
    ],
    categories: ['food-beverage', 'holidays'],
  },
  {
    name: 'mug-saucer',
    label: 'Mug Saucer',
    unicode: 'f0f4',
    styles: ['solid'],
    searchTerms: [
      'beverage',
      'breakfast',
      'cafe',
      'drink',
      'fall',
      'morning',
      'mug',
      'seasonal',
      'tea',
    ],
    categories: [
      'business',
      'coding',
      'food-beverage',
      'household',
      'maps',
      'travel-hotel',
    ],
    aliases: ['coffee'],
  },
  {
    name: 'music',
    label: 'Music',
    unicode: 'f001',
    styles: ['solid'],
    searchTerms: [
      'lyrics',
      'melody',
      'music',
      'musical note',
      'note',
      'sing',
      'sound',
    ],
    categories: ['education', 'maps', 'media-playback', 'music-audio'],
  },
  {
    name: 'n',
    label: 'N',
    unicode: '4e',
    styles: ['solid'],
    searchTerms: [
      'Latin Capital Letter N',
      'Latin Small Letter N',
      'letter',
      'nay',
      'no',
    ],
    categories: ['alphabet'],
  },
  {
    name: 'naira-sign',
    label: 'Naira Sign',
    unicode: 'e1f6',
    styles: ['solid'],
    searchTerms: ['Naira Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'napster',
    label: 'Napster',
    unicode: 'f3d2',
    styles: ['brands'],
    searchTerms: [],
    categories: ['music-audio'],
  },
  {
    name: 'neos',
    label: 'Neos',
    unicode: 'f612',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'network-wired',
    label: 'Network Wired',
    unicode: 'f6ff',
    styles: ['solid'],
    searchTerms: ['computer', 'connect', 'ethernet', 'internet', 'intranet'],
    categories: ['business', 'coding'],
  },
  {
    name: 'neuter',
    label: 'Neuter',
    unicode: 'f22c',
    styles: ['solid'],
    searchTerms: ['Neuter', 'gender'],
    categories: ['gender'],
  },
  {
    name: 'newspaper',
    label: 'Newspaper',
    unicode: 'f1ea',
    styles: ['regular', 'solid'],
    searchTerms: [
      'article',
      'editorial',
      'headline',
      'journal',
      'journalism',
      'news',
      'newsletter',
      'newspaper',
      'paper',
      'press',
    ],
    categories: ['maps', 'writing'],
  },
  {
    name: 'nfc-directional',
    label: 'NFC Directional',
    unicode: 'e530',
    styles: ['brands'],
    searchTerms: [
      'connect',
      'data',
      'near field communication',
      'nfc',
      'scan',
      'signal',
      'transfer',
      'wireless',
    ],
    categories: ['shopping'],
  },
  {
    name: 'nfc-symbol',
    label: 'Nfc Symbol',
    unicode: 'e531',
    styles: ['brands'],
    searchTerms: [
      'connect',
      'data',
      'near field communication',
      'nfc',
      'scan',
      'signal',
      'transfer',
      'wireless',
    ],
    categories: ['shopping'],
  },
  {
    name: 'nimblr',
    label: 'Nimblr',
    unicode: 'f5a8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'node',
    label: 'Node.js',
    unicode: 'f419',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'node-js',
    label: 'Node.js JS',
    unicode: 'f3d3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'not-equal',
    label: 'Not Equal',
    unicode: 'f53e',
    styles: ['solid'],
    searchTerms: ['arithmetic', 'compare', 'math'],
    categories: ['mathematics'],
  },
  {
    name: 'notdef',
    label: 'Notdef',
    unicode: 'e1fe',
    styles: ['solid'],
    searchTerms: ['404', 'close', 'missing', 'not found'],
    categories: ['coding', 'writing'],
  },
  {
    name: 'note-sticky',
    label: 'Note Sticky',
    unicode: 'f249',
    styles: ['regular', 'solid'],
    searchTerms: ['message', 'note', 'paper', 'reminder', 'sticker'],
    categories: ['business', 'files', 'writing'],
    aliases: ['sticky-note'],
  },
  {
    name: 'notes-medical',
    label: 'Notes Medical',
    unicode: 'f481',
    styles: ['solid'],
    searchTerms: ['clipboard', 'doctor', 'ehr', 'health', 'history', 'records'],
    categories: ['medical-health'],
  },
  {
    name: 'npm',
    label: 'npm',
    unicode: 'f3d4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ns8',
    label: 'NS8',
    unicode: 'f3d5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'nutritionix',
    label: 'Nutritionix',
    unicode: 'f3d6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'o',
    label: 'O',
    unicode: '4f',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter O', 'Latin Small Letter O', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'object-group',
    label: 'Object Group',
    unicode: 'f247',
    styles: ['regular', 'solid'],
    searchTerms: ['combine', 'copy', 'design', 'merge', 'select'],
    categories: ['design'],
  },
  {
    name: 'object-ungroup',
    label: 'Object Ungroup',
    unicode: 'f248',
    styles: ['regular', 'solid'],
    searchTerms: ['copy', 'design', 'merge', 'select', 'separate'],
    categories: ['design'],
  },
  {
    name: 'octopus-deploy',
    label: 'Octopus Deploy',
    unicode: 'e082',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'odnoklassniki',
    label: 'Odnoklassniki',
    unicode: 'f263',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'odysee',
    label: 'Odysee',
    unicode: 'e5c6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'oil-can',
    label: 'Oil Can',
    unicode: 'f613',
    styles: ['solid'],
    searchTerms: [
      'auto',
      'crude',
      'gasoline',
      'grease',
      'lubricate',
      'petroleum',
    ],
    categories: ['automotive'],
  },
  {
    name: 'oil-well',
    label: 'Oil Well',
    unicode: 'e532',
    styles: ['solid'],
    searchTerms: ['drill', 'oil', 'rig'],
    categories: ['buildings', 'energy', 'humanitarian'],
  },
  {
    name: 'old-republic',
    label: 'Old Republic',
    unicode: 'f510',
    styles: ['brands'],
    searchTerms: ['politics', 'star wars'],
    categories: ['science-fiction'],
  },
  {
    name: 'om',
    label: 'Om',
    unicode: 'f679',
    styles: ['solid'],
    searchTerms: [
      'Hindu',
      'buddhism',
      'hinduism',
      'jainism',
      'mantra',
      'om',
      'religion',
    ],
    categories: ['religion'],
  },
  {
    name: 'opencart',
    label: 'OpenCart',
    unicode: 'f23d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'openid',
    label: 'OpenID',
    unicode: 'f19b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'opensuse',
    label: 'Opensuse',
    unicode: 'e62b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'opera',
    label: 'Opera',
    unicode: 'f26a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'optin-monster',
    label: 'Optin Monster',
    unicode: 'f23c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'orcid',
    label: 'ORCID',
    unicode: 'f8d2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'osi',
    label: 'Open Source Initiative',
    unicode: 'f41a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'otter',
    label: 'Otter',
    unicode: 'f700',
    styles: ['solid'],
    searchTerms: [
      'animal',
      'badger',
      'fauna',
      'fishing',
      'fur',
      'mammal',
      'marten',
      'otter',
      'playful',
    ],
    categories: ['animals', 'maritime'],
  },
  {
    name: 'outdent',
    label: 'Outdent',
    unicode: 'f03b',
    styles: ['solid'],
    searchTerms: ['align', 'justify', 'paragraph', 'tab'],
    categories: ['text-formatting'],
    aliases: ['dedent'],
  },
  {
    name: 'p',
    label: 'P',
    unicode: '50',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter P', 'Latin Small Letter P', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'padlet',
    label: 'Padlet',
    unicode: 'e4a0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'page4',
    label: 'page4 Corporation',
    unicode: 'f3d7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pagelines',
    label: 'Pagelines',
    unicode: 'f18c',
    styles: ['brands'],
    searchTerms: ['eco', 'flora', 'leaf', 'leaves', 'nature', 'plant', 'tree'],
    categories: [],
  },
  {
    name: 'pager',
    label: 'Pager',
    unicode: 'f815',
    styles: ['solid'],
    searchTerms: ['beeper', 'cell phone', 'communication', 'page', 'pager'],
    categories: ['medical-health'],
  },
  {
    name: 'paint-roller',
    label: 'Paint Roller',
    unicode: 'f5aa',
    styles: ['solid'],
    searchTerms: [
      'acrylic',
      'art',
      'brush',
      'color',
      'fill',
      'maintenance',
      'paint',
      'pigment',
      'watercolor',
    ],
    categories: ['construction', 'design'],
  },
  {
    name: 'paintbrush',
    label: 'Paintbrush',
    unicode: 'f1fc',
    styles: ['solid'],
    searchTerms: [
      'acrylic',
      'art',
      'brush',
      'color',
      'fill',
      'modify',
      'paint',
      'paintbrush',
      'painting',
      'pigment',
      'watercolor',
    ],
    categories: ['design', 'editing'],
    aliases: ['paint-brush'],
  },
  {
    name: 'palette',
    label: 'Palette',
    unicode: 'f53f',
    styles: ['solid'],
    searchTerms: [
      'acrylic',
      'art',
      'artist palette',
      'brush',
      'color',
      'fill',
      'museum',
      'paint',
      'painting',
      'palette',
      'pigment',
      'watercolor',
    ],
    categories: ['design', 'spinners'],
  },
  {
    name: 'palfed',
    label: 'Palfed',
    unicode: 'f3d8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pallet',
    label: 'Pallet',
    unicode: 'f482',
    styles: ['solid'],
    searchTerms: ['archive', 'box', 'inventory', 'shipping', 'warehouse'],
    categories: ['logistics'],
  },
  {
    name: 'panorama',
    label: 'Panorama',
    unicode: 'e209',
    styles: ['solid'],
    searchTerms: ['image', 'img', 'landscape', 'photo', 'wide'],
    categories: ['photos-images'],
  },
  {
    name: 'paper-plane',
    label: 'Paper Plane',
    unicode: 'f1d8',
    styles: ['regular', 'solid'],
    searchTerms: ['air', 'float', 'fold', 'mail', 'paper', 'send'],
    categories: ['communication', 'transportation', 'writing'],
  },
  {
    name: 'paperclip',
    label: 'Paperclip',
    unicode: 'f0c6',
    styles: ['solid'],
    searchTerms: [
      'attach',
      'attachment',
      'connect',
      'link',
      'papercli',
      'paperclip',
    ],
    categories: ['business', 'writing'],
  },
  {
    name: 'parachute-box',
    label: 'Parachute Box',
    unicode: 'f4cd',
    styles: ['solid'],
    searchTerms: ['aid', 'assistance', 'goods', 'relief', 'rescue', 'supplies'],
    categories: ['charity', 'humanitarian'],
  },
  {
    name: 'paragraph',
    label: 'Paragraph',
    unicode: 'f1dd',
    styles: ['solid'],
    searchTerms: ['Pilcrow Sign', 'edit', 'format', 'text', 'writing'],
    categories: ['text-formatting', 'writing'],
  },
  {
    name: 'passport',
    label: 'Passport',
    unicode: 'f5ab',
    styles: ['solid'],
    searchTerms: ['document', 'id', 'identification', 'issued', 'travel'],
    categories: ['security', 'travel-hotel'],
  },
  {
    name: 'paste',
    label: 'Paste',
    unicode: 'f0ea',
    styles: ['regular', 'solid'],
    searchTerms: ['clipboard', 'copy', 'document', 'paper'],
    categories: ['business', 'design', 'files'],
    aliases: ['file-clipboard'],
  },
  {
    name: 'patreon',
    label: 'Patreon',
    unicode: 'f3d9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pause',
    label: 'Pause',
    unicode: 'f04c',
    styles: ['solid'],
    searchTerms: [
      'bar',
      'double',
      'hold',
      'pause',
      'pause button',
      'vertical',
      'wait',
    ],
    categories: ['media-playback'],
  },
  {
    name: 'paw',
    label: 'Paw',
    unicode: 'f1b0',
    styles: ['solid'],
    searchTerms: ['animal', 'cat', 'dog', 'pet', 'print'],
    categories: ['animals', 'maps'],
  },
  {
    name: 'paypal',
    label: 'Paypal',
    unicode: 'f1ed',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'peace',
    label: 'Peace',
    unicode: 'f67c',
    styles: ['solid'],
    searchTerms: [
      'peace',
      'peace symbol',
      'serenity',
      'tranquility',
      'truce',
      'war',
    ],
    categories: ['religion'],
  },
  {
    name: 'pen',
    label: 'Pen',
    unicode: 'f304',
    styles: ['solid'],
    searchTerms: [
      'ballpoint',
      'design',
      'edit',
      'modify',
      'pen',
      'update',
      'write',
    ],
    categories: ['business', 'design', 'editing', 'writing'],
  },
  {
    name: 'pen-clip',
    label: 'Pen Clip',
    unicode: 'f305',
    styles: ['solid'],
    searchTerms: ['design', 'edit', 'modify', 'update', 'write'],
    categories: ['business', 'design', 'editing', 'writing'],
    aliases: ['pen-alt'],
  },
  {
    name: 'pen-fancy',
    label: 'Pen Fancy',
    unicode: 'f5ac',
    styles: ['solid'],
    searchTerms: [
      'black nib',
      'design',
      'edit',
      'fountain',
      'fountain pen',
      'modify',
      'nib',
      'pen',
      'update',
      'write',
    ],
    categories: ['business', 'design', 'editing'],
  },
  {
    name: 'pen-nib',
    label: 'Pen Nib',
    unicode: 'f5ad',
    styles: ['solid'],
    searchTerms: [
      'design',
      'edit',
      'fountain pen',
      'modify',
      'update',
      'write',
    ],
    categories: ['business', 'design', 'editing'],
  },
  {
    name: 'pen-ruler',
    label: 'Pen Ruler',
    unicode: 'f5ae',
    styles: ['solid'],
    searchTerms: ['design', 'draft', 'draw', 'maintenance', 'modify', 'pencil'],
    categories: ['construction', 'design', 'editing'],
    aliases: ['pencil-ruler'],
  },
  {
    name: 'pen-to-square',
    label: 'Pen To Square',
    unicode: 'f044',
    styles: ['regular', 'solid'],
    searchTerms: ['edit', 'modify', 'pen', 'pencil', 'update', 'write'],
    categories: ['business', 'design', 'editing', 'writing'],
    aliases: ['edit'],
  },
  {
    name: 'pencil',
    label: 'Pencil',
    unicode: 'f303',
    styles: ['solid'],
    searchTerms: [
      'Lower Left Pencil',
      'design',
      'draw',
      'edit',
      'lead',
      'maintenance',
      'modify',
      'pencil',
      'update',
      'write',
    ],
    categories: ['business', 'construction', 'design', 'editing', 'writing'],
    aliases: ['pencil-alt'],
  },
  {
    name: 'people-arrows',
    label: 'People Arrows',
    unicode: 'e068',
    styles: ['solid'],
    searchTerms: [
      'conversation',
      'discussion',
      'distance',
      'insert',
      'isolation',
      'separate',
      'social distancing',
      'talk',
      'talking',
      'together',
      'uer',
      'users-people',
    ],
    categories: ['humanitarian', 'users-people'],
    aliases: ['people-arrows-left-right'],
  },
  {
    name: 'people-carry-box',
    label: 'People Carry Box',
    unicode: 'f4ce',
    styles: ['solid'],
    searchTerms: ['together', 'uer', 'users-people'],
    categories: ['moving', 'users-people'],
    aliases: ['people-carry'],
  },
  {
    name: 'people-group',
    label: 'People Group',
    unicode: 'e533',
    styles: ['solid'],
    searchTerms: ['crowd', 'family', 'group', 'team', 'together', 'uer'],
    categories: ['humanitarian', 'marketing', 'users-people'],
  },
  {
    name: 'people-line',
    label: 'People Line',
    unicode: 'e534',
    styles: ['solid'],
    searchTerms: ['crowd', 'group', 'need', 'together', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'people-pulling',
    label: 'People Pulling',
    unicode: 'e535',
    styles: ['solid'],
    searchTerms: ['forced return', 'together', 'uer', 'yanking'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'people-robbery',
    label: 'People Robbery',
    unicode: 'e536',
    styles: ['solid'],
    searchTerms: ['criminal', 'hands up', 'looting', 'robbery', 'steal', 'uer'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'people-roof',
    label: 'People Roof',
    unicode: 'e537',
    styles: ['solid'],
    searchTerms: [
      'crowd',
      'family',
      'group',
      'manage',
      'people',
      'safe',
      'shelter',
      'together',
      'uer',
    ],
    categories: ['camping', 'household', 'humanitarian', 'users-people'],
  },
  {
    name: 'pepper-hot',
    label: 'Pepper Hot',
    unicode: 'f816',
    styles: ['solid'],
    searchTerms: [
      'buffalo wings',
      'capsicum',
      'chili',
      'chilli',
      'habanero',
      'hot',
      'hot pepper',
      'jalapeno',
      'mexican',
      'pepper',
      'spicy',
      'tabasco',
      'vegetable',
    ],
    categories: ['food-beverage', 'fruits-vegetables'],
  },
  {
    name: 'perbyte',
    label: 'PerByte',
    unicode: 'e083',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'percent',
    label: 'Percent',
    unicode: '25',
    styles: ['solid'],
    searchTerms: [
      'Percent Sign',
      'discount',
      'fraction',
      'proportion',
      'rate',
      'ratio',
    ],
    categories: ['business', 'mathematics', 'money', 'punctuation-symbols'],
    aliases: ['percentage'],
  },
  {
    name: 'periscope',
    label: 'Periscope',
    unicode: 'f3da',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'person',
    label: 'Person',
    unicode: 'f183',
    styles: ['solid'],
    searchTerms: [
      'default',
      'man',
      'person standing',
      'stand',
      'standing',
      'uer',
      'woman',
    ],
    categories: ['humanitarian', 'maps', 'users-people'],
    aliases: ['male'],
  },
  {
    name: 'person-arrow-down-to-line',
    label: 'Person Arrow Down To Line',
    unicode: 'e538',
    styles: ['solid'],
    searchTerms: ['ground', 'indigenous', 'insert', 'native', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-arrow-up-from-line',
    label: 'Person Arrow Up From Line',
    unicode: 'e539',
    styles: ['solid'],
    searchTerms: ['population', 'rise', 'uer', 'upgrade'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-biking',
    label: 'Person Biking',
    unicode: 'f84a',
    styles: ['solid'],
    searchTerms: [
      'bicycle',
      'bike',
      'biking',
      'cyclist',
      'pedal',
      'person biking',
      'summer',
      'uer',
      'wheel',
    ],
    categories: ['childhood', 'sports-fitness', 'users-people'],
    aliases: ['biking'],
  },
  {
    name: 'person-booth',
    label: 'Person Booth',
    unicode: 'f756',
    styles: ['solid'],
    searchTerms: ['changing room', 'curtain', 'uer', 'vote', 'voting'],
    categories: ['political', 'shopping', 'users-people'],
  },
  {
    name: 'person-breastfeeding',
    label: 'Person Breastfeeding',
    unicode: 'e53a',
    styles: ['solid'],
    searchTerms: [
      'baby',
      'child',
      'infant',
      'mother',
      'nutrition',
      'parent',
      'sustenance',
      'uer',
    ],
    categories: ['childhood', 'humanitarian', 'medical-health', 'users-people'],
  },
  {
    name: 'person-burst',
    label: 'Person Burst',
    unicode: 'e53b',
    styles: ['solid'],
    searchTerms: ['abuse', 'accident', 'crash', 'explode', 'uer', 'violence'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-cane',
    label: 'Person Cane',
    unicode: 'e53c',
    styles: ['solid'],
    searchTerms: ['aging', 'cane', 'elderly', 'old', 'staff', 'uer'],
    categories: [
      'accessibility',
      'humanitarian',
      'medical-health',
      'users-people',
    ],
  },
  {
    name: 'person-chalkboard',
    label: 'Person Chalkboard',
    unicode: 'e53d',
    styles: ['solid'],
    searchTerms: [
      'blackboard',
      'instructor',
      'keynote',
      'lesson',
      'presentation',
      'teacher',
      'uer',
    ],
    categories: ['business', 'education', 'humanitarian', 'users-people'],
  },
  {
    name: 'person-circle-check',
    label: 'Person Circle Check',
    unicode: 'e53e',
    styles: ['solid'],
    searchTerms: [
      'approved',
      'enable',
      'not affected',
      'ok',
      'okay',
      'uer',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-circle-exclamation',
    label: 'Person Circle Exclamation',
    unicode: 'e53f',
    styles: ['solid'],
    searchTerms: ['affected', 'alert', 'failed', 'lost', 'missing', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-circle-minus',
    label: 'Person Circle Minus',
    unicode: 'e540',
    styles: ['solid'],
    searchTerms: ['delete', 'remove', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-circle-plus',
    label: 'Person Circle Plus',
    unicode: 'e541',
    styles: ['solid'],
    searchTerms: ['add', 'follow', 'found', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-circle-question',
    label: 'Person Circle Question',
    unicode: 'e542',
    styles: ['solid'],
    searchTerms: ['faq', 'lost', 'missing', 'request', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-circle-xmark',
    label: 'Person Circle Xmark',
    unicode: 'e543',
    styles: ['solid'],
    searchTerms: ['dead', 'removed', 'uer', 'uncheck'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-digging',
    label: 'Person Digging',
    unicode: 'f85e',
    styles: ['solid'],
    searchTerms: [
      'bury',
      'construction',
      'debris',
      'dig',
      'maintenance',
      'men at work',
      'uer',
    ],
    categories: ['construction', 'humanitarian', 'users-people'],
    aliases: ['digging'],
  },
  {
    name: 'person-dots-from-line',
    label: 'Person Dots From Line',
    unicode: 'f470',
    styles: ['solid'],
    searchTerms: ['allergy', 'diagnosis', 'uer'],
    categories: ['medical-health', 'users-people'],
    aliases: ['diagnoses'],
  },
  {
    name: 'person-dress',
    label: 'Person Dress',
    unicode: 'f182',
    styles: ['solid'],
    searchTerms: ['man', 'skirt', 'uer', 'woman'],
    categories: ['humanitarian', 'users-people'],
    aliases: ['female'],
  },
  {
    name: 'person-dress-burst',
    label: 'Person Dress Burst',
    unicode: 'e544',
    styles: ['solid'],
    searchTerms: ['abuse', 'accident', 'crash', 'explode', 'uer', 'violence'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-drowning',
    label: 'Person Drowning',
    unicode: 'e545',
    styles: ['solid'],
    searchTerms: ['drown', 'emergency', 'swim', 'uer'],
    categories: ['disaster', 'humanitarian', 'users-people'],
  },
  {
    name: 'person-falling',
    label: 'Person Falling',
    unicode: 'e546',
    styles: ['solid'],
    searchTerms: ['accident', 'fall', 'trip', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-falling-burst',
    label: 'Person Falling Burst',
    unicode: 'e547',
    styles: ['solid'],
    searchTerms: [
      'accident',
      'crash',
      'death',
      'fall',
      'homicide',
      'murder',
      'uer',
    ],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-half-dress',
    label: 'Person Half Dress',
    unicode: 'e548',
    styles: ['solid'],
    searchTerms: ['gender', 'man', 'restroom', 'transgender', 'uer', 'woman'],
    categories: ['gender', 'humanitarian', 'medical-health', 'users-people'],
  },
  {
    name: 'person-harassing',
    label: 'Person Harassing',
    unicode: 'e549',
    styles: ['solid'],
    searchTerms: ['abuse', 'scream', 'shame', 'shout', 'uer', 'yell'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-hiking',
    label: 'Person Hiking',
    unicode: 'f6ec',
    styles: ['solid'],
    searchTerms: [
      'autumn',
      'fall',
      'follow',
      'hike',
      'mountain',
      'outdoors',
      'summer',
      'uer',
      'walk',
    ],
    categories: ['camping', 'nature', 'sports-fitness', 'users-people'],
    aliases: ['hiking'],
  },
  {
    name: 'person-military-pointing',
    label: 'Person Military Pointing',
    unicode: 'e54a',
    styles: ['solid'],
    searchTerms: ['army', 'customs', 'guard', 'uer'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-military-rifle',
    label: 'Person Military Rifle',
    unicode: 'e54b',
    styles: ['solid'],
    searchTerms: ['armed forces', 'army', 'military', 'rifle', 'uer', 'war'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-military-to-person',
    label: 'Person Military To Person',
    unicode: 'e54c',
    styles: ['solid'],
    searchTerms: ['civilian', 'coordination', 'military', 'uer'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-praying',
    label: 'Person Praying',
    unicode: 'f683',
    styles: ['solid'],
    searchTerms: [
      'kneel',
      'place of worship',
      'religion',
      'thank',
      'uer',
      'worship',
    ],
    categories: ['religion', 'users-people'],
    aliases: ['pray'],
  },
  {
    name: 'person-pregnant',
    label: 'Person Pregnant',
    unicode: 'e31e',
    styles: ['solid'],
    searchTerms: [
      'baby',
      'birth',
      'child',
      'parent',
      'pregnant',
      'pregnant woman',
      'uer',
      'woman',
    ],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'person-rays',
    label: 'Person Rays',
    unicode: 'e54d',
    styles: ['solid'],
    searchTerms: ['affected', 'focus', 'shine', 'uer'],
    categories: ['humanitarian', 'marketing', 'users-people'],
  },
  {
    name: 'person-rifle',
    label: 'Person Rifle',
    unicode: 'e54e',
    styles: ['solid'],
    searchTerms: [
      'army',
      'combatant',
      'gun',
      'military',
      'rifle',
      'uer',
      'war',
    ],
    categories: ['disaster', 'humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-running',
    label: 'Person Running',
    unicode: 'f70c',
    styles: ['solid'],
    searchTerms: [
      'exit',
      'flee',
      'follow',
      'marathon',
      'person running',
      'race',
      'running',
      'uer',
      'workout',
    ],
    categories: ['sports-fitness', 'users-people'],
    aliases: ['running'],
  },
  {
    name: 'person-shelter',
    label: 'Person Shelter',
    unicode: 'e54f',
    styles: ['solid'],
    searchTerms: [
      'house',
      'inside',
      'roof',
      'safe',
      'safety',
      'shelter',
      'uer',
    ],
    categories: ['camping', 'humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-skating',
    label: 'Person Skating',
    unicode: 'f7c5',
    styles: ['solid'],
    searchTerms: [
      'figure skating',
      'ice',
      'olympics',
      'rink',
      'skate',
      'uer',
      'winter',
    ],
    categories: ['sports-fitness', 'users-people'],
    aliases: ['skating'],
  },
  {
    name: 'person-skiing',
    label: 'Person Skiing',
    unicode: 'f7c9',
    styles: ['solid'],
    searchTerms: [
      'downhill',
      'olympics',
      'ski',
      'skier',
      'snow',
      'uer',
      'winter',
    ],
    categories: ['sports-fitness', 'users-people'],
    aliases: ['skiing'],
  },
  {
    name: 'person-skiing-nordic',
    label: 'Person Skiing Nordic',
    unicode: 'f7ca',
    styles: ['solid'],
    searchTerms: ['cross country', 'olympics', 'uer', 'winter'],
    categories: ['sports-fitness', 'users-people'],
    aliases: ['skiing-nordic'],
  },
  {
    name: 'person-snowboarding',
    label: 'Person Snowboarding',
    unicode: 'f7ce',
    styles: ['solid'],
    searchTerms: [
      'olympics',
      'ski',
      'snow',
      'snowboard',
      'snowboarder',
      'uer',
      'winter',
    ],
    categories: ['sports-fitness', 'users-people'],
    aliases: ['snowboarding'],
  },
  {
    name: 'person-swimming',
    label: 'Person Swimming',
    unicode: 'f5c4',
    styles: ['solid'],
    searchTerms: [
      'ocean',
      'person swimming',
      'pool',
      'sea',
      'swim',
      'uer',
      'water',
    ],
    categories: ['maritime', 'sports-fitness', 'travel-hotel', 'users-people'],
    aliases: ['swimmer'],
  },
  {
    name: 'person-through-window',
    label: 'Person Through Window',
    unicode: 'e5a9',
    styles: ['solid'],
    searchTerms: [
      'door',
      'exit',
      'forced entry',
      'leave',
      'robbery',
      'steal',
      'uer',
      'window',
    ],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'person-walking',
    label: 'Person Walking',
    unicode: 'f554',
    styles: ['solid'],
    searchTerms: [
      'crosswalk',
      'exercise',
      'follow',
      'hike',
      'move',
      'person walking',
      'uer',
      'walk',
      'walking',
      'workout',
    ],
    categories: ['humanitarian', 'sports-fitness', 'users-people'],
    aliases: ['walking'],
  },
  {
    name: 'person-walking-arrow-loop-left',
    label: 'Person Walking Arrow Loop Left',
    unicode: 'e551',
    styles: ['solid'],
    searchTerms: ['follow', 'population return', 'return', 'uer'],
    categories: ['disaster', 'humanitarian', 'users-people'],
  },
  {
    name: 'person-walking-arrow-right',
    label: 'Person Walking Arrow Right',
    unicode: 'e552',
    styles: ['solid'],
    searchTerms: [
      'exit',
      'follow',
      'internally displaced',
      'leave',
      'refugee',
      'uer',
    ],
    categories: ['disaster', 'humanitarian', 'users-people'],
  },
  {
    name: 'person-walking-dashed-line-arrow-right',
    label: 'Person Walking Dashed Line Arrow Right',
    unicode: 'e553',
    styles: ['solid'],
    searchTerms: ['exit', 'follow', 'refugee', 'uer'],
    categories: ['disaster', 'humanitarian', 'users-people'],
  },
  {
    name: 'person-walking-luggage',
    label: 'Person Walking Luggage',
    unicode: 'e554',
    styles: ['solid'],
    searchTerms: [
      'bag',
      'baggage',
      'briefcase',
      'carry-on',
      'deployment',
      'follow',
      'rolling',
      'uer',
    ],
    categories: ['humanitarian', 'travel-hotel', 'users-people'],
  },
  {
    name: 'person-walking-with-cane',
    label: 'Person Walking With Cane',
    unicode: 'f29d',
    styles: ['solid'],
    searchTerms: ['blind', 'cane', 'follow', 'uer'],
    categories: ['accessibility', 'maps', 'users-people'],
    aliases: ['blind'],
  },
  {
    name: 'peseta-sign',
    label: 'Peseta Sign',
    unicode: 'e221',
    styles: ['solid'],
    searchTerms: ['Peseta Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'peso-sign',
    label: 'Peso Sign',
    unicode: 'e222',
    styles: ['solid'],
    searchTerms: ['Peso Sign', 'currency'],
    categories: ['money'],
  },
  {
    name: 'phabricator',
    label: 'Phabricator',
    unicode: 'f3db',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'phoenix-framework',
    label: 'Phoenix Framework',
    unicode: 'f3dc',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'phoenix-squadron',
    label: 'Phoenix Squadron',
    unicode: 'f511',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'phone',
    label: 'Phone',
    unicode: 'f095',
    styles: ['solid'],
    searchTerms: [
      'Left Hand Telephone Receiver',
      'call',
      'earphone',
      'number',
      'phone',
      'receiver',
      'support',
      'talking',
      'telephone',
      'telephone receiver',
      'voice',
    ],
    categories: ['business', 'communication', 'maps'],
  },
  {
    name: 'phone-flip',
    label: 'Phone Flip',
    unicode: 'f879',
    styles: ['solid'],
    searchTerms: [
      'Right Hand Telephone Receiver',
      'call',
      'earphone',
      'number',
      'support',
      'telephone',
      'voice',
    ],
    categories: ['business', 'communication', 'maps'],
    aliases: ['phone-alt'],
  },
  {
    name: 'phone-slash',
    label: 'Phone Slash',
    unicode: 'f3dd',
    styles: ['solid'],
    searchTerms: [
      'call',
      'cancel',
      'disabled',
      'disconnect',
      'earphone',
      'mute',
      'number',
      'support',
      'telephone',
      'voice',
    ],
    categories: ['business', 'communication'],
  },
  {
    name: 'phone-volume',
    label: 'Phone Volume',
    unicode: 'f2a0',
    styles: ['solid'],
    searchTerms: [
      'call',
      'earphone',
      'number',
      'ring',
      'ringing',
      'sound',
      'support',
      'talking',
      'telephone',
      'voice',
      'volume-control-phone',
    ],
    categories: [
      'accessibility',
      'business',
      'communication',
      'maps',
      'media-playback',
    ],
    aliases: ['volume-control-phone'],
  },
  {
    name: 'photo-film',
    label: 'Photo Film',
    unicode: 'f87c',
    styles: ['solid'],
    searchTerms: ['av', 'film', 'image', 'library', 'media'],
    categories: ['files', 'film-video', 'photos-images', 'social'],
    aliases: ['photo-video'],
  },
  {
    name: 'php',
    label: 'PHP',
    unicode: 'f457',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pied-piper',
    label: 'Pied Piper Logo',
    unicode: 'f2ae',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pied-piper-alt',
    label: 'Alternate Pied Piper Logo (Old)',
    unicode: 'f1a8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pied-piper-hat',
    label: 'Pied Piper Hat (Old)',
    unicode: 'f4e5',
    styles: ['brands'],
    searchTerms: ['clothing'],
    categories: [],
  },
  {
    name: 'pied-piper-pp',
    label: 'Pied Piper PP Logo (Old)',
    unicode: 'f1a7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'piggy-bank',
    label: 'Piggy Bank',
    unicode: 'f4d3',
    styles: ['solid'],
    searchTerms: ['bank', 'salary', 'save', 'savings'],
    categories: ['charity', 'money', 'political'],
  },
  {
    name: 'pills',
    label: 'Pills',
    unicode: 'f484',
    styles: ['solid'],
    searchTerms: ['drugs', 'medicine', 'prescription', 'tablets'],
    categories: ['humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'pinterest',
    label: 'Pinterest',
    unicode: 'f0d2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pinterest-p',
    label: 'Pinterest P',
    unicode: 'f231',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pix',
    label: 'Pix',
    unicode: 'e43a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pixiv',
    label: 'Pixiv',
    unicode: 'e640',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pizza-slice',
    label: 'Pizza Slice',
    unicode: 'f818',
    styles: ['solid'],
    searchTerms: [
      'cheese',
      'chicago',
      'italian',
      'mozzarella',
      'new york',
      'pepperoni',
      'pie',
      'slice',
      'teenage mutant ninja turtles',
      'tomato',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'place-of-worship',
    label: 'Place Of Worship',
    unicode: 'f67f',
    styles: ['solid'],
    searchTerms: ['building', 'church', 'holy', 'mosque', 'synagogue'],
    categories: ['buildings', 'religion'],
  },
  {
    name: 'plane',
    label: 'Plane',
    unicode: 'f072',
    styles: ['solid'],
    searchTerms: [
      'airplane',
      'airport',
      'destination',
      'fly',
      'location',
      'mode',
      'travel',
      'trip',
    ],
    categories: ['maps', 'transportation', 'travel-hotel'],
  },
  {
    name: 'plane-arrival',
    label: 'Plane Arrival',
    unicode: 'f5af',
    styles: ['solid'],
    searchTerms: [
      'aeroplane',
      'airplane',
      'airplane arrival',
      'airport',
      'arrivals',
      'arriving',
      'destination',
      'fly',
      'land',
      'landing',
      'location',
      'mode',
      'travel',
      'trip',
    ],
    categories: ['travel-hotel'],
  },
  {
    name: 'plane-circle-check',
    label: 'Plane Circle Check',
    unicode: 'e555',
    styles: ['solid'],
    searchTerms: [
      'airplane',
      'airport',
      'enable',
      'flight',
      'fly',
      'not affected',
      'ok',
      'okay',
      'travel',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'logistics', 'travel-hotel'],
  },
  {
    name: 'plane-circle-exclamation',
    label: 'Plane Circle Exclamation',
    unicode: 'e556',
    styles: ['solid'],
    searchTerms: [
      'affected',
      'airplane',
      'airport',
      'failed',
      'flight',
      'fly',
      'travel',
    ],
    categories: ['humanitarian', 'logistics', 'travel-hotel'],
  },
  {
    name: 'plane-circle-xmark',
    label: 'Plane Circle Xmark',
    unicode: 'e557',
    styles: ['solid'],
    searchTerms: [
      'airplane',
      'airport',
      'destroy',
      'flight',
      'fly',
      'travel',
      'uncheck',
    ],
    categories: ['humanitarian', 'logistics', 'travel-hotel'],
  },
  {
    name: 'plane-departure',
    label: 'Plane Departure',
    unicode: 'f5b0',
    styles: ['solid'],
    searchTerms: [
      'aeroplane',
      'airplane',
      'airplane departure',
      'airport',
      'check-in',
      'departing',
      'departure',
      'departures',
      'destination',
      'fly',
      'location',
      'mode',
      'take off',
      'taking off',
      'travel',
      'trip',
    ],
    categories: ['travel-hotel'],
  },
  {
    name: 'plane-lock',
    label: 'Plane Lock',
    unicode: 'e558',
    styles: ['solid'],
    searchTerms: [
      'airplane',
      'airport',
      'closed',
      'flight',
      'fly',
      'lockdown',
      'padlock',
      'privacy',
      'quarantine',
      'travel',
    ],
    categories: ['humanitarian', 'logistics', 'travel-hotel'],
  },
  {
    name: 'plane-slash',
    label: 'Plane Slash',
    unicode: 'e069',
    styles: ['solid'],
    searchTerms: [
      'airplane mode',
      'airport',
      'canceled',
      'covid-19',
      'delayed',
      'disabled',
      'grounded',
      'travel',
    ],
    categories: ['transportation', 'travel-hotel'],
  },
  {
    name: 'plane-up',
    label: 'Plane Up',
    unicode: 'e22d',
    styles: ['solid'],
    searchTerms: [
      'airplane',
      'airport',
      'internet',
      'signal',
      'sky',
      'wifi',
      'wireless',
    ],
    categories: ['humanitarian', 'toggle', 'transportation', 'travel-hotel'],
  },
  {
    name: 'plant-wilt',
    label: 'Plant Wilt',
    unicode: 'e5aa',
    styles: ['solid'],
    searchTerms: ['drought', 'planting', 'vegetation', 'wilt'],
    categories: ['disaster', 'humanitarian', 'nature'],
  },
  {
    name: 'plate-wheat',
    label: 'Plate Wheat',
    unicode: 'e55a',
    styles: ['solid'],
    searchTerms: ['bowl', 'hunger', 'rations', 'wheat'],
    categories: ['food-beverage', 'humanitarian'],
  },
  {
    name: 'play',
    label: 'Play',
    unicode: 'f04b',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'audio',
      'music',
      'play',
      'play button',
      'playing',
      'right',
      'sound',
      'start',
      'triangle',
      'video',
    ],
    categories: ['media-playback', 'shapes'],
  },
  {
    name: 'playstation',
    label: 'PlayStation',
    unicode: 'f3df',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
  },
  {
    name: 'plug',
    label: 'Plug',
    unicode: 'f1e6',
    styles: ['solid'],
    searchTerms: [
      'connect',
      'electric',
      'electric plug',
      'electricity',
      'online',
      'plug',
      'power',
    ],
    categories: [
      'devices-hardware',
      'energy',
      'household',
      'humanitarian',
      'maps',
    ],
  },
  {
    name: 'plug-circle-bolt',
    label: 'Plug Circle Bolt',
    unicode: 'e55b',
    styles: ['solid'],
    searchTerms: ['electric', 'electricity', 'plug', 'power'],
    categories: ['energy', 'humanitarian'],
  },
  {
    name: 'plug-circle-check',
    label: 'Plug Circle Check',
    unicode: 'e55c',
    styles: ['solid'],
    searchTerms: [
      'electric',
      'electricity',
      'enable',
      'not affected',
      'ok',
      'okay',
      'plug',
      'power',
      'validate',
      'working',
    ],
    categories: ['energy', 'humanitarian'],
  },
  {
    name: 'plug-circle-exclamation',
    label: 'Plug Circle Exclamation',
    unicode: 'e55d',
    styles: ['solid'],
    searchTerms: [
      'affected',
      'electric',
      'electricity',
      'failed',
      'plug',
      'power',
    ],
    categories: ['energy', 'humanitarian'],
  },
  {
    name: 'plug-circle-minus',
    label: 'Plug Circle Minus',
    unicode: 'e55e',
    styles: ['solid'],
    searchTerms: ['disconnect', 'electric', 'electricity', 'plug', 'power'],
    categories: ['energy', 'humanitarian'],
  },
  {
    name: 'plug-circle-plus',
    label: 'Plug Circle Plus',
    unicode: 'e55f',
    styles: ['solid'],
    searchTerms: ['electric', 'electricity', 'plug', 'power'],
    categories: ['energy', 'humanitarian'],
  },
  {
    name: 'plug-circle-xmark',
    label: 'Plug Circle Xmark',
    unicode: 'e560',
    styles: ['solid'],
    searchTerms: [
      'destroy',
      'disconnect',
      'electric',
      'electricity',
      'outage',
      'plug',
      'power',
      'uncheck',
    ],
    categories: ['energy', 'humanitarian'],
  },
  {
    name: 'plus',
    label: 'Plus',
    unicode: '2b',
    styles: ['solid'],
    searchTerms: [
      '+',
      'Plus Sign',
      'add',
      'create',
      'expand',
      'follow',
      'math',
      'modify',
      'new',
      'plus',
      'positive',
      'shape',
      'sign',
    ],
    categories: [
      'editing',
      'maps',
      'mathematics',
      'medical-health',
      'punctuation-symbols',
    ],
    aliases: ['add'],
  },
  {
    name: 'plus-minus',
    label: 'Plus Minus',
    unicode: 'e43c',
    styles: ['solid'],
    searchTerms: ['Plus-Minus Sign', 'add', 'math', 'subtract'],
    categories: ['mathematics', 'media-playback'],
  },
  {
    name: 'podcast',
    label: 'Podcast',
    unicode: 'f2ce',
    styles: ['solid'],
    searchTerms: ['audio', 'broadcast', 'music', 'sound'],
    categories: ['film-video'],
  },
  {
    name: 'poo',
    label: 'Poo',
    unicode: 'f2fe',
    styles: ['solid'],
    searchTerms: [
      'crap',
      'dung',
      'face',
      'monster',
      'pile of poo',
      'poo',
      'poop',
      'shit',
      'smile',
      'turd',
      'uer',
    ],
    categories: ['communication', 'users-people'],
  },
  {
    name: 'poo-storm',
    label: 'Poo Storm',
    unicode: 'f75a',
    styles: ['solid'],
    searchTerms: [
      'bolt',
      'cloud',
      'euphemism',
      'lightning',
      'mess',
      'poop',
      'shit',
      'turd',
    ],
    categories: ['weather'],
    aliases: ['poo-bolt'],
  },
  {
    name: 'poop',
    label: 'Poop',
    unicode: 'f619',
    styles: ['solid'],
    searchTerms: ['crap', 'poop', 'shit', 'smile', 'turd'],
    categories: ['energy', 'medical-health'],
  },
  {
    name: 'power-off',
    label: 'Power Off',
    unicode: 'f011',
    styles: ['solid'],
    searchTerms: [
      'Power Symbol',
      'cancel',
      'computer',
      'on',
      'reboot',
      'restart',
    ],
    categories: ['devices-hardware', 'energy'],
  },
  {
    name: 'prescription',
    label: 'Prescription',
    unicode: 'f5b1',
    styles: ['solid'],
    searchTerms: ['drugs', 'medical', 'medicine', 'pharmacy', 'rx'],
    categories: ['medical-health'],
  },
  {
    name: 'prescription-bottle',
    label: 'Prescription Bottle',
    unicode: 'f485',
    styles: ['solid'],
    searchTerms: ['drugs', 'medical', 'medicine', 'pharmacy', 'rx'],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'prescription-bottle-medical',
    label: 'Prescription Bottle Medical',
    unicode: 'f486',
    styles: ['solid'],
    searchTerms: ['drugs', 'medical', 'medicine', 'pharmacy', 'rx'],
    categories: ['medical-health'],
    aliases: ['prescription-bottle-alt'],
  },
  {
    name: 'print',
    label: 'Print',
    unicode: 'f02f',
    styles: ['solid'],
    searchTerms: [
      'Print Screen Symbol',
      'Printer Icon',
      'business',
      'computer',
      'copy',
      'document',
      'office',
      'paper',
      'printer',
    ],
    categories: ['business', 'devices-hardware', 'maps'],
  },
  {
    name: 'product-hunt',
    label: 'Product Hunt',
    unicode: 'f288',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'pump-medical',
    label: 'Pump Medical',
    unicode: 'e06a',
    styles: ['solid'],
    searchTerms: [
      'anti-bacterial',
      'clean',
      'covid-19',
      'disinfect',
      'hygiene',
      'medical grade',
      'sanitizer',
      'soap',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'pump-soap',
    label: 'Pump Soap',
    unicode: 'e06b',
    styles: ['solid'],
    searchTerms: [
      'anti-bacterial',
      'clean',
      'covid-19',
      'disinfect',
      'hygiene',
      'sanitizer',
      'soap',
    ],
    categories: ['household', 'humanitarian'],
  },
  {
    name: 'pushed',
    label: 'Pushed',
    unicode: 'f3e1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'puzzle-piece',
    label: 'Puzzle Piece',
    unicode: 'f12e',
    styles: ['solid'],
    searchTerms: [
      'add-on',
      'addon',
      'clue',
      'game',
      'interlocking',
      'jigsaw',
      'piece',
      'puzzle',
      'puzzle piece',
      'section',
    ],
    categories: ['childhood', 'gaming'],
  },
  {
    name: 'python',
    label: 'Python',
    unicode: 'f3e2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'q',
    label: 'Q',
    unicode: '51',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter Q', 'Latin Small Letter Q', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'qq',
    label: 'QQ',
    unicode: 'f1d6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'qrcode',
    label: 'Qrcode',
    unicode: 'f029',
    styles: ['solid'],
    searchTerms: ['barcode', 'info', 'information', 'scan'],
    categories: ['coding'],
  },
  {
    name: 'question',
    label: 'Question',
    unicode: '3f',
    styles: ['solid'],
    searchTerms: [
      '?',
      'Question Mark',
      'faq',
      'help',
      'information',
      'mark',
      'outlined',
      'punctuation',
      'question',
      'red question mark',
      'request',
      'support',
      'unknown',
      'white question mark',
    ],
    categories: ['accessibility', 'alert', 'punctuation-symbols'],
  },
  {
    name: 'quinscape',
    label: 'QuinScape',
    unicode: 'f459',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'quora',
    label: 'Quora',
    unicode: 'f2c4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'quote-left',
    label: 'Quote Left',
    unicode: 'f10d',
    styles: ['solid'],
    searchTerms: [
      'Left Double Quotation Mark',
      'mention',
      'note',
      'phrase',
      'text',
      'type',
    ],
    categories: ['communication', 'punctuation-symbols', 'writing'],
    aliases: ['quote-left-alt'],
  },
  {
    name: 'quote-right',
    label: 'Quote Right',
    unicode: 'f10e',
    styles: ['solid'],
    searchTerms: [
      'Right Double Quotation Mark',
      'mention',
      'note',
      'phrase',
      'text',
      'type',
    ],
    categories: ['communication', 'punctuation-symbols', 'writing'],
    aliases: ['quote-right-alt'],
  },
  {
    name: 'r',
    label: 'R',
    unicode: '52',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter R', 'Latin Small Letter R', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'r-project',
    label: 'R Project',
    unicode: 'f4f7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'radiation',
    label: 'Radiation',
    unicode: 'f7b9',
    styles: ['solid'],
    searchTerms: [
      'danger',
      'dangerous',
      'deadly',
      'hazard',
      'nuclear',
      'radioactive',
      'warning',
    ],
    categories: [
      'alert',
      'disaster',
      'energy',
      'humanitarian',
      'medical-health',
      'science',
    ],
  },
  {
    name: 'radio',
    label: 'Radio',
    unicode: 'f8d7',
    styles: ['solid'],
    searchTerms: [
      'am',
      'broadcast',
      'fm',
      'frequency',
      'music',
      'news',
      'radio',
      'receiver',
      'transmitter',
      'tuner',
      'video',
    ],
    categories: ['humanitarian', 'music-audio'],
  },
  {
    name: 'rainbow',
    label: 'Rainbow',
    unicode: 'f75b',
    styles: ['solid'],
    searchTerms: ['gold', 'leprechaun', 'prism', 'rain', 'rainbow', 'sky'],
    categories: ['weather'],
  },
  {
    name: 'ranking-star',
    label: 'Ranking Star',
    unicode: 'e561',
    styles: ['solid'],
    searchTerms: [
      'chart',
      'first place',
      'podium',
      'quality',
      'rank',
      'revenue',
      'win',
    ],
    categories: ['humanitarian', 'marketing', 'sports-fitness'],
  },
  {
    name: 'raspberry-pi',
    label: 'Raspberry Pi',
    unicode: 'f7bb',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ravelry',
    label: 'Ravelry',
    unicode: 'f2d9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'react',
    label: 'React',
    unicode: 'f41b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'reacteurope',
    label: 'ReactEurope',
    unicode: 'f75d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'readme',
    label: 'ReadMe',
    unicode: 'f4d5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'rebel',
    label: 'Rebel Alliance',
    unicode: 'f1d0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'receipt',
    label: 'Receipt',
    unicode: 'f543',
    styles: ['solid'],
    searchTerms: [
      'accounting',
      'bookkeeping',
      'check',
      'coupon',
      'evidence',
      'invoice',
      'money',
      'pay',
      'proof',
      'receipt',
      'table',
    ],
    categories: ['medical-health', 'money', 'shopping'],
  },
  {
    name: 'record-vinyl',
    label: 'Record Vinyl',
    unicode: 'f8d9',
    styles: ['solid'],
    searchTerms: ['LP', 'album', 'analog', 'music', 'phonograph', 'sound'],
    categories: ['music-audio'],
  },
  {
    name: 'rectangle-ad',
    label: 'Rectangle Ad',
    unicode: 'f641',
    styles: ['solid'],
    searchTerms: [
      'advertisement',
      'media',
      'newspaper',
      'promotion',
      'publicity',
    ],
    categories: ['marketing'],
    aliases: ['ad'],
  },
  {
    name: 'rectangle-list',
    label: 'Rectangle List',
    unicode: 'f022',
    styles: ['regular', 'solid'],
    searchTerms: [
      'cheatsheet',
      'checklist',
      'completed',
      'done',
      'finished',
      'ol',
      'summary',
      'todo',
      'ul',
    ],
    categories: ['text-formatting'],
    aliases: ['list-alt'],
  },
  {
    name: 'rectangle-xmark',
    label: 'Rectangle Xmark',
    unicode: 'f410',
    styles: ['regular', 'solid'],
    searchTerms: ['browser', 'cancel', 'computer', 'development', 'uncheck'],
    categories: ['coding'],
    aliases: ['rectangle-times', 'times-rectangle', 'window-close'],
  },
  {
    name: 'recycle',
    label: 'Recycle',
    unicode: 'f1b8',
    styles: ['solid'],
    searchTerms: [
      'Recycling Symbol For Generic Materials',
      'Universal Recycling Symbol',
      'Waste',
      'compost',
      'garbage',
      'recycle',
      'recycling symbol',
      'reuse',
      'trash',
    ],
    categories: ['arrows', 'maps'],
  },
  {
    name: 'red-river',
    label: 'red river',
    unicode: 'f3e3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'reddit',
    label: 'Reddit',
    unicode: 'f1a1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'reddit-alien',
    label: 'Reddit Alien',
    unicode: 'f281',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'redhat',
    label: 'Redhat',
    unicode: 'f7bc',
    styles: ['brands'],
    searchTerms: ['linux', 'operating system', 'os'],
    categories: [],
  },
  {
    name: 'registered',
    label: 'Registered',
    unicode: 'f25d',
    styles: ['regular', 'solid'],
    searchTerms: ['copyright', 'mark', 'r', 'registered', 'trademark'],
    categories: ['business'],
  },
  {
    name: 'renren',
    label: 'Renren',
    unicode: 'f18b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'repeat',
    label: 'Repeat',
    unicode: 'f363',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'clockwise',
      'flip',
      'reload',
      'renew',
      'repeat',
      'repeat button',
      'retry',
      'rewind',
      'switch',
    ],
    categories: ['arrows', 'media-playback'],
  },
  {
    name: 'reply',
    label: 'Reply',
    unicode: 'f3e5',
    styles: ['solid'],
    searchTerms: ['mail', 'message', 'respond'],
    categories: ['arrows'],
    aliases: ['mail-reply'],
  },
  {
    name: 'reply-all',
    label: 'Reply All',
    unicode: 'f122',
    styles: ['solid'],
    searchTerms: ['mail', 'message', 'respond'],
    categories: ['arrows'],
    aliases: ['mail-reply-all'],
  },
  {
    name: 'replyd',
    label: 'replyd',
    unicode: 'f3e6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'republican',
    label: 'Republican',
    unicode: 'f75e',
    styles: ['solid'],
    searchTerms: [
      'american',
      'conservative',
      'election',
      'elephant',
      'politics',
      'republican party',
      'right',
      'right-wing',
      'usa',
    ],
    categories: ['political'],
  },
  {
    name: 'researchgate',
    label: 'Researchgate',
    unicode: 'f4f8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'resolving',
    label: 'Resolving',
    unicode: 'f3e7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'restroom',
    label: 'Restroom',
    unicode: 'f7bd',
    styles: ['solid'],
    searchTerms: ['bathroom', 'toilet', 'uer', 'water closet', 'wc'],
    categories: ['maps', 'users-people'],
  },
  {
    name: 'retweet',
    label: 'Retweet',
    unicode: 'f079',
    styles: ['solid'],
    searchTerms: ['refresh', 'reload', 'renew', 'retry', 'share', 'swap'],
    categories: ['arrows', 'social'],
  },
  {
    name: 'rev',
    label: 'Rev.io',
    unicode: 'f5b2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ribbon',
    label: 'Ribbon',
    unicode: 'f4d6',
    styles: ['solid'],
    searchTerms: [
      'badge',
      'cause',
      'celebration',
      'lapel',
      'pin',
      'reminder',
      'reminder ribbon',
      'ribbon',
    ],
    categories: ['charity'],
  },
  {
    name: 'right-from-bracket',
    label: 'Right From Bracket',
    unicode: 'f2f5',
    styles: ['solid'],
    searchTerms: ['arrow', 'exit', 'leave', 'log out', 'logout', 'sign-out'],
    categories: ['arrows'],
    aliases: ['sign-out-alt'],
  },
  {
    name: 'right-left',
    label: 'Right Left',
    unicode: 'f362',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'arrows',
      'exchange',
      'reciprocate',
      'return',
      'swap',
      'transfer',
    ],
    categories: ['arrows'],
    aliases: ['exchange-alt'],
  },
  {
    name: 'right-long',
    label: 'Right Long',
    unicode: 'f30b',
    styles: ['solid'],
    searchTerms: ['forward', 'long-arrow-right', 'next'],
    categories: ['arrows'],
    aliases: ['long-arrow-alt-right'],
  },
  {
    name: 'right-to-bracket',
    label: 'Right To Bracket',
    unicode: 'f2f6',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'enter',
      'join',
      'log in',
      'login',
      'sign in',
      'sign up',
      'sign-in',
      'signin',
      'signup',
    ],
    categories: ['arrows'],
    aliases: ['sign-in-alt'],
  },
  {
    name: 'ring',
    label: 'Ring',
    unicode: 'f70b',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'Gollum',
      'band',
      'binding',
      'd&d',
      'dnd',
      'engagement',
      'fantasy',
      'gold',
      'jewelry',
      'marriage',
      'precious',
      'premium',
    ],
    categories: ['gaming', 'spinners'],
  },
  {
    name: 'road',
    label: 'Road',
    unicode: 'f018',
    styles: ['solid'],
    searchTerms: [
      'highway',
      'map',
      'motorway',
      'pavement',
      'road',
      'route',
      'street',
      'travel',
    ],
    categories: ['humanitarian', 'logistics', 'maps', 'transportation'],
  },
  {
    name: 'road-barrier',
    label: 'Road Barrier',
    unicode: 'e562',
    styles: ['solid'],
    searchTerms: ['block', 'border', 'no entry', 'roadblock'],
    categories: ['humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'road-bridge',
    label: 'Road Bridge',
    unicode: 'e563',
    styles: ['solid'],
    searchTerms: ['bridge', 'infrastructure', 'road', 'travel'],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'road-circle-check',
    label: 'Road Circle Check',
    unicode: 'e564',
    styles: ['solid'],
    searchTerms: [
      'enable',
      'freeway',
      'highway',
      'not affected',
      'ok',
      'okay',
      'pavement',
      'road',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'road-circle-exclamation',
    label: 'Road Circle Exclamation',
    unicode: 'e565',
    styles: ['solid'],
    searchTerms: [
      'affected',
      'failed',
      'freeway',
      'highway',
      'pavement',
      'road',
    ],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'road-circle-xmark',
    label: 'Road Circle Xmark',
    unicode: 'e566',
    styles: ['solid'],
    searchTerms: [
      'destroy',
      'freeway',
      'highway',
      'pavement',
      'road',
      'uncheck',
    ],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'road-lock',
    label: 'Road Lock',
    unicode: 'e567',
    styles: ['solid'],
    searchTerms: [
      'closed',
      'freeway',
      'highway',
      'lockdown',
      'padlock',
      'pavement',
      'privacy',
      'quarantine',
      'road',
    ],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'road-spikes',
    label: 'Road Spikes',
    unicode: 'e568',
    styles: ['solid'],
    searchTerms: ['barrier', 'roadblock', 'spikes'],
    categories: ['humanitarian', 'security', 'transportation'],
  },
  {
    name: 'robot',
    label: 'Robot',
    unicode: 'f544',
    styles: ['solid'],
    searchTerms: [
      'android',
      'automate',
      'computer',
      'cyborg',
      'face',
      'monster',
      'robot',
    ],
    categories: ['childhood', 'science-fiction'],
  },
  {
    name: 'rocket',
    label: 'Rocket',
    unicode: 'f135',
    styles: ['solid'],
    searchTerms: ['aircraft', 'app', 'jet', 'launch', 'nasa', 'space'],
    categories: ['maps', 'science-fiction', 'transportation'],
  },
  {
    name: 'rocketchat',
    label: 'Rocket.Chat',
    unicode: 'f3e8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'rockrms',
    label: 'Rockrms',
    unicode: 'f3e9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'rotate',
    label: 'Rotate',
    unicode: 'f2f1',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'clockwise',
      'exchange',
      'modify',
      'refresh',
      'reload',
      'renew',
      'retry',
      'rotate',
      'swap',
      'withershins',
    ],
    categories: ['arrows', 'editing', 'media-playback', 'spinners'],
    aliases: ['sync-alt'],
  },
  {
    name: 'rotate-left',
    label: 'Rotate Left',
    unicode: 'f2ea',
    styles: ['solid'],
    searchTerms: ['back', 'control z', 'exchange', 'oops', 'return', 'swap'],
    categories: ['arrows', 'media-playback', 'spinners'],
    aliases: ['rotate-back', 'rotate-backward', 'undo-alt'],
  },
  {
    name: 'rotate-right',
    label: 'Rotate Right',
    unicode: 'f2f9',
    styles: ['solid'],
    searchTerms: ['forward', 'refresh', 'reload', 'renew', 'repeat', 'retry'],
    categories: ['arrows', 'media-playback', 'spinners'],
    aliases: ['redo-alt', 'rotate-forward'],
  },
  {
    name: 'route',
    label: 'Route',
    unicode: 'f4d7',
    styles: ['solid'],
    searchTerms: ['directions', 'navigation', 'travel'],
    categories: ['camping', 'maps', 'moving'],
  },
  {
    name: 'rss',
    label: 'Rss',
    unicode: 'f09e',
    styles: ['solid'],
    searchTerms: ['blog', 'feed', 'journal', 'news', 'writing'],
    categories: ['connectivity', 'media-playback'],
    aliases: ['feed'],
  },
  {
    name: 'ruble-sign',
    label: 'Ruble Sign',
    unicode: 'f158',
    styles: ['solid'],
    searchTerms: ['Ruble Sign', 'currency'],
    categories: ['money'],
    aliases: ['rouble', 'rub', 'ruble'],
  },
  {
    name: 'rug',
    label: 'Rug',
    unicode: 'e569',
    styles: ['solid'],
    searchTerms: ['blanket', 'carpet', 'rug', 'textile'],
    categories: ['household', 'humanitarian'],
  },
  {
    name: 'ruler',
    label: 'Ruler',
    unicode: 'f545',
    styles: ['solid'],
    searchTerms: [
      'design',
      'draft',
      'length',
      'measure',
      'planning',
      'ruler',
      'straight edge',
      'straight ruler',
    ],
    categories: ['construction'],
  },
  {
    name: 'ruler-combined',
    label: 'Ruler Combined',
    unicode: 'f546',
    styles: ['solid'],
    searchTerms: ['design', 'draft', 'length', 'measure', 'planning'],
    categories: ['construction', 'design'],
  },
  {
    name: 'ruler-horizontal',
    label: 'Ruler Horizontal',
    unicode: 'f547',
    styles: ['solid'],
    searchTerms: ['design', 'draft', 'length', 'measure', 'planning'],
    categories: ['construction', 'design'],
  },
  {
    name: 'ruler-vertical',
    label: 'Ruler Vertical',
    unicode: 'f548',
    styles: ['solid'],
    searchTerms: ['design', 'draft', 'length', 'measure', 'planning'],
    categories: ['construction', 'design'],
  },
  {
    name: 'rupee-sign',
    label: 'Rupee Sign',
    unicode: 'f156',
    styles: ['solid'],
    searchTerms: ['Rupee Sign', 'currency'],
    categories: ['money'],
    aliases: ['rupee'],
  },
  {
    name: 'rupiah-sign',
    label: 'Rupiah Sign',
    unicode: 'e23d',
    styles: ['solid'],
    searchTerms: ['currency'],
    categories: ['money'],
  },
  {
    name: 'rust',
    label: 'Rust',
    unicode: 'e07a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 's',
    label: 'S',
    unicode: '53',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter S', 'Latin Small Letter S', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'sack-dollar',
    label: 'Sack Dollar',
    unicode: 'f81d',
    styles: ['solid'],
    searchTerms: [
      'bag',
      'burlap',
      'cash',
      'dollar',
      'investment',
      'money',
      'money bag',
      'moneybag',
      'premium',
      'robber',
      'salary',
      'santa',
      'usd',
    ],
    categories: ['humanitarian', 'money'],
  },
  {
    name: 'sack-xmark',
    label: 'Sack Xmark',
    unicode: 'e56a',
    styles: ['solid'],
    searchTerms: ['bag', 'burlap', 'coupon', 'rations', 'salary', 'uncheck'],
    categories: ['humanitarian', 'money'],
  },
  {
    name: 'safari',
    label: 'Safari',
    unicode: 'f267',
    styles: ['brands'],
    searchTerms: ['browser'],
    categories: [],
  },
  {
    name: 'sailboat',
    label: 'Sailboat',
    unicode: 'e445',
    styles: ['solid'],
    searchTerms: ['dinghy', 'mast', 'sailboat', 'sailing', 'yacht'],
    categories: ['humanitarian', 'logistics', 'maritime', 'transportation'],
  },
  {
    name: 'salesforce',
    label: 'Salesforce',
    unicode: 'f83b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'sass',
    label: 'Sass',
    unicode: 'f41e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'satellite',
    label: 'Satellite',
    unicode: 'f7bf',
    styles: ['solid'],
    searchTerms: ['communications', 'hardware', 'orbit', 'satellite', 'space'],
    categories: ['astronomy', 'devices-hardware'],
  },
  {
    name: 'satellite-dish',
    label: 'Satellite Dish',
    unicode: 'f7c0',
    styles: ['solid'],
    searchTerms: [
      'SETI',
      'antenna',
      'communications',
      'dish',
      'hardware',
      'radar',
      'receiver',
      'satellite',
      'satellite antenna',
      'saucer',
      'signal',
      'space',
    ],
    categories: [
      'astronomy',
      'connectivity',
      'devices-hardware',
      'humanitarian',
    ],
  },
  {
    name: 'scale-balanced',
    label: 'Scale Balanced',
    unicode: 'f24e',
    styles: ['solid'],
    searchTerms: [
      'Libra',
      'balance',
      'balance scale',
      'balanced',
      'justice',
      'law',
      'legal',
      'measure',
      'rule',
      'scale',
      'weight',
      'zodiac',
    ],
    categories: ['business', 'humanitarian', 'maps', 'money', 'political'],
    aliases: ['balance-scale'],
  },
  {
    name: 'scale-unbalanced',
    label: 'Scale Unbalanced',
    unicode: 'f515',
    styles: ['solid'],
    searchTerms: ['justice', 'legal', 'measure', 'unbalanced', 'weight'],
    categories: ['business', 'maps', 'money', 'political'],
    aliases: ['balance-scale-left'],
  },
  {
    name: 'scale-unbalanced-flip',
    label: 'Scale Unbalanced Flip',
    unicode: 'f516',
    styles: ['solid'],
    searchTerms: ['justice', 'legal', 'measure', 'unbalanced', 'weight'],
    categories: ['business', 'maps', 'money', 'political'],
    aliases: ['balance-scale-right'],
  },
  {
    name: 'schlix',
    label: 'SCHLIX',
    unicode: 'f3ea',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'school',
    label: 'School',
    unicode: 'f549',
    styles: ['solid'],
    searchTerms: [
      'building',
      'education',
      'learn',
      'school',
      'student',
      'teacher',
    ],
    categories: ['buildings', 'childhood', 'education', 'humanitarian'],
  },
  {
    name: 'school-circle-check',
    label: 'School Circle Check',
    unicode: 'e56b',
    styles: ['solid'],
    searchTerms: [
      'enable',
      'not affected',
      'ok',
      'okay',
      'schoolhouse',
      'validate',
      'working',
    ],
    categories: ['buildings', 'education', 'humanitarian'],
  },
  {
    name: 'school-circle-exclamation',
    label: 'School Circle Exclamation',
    unicode: 'e56c',
    styles: ['solid'],
    searchTerms: ['affected', 'failed', 'schoolhouse'],
    categories: ['buildings', 'education', 'humanitarian'],
  },
  {
    name: 'school-circle-xmark',
    label: 'School Circle Xmark',
    unicode: 'e56d',
    styles: ['solid'],
    searchTerms: ['destroy', 'schoolhouse', 'uncheck'],
    categories: ['buildings', 'education', 'humanitarian'],
  },
  {
    name: 'school-flag',
    label: 'School Flag',
    unicode: 'e56e',
    styles: ['solid'],
    searchTerms: ['educate', 'flag', 'school', 'schoolhouse'],
    categories: ['buildings', 'education', 'humanitarian'],
  },
  {
    name: 'school-lock',
    label: 'School Lock',
    unicode: 'e56f',
    styles: ['solid'],
    searchTerms: [
      'closed',
      'lockdown',
      'padlock',
      'privacy',
      'quarantine',
      'schoolhouse',
    ],
    categories: ['buildings', 'education', 'humanitarian'],
  },
  {
    name: 'scissors',
    label: 'Scissors',
    unicode: 'f0c4',
    styles: ['solid'],
    searchTerms: [
      'Black Safety Scissors',
      'White Scissors',
      'clip',
      'cutting',
      'equipment',
      'modify',
      'scissors',
      'snip',
      'tool',
    ],
    categories: ['business', 'design', 'editing', 'files'],
    aliases: ['cut'],
  },
  {
    name: 'screenpal',
    label: 'Screenpal',
    unicode: 'e570',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'screwdriver',
    label: 'Screwdriver',
    unicode: 'f54a',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'configuration',
      'equipment',
      'fix',
      'maintenance',
      'mechanic',
      'modify',
      'repair',
      'screw',
      'screwdriver',
      'settings',
      'tool',
    ],
    categories: ['construction'],
  },
  {
    name: 'screwdriver-wrench',
    label: 'Screwdriver Wrench',
    unicode: 'f7d9',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'configuration',
      'equipment',
      'fix',
      'maintenance',
      'modify',
      'repair',
      'screwdriver',
      'settings',
      'tools',
      'wrench',
    ],
    categories: ['construction'],
    aliases: ['tools'],
  },
  {
    name: 'scribd',
    label: 'Scribd',
    unicode: 'f28a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'scroll',
    label: 'Scroll',
    unicode: 'f70e',
    styles: ['solid'],
    searchTerms: [
      'Dungeons & Dragons',
      'announcement',
      'd&d',
      'dnd',
      'fantasy',
      'paper',
      'scholar',
      'script',
      'scroll',
    ],
    categories: ['gaming'],
  },
  {
    name: 'scroll-torah',
    label: 'Scroll Torah',
    unicode: 'f6a0',
    styles: ['solid'],
    searchTerms: ['book', 'jewish', 'judaism', 'religion', 'scroll'],
    categories: ['religion'],
    aliases: ['torah'],
  },
  {
    name: 'sd-card',
    label: 'Sd Card',
    unicode: 'f7c2',
    styles: ['solid'],
    searchTerms: ['image', 'img', 'memory', 'photo', 'save'],
    categories: ['devices-hardware'],
  },
  {
    name: 'searchengin',
    label: 'Searchengin',
    unicode: 'f3eb',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'section',
    label: 'Section',
    unicode: 'e447',
    styles: ['solid'],
    searchTerms: ['Section Sign', 'law', 'legal', 'silcrow'],
    categories: ['punctuation-symbols'],
  },
  {
    name: 'seedling',
    label: 'Seedling',
    unicode: 'f4d8',
    styles: ['solid'],
    searchTerms: [
      'environment',
      'flora',
      'grow',
      'investment',
      'plant',
      'sapling',
      'seedling',
      'vegan',
      'young',
    ],
    categories: [
      'charity',
      'energy',
      'food-beverage',
      'fruits-vegetables',
      'humanitarian',
      'nature',
      'science',
    ],
    aliases: ['sprout'],
  },
  {
    name: 'sellcast',
    label: 'Sellcast',
    unicode: 'f2da',
    styles: ['brands'],
    searchTerms: ['eercast'],
    categories: [],
  },
  {
    name: 'sellsy',
    label: 'Sellsy',
    unicode: 'f213',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'server',
    label: 'Server',
    unicode: 'f233',
    styles: ['solid'],
    searchTerms: [
      'computer',
      'cpu',
      'database',
      'hardware',
      'mysql',
      'network',
      'sql',
    ],
    categories: ['devices-hardware'],
  },
  {
    name: 'servicestack',
    label: 'Servicestack',
    unicode: 'f3ec',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'shapes',
    label: 'Shapes',
    unicode: 'f61f',
    styles: ['solid'],
    searchTerms: ['blocks', 'build', 'circle', 'square', 'triangle'],
    categories: ['childhood', 'education', 'shapes'],
    aliases: ['triangle-circle-square'],
  },
  {
    name: 'share',
    label: 'Share',
    unicode: 'f064',
    styles: ['solid'],
    searchTerms: ['forward', 'save', 'send', 'social'],
    categories: ['arrows', 'social'],
    aliases: ['mail-forward'],
  },
  {
    name: 'share-from-square',
    label: 'Share From Square',
    unicode: 'f14d',
    styles: ['regular', 'solid'],
    searchTerms: ['forward', 'save', 'send', 'social'],
    categories: ['arrows', 'social'],
    aliases: ['share-square'],
  },
  {
    name: 'share-nodes',
    label: 'Share Nodes',
    unicode: 'f1e0',
    styles: ['solid'],
    searchTerms: ['forward', 'save', 'send', 'social'],
    categories: ['social'],
    aliases: ['share-alt'],
  },
  {
    name: 'sheet-plastic',
    label: 'Sheet Plastic',
    unicode: 'e571',
    styles: ['solid'],
    searchTerms: [
      'plastic',
      'plastic wrap',
      'protect',
      'tarp',
      'tarpaulin',
      'waterproof',
    ],
    categories: ['construction', 'household', 'humanitarian'],
  },
  {
    name: 'shekel-sign',
    label: 'Shekel Sign',
    unicode: 'f20b',
    styles: ['solid'],
    searchTerms: ['New Sheqel Sign', 'currency', 'ils', 'money'],
    categories: ['money'],
    aliases: ['ils', 'shekel', 'sheqel', 'sheqel-sign'],
  },
  {
    name: 'shield',
    label: 'Shield',
    unicode: 'f132',
    styles: ['solid'],
    searchTerms: [
      'achievement',
      'armor',
      'award',
      'block',
      'cleric',
      'defend',
      'defense',
      'holy',
      'paladin',
      'protect',
      'safety',
      'security',
      'shield',
      'weapon',
      'winner',
    ],
    categories: ['coding', 'security', 'shapes'],
    aliases: ['shield-blank'],
  },
  {
    name: 'shield-cat',
    label: 'Shield Cat',
    unicode: 'e572',
    styles: ['solid'],
    searchTerms: ['animal', 'feline', 'pet', 'protect', 'safety', 'veterinary'],
    categories: ['animals', 'humanitarian', 'security'],
  },
  {
    name: 'shield-dog',
    label: 'Shield Dog',
    unicode: 'e573',
    styles: ['solid'],
    searchTerms: ['animal', 'canine', 'pet', 'protect', 'safety', 'veterinary'],
    categories: ['animals', 'humanitarian', 'security'],
  },
  {
    name: 'shield-halved',
    label: 'Shield Halved',
    unicode: 'f3ed',
    styles: ['solid'],
    searchTerms: [
      'achievement',
      'armor',
      'award',
      'block',
      'cleric',
      'defend',
      'defense',
      'holy',
      'paladin',
      'privacy',
      'security',
      'shield',
      'weapon',
      'winner',
    ],
    categories: ['coding', 'gaming', 'security'],
    aliases: ['shield-alt'],
  },
  {
    name: 'shield-heart',
    label: 'Shield Heart',
    unicode: 'e574',
    styles: ['solid'],
    searchTerms: ['love', 'protect', 'safe', 'safety', 'shield', 'wishlist'],
    categories: ['humanitarian', 'security'],
  },
  {
    name: 'shield-virus',
    label: 'Shield Virus',
    unicode: 'e06c',
    styles: ['solid'],
    searchTerms: [
      'antibodies',
      'barrier',
      'coronavirus',
      'covid-19',
      'flu',
      'health',
      'infection',
      'pandemic',
      'protect',
      'safety',
      'vaccine',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'ship',
    label: 'Ship',
    unicode: 'f21a',
    styles: ['solid'],
    searchTerms: ['boat', 'passenger', 'sea', 'ship', 'water'],
    categories: ['humanitarian', 'maps', 'maritime', 'transportation'],
  },
  {
    name: 'shirt',
    label: 'Shirt',
    unicode: 'f553',
    styles: ['solid'],
    searchTerms: [
      'clothing',
      'fashion',
      'garment',
      'shirt',
      'short sleeve',
      't-shirt',
      'tshirt',
    ],
    categories: ['clothing-fashion', 'humanitarian', 'shopping'],
    aliases: ['t-shirt', 'tshirt'],
  },
  {
    name: 'shirtsinbulk',
    label: 'Shirts in Bulk',
    unicode: 'f214',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'shoe-prints',
    label: 'Shoe Prints',
    unicode: 'f54b',
    styles: ['solid'],
    searchTerms: ['feet', 'footprints', 'steps', 'walk'],
    categories: ['clothing-fashion', 'maps', 'sports-fitness'],
  },
  {
    name: 'shoelace',
    label: 'Shoelace',
    unicode: 'e60c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'shop',
    label: 'Shop',
    unicode: 'f54f',
    styles: ['solid'],
    searchTerms: [
      'bodega',
      'building',
      'buy',
      'market',
      'purchase',
      'shopping',
      'store',
    ],
    categories: ['buildings', 'humanitarian', 'shopping'],
    aliases: ['store-alt'],
  },
  {
    name: 'shop-lock',
    label: 'Shop Lock',
    unicode: 'e4a5',
    styles: ['solid'],
    searchTerms: [
      'bodega',
      'building',
      'buy',
      'closed',
      'lock',
      'lockdown',
      'market',
      'padlock',
      'privacy',
      'purchase',
      'quarantine',
      'shop',
      'shopping',
      'store',
    ],
    categories: ['buildings', 'humanitarian', 'shopping'],
  },
  {
    name: 'shop-slash',
    label: 'Shop Slash',
    unicode: 'e070',
    styles: ['solid'],
    searchTerms: [
      'building',
      'buy',
      'closed',
      'covid-19',
      'disabled',
      'purchase',
      'shopping',
    ],
    categories: ['shopping'],
    aliases: ['store-alt-slash'],
  },
  {
    name: 'shopify',
    label: 'Shopify',
    unicode: 'e057',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'shopware',
    label: 'Shopware',
    unicode: 'f5b5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'shower',
    label: 'Shower',
    unicode: 'f2cc',
    styles: ['solid'],
    searchTerms: ['bath', 'clean', 'faucet', 'shower', 'water'],
    categories: ['household', 'humanitarian', 'maps', 'travel-hotel'],
  },
  {
    name: 'shrimp',
    label: 'Shrimp',
    unicode: 'e448',
    styles: ['solid'],
    searchTerms: [
      'allergy',
      'crustacean',
      'prawn',
      'seafood',
      'shellfish',
      'shrimp',
      'tail',
    ],
    categories: ['animals', 'food-beverage', 'maritime'],
  },
  {
    name: 'shuffle',
    label: 'Shuffle',
    unicode: 'f074',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'arrows',
      'crossed',
      'shuffle',
      'shuffle tracks button',
      'sort',
      'swap',
      'switch',
      'transfer',
    ],
    categories: ['arrows', 'media-playback'],
    aliases: ['random'],
  },
  {
    name: 'shuttle-space',
    label: 'Shuttle Space',
    unicode: 'f197',
    styles: ['solid'],
    searchTerms: [
      'astronaut',
      'machine',
      'nasa',
      'rocket',
      'space',
      'transportation',
    ],
    categories: ['astronomy', 'transportation'],
    aliases: ['space-shuttle'],
  },
  {
    name: 'sign-hanging',
    label: 'Sign Hanging',
    unicode: 'f4d9',
    styles: ['solid'],
    searchTerms: ['directions', 'real estate', 'signage', 'wayfinding'],
    categories: ['moving'],
    aliases: ['sign'],
  },
  {
    name: 'signal',
    label: 'Signal',
    unicode: 'f012',
    styles: ['solid'],
    searchTerms: [
      'antenna',
      'antenna bars',
      'bar',
      'bars',
      'cell',
      'graph',
      'mobile',
      'online',
      'phone',
      'reception',
      'status',
    ],
    categories: ['connectivity', 'toggle'],
    aliases: ['signal-5', 'signal-perfect'],
  },
  {
    name: 'signal-messenger',
    label: 'Signal Messenger',
    unicode: 'e663',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'signature',
    label: 'Signature',
    unicode: 'f5b7',
    styles: ['solid'],
    searchTerms: ['John Hancock', 'cursive', 'name', 'username', 'writing'],
    categories: ['business', 'editing', 'writing'],
  },
  {
    name: 'signs-post',
    label: 'Signs Post',
    unicode: 'f277',
    styles: ['solid'],
    searchTerms: ['directions', 'directory', 'map', 'signage', 'wayfinding'],
    categories: ['camping', 'maps', 'nature'],
    aliases: ['map-signs'],
  },
  {
    name: 'sim-card',
    label: 'Sim Card',
    unicode: 'f7c4',
    styles: ['solid'],
    searchTerms: [
      'hard drive',
      'hardware',
      'portable',
      'storage',
      'technology',
      'tiny',
    ],
    categories: ['devices-hardware'],
  },
  {
    name: 'simplybuilt',
    label: 'SimplyBuilt',
    unicode: 'f215',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'sink',
    label: 'Sink',
    unicode: 'e06d',
    styles: ['solid'],
    searchTerms: ['bathroom', 'covid-19', 'faucet', 'kitchen', 'wash'],
    categories: ['household'],
  },
  {
    name: 'sistrix',
    label: 'SISTRIX',
    unicode: 'f3ee',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'sitemap',
    label: 'Sitemap',
    unicode: 'f0e8',
    styles: ['solid'],
    searchTerms: [
      'directory',
      'hierarchy',
      'ia',
      'information architecture',
      'organization',
    ],
    categories: ['business', 'coding'],
  },
  {
    name: 'sith',
    label: 'Sith',
    unicode: 'f512',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'sitrox',
    label: 'Sitrox',
    unicode: 'e44a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'sketch',
    label: 'Sketch',
    unicode: 'f7c6',
    styles: ['brands'],
    searchTerms: ['app', 'design', 'interface'],
    categories: [],
  },
  {
    name: 'skull',
    label: 'Skull',
    unicode: 'f54c',
    styles: ['solid'],
    searchTerms: [
      'bones',
      'death',
      'face',
      'fairy tale',
      'monster',
      'skeleton',
      'skull',
      'uer',
      'x-ray',
      'yorick',
    ],
    categories: ['halloween', 'medical-health', 'users-people'],
  },
  {
    name: 'skull-crossbones',
    label: 'Skull Crossbones',
    unicode: 'f714',
    styles: ['solid'],
    searchTerms: [
      'Black Skull and Crossbones',
      'Dungeons & Dragons',
      'alert',
      'bones',
      'crossbones',
      'd&d',
      'danger',
      'dangerous area',
      'dead',
      'deadly',
      'death',
      'dnd',
      'face',
      'fantasy',
      'halloween',
      'holiday',
      'jolly-roger',
      'monster',
      'pirate',
      'poison',
      'skeleton',
      'skull',
      'skull and crossbones',
      'warning',
    ],
    categories: [
      'alert',
      'gaming',
      'halloween',
      'humanitarian',
      'medical-health',
      'science',
      'security',
    ],
  },
  {
    name: 'skyatlas',
    label: 'skyatlas',
    unicode: 'f216',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'skype',
    label: 'Skype',
    unicode: 'f17e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'slack',
    label: 'Slack Logo',
    unicode: 'f198',
    styles: ['brands'],
    searchTerms: ['anchor', 'hash', 'hashtag'],
    categories: [],
    aliases: ['slack-hash'],
  },
  {
    name: 'slash',
    label: 'Slash',
    unicode: 'f715',
    styles: ['solid'],
    searchTerms: ['cancel', 'close', 'mute', 'off', 'stop', 'x'],
    categories: ['spinners'],
  },
  {
    name: 'sleigh',
    label: 'Sleigh',
    unicode: 'f7cc',
    styles: ['solid'],
    searchTerms: [
      'christmas',
      'claus',
      'fly',
      'holiday',
      'santa',
      'sled',
      'snow',
      'xmas',
    ],
    categories: ['holidays', 'transportation'],
  },
  {
    name: 'sliders',
    label: 'Sliders',
    unicode: 'f1de',
    styles: ['solid'],
    searchTerms: [
      'adjust',
      'configuration',
      'modify',
      'settings',
      'sliders',
      'toggle',
    ],
    categories: ['editing', 'media-playback', 'music-audio', 'photos-images'],
    aliases: ['sliders-h'],
  },
  {
    name: 'slideshare',
    label: 'Slideshare',
    unicode: 'f1e7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'smog',
    label: 'Smog',
    unicode: 'f75f',
    styles: ['solid'],
    searchTerms: ['dragon', 'fog', 'haze', 'pollution', 'smoke', 'weather'],
    categories: ['weather'],
  },
  {
    name: 'smoking',
    label: 'Smoking',
    unicode: 'f48d',
    styles: ['solid'],
    searchTerms: [
      'cancer',
      'cigarette',
      'nicotine',
      'smoking',
      'smoking status',
      'tobacco',
    ],
    categories: ['medical-health', 'travel-hotel'],
  },
  {
    name: 'snapchat',
    label: 'Snapchat',
    unicode: 'f2ab',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['snapchat-ghost'],
  },
  {
    name: 'snowflake',
    label: 'Snowflake',
    unicode: 'f2dc',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Heavy Chevron Snowflake',
      'cold',
      'precipitation',
      'rain',
      'snow',
      'snowfall',
      'snowflake',
      'winter',
    ],
    categories: [
      'disaster',
      'household',
      'humanitarian',
      'spinners',
      'travel-hotel',
      'weather',
    ],
  },
  {
    name: 'snowman',
    label: 'Snowman',
    unicode: 'f7d0',
    styles: ['solid'],
    searchTerms: [
      'cold',
      'decoration',
      'frost',
      'frosty',
      'holiday',
      'snow',
      'snowman',
      'snowman without snow',
    ],
    categories: ['childhood', 'holidays'],
  },
  {
    name: 'snowplow',
    label: 'Snowplow',
    unicode: 'f7d2',
    styles: ['solid'],
    searchTerms: ['clean up', 'cold', 'road', 'storm', 'winter'],
    categories: ['maps', 'transportation'],
  },
  {
    name: 'soap',
    label: 'Soap',
    unicode: 'e06e',
    styles: ['solid'],
    searchTerms: [
      'bar',
      'bathing',
      'bubbles',
      'clean',
      'cleaning',
      'covid-19',
      'hygiene',
      'lather',
      'soap',
      'soapdish',
      'wash',
    ],
    categories: ['household', 'humanitarian'],
  },
  {
    name: 'socks',
    label: 'Socks',
    unicode: 'f696',
    styles: ['solid'],
    searchTerms: [
      'business socks',
      'business time',
      'clothing',
      'feet',
      'flight of the conchords',
      'socks',
      'stocking',
      'wednesday',
    ],
    categories: ['business', 'clothing-fashion'],
  },
  {
    name: 'solar-panel',
    label: 'Solar Panel',
    unicode: 'f5ba',
    styles: ['solid'],
    searchTerms: ['clean', 'eco-friendly', 'energy', 'green', 'sun'],
    categories: ['energy'],
  },
  {
    name: 'sort',
    label: 'Sort',
    unicode: 'f0dc',
    styles: ['solid'],
    searchTerms: ['filter', 'order'],
    categories: ['arrows'],
    aliases: ['unsorted'],
  },
  {
    name: 'sort-down',
    label: 'Sort Down',
    unicode: 'f0dd',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'descending',
      'filter',
      'insert',
      'order',
      'sort-desc',
    ],
    categories: ['arrows'],
    aliases: ['sort-desc'],
  },
  {
    name: 'sort-up',
    label: 'Sort Up',
    unicode: 'f0de',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'ascending',
      'filter',
      'order',
      'sort-asc',
      'upgrade',
    ],
    categories: ['arrows'],
    aliases: ['sort-asc'],
  },
  {
    name: 'soundcloud',
    label: 'Soundcloud',
    unicode: 'f1be',
    styles: ['brands'],
    searchTerms: [],
    categories: ['music-audio'],
  },
  {
    name: 'sourcetree',
    label: 'Sourcetree',
    unicode: 'f7d3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'spa',
    label: 'Spa',
    unicode: 'f5bb',
    styles: ['solid'],
    searchTerms: ['flora', 'massage', 'mindfulness', 'plant', 'wellness'],
    categories: ['sports-fitness', 'travel-hotel'],
  },
  {
    name: 'space-awesome',
    label: 'Space Awesome',
    unicode: 'e5ac',
    styles: ['brands'],
    searchTerms: ['adventure', 'rocket', 'ship', 'shuttle'],
    categories: ['science-fiction'],
  },
  {
    name: 'spaghetti-monster-flying',
    label: 'Spaghetti Monster Flying',
    unicode: 'f67b',
    styles: ['solid'],
    searchTerms: ['agnosticism', 'atheism', 'flying spaghetti monster', 'fsm'],
    categories: ['religion'],
    aliases: ['pastafarianism'],
  },
  {
    name: 'speakap',
    label: 'Speakap',
    unicode: 'f3f3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'speaker-deck',
    label: 'Speaker Deck',
    unicode: 'f83c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'spell-check',
    label: 'Spell Check',
    unicode: 'f891',
    styles: ['solid'],
    searchTerms: [
      'dictionary',
      'edit',
      'editor',
      'enable',
      'grammar',
      'text',
      'validate',
      'working',
    ],
    categories: ['text-formatting'],
  },
  {
    name: 'spider',
    label: 'Spider',
    unicode: 'f717',
    styles: ['solid'],
    searchTerms: [
      'arachnid',
      'bug',
      'charlotte',
      'crawl',
      'eight',
      'halloween',
      'insect',
      'spider',
    ],
    categories: ['animals', 'halloween', 'nature'],
  },
  {
    name: 'spinner',
    label: 'Spinner',
    unicode: 'f110',
    styles: ['solid'],
    searchTerms: ['circle', 'loading', 'pending', 'progress'],
    categories: ['spinners'],
  },
  {
    name: 'splotch',
    label: 'Splotch',
    unicode: 'f5bc',
    styles: ['solid'],
    searchTerms: ['Ink', 'blob', 'blotch', 'glob', 'stain'],
    categories: ['design'],
  },
  {
    name: 'spoon',
    label: 'Spoon',
    unicode: 'f2e5',
    styles: ['solid'],
    searchTerms: [
      'cutlery',
      'dining',
      'scoop',
      'silverware',
      'spoon',
      'tableware',
    ],
    categories: ['household', 'maps'],
    aliases: ['utensil-spoon'],
  },
  {
    name: 'spotify',
    label: 'Spotify',
    unicode: 'f1bc',
    styles: ['brands'],
    searchTerms: [],
    categories: ['music-audio'],
  },
  {
    name: 'spray-can',
    label: 'Spray Can',
    unicode: 'f5bd',
    styles: ['solid'],
    searchTerms: ['Paint', 'aerosol', 'design', 'graffiti', 'tag'],
    categories: ['design'],
  },
  {
    name: 'spray-can-sparkles',
    label: 'Spray Can Sparkles',
    unicode: 'f5d0',
    styles: ['solid'],
    searchTerms: ['car', 'clean', 'deodorize', 'fresh', 'pine', 'scent'],
    categories: ['automotive'],
    aliases: ['air-freshener'],
  },
  {
    name: 'square',
    label: 'Square',
    unicode: 'f0c8',
    styles: ['regular', 'solid'],
    searchTerms: [
      'Black Square',
      'black medium square',
      'block',
      'box',
      'geometric',
      'shape',
      'square',
      'white medium square',
    ],
    categories: ['shapes'],
  },
  {
    name: 'square-arrow-up-right',
    label: 'Square Arrow Up Right',
    unicode: 'f14c',
    styles: ['solid'],
    searchTerms: ['diagonal', 'new', 'open', 'send', 'share'],
    categories: ['arrows'],
    aliases: ['external-link-square'],
  },
  {
    name: 'square-behance',
    label: 'Square Behance',
    unicode: 'f1b5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['behance-square'],
  },
  {
    name: 'square-binary',
    label: 'Square Binary',
    unicode: 'e69b',
    styles: ['solid'],
    searchTerms: [
      'ai',
      'data',
      'language',
      'llm',
      'model',
      'programming',
      'token',
    ],
    categories: ['coding', 'shapes'],
  },
  {
    name: 'square-bluesky',
    label: 'Square Bluesky',
    unicode: 'e6a3',
    styles: ['brands'],
    searchTerms: ['social network'],
    categories: ['social'],
  },
  {
    name: 'square-caret-down',
    label: 'Square Caret Down',
    unicode: 'f150',
    styles: ['regular', 'solid'],
    searchTerms: [
      'arrow',
      'caret-square-o-down',
      'dropdown',
      'expand',
      'insert',
      'menu',
      'more',
      'triangle',
    ],
    categories: ['arrows'],
    aliases: ['caret-square-down'],
  },
  {
    name: 'square-caret-left',
    label: 'Square Caret Left',
    unicode: 'f191',
    styles: ['regular', 'solid'],
    searchTerms: [
      'arrow',
      'back',
      'caret-square-o-left',
      'previous',
      'triangle',
    ],
    categories: ['arrows'],
    aliases: ['caret-square-left'],
  },
  {
    name: 'square-caret-right',
    label: 'Square Caret Right',
    unicode: 'f152',
    styles: ['regular', 'solid'],
    searchTerms: [
      'arrow',
      'caret-square-o-right',
      'forward',
      'next',
      'triangle',
    ],
    categories: ['arrows'],
    aliases: ['caret-square-right'],
  },
  {
    name: 'square-caret-up',
    label: 'Square Caret Up',
    unicode: 'f151',
    styles: ['regular', 'solid'],
    searchTerms: [
      'arrow',
      'caret-square-o-up',
      'collapse',
      'triangle',
      'upgrade',
      'upload',
    ],
    categories: ['arrows'],
    aliases: ['caret-square-up'],
  },
  {
    name: 'square-check',
    label: 'Square Check',
    unicode: 'f14a',
    styles: ['regular', 'solid'],
    searchTerms: [
      'accept',
      'agree',
      'box',
      'button',
      'check',
      'check box with check',
      'check mark button',
      'checkmark',
      'confirm',
      'correct',
      'coupon',
      'done',
      'enable',
      'mark',
      'ok',
      'select',
      'success',
      'tick',
      'todo',
      'validate',
      'working',
      'yes',
      '✓',
    ],
    categories: ['editing', 'text-formatting'],
    aliases: ['check-square'],
  },
  {
    name: 'square-dribbble',
    label: 'Square Dribbble',
    unicode: 'f397',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['dribbble-square'],
  },
  {
    name: 'square-envelope',
    label: 'Square Envelope',
    unicode: 'f199',
    styles: ['solid'],
    searchTerms: [
      'e-mail',
      'email',
      'letter',
      'mail',
      'message',
      'notification',
      'offer',
      'support',
    ],
    categories: ['business', 'communication'],
    aliases: ['envelope-square'],
  },
  {
    name: 'square-facebook',
    label: 'Square Facebook',
    unicode: 'f082',
    styles: ['brands'],
    searchTerms: ['fabook', 'fb', 'social network'],
    categories: [],
    aliases: ['facebook-square'],
  },
  {
    name: 'square-font-awesome',
    label: 'Square Font Awesome',
    unicode: 'e5ad',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'square-font-awesome-stroke',
    label: 'Square Font Awesome Stroke',
    unicode: 'f35c',
    styles: ['brands'],
    searchTerms: ['awesome', 'flag', 'font', 'icons', 'typeface'],
    categories: [],
    aliases: ['font-awesome-alt'],
  },
  {
    name: 'square-full',
    label: 'Square Full',
    unicode: 'f45c',
    styles: ['regular', 'solid'],
    searchTerms: [
      'black large square',
      'block',
      'blue',
      'blue square',
      'box',
      'brown',
      'brown square',
      'geometric',
      'green',
      'green square',
      'orange',
      'orange square',
      'purple',
      'purple square',
      'red',
      'red square',
      'shape',
      'square',
      'white large square',
      'yellow',
      'yellow square',
    ],
    categories: ['gaming'],
  },
  {
    name: 'square-git',
    label: 'Square Git',
    unicode: 'f1d2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['git-square'],
  },
  {
    name: 'square-github',
    label: 'Square Github',
    unicode: 'f092',
    styles: ['brands'],
    searchTerms: ['octocat'],
    categories: [],
    aliases: ['github-square'],
  },
  {
    name: 'square-gitlab',
    label: 'Square Gitlab',
    unicode: 'e5ae',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['gitlab-square'],
  },
  {
    name: 'square-google-plus',
    label: 'Square Google Plus',
    unicode: 'f0d4',
    styles: ['brands'],
    searchTerms: ['social network'],
    categories: [],
    aliases: ['google-plus-square'],
  },
  {
    name: 'square-h',
    label: 'Square H',
    unicode: 'f0fd',
    styles: ['solid'],
    searchTerms: [
      'directions',
      'emergency',
      'hospital',
      'hotel',
      'letter',
      'map',
    ],
    categories: ['alphabet', 'maps', 'medical-health'],
    aliases: ['h-square'],
  },
  {
    name: 'square-hacker-news',
    label: 'Square Hacker News',
    unicode: 'f3af',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['hacker-news-square'],
  },
  {
    name: 'square-instagram',
    label: 'Square Instagram',
    unicode: 'e055',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['instagram-square'],
  },
  {
    name: 'square-js',
    label: 'Square Js',
    unicode: 'f3b9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['js-square'],
  },
  {
    name: 'square-lastfm',
    label: 'Square Lastfm',
    unicode: 'f203',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['lastfm-square'],
  },
  {
    name: 'square-letterboxd',
    label: 'Square Letterboxd',
    unicode: 'e62e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'square-minus',
    label: 'Square Minus',
    unicode: 'f146',
    styles: ['regular', 'solid'],
    searchTerms: [
      'collapse',
      'delete',
      'hide',
      'minify',
      'negative',
      'remove',
      'shape',
      'trash',
    ],
    categories: ['mathematics'],
    aliases: ['minus-square'],
  },
  {
    name: 'square-nfi',
    label: 'Square Nfi',
    unicode: 'e576',
    styles: ['solid'],
    searchTerms: ['non-food item', 'supplies'],
    categories: ['humanitarian', 'logistics'],
  },
  {
    name: 'square-odnoklassniki',
    label: 'Square Odnoklassniki',
    unicode: 'f264',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['odnoklassniki-square'],
  },
  {
    name: 'square-parking',
    label: 'Square Parking',
    unicode: 'f540',
    styles: ['solid'],
    searchTerms: ['auto', 'car', 'garage', 'meter', 'parking'],
    categories: ['maps'],
    aliases: ['parking'],
  },
  {
    name: 'square-pen',
    label: 'Square Pen',
    unicode: 'f14b',
    styles: ['solid'],
    searchTerms: ['edit', 'modify', 'pencil-square', 'update', 'write'],
    categories: ['business', 'editing', 'writing'],
    aliases: ['pen-square', 'pencil-square'],
  },
  {
    name: 'square-person-confined',
    label: 'Square Person Confined',
    unicode: 'e577',
    styles: ['solid'],
    searchTerms: ['captivity', 'confined', 'uer'],
    categories: ['humanitarian', 'security', 'users-people'],
  },
  {
    name: 'square-phone',
    label: 'Square Phone',
    unicode: 'f098',
    styles: ['solid'],
    searchTerms: [
      'call',
      'earphone',
      'number',
      'support',
      'telephone',
      'voice',
    ],
    categories: ['business', 'communication', 'maps'],
    aliases: ['phone-square'],
  },
  {
    name: 'square-phone-flip',
    label: 'Square Phone Flip',
    unicode: 'f87b',
    styles: ['solid'],
    searchTerms: [
      'call',
      'earphone',
      'number',
      'support',
      'telephone',
      'voice',
    ],
    categories: ['business', 'communication', 'maps'],
    aliases: ['phone-square-alt'],
  },
  {
    name: 'square-pied-piper',
    label: 'Pied Piper Square Logo (Old)',
    unicode: 'e01e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['pied-piper-square'],
  },
  {
    name: 'square-pinterest',
    label: 'Square Pinterest',
    unicode: 'f0d3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['pinterest-square'],
  },
  {
    name: 'square-plus',
    label: 'Square Plus',
    unicode: 'f0fe',
    styles: ['regular', 'solid'],
    searchTerms: ['add', 'create', 'expand', 'new', 'positive', 'shape'],
    categories: ['maps', 'medical-health'],
    aliases: ['plus-square'],
  },
  {
    name: 'square-poll-horizontal',
    label: 'Square Poll Horizontal',
    unicode: 'f682',
    styles: ['solid'],
    searchTerms: [
      'chart',
      'graph',
      'results',
      'statistics',
      'survey',
      'trend',
      'vote',
      'voting',
    ],
    categories: ['business', 'charts-diagrams', 'marketing', 'social'],
    aliases: ['poll-h'],
  },
  {
    name: 'square-poll-vertical',
    label: 'Square Poll Vertical',
    unicode: 'f681',
    styles: ['solid'],
    searchTerms: [
      'chart',
      'graph',
      'results',
      'revenue',
      'statistics',
      'survey',
      'trend',
      'vote',
      'voting',
    ],
    categories: ['business', 'charts-diagrams', 'marketing', 'social'],
    aliases: ['poll'],
  },
  {
    name: 'square-reddit',
    label: 'Square Reddit',
    unicode: 'f1a2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['reddit-square'],
  },
  {
    name: 'square-root-variable',
    label: 'Square Root Variable',
    unicode: 'f698',
    styles: ['solid'],
    searchTerms: ['arithmetic', 'calculus', 'division', 'math'],
    categories: ['mathematics'],
    aliases: ['square-root-alt'],
  },
  {
    name: 'square-rss',
    label: 'Square Rss',
    unicode: 'f143',
    styles: ['solid'],
    searchTerms: ['blog', 'feed', 'journal', 'news', 'writing'],
    categories: ['communication', 'film-video'],
    aliases: ['rss-square'],
  },
  {
    name: 'square-share-nodes',
    label: 'Square Share Nodes',
    unicode: 'f1e1',
    styles: ['solid'],
    searchTerms: ['forward', 'save', 'send', 'social'],
    categories: ['social'],
    aliases: ['share-alt-square'],
  },
  {
    name: 'square-snapchat',
    label: 'Snapchat Square',
    unicode: 'f2ad',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['snapchat-square'],
  },
  {
    name: 'square-steam',
    label: 'Square Steam',
    unicode: 'f1b7',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
    aliases: ['steam-square'],
  },
  {
    name: 'square-threads',
    label: 'Square Threads',
    unicode: 'e619',
    styles: ['brands'],
    searchTerms: ['social network'],
    categories: [],
  },
  {
    name: 'square-tumblr',
    label: 'Square Tumblr',
    unicode: 'f174',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['tumblr-square'],
  },
  {
    name: 'square-twitter',
    label: 'Square Twitter',
    unicode: 'f081',
    styles: ['brands'],
    searchTerms: ['social network', 'tweet'],
    categories: [],
    aliases: ['twitter-square'],
  },
  {
    name: 'square-up-right',
    label: 'Square Up Right',
    unicode: 'f360',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'diagonal',
      'direction',
      'external-link-square',
      'intercardinal',
      'new',
      'northeast',
      'open',
      'share',
      'up-right arrow',
    ],
    categories: ['arrows'],
    aliases: ['external-link-square-alt'],
  },
  {
    name: 'square-upwork',
    label: 'Square Upwork',
    unicode: 'e67c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'square-viadeo',
    label: 'Square Viadeo',
    unicode: 'f2aa',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['viadeo-square'],
  },
  {
    name: 'square-vimeo',
    label: 'Square Vimeo',
    unicode: 'f194',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['vimeo-square'],
  },
  {
    name: 'square-virus',
    label: 'Square Virus',
    unicode: 'e578',
    styles: ['solid'],
    searchTerms: [
      'coronavirus',
      'covid-19',
      'disease',
      'flu',
      'infection',
      'pandemic',
    ],
    categories: ['humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'square-web-awesome',
    label: 'Square Web Awesome',
    unicode: 'e683',
    styles: ['brands'],
    searchTerms: ['awesome', 'coding', 'components', 'crown', 'web'],
    categories: [],
  },
  {
    name: 'square-web-awesome-stroke',
    label: 'Square Web Awesome Stroke',
    unicode: 'e684',
    styles: ['brands'],
    searchTerms: ['awesome', 'coding', 'components', 'crown', 'web'],
    categories: [],
  },
  {
    name: 'square-whatsapp',
    label: 'Square Whatsapp',
    unicode: 'f40c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['whatsapp-square'],
  },
  {
    name: 'square-x-twitter',
    label: 'Square X Twitter',
    unicode: 'e61a',
    styles: ['brands'],
    searchTerms: ['elon', 'twitter', 'x'],
    categories: [],
  },
  {
    name: 'square-xing',
    label: 'Square Xing',
    unicode: 'f169',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['xing-square'],
  },
  {
    name: 'square-xmark',
    label: 'Square Xmark',
    unicode: 'f2d3',
    styles: ['solid'],
    searchTerms: [
      'close',
      'cross',
      'cross mark button',
      'incorrect',
      'mark',
      'notice',
      'notification',
      'notify',
      'problem',
      'square',
      'uncheck',
      'window',
      'wrong',
      'x',
      '×',
    ],
    categories: ['mathematics'],
    aliases: ['times-square', 'xmark-square'],
  },
  {
    name: 'square-youtube',
    label: 'Square Youtube',
    unicode: 'f431',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['youtube-square'],
  },
  {
    name: 'squarespace',
    label: 'Squarespace',
    unicode: 'f5be',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'stack-exchange',
    label: 'Stack Exchange',
    unicode: 'f18d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'stack-overflow',
    label: 'Stack Overflow',
    unicode: 'f16c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'stackpath',
    label: 'Stackpath',
    unicode: 'f842',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'staff-snake',
    label: 'Staff Snake',
    unicode: 'e579',
    styles: ['solid'],
    searchTerms: ['asclepius', 'asklepian', 'health', 'serpent', 'wellness'],
    categories: ['humanitarian', 'medical-health'],
    aliases: ['rod-asclepius', 'rod-snake', 'staff-aesculapius'],
  },
  {
    name: 'stairs',
    label: 'Stairs',
    unicode: 'e289',
    styles: ['solid'],
    searchTerms: ['exit', 'steps', 'up'],
    categories: ['household', 'travel-hotel'],
  },
  {
    name: 'stamp',
    label: 'Stamp',
    unicode: 'f5bf',
    styles: ['solid'],
    searchTerms: ['art', 'certificate', 'imprint', 'rubber', 'seal'],
    categories: ['design', 'money'],
  },
  {
    name: 'stapler',
    label: 'Stapler',
    unicode: 'e5af',
    styles: ['solid'],
    searchTerms: ['desktop', 'milton', 'office', 'paperclip', 'staple'],
    categories: ['business', 'design'],
  },
  {
    name: 'star',
    label: 'Star',
    unicode: 'f005',
    styles: ['regular', 'solid'],
    searchTerms: [
      'achievement',
      'award',
      'favorite',
      'important',
      'night',
      'quality',
      'rating',
      'score',
      'star',
      'vip',
    ],
    categories: ['shapes', 'shopping', 'social', 'toggle'],
  },
  {
    name: 'star-and-crescent',
    label: 'Star And Crescent',
    unicode: 'f699',
    styles: ['solid'],
    searchTerms: ['Muslim', 'islam', 'muslim', 'religion', 'star and crescent'],
    categories: ['religion'],
  },
  {
    name: 'star-half',
    label: 'Star Half',
    unicode: 'f089',
    styles: ['regular', 'solid'],
    searchTerms: [
      'achievement',
      'award',
      'rating',
      'score',
      'star-half-empty',
      'star-half-full',
    ],
    categories: ['toggle'],
  },
  {
    name: 'star-half-stroke',
    label: 'Star Half Stroke',
    unicode: 'f5c0',
    styles: ['regular', 'solid'],
    searchTerms: [
      'achievement',
      'award',
      'rating',
      'score',
      'star-half-empty',
      'star-half-full',
    ],
    categories: ['toggle'],
    aliases: ['star-half-alt'],
  },
  {
    name: 'star-of-david',
    label: 'Star Of David',
    unicode: 'f69a',
    styles: ['solid'],
    searchTerms: [
      'David',
      'Jew',
      'Jewish',
      'jewish',
      'judaism',
      'religion',
      'star',
      'star of David',
    ],
    categories: ['religion'],
  },
  {
    name: 'star-of-life',
    label: 'Star Of Life',
    unicode: 'f621',
    styles: ['solid'],
    searchTerms: ['doctor', 'emt', 'first aid', 'health', 'medical'],
    categories: ['medical-health'],
  },
  {
    name: 'staylinked',
    label: 'StayLinked',
    unicode: 'f3f5',
    styles: ['brands'],
    searchTerms: ['linkin'],
    categories: [],
  },
  {
    name: 'steam',
    label: 'Steam',
    unicode: 'f1b6',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
  },
  {
    name: 'steam-symbol',
    label: 'Steam Symbol',
    unicode: 'f3f6',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
  },
  {
    name: 'sterling-sign',
    label: 'Sterling Sign',
    unicode: 'f154',
    styles: ['solid'],
    searchTerms: ['Pound Sign', 'currency'],
    categories: ['money'],
    aliases: ['gbp', 'pound-sign'],
  },
  {
    name: 'stethoscope',
    label: 'Stethoscope',
    unicode: 'f0f1',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'diagnosis',
      'doctor',
      'general practitioner',
      'heart',
      'hospital',
      'infirmary',
      'medicine',
      'office',
      'outpatient',
      'stethoscope',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'sticker-mule',
    label: 'Sticker Mule',
    unicode: 'f3f7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'stop',
    label: 'Stop',
    unicode: 'f04d',
    styles: ['solid'],
    searchTerms: ['block', 'box', 'square', 'stop', 'stop button'],
    categories: ['media-playback'],
  },
  {
    name: 'stopwatch',
    label: 'Stopwatch',
    unicode: 'f2f2',
    styles: ['solid'],
    searchTerms: ['clock', 'reminder', 'stopwatch', 'time', 'waiting'],
    categories: ['time'],
  },
  {
    name: 'stopwatch-20',
    label: 'Stopwatch 20',
    unicode: 'e06f',
    styles: ['solid'],
    searchTerms: [
      'ABCs',
      'countdown',
      'covid-19',
      'happy birthday',
      'i will survive',
      'reminder',
      'seconds',
      'time',
      'timer',
    ],
    categories: ['sports-fitness', 'time'],
  },
  {
    name: 'store',
    label: 'Store',
    unicode: 'f54e',
    styles: ['solid'],
    searchTerms: [
      'bodega',
      'building',
      'buy',
      'market',
      'purchase',
      'shopping',
      'store',
    ],
    categories: ['buildings', 'shopping'],
  },
  {
    name: 'store-slash',
    label: 'Store Slash',
    unicode: 'e071',
    styles: ['solid'],
    searchTerms: [
      'building',
      'buy',
      'closed',
      'covid-19',
      'disabled',
      'purchase',
      'shopping',
    ],
    categories: ['shopping'],
  },
  {
    name: 'strava',
    label: 'Strava',
    unicode: 'f428',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'street-view',
    label: 'Street View',
    unicode: 'f21d',
    styles: ['solid'],
    searchTerms: ['directions', 'location', 'map', 'navigation', 'uer'],
    categories: ['maps', 'users-people'],
  },
  {
    name: 'strikethrough',
    label: 'Strikethrough',
    unicode: 'f0cc',
    styles: ['solid'],
    searchTerms: ['cancel', 'edit', 'font', 'format', 'modify', 'text', 'type'],
    categories: ['text-formatting'],
  },
  {
    name: 'stripe',
    label: 'Stripe',
    unicode: 'f429',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'stripe-s',
    label: 'Stripe S',
    unicode: 'f42a',
    styles: ['brands'],
    searchTerms: [],
    categories: ['shopping'],
  },
  {
    name: 'stroopwafel',
    label: 'Stroopwafel',
    unicode: 'f551',
    styles: ['solid'],
    searchTerms: ['caramel', 'cookie', 'dessert', 'sweets', 'waffle'],
    categories: ['food-beverage', 'spinners'],
  },
  {
    name: 'stubber',
    label: 'Stubber',
    unicode: 'e5c7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'studiovinari',
    label: 'Studio Vinari',
    unicode: 'f3f8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'stumbleupon',
    label: 'StumbleUpon Logo',
    unicode: 'f1a4',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'stumbleupon-circle',
    label: 'StumbleUpon Circle',
    unicode: 'f1a3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'subscript',
    label: 'Subscript',
    unicode: 'f12c',
    styles: ['solid'],
    searchTerms: ['edit', 'font', 'format', 'text', 'type'],
    categories: ['mathematics', 'text-formatting'],
  },
  {
    name: 'suitcase',
    label: 'Suitcase',
    unicode: 'f0f2',
    styles: ['solid'],
    searchTerms: [
      'baggage',
      'luggage',
      'move',
      'packing',
      'suitcase',
      'travel',
      'trip',
    ],
    categories: ['maps', 'moving', 'travel-hotel'],
  },
  {
    name: 'suitcase-medical',
    label: 'Suitcase Medical',
    unicode: 'f0fa',
    styles: ['solid'],
    searchTerms: [
      'first aid',
      'firstaid',
      'health',
      'help',
      'medical',
      'supply',
      'support',
    ],
    categories: ['humanitarian', 'maps', 'medical-health'],
    aliases: ['medkit'],
  },
  {
    name: 'suitcase-rolling',
    label: 'Suitcase Rolling',
    unicode: 'f5c1',
    styles: ['solid'],
    searchTerms: ['baggage', 'luggage', 'move', 'suitcase', 'travel', 'trip'],
    categories: ['travel-hotel'],
  },
  {
    name: 'sun',
    label: 'Sun',
    unicode: 'f185',
    styles: ['regular', 'solid'],
    searchTerms: [
      'bright',
      'brighten',
      'contrast',
      'day',
      'lighter',
      'rays',
      'sol',
      'solar',
      'star',
      'sun',
      'sunny',
      'weather',
    ],
    categories: ['energy', 'spinners', 'weather'],
  },
  {
    name: 'sun-plant-wilt',
    label: 'Sun Plant Wilt',
    unicode: 'e57a',
    styles: ['solid'],
    searchTerms: ['arid', 'droop', 'drought'],
    categories: ['disaster', 'humanitarian', 'weather'],
  },
  {
    name: 'superpowers',
    label: 'Superpowers',
    unicode: 'f2dd',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'superscript',
    label: 'Superscript',
    unicode: 'f12b',
    styles: ['solid'],
    searchTerms: ['edit', 'exponential', 'font', 'format', 'text', 'type'],
    categories: ['mathematics', 'text-formatting'],
  },
  {
    name: 'supple',
    label: 'Supple',
    unicode: 'f3f9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'suse',
    label: 'Suse',
    unicode: 'f7d6',
    styles: ['brands'],
    searchTerms: ['linux', 'operating system', 'os'],
    categories: [],
  },
  {
    name: 'swatchbook',
    label: 'Swatchbook',
    unicode: 'f5c3',
    styles: ['solid'],
    searchTerms: ['Pantone', 'color', 'design', 'hue', 'palette'],
    categories: ['design'],
  },
  {
    name: 'swift',
    label: 'Swift',
    unicode: 'f8e1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'symfony',
    label: 'Symfony',
    unicode: 'f83d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'synagogue',
    label: 'Synagogue',
    unicode: 'f69b',
    styles: ['solid'],
    searchTerms: [
      'Jew',
      'Jewish',
      'building',
      'jewish',
      'judaism',
      'religion',
      'star of david',
      'synagogue',
      'temple',
    ],
    categories: ['buildings', 'religion'],
  },
  {
    name: 'syringe',
    label: 'Syringe',
    unicode: 'f48e',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'doctor',
      'immunizations',
      'medical',
      'medicine',
      'needle',
      'shot',
      'sick',
      'syringe',
      'vaccinate',
      'vaccine',
    ],
    categories: ['humanitarian', 'medical-health', 'science'],
  },
  {
    name: 't',
    label: 'T',
    unicode: '54',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter T', 'Latin Small Letter T', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'table',
    label: 'Table',
    unicode: 'f0ce',
    styles: ['solid'],
    searchTerms: ['category', 'data', 'excel', 'spreadsheet'],
    categories: ['business', 'text-formatting'],
  },
  {
    name: 'table-cells',
    label: 'Table Cells',
    unicode: 'f00a',
    styles: ['solid'],
    searchTerms: [
      'blocks',
      'boxes',
      'category',
      'excel',
      'grid',
      'spreadsheet',
      'squares',
    ],
    categories: ['text-formatting'],
    aliases: ['th'],
  },
  {
    name: 'table-cells-column-lock',
    label: 'Table Cells Column Lock',
    unicode: 'e678',
    styles: ['solid'],
    searchTerms: [
      'blocks',
      'boxes',
      'category',
      'column',
      'excel',
      'grid',
      'lock',
      'spreadsheet',
      'squares',
    ],
    categories: ['text-formatting'],
  },
  {
    name: 'table-cells-large',
    label: 'Table Cells Large',
    unicode: 'f009',
    styles: ['solid'],
    searchTerms: [
      'blocks',
      'boxes',
      'category',
      'excel',
      'grid',
      'spreadsheet',
      'squares',
    ],
    categories: ['text-formatting'],
    aliases: ['th-large'],
  },
  {
    name: 'table-cells-row-lock',
    label: 'Table Cells Row Lock',
    unicode: 'e67a',
    styles: ['solid'],
    searchTerms: [
      'blocks',
      'boxes',
      'category',
      'column',
      'column',
      'excel',
      'grid',
      'lock',
      'lock',
      'spreadsheet',
      'squares',
    ],
    categories: ['text-formatting'],
  },
  {
    name: 'table-cells-row-unlock',
    label: 'Table Cells Row Unlock',
    unicode: 'e691',
    styles: ['solid'],
    searchTerms: [
      'blocks',
      'boxes',
      'category',
      'column',
      'column',
      'excel',
      'grid',
      'lock',
      'lock',
      'spreadsheet',
      'squares',
      'unlock',
    ],
    categories: ['text-formatting'],
  },
  {
    name: 'table-columns',
    label: 'Table Columns',
    unicode: 'f0db',
    styles: ['solid'],
    searchTerms: [
      'browser',
      'category',
      'dashboard',
      'organize',
      'panes',
      'split',
    ],
    categories: ['business', 'text-formatting'],
    aliases: ['columns'],
  },
  {
    name: 'table-list',
    label: 'Table List',
    unicode: 'f00b',
    styles: ['solid'],
    searchTerms: [
      'category',
      'cheatsheet',
      'checklist',
      'completed',
      'done',
      'finished',
      'ol',
      'summary',
      'todo',
      'ul',
    ],
    categories: ['text-formatting'],
    aliases: ['th-list'],
  },
  {
    name: 'table-tennis-paddle-ball',
    label: 'Table Tennis Paddle Ball',
    unicode: 'f45d',
    styles: ['solid'],
    searchTerms: ['ball', 'bat', 'game', 'paddle', 'ping pong', 'table tennis'],
    categories: ['sports-fitness'],
    aliases: ['ping-pong-paddle-ball', 'table-tennis'],
  },
  {
    name: 'tablet',
    label: 'Tablet',
    unicode: 'f3fb',
    styles: ['solid'],
    searchTerms: ['device', 'kindle', 'screen'],
    categories: ['devices-hardware'],
    aliases: ['tablet-android'],
  },
  {
    name: 'tablet-button',
    label: 'Tablet Button',
    unicode: 'f10a',
    styles: ['solid'],
    searchTerms: ['apple', 'device', 'ipad', 'kindle', 'screen'],
    categories: ['devices-hardware'],
  },
  {
    name: 'tablet-screen-button',
    label: 'Tablet Screen Button',
    unicode: 'f3fa',
    styles: ['solid'],
    searchTerms: ['apple', 'device', 'ipad', 'kindle', 'screen'],
    categories: ['devices-hardware'],
    aliases: ['tablet-alt'],
  },
  {
    name: 'tablets',
    label: 'Tablets',
    unicode: 'f490',
    styles: ['solid'],
    searchTerms: ['drugs', 'medicine', 'pills', 'prescription'],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'tachograph-digital',
    label: 'Tachograph Digital',
    unicode: 'f566',
    styles: ['solid'],
    searchTerms: ['data', 'distance', 'speed', 'tachometer'],
    categories: ['devices-hardware'],
    aliases: ['digital-tachograph'],
  },
  {
    name: 'tag',
    label: 'Tag',
    unicode: 'f02b',
    styles: ['solid'],
    searchTerms: ['discount', 'labe', 'label', 'price', 'shopping'],
    categories: ['business', 'maps', 'shopping'],
  },
  {
    name: 'tags',
    label: 'Tags',
    unicode: 'f02c',
    styles: ['solid'],
    searchTerms: ['discount', 'label', 'price', 'shopping'],
    categories: ['business', 'maps', 'shopping'],
  },
  {
    name: 'tape',
    label: 'Tape',
    unicode: 'f4db',
    styles: ['solid'],
    searchTerms: ['design', 'package', 'sticky'],
    categories: ['moving'],
  },
  {
    name: 'tarp',
    label: 'Tarp',
    unicode: 'e57b',
    styles: ['solid'],
    searchTerms: ['protection', 'tarp', 'tent', 'waterproof'],
    categories: ['camping', 'construction', 'humanitarian'],
  },
  {
    name: 'tarp-droplet',
    label: 'Tarp Droplet',
    unicode: 'e57c',
    styles: ['solid'],
    searchTerms: ['protection', 'tarp', 'tent', 'waterproof'],
    categories: ['camping', 'construction', 'humanitarian'],
  },
  {
    name: 'taxi',
    label: 'Taxi',
    unicode: 'f1ba',
    styles: ['solid'],
    searchTerms: [
      'cab',
      'cabbie',
      'car',
      'car service',
      'lyft',
      'machine',
      'oncoming',
      'oncoming taxi',
      'taxi',
      'transportation',
      'travel',
      'uber',
      'vehicle',
    ],
    categories: ['automotive', 'maps', 'transportation', 'travel-hotel'],
    aliases: ['cab'],
  },
  {
    name: 'teamspeak',
    label: 'Teamspeak',
    unicode: 'f4f9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'teeth',
    label: 'Teeth',
    unicode: 'f62e',
    styles: ['solid'],
    searchTerms: [
      'bite',
      'dental',
      'dentist',
      'gums',
      'mouth',
      'smile',
      'tooth',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'teeth-open',
    label: 'Teeth Open',
    unicode: 'f62f',
    styles: ['solid'],
    searchTerms: ['dental', 'dentist', 'gums bite', 'mouth', 'smile', 'tooth'],
    categories: ['medical-health'],
  },
  {
    name: 'telegram',
    label: 'Telegram',
    unicode: 'f2c6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['telegram-plane'],
  },
  {
    name: 'temperature-arrow-down',
    label: 'Temperature Arrow Down',
    unicode: 'e03f',
    styles: ['solid'],
    searchTerms: [
      'air conditioner',
      'cold',
      'heater',
      'mercury',
      'thermometer',
      'winter',
    ],
    categories: ['disaster', 'household', 'humanitarian', 'weather'],
    aliases: ['temperature-down'],
  },
  {
    name: 'temperature-arrow-up',
    label: 'Temperature Arrow Up',
    unicode: 'e040',
    styles: ['solid'],
    searchTerms: [
      'air conditioner',
      'cold',
      'heater',
      'mercury',
      'thermometer',
      'winter',
    ],
    categories: ['disaster', 'household', 'humanitarian', 'weather'],
    aliases: ['temperature-up'],
  },
  {
    name: 'temperature-empty',
    label: 'Temperature Empty',
    unicode: 'f2cb',
    styles: ['solid'],
    searchTerms: ['cold', 'mercury', 'status', 'temperature'],
    categories: ['weather'],
    aliases: ['temperature-0', 'thermometer-0', 'thermometer-empty'],
  },
  {
    name: 'temperature-full',
    label: 'Temperature Full',
    unicode: 'f2c7',
    styles: ['solid'],
    searchTerms: ['fever', 'hot', 'mercury', 'status', 'temperature'],
    categories: ['weather'],
    aliases: ['temperature-4', 'thermometer-4', 'thermometer-full'],
  },
  {
    name: 'temperature-half',
    label: 'Temperature Half',
    unicode: 'f2c9',
    styles: ['solid'],
    searchTerms: ['mercury', 'status', 'temperature', 'thermometer', 'weather'],
    categories: ['weather'],
    aliases: ['temperature-2', 'thermometer-2', 'thermometer-half'],
  },
  {
    name: 'temperature-high',
    label: 'Temperature High',
    unicode: 'f769',
    styles: ['solid'],
    searchTerms: [
      'cook',
      'covid-19',
      'mercury',
      'summer',
      'thermometer',
      'warm',
    ],
    categories: ['science', 'weather'],
  },
  {
    name: 'temperature-low',
    label: 'Temperature Low',
    unicode: 'f76b',
    styles: ['solid'],
    searchTerms: [
      'cold',
      'cool',
      'covid-19',
      'mercury',
      'thermometer',
      'winter',
    ],
    categories: ['science', 'weather'],
  },
  {
    name: 'temperature-quarter',
    label: 'Temperature Quarter',
    unicode: 'f2ca',
    styles: ['solid'],
    searchTerms: ['mercury', 'status', 'temperature'],
    categories: ['weather'],
    aliases: ['temperature-1', 'thermometer-1', 'thermometer-quarter'],
  },
  {
    name: 'temperature-three-quarters',
    label: 'Temperature Three Quarters',
    unicode: 'f2c8',
    styles: ['solid'],
    searchTerms: ['mercury', 'status', 'temperature'],
    categories: ['weather'],
    aliases: ['temperature-3', 'thermometer-3', 'thermometer-three-quarters'],
  },
  {
    name: 'tencent-weibo',
    label: 'Tencent Weibo',
    unicode: 'f1d5',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'tenge-sign',
    label: 'Tenge Sign',
    unicode: 'f7d7',
    styles: ['solid'],
    searchTerms: ['Tenge Sign', 'currency'],
    categories: ['money'],
    aliases: ['tenge'],
  },
  {
    name: 'tent',
    label: 'Tent',
    unicode: 'e57d',
    styles: ['solid'],
    searchTerms: [
      'bivouac',
      'campground',
      'campsite',
      'refugee',
      'shelter',
      'tent',
    ],
    categories: ['buildings', 'camping', 'humanitarian'],
  },
  {
    name: 'tent-arrow-down-to-line',
    label: 'Tent Arrow Down To Line',
    unicode: 'e57e',
    styles: ['solid'],
    searchTerms: [
      'bivouac',
      'campground',
      'campsite',
      'permanent',
      'refugee',
      'refugee',
      'shelter',
      'shelter',
      'tent',
    ],
    categories: ['buildings', 'camping', 'humanitarian'],
  },
  {
    name: 'tent-arrow-left-right',
    label: 'Tent Arrow Left Right',
    unicode: 'e57f',
    styles: ['solid'],
    searchTerms: [
      'bivouac',
      'campground',
      'campsite',
      'refugee',
      'refugee',
      'shelter',
      'shelter',
      'tent',
      'transition',
    ],
    categories: ['buildings', 'camping', 'humanitarian'],
  },
  {
    name: 'tent-arrow-turn-left',
    label: 'Tent Arrow Turn Left',
    unicode: 'e580',
    styles: ['solid'],
    searchTerms: [
      'bivouac',
      'campground',
      'campsite',
      'refugee',
      'refugee',
      'shelter',
      'shelter',
      'temporary',
      'tent',
    ],
    categories: ['buildings', 'camping', 'humanitarian'],
  },
  {
    name: 'tent-arrows-down',
    label: 'Tent Arrows Down',
    unicode: 'e581',
    styles: ['solid'],
    searchTerms: [
      'bivouac',
      'campground',
      'campsite',
      'insert',
      'refugee',
      'refugee',
      'shelter',
      'shelter',
      'spontaneous',
      'tent',
    ],
    categories: ['buildings', 'camping', 'humanitarian'],
  },
  {
    name: 'tents',
    label: 'Tents',
    unicode: 'e582',
    styles: ['solid'],
    searchTerms: [
      'bivouac',
      'bivouac',
      'campground',
      'campground',
      'campsite',
      'refugee',
      'refugee',
      'shelter',
      'shelter',
      'tent',
      'tent',
    ],
    categories: ['buildings', 'camping', 'humanitarian'],
  },
  {
    name: 'terminal',
    label: 'Terminal',
    unicode: 'f120',
    styles: ['solid'],
    searchTerms: [
      'code',
      'coding',
      'command',
      'console',
      'development',
      'prompt',
      'terminal',
    ],
    categories: ['coding'],
  },
  {
    name: 'text-height',
    label: 'Text Height',
    unicode: 'f034',
    styles: ['solid'],
    searchTerms: ['edit', 'font', 'format', 'modify', 'text', 'type'],
    categories: ['text-formatting'],
  },
  {
    name: 'text-slash',
    label: 'Text Slash',
    unicode: 'f87d',
    styles: ['solid'],
    searchTerms: [
      'cancel',
      'disabled',
      'font',
      'format',
      'remove',
      'style',
      'text',
    ],
    categories: ['text-formatting'],
    aliases: ['remove-format'],
  },
  {
    name: 'text-width',
    label: 'Text Width',
    unicode: 'f035',
    styles: ['solid'],
    searchTerms: ['edit', 'font', 'format', 'modify', 'text', 'type'],
    categories: ['text-formatting'],
  },
  {
    name: 'the-red-yeti',
    label: 'The Red Yeti',
    unicode: 'f69d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'themeco',
    label: 'Themeco',
    unicode: 'f5c6',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'themeisle',
    label: 'ThemeIsle',
    unicode: 'f2b2',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'thermometer',
    label: 'Thermometer',
    unicode: 'f491',
    styles: ['solid'],
    searchTerms: ['covid-19', 'mercury', 'status', 'temperature'],
    categories: ['medical-health'],
  },
  {
    name: 'think-peaks',
    label: 'Think Peaks',
    unicode: 'f731',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'threads',
    label: 'Threads',
    unicode: 'e618',
    styles: ['brands'],
    searchTerms: ['social network'],
    categories: [],
  },
  {
    name: 'thumbs-down',
    label: 'Thumbs Down',
    unicode: 'f165',
    styles: ['regular', 'solid'],
    searchTerms: [
      '-1',
      'disagree',
      'disapprove',
      'dislike',
      'down',
      'hand',
      'social',
      'thumb',
      'thumbs down',
      'thumbs-o-down',
    ],
    categories: ['hands', 'shopping', 'social'],
  },
  {
    name: 'thumbs-up',
    label: 'Thumbs Up',
    unicode: 'f164',
    styles: ['regular', 'solid'],
    searchTerms: [
      '+1',
      'agree',
      'approve',
      'favorite',
      'hand',
      'like',
      'ok',
      'okay',
      'social',
      'success',
      'thumb',
      'thumbs up',
      'thumbs-o-up',
      'up',
      'yes',
      'you got it dude',
    ],
    categories: ['hands', 'shopping', 'social'],
  },
  {
    name: 'thumbtack',
    label: 'Thumbtack',
    unicode: 'f08d',
    styles: ['solid'],
    searchTerms: [
      'Black Pushpin',
      'coordinates',
      'location',
      'marker',
      'pin',
      'pushpin',
      'thumb-tack',
    ],
    categories: ['business', 'maps', 'social', 'writing'],
    aliases: ['thumb-tack'],
  },
  {
    name: 'thumbtack-slash',
    label: 'Thumbtack Slash',
    unicode: 'e68f',
    styles: ['solid'],
    searchTerms: [
      'Black Pushpin',
      'coordinates',
      'location',
      'marker',
      'pin',
      'pushpin',
      'thumb-tack',
      'unpin',
    ],
    categories: ['business', 'maps', 'social', 'writing'],
    aliases: ['thumb-tack-slash'],
  },
  {
    name: 'ticket',
    label: 'Ticket',
    unicode: 'f145',
    styles: ['solid'],
    searchTerms: [
      'admission',
      'admission tickets',
      'coupon',
      'movie',
      'pass',
      'support',
      'ticket',
      'voucher',
    ],
    categories: ['film-video', 'maps'],
  },
  {
    name: 'ticket-simple',
    label: 'Ticket Simple',
    unicode: 'f3ff',
    styles: ['solid'],
    searchTerms: [
      'admission',
      'coupon',
      'movie',
      'pass',
      'support',
      'ticket',
      'voucher',
    ],
    categories: ['maps', 'shapes'],
    aliases: ['ticket-alt'],
  },
  {
    name: 'tiktok',
    label: 'TikTok',
    unicode: 'e07b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'timeline',
    label: 'Timeline',
    unicode: 'e29c',
    styles: ['solid'],
    searchTerms: ['chronological', 'deadline', 'history', 'linear'],
    categories: ['business', 'marketing'],
  },
  {
    name: 'toggle-off',
    label: 'Toggle Off',
    unicode: 'f204',
    styles: ['solid'],
    searchTerms: ['button', 'off', 'on', 'switch'],
    categories: ['toggle'],
  },
  {
    name: 'toggle-on',
    label: 'Toggle On',
    unicode: 'f205',
    styles: ['solid'],
    searchTerms: ['button', 'off', 'on', 'switch'],
    categories: ['toggle'],
  },
  {
    name: 'toilet',
    label: 'Toilet',
    unicode: 'f7d8',
    styles: ['solid'],
    searchTerms: [
      'bathroom',
      'flush',
      'john',
      'loo',
      'pee',
      'plumbing',
      'poop',
      'porcelain',
      'potty',
      'restroom',
      'throne',
      'toile',
      'toilet',
      'washroom',
      'waste',
      'wc',
    ],
    categories: ['household', 'humanitarian', 'travel-hotel'],
  },
  {
    name: 'toilet-paper',
    label: 'Toilet Paper',
    unicode: 'f71e',
    styles: ['solid'],
    searchTerms: [
      'bathroom',
      'covid-19',
      'halloween',
      'holiday',
      'lavatory',
      'paper towels',
      'prank',
      'privy',
      'restroom',
      'roll',
      'roll of paper',
      'toilet',
      'toilet paper',
      'wipe',
    ],
    categories: ['camping', 'halloween', 'household', 'travel-hotel'],
  },
  {
    name: 'toilet-paper-slash',
    label: 'Toilet Paper Slash',
    unicode: 'e072',
    styles: ['solid'],
    searchTerms: [
      'bathroom',
      'covid-19',
      'disabled',
      'halloween',
      'holiday',
      'lavatory',
      'leaves',
      'prank',
      'privy',
      'restroom',
      'roll',
      'toilet',
      'trouble',
      'ut oh',
      'wipe',
    ],
    categories: ['household'],
  },
  {
    name: 'toilet-portable',
    label: 'Toilet Portable',
    unicode: 'e583',
    styles: ['solid'],
    searchTerms: ['outhouse', 'toilet'],
    categories: ['buildings', 'construction', 'humanitarian'],
  },
  {
    name: 'toilets-portable',
    label: 'Toilets Portable',
    unicode: 'e584',
    styles: ['solid'],
    searchTerms: ['outhouse', 'toilet'],
    categories: ['buildings', 'construction', 'humanitarian'],
  },
  {
    name: 'toolbox',
    label: 'Toolbox',
    unicode: 'f552',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'chest',
      'configuration',
      'container',
      'equipment',
      'fix',
      'maintenance',
      'mechanic',
      'modify',
      'repair',
      'settings',
      'tool',
      'toolbox',
      'tools',
    ],
    categories: ['construction'],
  },
  {
    name: 'tooth',
    label: 'Tooth',
    unicode: 'f5c9',
    styles: ['solid'],
    searchTerms: [
      'bicuspid',
      'dental',
      'dentist',
      'molar',
      'mouth',
      'teeth',
      'tooth',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'torii-gate',
    label: 'Torii Gate',
    unicode: 'f6a1',
    styles: ['solid'],
    searchTerms: [
      'building',
      'religion',
      'shinto',
      'shinto shrine',
      'shintoism',
      'shrine',
    ],
    categories: ['buildings', 'religion'],
  },
  {
    name: 'tornado',
    label: 'Tornado',
    unicode: 'f76f',
    styles: ['solid'],
    searchTerms: [
      'cloud',
      'cyclone',
      'dorothy',
      'landspout',
      'tornado',
      'toto',
      'twister',
      'vortext',
      'waterspout',
      'weather',
      'whirlwind',
    ],
    categories: ['disaster', 'humanitarian', 'weather'],
  },
  {
    name: 'tower-broadcast',
    label: 'Tower Broadcast',
    unicode: 'f519',
    styles: ['solid'],
    searchTerms: [
      'airwaves',
      'antenna',
      'communication',
      'emergency',
      'radio',
      'reception',
      'signal',
      'waves',
    ],
    categories: ['connectivity', 'energy', 'film-video', 'humanitarian'],
    aliases: ['broadcast-tower'],
  },
  {
    name: 'tower-cell',
    label: 'Tower Cell',
    unicode: 'e585',
    styles: ['solid'],
    searchTerms: [
      'airwaves',
      'antenna',
      'communication',
      'radio',
      'reception',
      'signal',
      'waves',
    ],
    categories: ['communication', 'connectivity', 'film-video', 'humanitarian'],
  },
  {
    name: 'tower-observation',
    label: 'Tower Observation',
    unicode: 'e586',
    styles: ['solid'],
    searchTerms: ['fire tower', 'view'],
    categories: ['buildings', 'humanitarian', 'security'],
  },
  {
    name: 'tractor',
    label: 'Tractor',
    unicode: 'f722',
    styles: ['solid'],
    searchTerms: ['agriculture', 'farm', 'tractor', 'vehicle'],
    categories: ['transportation'],
  },
  {
    name: 'trade-federation',
    label: 'Trade Federation',
    unicode: 'f513',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'trademark',
    label: 'Trademark',
    unicode: 'f25c',
    styles: ['solid'],
    searchTerms: [
      'copyright',
      'mark',
      'register',
      'symbol',
      'tm',
      'trade mark',
      'trademark',
    ],
    categories: ['business'],
  },
  {
    name: 'traffic-light',
    label: 'Traffic Light',
    unicode: 'f637',
    styles: ['solid'],
    searchTerms: [
      'direction',
      'go',
      'light',
      'road',
      'signal',
      'slow',
      'stop',
      'traffic',
      'travel',
      'vertical traffic light',
    ],
    categories: ['maps'],
  },
  {
    name: 'trailer',
    label: 'Trailer',
    unicode: 'e041',
    styles: ['solid'],
    searchTerms: ['carry', 'haul', 'moving', 'travel'],
    categories: ['automotive', 'camping', 'moving'],
  },
  {
    name: 'train',
    label: 'Train',
    unicode: 'f238',
    styles: ['solid'],
    searchTerms: [
      'bullet',
      'commute',
      'locomotive',
      'railway',
      'subway',
      'train',
    ],
    categories: ['logistics', 'maps', 'transportation'],
  },
  {
    name: 'train-subway',
    label: 'Train Subway',
    unicode: 'f239',
    styles: ['solid'],
    searchTerms: ['machine', 'railway', 'train', 'transportation', 'vehicle'],
    categories: ['humanitarian', 'logistics', 'maps', 'transportation'],
    aliases: ['subway'],
  },
  {
    name: 'train-tram',
    label: 'Train Tram',
    unicode: 'e5b4',
    styles: ['solid'],
    searchTerms: [
      'crossing',
      'machine',
      'mountains',
      'seasonal',
      'tram',
      'transportation',
      'trolleybus',
    ],
    categories: ['maps', 'transportation', 'travel-hotel'],
  },
  {
    name: 'transgender',
    label: 'Transgender',
    unicode: 'f225',
    styles: ['solid'],
    searchTerms: [
      'female',
      'gender',
      'intersex',
      'male',
      'transgender',
      'transgender symbol',
    ],
    categories: ['gender'],
    aliases: ['transgender-alt'],
  },
  {
    name: 'trash',
    label: 'Trash',
    unicode: 'f1f8',
    styles: ['solid'],
    searchTerms: ['delete', 'garbage', 'hide', 'remove'],
    categories: ['editing'],
  },
  {
    name: 'trash-arrow-up',
    label: 'Trash Arrow Up',
    unicode: 'f829',
    styles: ['solid'],
    searchTerms: [
      'back',
      'control z',
      'delete',
      'garbage',
      'hide',
      'oops',
      'remove',
      'undo',
      'upgrade',
    ],
    categories: ['editing'],
    aliases: ['trash-restore'],
  },
  {
    name: 'trash-can',
    label: 'Trash Can',
    unicode: 'f2ed',
    styles: ['regular', 'solid'],
    searchTerms: ['delete', 'garbage', 'hide', 'remove', 'trash-o'],
    categories: ['editing', 'humanitarian'],
    aliases: ['trash-alt'],
  },
  {
    name: 'trash-can-arrow-up',
    label: 'Trash Can Arrow Up',
    unicode: 'f82a',
    styles: ['solid'],
    searchTerms: [
      'back',
      'control z',
      'delete',
      'garbage',
      'hide',
      'oops',
      'remove',
      'undo',
      'upgrade',
    ],
    categories: ['editing'],
    aliases: ['trash-restore-alt'],
  },
  {
    name: 'tree',
    label: 'Tree',
    unicode: 'f1bb',
    styles: ['solid'],
    searchTerms: [
      'bark',
      'evergreen tree',
      'fall',
      'flora',
      'forest',
      'investment',
      'nature',
      'plant',
      'seasonal',
      'tree',
    ],
    categories: ['camping', 'maps', 'nature'],
  },
  {
    name: 'tree-city',
    label: 'Tree City',
    unicode: 'e587',
    styles: ['solid'],
    searchTerms: ['building', 'city', 'urban'],
    categories: ['buildings', 'humanitarian', 'travel-hotel'],
  },
  {
    name: 'trello',
    label: 'Trello',
    unicode: 'f181',
    styles: ['brands'],
    searchTerms: ['atlassian'],
    categories: [],
  },
  {
    name: 'triangle-exclamation',
    label: 'Triangle Exclamation',
    unicode: 'f071',
    styles: ['solid'],
    searchTerms: [
      'alert',
      'attention',
      'danger',
      'error',
      'failed',
      'important',
      'notice',
      'notification',
      'notify',
      'problem',
      'required',
      'warnin',
      'warning',
    ],
    categories: ['alert'],
    aliases: ['exclamation-triangle', 'warning'],
  },
  {
    name: 'trophy',
    label: 'Trophy',
    unicode: 'f091',
    styles: ['solid'],
    searchTerms: [
      'achievement',
      'award',
      'cup',
      'game',
      'prize',
      'trophy',
      'winner',
    ],
    categories: ['maps', 'shopping'],
  },
  {
    name: 'trowel',
    label: 'Trowel',
    unicode: 'e589',
    styles: ['solid'],
    searchTerms: ['build', 'construction', 'equipment', 'maintenance', 'tool'],
    categories: ['construction', 'humanitarian'],
  },
  {
    name: 'trowel-bricks',
    label: 'Trowel Bricks',
    unicode: 'e58a',
    styles: ['solid'],
    searchTerms: [
      'build',
      'construction',
      'maintenance',
      'reconstruction',
      'tool',
    ],
    categories: ['construction', 'humanitarian'],
  },
  {
    name: 'truck',
    label: 'Truck',
    unicode: 'f0d1',
    styles: ['solid'],
    searchTerms: [
      'Black Truck',
      'cargo',
      'delivery',
      'delivery truck',
      'shipping',
      'truck',
      'vehicle',
    ],
    categories: [
      'automotive',
      'humanitarian',
      'logistics',
      'maps',
      'shopping',
      'transportation',
    ],
  },
  {
    name: 'truck-arrow-right',
    label: 'Truck Arrow Right',
    unicode: 'e58b',
    styles: ['solid'],
    searchTerms: ['access', 'fast', 'shipping', 'transport'],
    categories: ['humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'truck-droplet',
    label: 'Truck Droplet',
    unicode: 'e58c',
    styles: ['solid'],
    searchTerms: ['blood', 'thirst', 'truck', 'water', 'water supply'],
    categories: ['humanitarian', 'medical-health', 'transportation'],
  },
  {
    name: 'truck-fast',
    label: 'Truck Fast',
    unicode: 'f48b',
    styles: ['solid'],
    searchTerms: [
      'express',
      'fedex',
      'mail',
      'overnight',
      'package',
      'quick',
      'ups',
    ],
    categories: ['logistics', 'shopping'],
    aliases: ['shipping-fast'],
  },
  {
    name: 'truck-field',
    label: 'Truck Field',
    unicode: 'e58d',
    styles: ['solid'],
    searchTerms: ['supplies', 'truck'],
    categories: ['automotive', 'humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'truck-field-un',
    label: 'Truck Field Un',
    unicode: 'e58e',
    styles: ['solid'],
    searchTerms: ['supplies', 'truck', 'united nations'],
    categories: ['automotive', 'humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'truck-front',
    label: 'Truck Front',
    unicode: 'e2b7',
    styles: ['solid'],
    searchTerms: ['shuttle', 'truck', 'van'],
    categories: ['humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'truck-medical',
    label: 'Truck Medical',
    unicode: 'f0f9',
    styles: ['solid'],
    searchTerms: [
      'ambulance',
      'clinic',
      'covid-19',
      'emergency',
      'emt',
      'er',
      'help',
      'hospital',
      'mobile',
      'support',
      'vehicle',
    ],
    categories: [
      'automotive',
      'humanitarian',
      'maps',
      'medical-health',
      'transportation',
    ],
    aliases: ['ambulance'],
  },
  {
    name: 'truck-monster',
    label: 'Truck Monster',
    unicode: 'f63b',
    styles: ['solid'],
    searchTerms: ['offroad', 'vehicle', 'wheel'],
    categories: ['automotive', 'transportation'],
  },
  {
    name: 'truck-moving',
    label: 'Truck Moving',
    unicode: 'f4df',
    styles: ['solid'],
    searchTerms: ['cargo', 'inventory', 'rental', 'vehicle'],
    categories: ['moving'],
  },
  {
    name: 'truck-pickup',
    label: 'Truck Pickup',
    unicode: 'f63c',
    styles: ['solid'],
    searchTerms: [
      'cargo',
      'maintenance',
      'pick-up',
      'pickup',
      'pickup truck',
      'truck',
      'vehicle',
    ],
    categories: ['automotive', 'construction', 'transportation'],
  },
  {
    name: 'truck-plane',
    label: 'Truck Plane',
    unicode: 'e58f',
    styles: ['solid'],
    searchTerms: ['airplane', 'plane', 'transportation', 'truck', 'vehicle'],
    categories: ['humanitarian', 'logistics', 'transportation'],
  },
  {
    name: 'truck-ramp-box',
    label: 'Truck Ramp Box',
    unicode: 'f4de',
    styles: ['solid'],
    searchTerms: [
      'box',
      'cargo',
      'delivery',
      'inventory',
      'moving',
      'rental',
      'vehicle',
    ],
    categories: ['moving'],
    aliases: ['truck-loading'],
  },
  {
    name: 'tty',
    label: 'Tty',
    unicode: 'f1e4',
    styles: ['solid'],
    searchTerms: [
      'communication',
      'deaf',
      'telephone',
      'teletypewriter',
      'text',
    ],
    categories: ['accessibility', 'communication', 'maps'],
    aliases: ['teletype'],
  },
  {
    name: 'tumblr',
    label: 'Tumblr',
    unicode: 'f173',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'turkish-lira-sign',
    label: 'Turkish Lira Sign',
    unicode: 'e2bb',
    styles: ['solid'],
    searchTerms: ['Turkish Lira Sign', 'currency'],
    categories: ['money'],
    aliases: ['try', 'turkish-lira'],
  },
  {
    name: 'turn-down',
    label: 'Turn Down',
    unicode: 'f3be',
    styles: ['solid'],
    searchTerms: ['arrow', 'down', 'level-down', 'right arrow curving down'],
    categories: ['arrows'],
    aliases: ['level-down-alt'],
  },
  {
    name: 'turn-up',
    label: 'Turn Up',
    unicode: 'f3bf',
    styles: ['solid'],
    searchTerms: ['arrow', 'level-up', 'right arrow curving up'],
    categories: ['arrows'],
    aliases: ['level-up-alt'],
  },
  {
    name: 'tv',
    label: 'Tv',
    unicode: 'f26c',
    styles: ['solid'],
    searchTerms: ['computer', 'display', 'monitor', 'television'],
    categories: ['devices-hardware', 'film-video', 'household', 'travel-hotel'],
    aliases: ['television', 'tv-alt'],
  },
  {
    name: 'twitch',
    label: 'Twitch',
    unicode: 'f1e8',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
  },
  {
    name: 'twitter',
    label: 'Twitter',
    unicode: 'f099',
    styles: ['brands'],
    searchTerms: ['social network', 'tweet'],
    categories: [],
  },
  {
    name: 'typo3',
    label: 'Typo3',
    unicode: 'f42b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'u',
    label: 'U',
    unicode: '55',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter U', 'Latin Small Letter U', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'uber',
    label: 'Uber',
    unicode: 'f402',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'ubuntu',
    label: 'Ubuntu',
    unicode: 'f7df',
    styles: ['brands'],
    searchTerms: ['linux', 'operating system', 'os'],
    categories: [],
  },
  {
    name: 'uikit',
    label: 'UIkit',
    unicode: 'f403',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'umbraco',
    label: 'Umbraco',
    unicode: 'f8e8',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'umbrella',
    label: 'Umbrella',
    unicode: 'f0e9',
    styles: ['solid'],
    searchTerms: ['protection', 'rain', 'storm', 'wet'],
    categories: ['maps', 'weather'],
  },
  {
    name: 'umbrella-beach',
    label: 'Umbrella Beach',
    unicode: 'f5ca',
    styles: ['solid'],
    searchTerms: [
      'beach',
      'beach with umbrella',
      'protection',
      'recreation',
      'sand',
      'shade',
      'summer',
      'sun',
      'umbrella',
    ],
    categories: ['travel-hotel'],
  },
  {
    name: 'uncharted',
    label: 'Uncharted Software',
    unicode: 'e084',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'underline',
    label: 'Underline',
    unicode: 'f0cd',
    styles: ['solid'],
    searchTerms: ['edit', 'emphasis', 'format', 'modify', 'text', 'writing'],
    categories: ['text-formatting'],
  },
  {
    name: 'uniregistry',
    label: 'Uniregistry',
    unicode: 'f404',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'unity',
    label: 'Unity 3D',
    unicode: 'e049',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'universal-access',
    label: 'Universal Access',
    unicode: 'f29a',
    styles: ['solid'],
    searchTerms: ['uer', 'users-people'],
    categories: ['accessibility'],
  },
  {
    name: 'unlock',
    label: 'Unlock',
    unicode: 'f09c',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'lock',
      'open',
      'padlock',
      'password',
      'privacy',
      'private',
      'protect',
      'unlock',
      'unlocked',
    ],
    categories: ['security'],
  },
  {
    name: 'unlock-keyhole',
    label: 'Unlock Keyhole',
    unicode: 'f13e',
    styles: ['solid'],
    searchTerms: [
      'admin',
      'lock',
      'padlock',
      'password',
      'privacy',
      'private',
      'protect',
    ],
    categories: ['security'],
    aliases: ['unlock-alt'],
  },
  {
    name: 'unsplash',
    label: 'Unsplash',
    unicode: 'e07c',
    styles: ['brands'],
    searchTerms: [],
    categories: ['photos-images'],
  },
  {
    name: 'untappd',
    label: 'Untappd',
    unicode: 'f405',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'up-down',
    label: 'Up Down',
    unicode: 'f338',
    styles: ['solid'],
    searchTerms: [
      'Up Down Black Arrow',
      'arrow',
      'arrows-v',
      'expand',
      'portrait',
      'resize',
      'tall',
      'up-down arrow',
      'vertical',
    ],
    categories: ['arrows'],
    aliases: ['arrows-alt-v'],
  },
  {
    name: 'up-down-left-right',
    label: 'Up Down Left Right',
    unicode: 'f0b2',
    styles: ['solid'],
    searchTerms: [
      'arrow',
      'arrows',
      'bigger',
      'enlarge',
      'expand',
      'fullscreen',
      'move',
      'position',
      'reorder',
      'resize',
    ],
    categories: ['arrows'],
    aliases: ['arrows-alt'],
  },
  {
    name: 'up-long',
    label: 'Up Long',
    unicode: 'f30c',
    styles: ['solid'],
    searchTerms: ['long-arrow-up', 'upgrade', 'upload'],
    categories: ['arrows'],
    aliases: ['long-arrow-alt-up'],
  },
  {
    name: 'up-right-and-down-left-from-center',
    label: 'Up Right And Down Left From Center',
    unicode: 'f424',
    styles: ['solid'],
    searchTerms: [
      'arrows',
      'bigger',
      'enlarge',
      'expand',
      'fullscreen',
      'maximize',
      'resize',
      'resize',
      'scale',
      'size',
    ],
    categories: ['arrows', 'media-playback'],
    aliases: ['expand-alt'],
  },
  {
    name: 'up-right-from-square',
    label: 'Up Right From Square',
    unicode: 'f35d',
    styles: ['solid'],
    searchTerms: ['external-link', 'new', 'open', 'share', 'upgrade'],
    categories: ['arrows'],
    aliases: ['external-link-alt'],
  },
  {
    name: 'upload',
    label: 'Upload',
    unicode: 'f093',
    styles: ['solid'],
    searchTerms: ['hard drive', 'import', 'publish', 'upgrade'],
    categories: ['arrows', 'devices-hardware'],
  },
  {
    name: 'ups',
    label: 'UPS',
    unicode: 'f7e0',
    styles: ['brands'],
    searchTerms: ['United Parcel Service', 'package', 'shipping'],
    categories: [],
  },
  {
    name: 'upwork',
    label: 'Upwork',
    unicode: 'e641',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'usb',
    label: 'USB',
    unicode: 'f287',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'user',
    label: 'User',
    unicode: 'f007',
    styles: ['regular', 'solid'],
    searchTerms: [
      'adult',
      'bust',
      'bust in silhouette',
      'default',
      'employee',
      'gender-neutral',
      'person',
      'profile',
      'silhouette',
      'uer',
      'unspecified gender',
      'username',
      'users-people',
    ],
    categories: ['social', 'users-people'],
  },
  {
    name: 'user-astronaut',
    label: 'User Astronaut',
    unicode: 'f4fb',
    styles: ['solid'],
    searchTerms: [
      'avatar',
      'clothing',
      'cosmonaut',
      'nasa',
      'space',
      'suit',
      'uer',
    ],
    categories: ['astronomy', 'science-fiction', 'users-people'],
  },
  {
    name: 'user-check',
    label: 'User Check',
    unicode: 'f4fc',
    styles: ['solid'],
    searchTerms: [
      'employee',
      'enable',
      'uer',
      'users-people',
      'validate',
      'working',
    ],
    categories: ['users-people'],
  },
  {
    name: 'user-clock',
    label: 'User Clock',
    unicode: 'f4fd',
    styles: ['solid'],
    searchTerms: ['employee', 'uer', 'users-people'],
    categories: ['users-people'],
  },
  {
    name: 'user-doctor',
    label: 'User Doctor',
    unicode: 'f0f0',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'health',
      'job',
      'medical',
      'nurse',
      'occupation',
      'physician',
      'profile',
      'surgeon',
      'uer',
      'worker',
    ],
    categories: ['humanitarian', 'medical-health', 'users-people'],
    aliases: ['user-md'],
  },
  {
    name: 'user-gear',
    label: 'User Gear',
    unicode: 'f4fe',
    styles: ['solid'],
    searchTerms: ['employee', 'together', 'uer', 'users-people'],
    categories: ['users-people'],
    aliases: ['user-cog'],
  },
  {
    name: 'user-graduate',
    label: 'User Graduate',
    unicode: 'f501',
    styles: ['solid'],
    searchTerms: ['uer', 'users-people'],
    categories: ['education', 'users-people'],
  },
  {
    name: 'user-group',
    label: 'User Group',
    unicode: 'f500',
    styles: ['solid'],
    searchTerms: [
      'bust',
      'busts in silhouette',
      'crowd',
      'employee',
      'silhouette',
      'together',
      'uer',
      'users-people',
    ],
    categories: ['social', 'users-people'],
    aliases: ['user-friends'],
  },
  {
    name: 'user-injured',
    label: 'User Injured',
    unicode: 'f728',
    styles: ['solid'],
    searchTerms: ['employee', 'uer', 'users-people'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'user-large',
    label: 'User Large',
    unicode: 'f406',
    styles: ['solid'],
    searchTerms: ['employee', 'uer', 'users-people'],
    categories: ['users-people'],
    aliases: ['user-alt'],
  },
  {
    name: 'user-large-slash',
    label: 'User Large Slash',
    unicode: 'f4fa',
    styles: ['solid'],
    searchTerms: ['disabled', 'disconnect', 'employee', 'uer', 'users-people'],
    categories: ['users-people'],
    aliases: ['user-alt-slash'],
  },
  {
    name: 'user-lock',
    label: 'User Lock',
    unicode: 'f502',
    styles: ['solid'],
    searchTerms: ['employee', 'padlock', 'privacy', 'uer', 'users-people'],
    categories: ['security', 'users-people'],
  },
  {
    name: 'user-minus',
    label: 'User Minus',
    unicode: 'f503',
    styles: ['solid'],
    searchTerms: ['delete', 'employee', 'negative', 'remove', 'uer'],
    categories: ['users-people'],
  },
  {
    name: 'user-ninja',
    label: 'User Ninja',
    unicode: 'f504',
    styles: ['solid'],
    searchTerms: [
      'assassin',
      'avatar',
      'dangerous',
      'deadly',
      'fighter',
      'hidden',
      'ninja',
      'sneaky',
      'stealth',
      'uer',
    ],
    categories: ['users-people'],
  },
  {
    name: 'user-nurse',
    label: 'User Nurse',
    unicode: 'f82f',
    styles: ['solid'],
    searchTerms: [
      'covid-19',
      'doctor',
      'health',
      'md',
      'medical',
      'midwife',
      'physician',
      'practitioner',
      'surgeon',
      'uer',
      'worker',
    ],
    categories: ['medical-health', 'users-people'],
  },
  {
    name: 'user-pen',
    label: 'User Pen',
    unicode: 'f4ff',
    styles: ['solid'],
    searchTerms: ['employee', 'modify', 'uer', 'users-people'],
    categories: ['users-people'],
    aliases: ['user-edit'],
  },
  {
    name: 'user-plus',
    label: 'User Plus',
    unicode: 'f234',
    styles: ['solid'],
    searchTerms: [
      'add',
      'avatar',
      'employee',
      'follow',
      'positive',
      'sign up',
      'signup',
      'team',
      'uer',
    ],
    categories: ['social', 'users-people'],
  },
  {
    name: 'user-secret',
    label: 'User Secret',
    unicode: 'f21b',
    styles: ['solid'],
    searchTerms: ['detective', 'sleuth', 'spy', 'uer', 'users-people'],
    categories: ['coding', 'security', 'users-people'],
  },
  {
    name: 'user-shield',
    label: 'User Shield',
    unicode: 'f505',
    styles: ['solid'],
    searchTerms: ['employee', 'protect', 'safety', 'uer'],
    categories: ['security', 'users-people'],
  },
  {
    name: 'user-slash',
    label: 'User Slash',
    unicode: 'f506',
    styles: ['solid'],
    searchTerms: [
      'ban',
      'delete',
      'deny',
      'disabled',
      'disconnect',
      'employee',
      'remove',
      'uer',
    ],
    categories: ['users-people'],
  },
  {
    name: 'user-tag',
    label: 'User Tag',
    unicode: 'f507',
    styles: ['solid'],
    searchTerms: ['employee', 'uer', 'users-people'],
    categories: ['users-people'],
  },
  {
    name: 'user-tie',
    label: 'User Tie',
    unicode: 'f508',
    styles: ['solid'],
    searchTerms: [
      'administrator',
      'avatar',
      'business',
      'clothing',
      'employee',
      'formal',
      'offer',
      'portfolio',
      'professional',
      'suit',
      'uer',
    ],
    categories: ['clothing-fashion', 'users-people'],
  },
  {
    name: 'user-xmark',
    label: 'User Xmark',
    unicode: 'f235',
    styles: ['solid'],
    searchTerms: [
      'archive',
      'delete',
      'employee',
      'remove',
      'uer',
      'uncheck',
      'x',
    ],
    categories: ['users-people'],
    aliases: ['user-times'],
  },
  {
    name: 'users',
    label: 'Users',
    unicode: 'f0c0',
    styles: ['solid'],
    searchTerms: ['employee', 'together', 'uer', 'users-people'],
    categories: ['social', 'users-people'],
  },
  {
    name: 'users-between-lines',
    label: 'Users Between Lines',
    unicode: 'e591',
    styles: ['solid'],
    searchTerms: [
      'covered',
      'crowd',
      'employee',
      'group',
      'people',
      'together',
      'uer',
    ],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'users-gear',
    label: 'Users Gear',
    unicode: 'f509',
    styles: ['solid'],
    searchTerms: ['employee', 'uer', 'users-people'],
    categories: ['users-people'],
    aliases: ['users-cog'],
  },
  {
    name: 'users-line',
    label: 'Users Line',
    unicode: 'e592',
    styles: ['solid'],
    searchTerms: [
      'crowd',
      'employee',
      'group',
      'need',
      'people',
      'together',
      'uer',
    ],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'users-rays',
    label: 'Users Rays',
    unicode: 'e593',
    styles: ['solid'],
    searchTerms: [
      'affected',
      'crowd',
      'employee',
      'focused',
      'group',
      'people',
      'uer',
    ],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'users-rectangle',
    label: 'Users Rectangle',
    unicode: 'e594',
    styles: ['solid'],
    searchTerms: [
      'crowd',
      'employee',
      'focus',
      'group',
      'people',
      'reached',
      'uer',
    ],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'users-slash',
    label: 'Users Slash',
    unicode: 'e073',
    styles: ['solid'],
    searchTerms: [
      'disabled',
      'disconnect',
      'employee',
      'together',
      'uer',
      'users-people',
    ],
    categories: ['users-people'],
  },
  {
    name: 'users-viewfinder',
    label: 'Users Viewfinder',
    unicode: 'e595',
    styles: ['solid'],
    searchTerms: ['crowd', 'focus', 'group', 'people', 'targeted', 'uer'],
    categories: ['humanitarian', 'users-people'],
  },
  {
    name: 'usps',
    label: 'United States Postal Service',
    unicode: 'f7e1',
    styles: ['brands'],
    searchTerms: ['american', 'package', 'shipping', 'usa'],
    categories: [],
  },
  {
    name: 'ussunnah',
    label: 'us-Sunnah Foundation',
    unicode: 'f407',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'utensils',
    label: 'Utensils',
    unicode: 'f2e7',
    styles: ['solid'],
    searchTerms: [
      'cooking',
      'cutlery',
      'dining',
      'dinner',
      'eat',
      'food',
      'fork',
      'fork and knife',
      'knife',
      'restaurant',
    ],
    categories: ['household', 'maps', 'travel-hotel'],
    aliases: ['cutlery'],
  },
  {
    name: 'v',
    label: 'V',
    unicode: '56',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter V', 'Latin Small Letter V', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'vaadin',
    label: 'Vaadin',
    unicode: 'f408',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'van-shuttle',
    label: 'Van Shuttle',
    unicode: 'f5b6',
    styles: ['solid'],
    searchTerms: [
      'airport',
      'bus',
      'machine',
      'minibus',
      'public-transportation',
      'transportation',
      'travel',
      'vehicle',
    ],
    categories: ['automotive', 'transportation', 'travel-hotel'],
    aliases: ['shuttle-van'],
  },
  {
    name: 'vault',
    label: 'Vault',
    unicode: 'e2c5',
    styles: ['solid'],
    searchTerms: [
      'bank',
      'important',
      'investment',
      'lock',
      'money',
      'premium',
      'privacy',
      'safe',
      'salary',
    ],
    categories: ['business', 'money', 'security'],
  },
  {
    name: 'vector-square',
    label: 'Vector Square',
    unicode: 'f5cb',
    styles: ['solid'],
    searchTerms: ['anchors', 'lines', 'object', 'render', 'shape'],
    categories: ['design'],
  },
  {
    name: 'venus',
    label: 'Venus',
    unicode: 'f221',
    styles: ['solid'],
    searchTerms: ['female', 'female sign', 'gender', 'woman'],
    categories: ['gender'],
  },
  {
    name: 'venus-double',
    label: 'Venus Double',
    unicode: 'f226',
    styles: ['solid'],
    searchTerms: ['Doubled Female Sign', 'female', 'gender', 'lesbian'],
    categories: ['gender'],
  },
  {
    name: 'venus-mars',
    label: 'Venus Mars',
    unicode: 'f228',
    styles: ['solid'],
    searchTerms: [
      'Interlocked Female and Male Sign',
      'female',
      'gender',
      'heterosexual',
      'male',
    ],
    categories: ['gender'],
  },
  {
    name: 'vest',
    label: 'Vest',
    unicode: 'e085',
    styles: ['solid'],
    searchTerms: ['biker', 'fashion', 'style'],
    categories: ['clothing-fashion', 'maps'],
  },
  {
    name: 'vest-patches',
    label: 'Vest Patches',
    unicode: 'e086',
    styles: ['solid'],
    searchTerms: ['biker', 'fashion', 'style'],
    categories: ['clothing-fashion', 'maps'],
  },
  {
    name: 'viacoin',
    label: 'Viacoin',
    unicode: 'f237',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'viadeo',
    label: 'Viadeo',
    unicode: 'f2a9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'vial',
    label: 'Vial',
    unicode: 'f492',
    styles: ['solid'],
    searchTerms: [
      'ampule',
      'chemist',
      'chemistry',
      'experiment',
      'knowledge',
      'lab',
      'sample',
      'science',
      'test',
      'test tube',
    ],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'vial-circle-check',
    label: 'Vial Circle Check',
    unicode: 'e596',
    styles: ['solid'],
    searchTerms: [
      'ampule',
      'chemist',
      'chemistry',
      'enable',
      'not affected',
      'ok',
      'okay',
      'success',
      'test tube',
      'tube',
      'vaccine',
      'validate',
      'working',
    ],
    categories: ['humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'vial-virus',
    label: 'Vial Virus',
    unicode: 'e597',
    styles: ['solid'],
    searchTerms: [
      'ampule',
      'coronavirus',
      'covid-19',
      'flue',
      'infection',
      'lab',
      'laboratory',
      'pandemic',
      'test',
      'test tube',
      'vaccine',
    ],
    categories: ['humanitarian', 'medical-health', 'science'],
  },
  {
    name: 'vials',
    label: 'Vials',
    unicode: 'f493',
    styles: ['solid'],
    searchTerms: [
      'ampule',
      'experiment',
      'knowledge',
      'lab',
      'sample',
      'science',
      'test',
      'test tube',
    ],
    categories: ['medical-health', 'science'],
  },
  {
    name: 'viber',
    label: 'Viber',
    unicode: 'f409',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'video',
    label: 'Video',
    unicode: 'f03d',
    styles: ['solid'],
    searchTerms: ['camera', 'film', 'movie', 'record', 'video-camera'],
    categories: ['communication', 'film-video', 'social'],
    aliases: ['video-camera'],
  },
  {
    name: 'video-slash',
    label: 'Video Slash',
    unicode: 'f4e2',
    styles: ['solid'],
    searchTerms: [
      'add',
      'create',
      'disabled',
      'disconnect',
      'film',
      'new',
      'positive',
      'record',
      'video',
    ],
    categories: ['communication', 'film-video'],
  },
  {
    name: 'vihara',
    label: 'Vihara',
    unicode: 'f6a7',
    styles: ['solid'],
    searchTerms: ['buddhism', 'buddhist', 'building', 'monastery'],
    categories: ['buildings', 'humanitarian', 'religion'],
  },
  {
    name: 'vimeo',
    label: 'Vimeo',
    unicode: 'f40a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'vimeo-v',
    label: 'Vimeo V',
    unicode: 'f27d',
    styles: ['brands'],
    searchTerms: ['vimeo'],
    categories: [],
  },
  {
    name: 'vine',
    label: 'Vine',
    unicode: 'f1ca',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'virus',
    label: 'Virus',
    unicode: 'e074',
    styles: ['solid'],
    searchTerms: [
      'bug',
      'coronavirus',
      'covid-19',
      'flu',
      'health',
      'infection',
      'pandemic',
      'sick',
      'vaccine',
      'viral',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'virus-covid',
    label: 'Virus Covid',
    unicode: 'e4a8',
    styles: ['solid'],
    searchTerms: [
      'bug',
      'covid-19',
      'flu',
      'health',
      'infection',
      'pandemic',
      'vaccine',
      'viral',
      'virus',
    ],
    categories: ['humanitarian', 'medical-health'],
  },
  {
    name: 'virus-covid-slash',
    label: 'Virus Covid Slash',
    unicode: 'e4a9',
    styles: ['solid'],
    searchTerms: [
      'bug',
      'covid-19',
      'disabled',
      'flu',
      'health',
      'infection',
      'pandemic',
      'vaccine',
      'viral',
      'virus',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'virus-slash',
    label: 'Virus Slash',
    unicode: 'e075',
    styles: ['solid'],
    searchTerms: [
      'bug',
      'coronavirus',
      'covid-19',
      'cure',
      'disabled',
      'eliminate',
      'flu',
      'health',
      'infection',
      'pandemic',
      'sick',
      'vaccine',
      'viral',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'viruses',
    label: 'Viruses',
    unicode: 'e076',
    styles: ['solid'],
    searchTerms: [
      'bugs',
      'coronavirus',
      'covid-19',
      'flu',
      'health',
      'infection',
      'multiply',
      'pandemic',
      'sick',
      'spread',
      'vaccine',
      'viral',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'vk',
    label: 'VK',
    unicode: 'f189',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'vnv',
    label: 'VNV',
    unicode: 'f40b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'voicemail',
    label: 'Voicemail',
    unicode: 'f897',
    styles: ['solid'],
    searchTerms: ['answer', 'inbox', 'message', 'phone'],
    categories: ['communication'],
  },
  {
    name: 'volcano',
    label: 'Volcano',
    unicode: 'f770',
    styles: ['solid'],
    searchTerms: [
      'caldera',
      'eruption',
      'lava',
      'magma',
      'mountain',
      'smoke',
      'volcano',
    ],
    categories: ['disaster', 'humanitarian', 'nature', 'weather'],
  },
  {
    name: 'volleyball',
    label: 'Volleyball',
    unicode: 'f45f',
    styles: ['solid'],
    searchTerms: ['ball', 'beach', 'game', 'olympics', 'sport', 'volleyball'],
    categories: ['sports-fitness'],
    aliases: ['volleyball-ball'],
  },
  {
    name: 'volume-high',
    label: 'Volume High',
    unicode: 'f028',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'higher',
      'loud',
      'louder',
      'music',
      'sound',
      'speaker',
      'speaker high volume',
    ],
    categories: ['media-playback', 'music-audio'],
    aliases: ['volume-up'],
  },
  {
    name: 'volume-low',
    label: 'Volume Low',
    unicode: 'f027',
    styles: ['solid'],
    searchTerms: [
      'audio',
      'lower',
      'music',
      'quieter',
      'soft',
      'sound',
      'speaker',
      'speaker low volume',
    ],
    categories: ['media-playback', 'music-audio'],
    aliases: ['volume-down'],
  },
  {
    name: 'volume-off',
    label: 'Volume Off',
    unicode: 'f026',
    styles: ['solid'],
    searchTerms: ['audio', 'ban', 'music', 'mute', 'quiet', 'silent', 'sound'],
    categories: ['media-playback', 'music-audio'],
  },
  {
    name: 'volume-xmark',
    label: 'Volume Xmark',
    unicode: 'f6a9',
    styles: ['solid'],
    searchTerms: ['audio', 'music', 'quiet', 'sound', 'speaker'],
    categories: ['media-playback', 'music-audio'],
    aliases: ['volume-mute', 'volume-times'],
  },
  {
    name: 'vr-cardboard',
    label: 'Vr Cardboard',
    unicode: 'f729',
    styles: ['solid'],
    searchTerms: ['3d', 'augment', 'google', 'reality', 'virtual'],
    categories: ['gaming'],
  },
  {
    name: 'vuejs',
    label: 'Vue.js',
    unicode: 'f41f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'w',
    label: 'W',
    unicode: '57',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter W', 'Latin Small Letter W', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'walkie-talkie',
    label: 'Walkie Talkie',
    unicode: 'f8ef',
    styles: ['solid'],
    searchTerms: [
      'communication',
      'copy',
      'intercom',
      'over',
      'portable',
      'radio',
      'two way radio',
    ],
    categories: ['communication', 'devices-hardware', 'humanitarian'],
  },
  {
    name: 'wallet',
    label: 'Wallet',
    unicode: 'f555',
    styles: ['solid'],
    searchTerms: ['billfold', 'cash', 'currency', 'money', 'salary'],
    categories: ['business', 'money'],
  },
  {
    name: 'wand-magic',
    label: 'Wand Magic',
    unicode: 'f0d0',
    styles: ['solid'],
    searchTerms: [
      'autocomplete',
      'automatic',
      'mage',
      'magic',
      'spell',
      'wand',
      'witch',
      'wizard',
    ],
    categories: ['design', 'editing'],
    aliases: ['magic'],
  },
  {
    name: 'wand-magic-sparkles',
    label: 'Wand Magic Sparkles',
    unicode: 'e2ca',
    styles: ['solid'],
    searchTerms: ['auto', 'magic', 'magic wand', 'trick', 'witch', 'wizard'],
    categories: ['design', 'editing'],
    aliases: ['magic-wand-sparkles'],
  },
  {
    name: 'wand-sparkles',
    label: 'Wand Sparkles',
    unicode: 'f72b',
    styles: ['solid'],
    searchTerms: [
      'autocomplete',
      'automatic',
      'fantasy',
      'halloween',
      'holiday',
      'magic',
      'weapon',
      'witch',
      'wizard',
    ],
    categories: ['gaming', 'halloween'],
  },
  {
    name: 'warehouse',
    label: 'Warehouse',
    unicode: 'f494',
    styles: ['solid'],
    searchTerms: ['building', 'capacity', 'garage', 'inventory', 'storage'],
    categories: ['buildings', 'logistics'],
  },
  {
    name: 'watchman-monitoring',
    label: 'Watchman Monitoring',
    unicode: 'e087',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'water',
    label: 'Water',
    unicode: 'f773',
    styles: ['solid'],
    searchTerms: ['lake', 'liquid', 'ocean', 'sea', 'swim', 'wet'],
    categories: ['energy', 'maritime', 'nature', 'weather'],
  },
  {
    name: 'water-ladder',
    label: 'Water Ladder',
    unicode: 'f5c5',
    styles: ['solid'],
    searchTerms: ['ladder', 'recreation', 'swim', 'water'],
    categories: ['travel-hotel'],
    aliases: ['ladder-water', 'swimming-pool'],
  },
  {
    name: 'wave-square',
    label: 'Wave Square',
    unicode: 'f83e',
    styles: ['solid'],
    searchTerms: ['frequency', 'pulse', 'signal'],
    categories: ['mathematics', 'music-audio'],
  },
  {
    name: 'waze',
    label: 'Waze',
    unicode: 'f83f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'web-awesome',
    label: 'Web Awesome',
    unicode: 'e682',
    styles: ['brands', 'solid'],
    searchTerms: ['awesome', 'coding', 'components', 'crown', 'web'],
    categories: ['coding', 'design'],
  },
  {
    name: 'webflow',
    label: 'Webflow',
    unicode: 'e65c',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'weebly',
    label: 'Weebly',
    unicode: 'f5cc',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'weibo',
    label: 'Weibo',
    unicode: 'f18a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'weight-hanging',
    label: 'Weight Hanging',
    unicode: 'f5cd',
    styles: ['solid'],
    searchTerms: ['anvil', 'heavy', 'measurement'],
    categories: ['sports-fitness'],
  },
  {
    name: 'weight-scale',
    label: 'Weight Scale',
    unicode: 'f496',
    styles: ['solid'],
    searchTerms: ['health', 'measurement', 'scale', 'weight'],
    categories: ['medical-health'],
    aliases: ['weight'],
  },
  {
    name: 'weixin',
    label: 'Weixin (WeChat)',
    unicode: 'f1d7',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'whatsapp',
    label: "What's App",
    unicode: 'f232',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wheat-awn',
    label: 'Wheat Awn',
    unicode: 'e2cd',
    styles: ['solid'],
    searchTerms: ['agriculture', 'autumn', 'fall', 'farming', 'grain'],
    categories: ['food-beverage', 'humanitarian'],
    aliases: ['wheat-alt'],
  },
  {
    name: 'wheat-awn-circle-exclamation',
    label: 'Wheat Awn Circle Exclamation',
    unicode: 'e598',
    styles: ['solid'],
    searchTerms: [
      'affected',
      'failed',
      'famine',
      'food',
      'gluten',
      'hunger',
      'starve',
      'straw',
    ],
    categories: ['disaster', 'food-beverage', 'humanitarian'],
  },
  {
    name: 'wheelchair',
    label: 'Wheelchair',
    unicode: 'f193',
    styles: ['solid'],
    searchTerms: ['disabled', 'uer', 'users-people'],
    categories: [
      'accessibility',
      'maps',
      'medical-health',
      'transportation',
      'travel-hotel',
      'users-people',
    ],
  },
  {
    name: 'wheelchair-move',
    label: 'Wheelchair Move',
    unicode: 'e2ce',
    styles: ['solid'],
    searchTerms: [
      'access',
      'disabled',
      'handicap',
      'impairment',
      'physical',
      'uer',
      'wheelchair symbol',
    ],
    categories: [
      'accessibility',
      'humanitarian',
      'maps',
      'medical-health',
      'transportation',
      'travel-hotel',
      'users-people',
    ],
    aliases: ['wheelchair-alt'],
  },
  {
    name: 'whiskey-glass',
    label: 'Whiskey Glass',
    unicode: 'f7a0',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'bar',
      'beverage',
      'bourbon',
      'drink',
      'glass',
      'liquor',
      'neat',
      'rye',
      'scotch',
      'shot',
      'tumbler',
      'tumbler glass',
      'whisky',
    ],
    categories: ['food-beverage'],
    aliases: ['glass-whiskey'],
  },
  {
    name: 'whmcs',
    label: 'WHMCS',
    unicode: 'f40d',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wifi',
    label: 'Wifi',
    unicode: 'f1eb',
    styles: ['solid'],
    searchTerms: [
      'connection',
      'hotspot',
      'internet',
      'network',
      'signal',
      'wireless',
      'www',
    ],
    categories: [
      'connectivity',
      'humanitarian',
      'maps',
      'toggle',
      'travel-hotel',
    ],
    aliases: ['wifi-3', 'wifi-strong'],
  },
  {
    name: 'wikipedia-w',
    label: 'Wikipedia W',
    unicode: 'f266',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wind',
    label: 'Wind',
    unicode: 'f72e',
    styles: ['solid'],
    searchTerms: ['air', 'blow', 'breeze', 'fall', 'seasonal', 'weather'],
    categories: ['disaster', 'energy', 'humanitarian', 'nature', 'weather'],
  },
  {
    name: 'window-maximize',
    label: 'Window Maximize',
    unicode: 'f2d0',
    styles: ['regular', 'solid'],
    searchTerms: ['Maximize', 'browser', 'computer', 'development', 'expand'],
    categories: ['coding'],
  },
  {
    name: 'window-minimize',
    label: 'Window Minimize',
    unicode: 'f2d1',
    styles: ['regular', 'solid'],
    searchTerms: ['Minimize', 'browser', 'collapse', 'computer', 'development'],
    categories: ['coding'],
  },
  {
    name: 'window-restore',
    label: 'Window Restore',
    unicode: 'f2d2',
    styles: ['regular', 'solid'],
    searchTerms: ['browser', 'computer', 'development'],
    categories: ['coding'],
  },
  {
    name: 'windows',
    label: 'Windows',
    unicode: 'f17a',
    styles: ['brands'],
    searchTerms: ['microsoft', 'operating system', 'os'],
    categories: [],
  },
  {
    name: 'wine-bottle',
    label: 'Wine Bottle',
    unicode: 'f72f',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'beverage',
      'cabernet',
      'drink',
      'glass',
      'grapes',
      'merlot',
      'sauvignon',
    ],
    categories: ['food-beverage'],
  },
  {
    name: 'wine-glass',
    label: 'Wine Glass',
    unicode: 'f4e3',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'bar',
      'beverage',
      'cabernet',
      'drink',
      'glass',
      'grapes',
      'merlot',
      'sauvignon',
      'wine',
      'wine glass',
    ],
    categories: ['food-beverage', 'maps', 'moving', 'travel-hotel'],
  },
  {
    name: 'wine-glass-empty',
    label: 'Wine Glass Empty',
    unicode: 'f5ce',
    styles: ['solid'],
    searchTerms: [
      'alcohol',
      'beverage',
      'cabernet',
      'drink',
      'grapes',
      'merlot',
      'sauvignon',
    ],
    categories: ['food-beverage', 'travel-hotel'],
    aliases: ['wine-glass-alt'],
  },
  {
    name: 'wirsindhandwerk',
    label: 'wirsindhandwerk',
    unicode: 'e2d0',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
    aliases: ['wsh'],
  },
  {
    name: 'wix',
    label: 'Wix',
    unicode: 'f5cf',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wizards-of-the-coast',
    label: 'Wizards of the Coast',
    unicode: 'f730',
    styles: ['brands'],
    searchTerms: [
      'Dungeons & Dragons',
      'd&d',
      'dnd',
      'fantasy',
      'game',
      'gaming',
      'tabletop',
    ],
    categories: ['gaming'],
  },
  {
    name: 'wodu',
    label: 'Wodu',
    unicode: 'e088',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wolf-pack-battalion',
    label: 'Wolf Pack Battalion',
    unicode: 'f514',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'won-sign',
    label: 'Won Sign',
    unicode: 'f159',
    styles: ['solid'],
    searchTerms: ['Won Sign', 'currency'],
    categories: ['money'],
    aliases: ['krw', 'won'],
  },
  {
    name: 'wordpress',
    label: 'WordPress Logo',
    unicode: 'f19a',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wordpress-simple',
    label: 'Wordpress Simple',
    unicode: 'f411',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'worm',
    label: 'Worm',
    unicode: 'e599',
    styles: ['solid'],
    searchTerms: ['dirt', 'garden', 'worm', 'wriggle'],
    categories: ['animals', 'disaster', 'humanitarian', 'nature'],
  },
  {
    name: 'wpbeginner',
    label: 'WPBeginner',
    unicode: 'f297',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wpexplorer',
    label: 'WPExplorer',
    unicode: 'f2de',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wpforms',
    label: 'WPForms',
    unicode: 'f298',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'wpressr',
    label: 'wpressr',
    unicode: 'f3e4',
    styles: ['brands'],
    searchTerms: ['rendact'],
    categories: [],
    aliases: ['rendact'],
  },
  {
    name: 'wrench',
    label: 'Wrench',
    unicode: 'f0ad',
    styles: ['solid'],
    searchTerms: [
      'configuration',
      'construction',
      'equipment',
      'fix',
      'mechanic',
      'modify',
      'plumbing',
      'settings',
      'spanner',
      'tool',
      'update',
      'wrench',
    ],
    categories: ['construction', 'maps'],
  },
  {
    name: 'x',
    label: 'X',
    unicode: '58',
    styles: ['solid'],
    searchTerms: [
      'Latin Capital Letter X',
      'Latin Small Letter X',
      'letter',
      'uncheck',
    ],
    categories: ['alphabet'],
  },
  {
    name: 'x-ray',
    label: 'X Ray',
    unicode: 'f497',
    styles: ['solid'],
    searchTerms: [
      'health',
      'medical',
      'radiological images',
      'radiology',
      'skeleton',
    ],
    categories: ['medical-health'],
  },
  {
    name: 'x-twitter',
    label: 'X Twitter',
    unicode: 'e61b',
    styles: ['brands'],
    searchTerms: ['elon', 'twitter', 'x'],
    categories: [],
  },
  {
    name: 'xbox',
    label: 'Xbox',
    unicode: 'f412',
    styles: ['brands'],
    searchTerms: [],
    categories: ['gaming'],
  },
  {
    name: 'xing',
    label: 'Xing',
    unicode: 'f168',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'xmark',
    label: 'Xmark',
    unicode: 'f00d',
    styles: ['solid'],
    searchTerms: [
      'Cancellation X',
      'Multiplication Sign',
      'Multiplication X',
      'cancel',
      'close',
      'cross',
      'cross mark',
      'error',
      'exit',
      'incorrect',
      'mark',
      'multiplication',
      'multiply',
      'notice',
      'notification',
      'notify',
      'problem',
      'sign',
      'uncheck',
      'wrong',
      'x',
      '×',
    ],
    categories: ['editing', 'mathematics'],
    aliases: ['close', 'multiply', 'remove', 'times'],
  },
  {
    name: 'xmarks-lines',
    label: 'Xmarks Lines',
    unicode: 'e59a',
    styles: ['solid'],
    searchTerms: ['barricade', 'barrier', 'fence', 'poison', 'roadblock'],
    categories: ['disaster', 'humanitarian', 'logistics'],
  },
  {
    name: 'y',
    label: 'Y',
    unicode: '59',
    styles: ['solid'],
    searchTerms: [
      'Latin Capital Letter Y',
      'Latin Small Letter Y',
      'letter',
      'yay',
      'yes',
    ],
    categories: ['alphabet'],
  },
  {
    name: 'y-combinator',
    label: 'Y Combinator',
    unicode: 'f23b',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yahoo',
    label: 'Yahoo Logo',
    unicode: 'f19e',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yammer',
    label: 'Yammer',
    unicode: 'f840',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yandex',
    label: 'Yandex',
    unicode: 'f413',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yandex-international',
    label: 'Yandex International',
    unicode: 'f414',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yarn',
    label: 'Yarn',
    unicode: 'f7e3',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yelp',
    label: 'Yelp',
    unicode: 'f1e9',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'yen-sign',
    label: 'Yen Sign',
    unicode: 'f157',
    styles: ['solid'],
    searchTerms: ['Yen Sign', 'currency'],
    categories: ['money'],
    aliases: ['cny', 'jpy', 'rmb', 'yen'],
  },
  {
    name: 'yin-yang',
    label: 'Yin Yang',
    unicode: 'f6ad',
    styles: ['solid'],
    searchTerms: [
      'daoism',
      'opposites',
      'religion',
      'tao',
      'taoism',
      'taoist',
      'yang',
      'yin',
      'yin yang',
    ],
    categories: ['religion', 'spinners'],
  },
  {
    name: 'yoast',
    label: 'Yoast',
    unicode: 'f2b1',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
  {
    name: 'youtube',
    label: 'YouTube',
    unicode: 'f167',
    styles: ['brands'],
    searchTerms: ['film', 'video', 'youtube-play', 'youtube-square'],
    categories: ['film-video'],
  },
  {
    name: 'z',
    label: 'Z',
    unicode: '5a',
    styles: ['solid'],
    searchTerms: ['Latin Capital Letter Z', 'Latin Small Letter Z', 'letter'],
    categories: ['alphabet'],
  },
  {
    name: 'zhihu',
    label: 'Zhihu',
    unicode: 'f63f',
    styles: ['brands'],
    searchTerms: [],
    categories: [],
  },
];

export default FONTAWESOME_ICONS;
